[
  {
    "clienteId": "CLI_0001",
    "clienteAnonimo": "0",
    "segmentoComercial": "Cliente possível coletivo",
    "ticketMedioSimulado": 1913,
    "ticketMedianoSimulado": 1881,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 3826,
    "maiorPedidoSimulado": 2063,
    "menorPedidoSimulado": 1116,
    "ticketMedioSimuladoFmt": "R$ 1.913",
    "ticketMedianoSimuladoFmt": "R$ 1.881",
    "valorTotalAcumuladoSimuladoFmt": "R$ 3.826",
    "maiorPedidoSimuladoFmt": "R$ 2.063",
    "menorPedidoSimuladoFmt": "R$ 1.116",
    "primeiraCompraSimulada": "07/01/2026",
    "ultimaCompraSimulada": "23/04/2026",
    "diasDesdeUltimaCompraSimulado": 21,
    "hipoteseDePerfil": "Possível compra coletiva, familiar ampliada ou corporativa. Não afirmar sem confirmação.",
    "objetivoProvavel": "Pode comprar para mais de uma pessoa, família ou equipe",
    "propensaoARecompra": "Indeterminada",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Tratar como hipótese de compra coletiva — G09 ativo.",
    "alertaSimulacao": "Possível compra familiar, equipe ou coletiva. Confirmar antes de assumir.",
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0001"
  },
  {
    "clienteId": "CLI_0002",
    "clienteAnonimo": "1",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 209,
    "ticketMedianoSimulado": 197,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 209,
    "maiorPedidoSimulado": 244,
    "menorPedidoSimulado": 144,
    "ticketMedioSimuladoFmt": "R$ 209",
    "ticketMedianoSimuladoFmt": "R$ 197",
    "valorTotalAcumuladoSimuladoFmt": "R$ 209",
    "maiorPedidoSimuladoFmt": "R$ 244",
    "menorPedidoSimuladoFmt": "R$ 144",
    "primeiraCompraSimulada": "22/12/2025",
    "ultimaCompraSimulada": "29/04/2026",
    "diasDesdeUltimaCompraSimulado": 15,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0002"
  },
  {
    "clienteId": "CLI_0003",
    "clienteAnonimo": "2",
    "segmentoComercial": "Cliente fiel",
    "ticketMedioSimulado": 472,
    "ticketMedianoSimulado": 457,
    "totalPedidosSimulado": 6,
    "valorTotalAcumuladoSimulado": 2832,
    "maiorPedidoSimulado": 539,
    "menorPedidoSimulado": 310,
    "ticketMedioSimuladoFmt": "R$ 472",
    "ticketMedianoSimuladoFmt": "R$ 457",
    "valorTotalAcumuladoSimuladoFmt": "R$ 2.832",
    "maiorPedidoSimuladoFmt": "R$ 539",
    "menorPedidoSimuladoFmt": "R$ 310",
    "primeiraCompraSimulada": "06/12/2025",
    "ultimaCompraSimulada": "22/03/2026",
    "diasDesdeUltimaCompraSimulado": 53,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode buscar organização da semana e praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente alta lealdade — sugerir assinatura e acomp. calórico (com G06).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0003"
  },
  {
    "clienteId": "CLI_0004",
    "clienteAnonimo": "3",
    "segmentoComercial": "Cliente fiel",
    "ticketMedioSimulado": 467,
    "ticketMedianoSimulado": 448,
    "totalPedidosSimulado": 8,
    "valorTotalAcumuladoSimulado": 3736,
    "maiorPedidoSimulado": 491,
    "menorPedidoSimulado": 257,
    "ticketMedioSimuladoFmt": "R$ 467",
    "ticketMedianoSimuladoFmt": "R$ 448",
    "valorTotalAcumuladoSimuladoFmt": "R$ 3.736",
    "maiorPedidoSimuladoFmt": "R$ 491",
    "menorPedidoSimuladoFmt": "R$ 257",
    "primeiraCompraSimulada": "21/11/2025",
    "ultimaCompraSimulada": "23/02/2026",
    "diasDesdeUltimaCompraSimulado": 80,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar organização da semana e praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente alta lealdade — sugerir assinatura e acomp. calórico (com G06).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0004"
  },
  {
    "clienteId": "CLI_0005",
    "clienteAnonimo": "4",
    "segmentoComercial": "Cliente fiel",
    "ticketMedioSimulado": 505,
    "ticketMedianoSimulado": 482,
    "totalPedidosSimulado": 5,
    "valorTotalAcumuladoSimulado": 2525,
    "maiorPedidoSimulado": 575,
    "menorPedidoSimulado": 330,
    "ticketMedioSimuladoFmt": "R$ 505",
    "ticketMedianoSimuladoFmt": "R$ 482",
    "valorTotalAcumuladoSimuladoFmt": "R$ 2.525",
    "maiorPedidoSimuladoFmt": "R$ 575",
    "menorPedidoSimuladoFmt": "R$ 330",
    "primeiraCompraSimulada": "05/11/2025",
    "ultimaCompraSimulada": "31/03/2026",
    "diasDesdeUltimaCompraSimulado": 44,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode buscar organização da semana e praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente alta lealdade — sugerir assinatura e acomp. calórico (com G06).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0005"
  },
  {
    "clienteId": "CLI_0006",
    "clienteAnonimo": "5",
    "segmentoComercial": "Cliente recorrente",
    "ticketMedioSimulado": 425,
    "ticketMedianoSimulado": 413,
    "totalPedidosSimulado": 5,
    "valorTotalAcumuladoSimulado": 2125,
    "maiorPedidoSimulado": 497,
    "menorPedidoSimulado": 293,
    "ticketMedioSimuladoFmt": "R$ 425",
    "ticketMedianoSimuladoFmt": "R$ 413",
    "valorTotalAcumuladoSimuladoFmt": "R$ 2.125",
    "maiorPedidoSimuladoFmt": "R$ 497",
    "menorPedidoSimuladoFmt": "R$ 293",
    "primeiraCompraSimulada": "06/11/2025",
    "ultimaCompraSimulada": "09/05/2026",
    "diasDesdeUltimaCompraSimulado": 5,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar manter rotina alimentar",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0006"
  },
  {
    "clienteId": "CLI_0007",
    "clienteAnonimo": "6",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 244,
    "ticketMedianoSimulado": 229,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 244,
    "maiorPedidoSimulado": 264,
    "menorPedidoSimulado": 143,
    "ticketMedioSimuladoFmt": "R$ 244",
    "ticketMedianoSimuladoFmt": "R$ 229",
    "valorTotalAcumuladoSimuladoFmt": "R$ 244",
    "maiorPedidoSimuladoFmt": "R$ 264",
    "menorPedidoSimuladoFmt": "R$ 143",
    "primeiraCompraSimulada": "22/11/2025",
    "ultimaCompraSimulada": "30/03/2026",
    "diasDesdeUltimaCompraSimulado": 45,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0007"
  },
  {
    "clienteId": "CLI_0008",
    "clienteAnonimo": "7",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 262,
    "ticketMedianoSimulado": 259,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 262,
    "maiorPedidoSimulado": 291,
    "menorPedidoSimulado": 162,
    "ticketMedioSimuladoFmt": "R$ 262",
    "ticketMedianoSimuladoFmt": "R$ 259",
    "valorTotalAcumuladoSimuladoFmt": "R$ 262",
    "maiorPedidoSimuladoFmt": "R$ 291",
    "menorPedidoSimuladoFmt": "R$ 162",
    "primeiraCompraSimulada": "08/12/2025",
    "ultimaCompraSimulada": "27/02/2026",
    "diasDesdeUltimaCompraSimulado": 76,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0008"
  },
  {
    "clienteId": "CLI_0009",
    "clienteAnonimo": "8",
    "segmentoComercial": "Cliente fiel",
    "ticketMedioSimulado": 659,
    "ticketMedianoSimulado": 610,
    "totalPedidosSimulado": 5,
    "valorTotalAcumuladoSimulado": 3295,
    "maiorPedidoSimulado": 791,
    "menorPedidoSimulado": 478,
    "ticketMedioSimuladoFmt": "R$ 659",
    "ticketMedianoSimuladoFmt": "R$ 610",
    "valorTotalAcumuladoSimuladoFmt": "R$ 3.295",
    "maiorPedidoSimuladoFmt": "R$ 791",
    "menorPedidoSimuladoFmt": "R$ 478",
    "primeiraCompraSimulada": "24/12/2025",
    "ultimaCompraSimulada": "01/04/2026",
    "diasDesdeUltimaCompraSimulado": 43,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode buscar organização da semana e praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente alta lealdade — sugerir assinatura e acomp. calórico (com G06).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0009"
  },
  {
    "clienteId": "CLI_0010",
    "clienteAnonimo": "9",
    "segmentoComercial": "Cliente fiel",
    "ticketMedioSimulado": 585,
    "ticketMedianoSimulado": 542,
    "totalPedidosSimulado": 6,
    "valorTotalAcumuladoSimulado": 3510,
    "maiorPedidoSimulado": 664,
    "menorPedidoSimulado": 380,
    "ticketMedioSimuladoFmt": "R$ 585",
    "ticketMedianoSimuladoFmt": "R$ 542",
    "valorTotalAcumuladoSimuladoFmt": "R$ 3.510",
    "maiorPedidoSimuladoFmt": "R$ 664",
    "menorPedidoSimuladoFmt": "R$ 380",
    "primeiraCompraSimulada": "11/02/2026",
    "ultimaCompraSimulada": "18/04/2026",
    "diasDesdeUltimaCompraSimulado": 26,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode buscar organização da semana e praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente alta lealdade — sugerir assinatura e acomp. calórico (com G06).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0010"
  },
  {
    "clienteId": "CLI_0011",
    "clienteAnonimo": "10",
    "segmentoComercial": "Cliente recorrente",
    "ticketMedioSimulado": 489,
    "ticketMedianoSimulado": 482,
    "totalPedidosSimulado": 4,
    "valorTotalAcumuladoSimulado": 1956,
    "maiorPedidoSimulado": 516,
    "menorPedidoSimulado": 272,
    "ticketMedioSimuladoFmt": "R$ 489",
    "ticketMedianoSimuladoFmt": "R$ 482",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.956",
    "maiorPedidoSimuladoFmt": "R$ 516",
    "menorPedidoSimuladoFmt": "R$ 272",
    "primeiraCompraSimulada": "27/02/2026",
    "ultimaCompraSimulada": "05/04/2026",
    "diasDesdeUltimaCompraSimulado": 39,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode buscar manter rotina alimentar",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0011"
  },
  {
    "clienteId": "CLI_0012",
    "clienteAnonimo": "11",
    "segmentoComercial": "Cliente fiel",
    "ticketMedioSimulado": 662,
    "ticketMedianoSimulado": 623,
    "totalPedidosSimulado": 7,
    "valorTotalAcumuladoSimulado": 4634,
    "maiorPedidoSimulado": 758,
    "menorPedidoSimulado": 438,
    "ticketMedioSimuladoFmt": "R$ 662",
    "ticketMedianoSimuladoFmt": "R$ 623",
    "valorTotalAcumuladoSimuladoFmt": "R$ 4.634",
    "maiorPedidoSimuladoFmt": "R$ 758",
    "menorPedidoSimuladoFmt": "R$ 438",
    "primeiraCompraSimulada": "15/03/2026",
    "ultimaCompraSimulada": "25/04/2026",
    "diasDesdeUltimaCompraSimulado": 19,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode buscar organização da semana e praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente alta lealdade — sugerir assinatura e acomp. calórico (com G06).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0012"
  },
  {
    "clienteId": "CLI_0013",
    "clienteAnonimo": "12",
    "segmentoComercial": "Cliente recorrente",
    "ticketMedioSimulado": 550,
    "ticketMedianoSimulado": 534,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1650,
    "maiorPedidoSimulado": 640,
    "menorPedidoSimulado": 376,
    "ticketMedioSimuladoFmt": "R$ 550",
    "ticketMedianoSimuladoFmt": "R$ 534",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.650",
    "maiorPedidoSimuladoFmt": "R$ 640",
    "menorPedidoSimuladoFmt": "R$ 376",
    "primeiraCompraSimulada": "31/03/2026",
    "ultimaCompraSimulada": "09/05/2026",
    "diasDesdeUltimaCompraSimulado": 5,
    "hipoteseDePerfil": "Compra compatível com abastecimento maior, família ou rotina intensa.",
    "objetivoProvavel": "Pode buscar manter rotina alimentar",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0013"
  },
  {
    "clienteId": "CLI_0014",
    "clienteAnonimo": "13",
    "segmentoComercial": "Cliente fiel",
    "ticketMedioSimulado": 661,
    "ticketMedianoSimulado": 632,
    "totalPedidosSimulado": 8,
    "valorTotalAcumuladoSimulado": 5288,
    "maiorPedidoSimulado": 710,
    "menorPedidoSimulado": 382,
    "ticketMedioSimuladoFmt": "R$ 661",
    "ticketMedianoSimuladoFmt": "R$ 632",
    "valorTotalAcumuladoSimuladoFmt": "R$ 5.288",
    "maiorPedidoSimuladoFmt": "R$ 710",
    "menorPedidoSimuladoFmt": "R$ 382",
    "primeiraCompraSimulada": "12/04/2026",
    "ultimaCompraSimulada": "06/05/2026",
    "diasDesdeUltimaCompraSimulado": 8,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar organização da semana e praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente alta lealdade — sugerir assinatura e acomp. calórico (com G06).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0014"
  },
  {
    "clienteId": "CLI_0015",
    "clienteAnonimo": "14",
    "segmentoComercial": "Cliente fiel",
    "ticketMedioSimulado": 622,
    "ticketMedianoSimulado": 595,
    "totalPedidosSimulado": 5,
    "valorTotalAcumuladoSimulado": 3110,
    "maiorPedidoSimulado": 694,
    "menorPedidoSimulado": 390,
    "ticketMedioSimuladoFmt": "R$ 622",
    "ticketMedianoSimuladoFmt": "R$ 595",
    "valorTotalAcumuladoSimuladoFmt": "R$ 3.110",
    "maiorPedidoSimuladoFmt": "R$ 694",
    "menorPedidoSimuladoFmt": "R$ 390",
    "primeiraCompraSimulada": "27/03/2026",
    "ultimaCompraSimulada": "22/04/2026",
    "diasDesdeUltimaCompraSimulado": 22,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode buscar organização da semana e praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente alta lealdade — sugerir assinatura e acomp. calórico (com G06).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0015"
  },
  {
    "clienteId": "CLI_0016",
    "clienteAnonimo": "15",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 244,
    "ticketMedianoSimulado": 237,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 244,
    "maiorPedidoSimulado": 291,
    "menorPedidoSimulado": 175,
    "ticketMedioSimuladoFmt": "R$ 244",
    "ticketMedianoSimuladoFmt": "R$ 237",
    "valorTotalAcumuladoSimuladoFmt": "R$ 244",
    "maiorPedidoSimuladoFmt": "R$ 291",
    "menorPedidoSimuladoFmt": "R$ 175",
    "primeiraCompraSimulada": "11/03/2026",
    "ultimaCompraSimulada": "20/04/2026",
    "diasDesdeUltimaCompraSimulado": 24,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0016"
  },
  {
    "clienteId": "CLI_0017",
    "clienteAnonimo": "16",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 226,
    "ticketMedianoSimulado": 213,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 226,
    "maiorPedidoSimulado": 249,
    "menorPedidoSimulado": 138,
    "ticketMedioSimuladoFmt": "R$ 226",
    "ticketMedianoSimuladoFmt": "R$ 213",
    "valorTotalAcumuladoSimuladoFmt": "R$ 226",
    "maiorPedidoSimuladoFmt": "R$ 249",
    "menorPedidoSimuladoFmt": "R$ 138",
    "primeiraCompraSimulada": "23/02/2026",
    "ultimaCompraSimulada": "02/05/2026",
    "diasDesdeUltimaCompraSimulado": 12,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0017"
  },
  {
    "clienteId": "CLI_0018",
    "clienteAnonimo": "17",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 207,
    "ticketMedianoSimulado": 204,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 207,
    "maiorPedidoSimulado": 225,
    "menorPedidoSimulado": 123,
    "ticketMedioSimuladoFmt": "R$ 207",
    "ticketMedianoSimuladoFmt": "R$ 204",
    "valorTotalAcumuladoSimuladoFmt": "R$ 207",
    "maiorPedidoSimuladoFmt": "R$ 225",
    "menorPedidoSimuladoFmt": "R$ 123",
    "primeiraCompraSimulada": "07/02/2026",
    "ultimaCompraSimulada": "30/04/2026",
    "diasDesdeUltimaCompraSimulado": 14,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0018"
  },
  {
    "clienteId": "CLI_0019",
    "clienteAnonimo": "18",
    "segmentoComercial": "Cliente baixo ticket",
    "ticketMedioSimulado": 84,
    "ticketMedianoSimulado": 78,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 84,
    "maiorPedidoSimulado": 99,
    "menorPedidoSimulado": 59,
    "ticketMedioSimuladoFmt": "R$ 84",
    "ticketMedianoSimuladoFmt": "R$ 78",
    "valorTotalAcumuladoSimuladoFmt": "R$ 84",
    "maiorPedidoSimuladoFmt": "R$ 99",
    "menorPedidoSimuladoFmt": "R$ 59",
    "primeiraCompraSimulada": "22/01/2026",
    "ultimaCompraSimulada": "03/04/2026",
    "diasDesdeUltimaCompraSimulado": 41,
    "hipoteseDePerfil": "Cliente em fase de teste ou primeira experiência.",
    "objetivoProvavel": "Pode estar testando a marca",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0019"
  },
  {
    "clienteId": "CLI_0020",
    "clienteAnonimo": "19",
    "segmentoComercial": "Cliente fiel",
    "ticketMedioSimulado": 543,
    "ticketMedianoSimulado": 502,
    "totalPedidosSimulado": 5,
    "valorTotalAcumuladoSimulado": 2715,
    "maiorPedidoSimulado": 629,
    "menorPedidoSimulado": 367,
    "ticketMedioSimuladoFmt": "R$ 543",
    "ticketMedianoSimuladoFmt": "R$ 502",
    "valorTotalAcumuladoSimuladoFmt": "R$ 2.715",
    "maiorPedidoSimuladoFmt": "R$ 629",
    "menorPedidoSimuladoFmt": "R$ 367",
    "primeiraCompraSimulada": "05/12/2025",
    "ultimaCompraSimulada": "25/04/2026",
    "diasDesdeUltimaCompraSimulado": 19,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode buscar organização da semana e praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente alta lealdade — sugerir assinatura e acomp. calórico (com G06).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0020"
  },
  {
    "clienteId": "CLI_0021",
    "clienteAnonimo": "20",
    "segmentoComercial": "Cliente recorrente",
    "ticketMedioSimulado": 393,
    "ticketMedianoSimulado": 388,
    "totalPedidosSimulado": 4,
    "valorTotalAcumuladoSimulado": 1572,
    "maiorPedidoSimulado": 420,
    "menorPedidoSimulado": 224,
    "ticketMedioSimuladoFmt": "R$ 393",
    "ticketMedianoSimuladoFmt": "R$ 388",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.572",
    "maiorPedidoSimuladoFmt": "R$ 420",
    "menorPedidoSimuladoFmt": "R$ 224",
    "primeiraCompraSimulada": "19/11/2025",
    "ultimaCompraSimulada": "18/04/2026",
    "diasDesdeUltimaCompraSimulado": 26,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode buscar manter rotina alimentar",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0021"
  },
  {
    "clienteId": "CLI_0022",
    "clienteAnonimo": "21",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 187,
    "ticketMedianoSimulado": 176,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 187,
    "maiorPedidoSimulado": 210,
    "menorPedidoSimulado": 119,
    "ticketMedioSimuladoFmt": "R$ 187",
    "ticketMedianoSimuladoFmt": "R$ 176",
    "valorTotalAcumuladoSimuladoFmt": "R$ 187",
    "maiorPedidoSimuladoFmt": "R$ 210",
    "menorPedidoSimuladoFmt": "R$ 119",
    "primeiraCompraSimulada": "03/11/2025",
    "ultimaCompraSimulada": "03/03/2026",
    "diasDesdeUltimaCompraSimulado": 72,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0022"
  },
  {
    "clienteId": "CLI_0023",
    "clienteAnonimo": "22",
    "segmentoComercial": "Cliente fiel",
    "ticketMedioSimulado": 473,
    "ticketMedianoSimulado": 461,
    "totalPedidosSimulado": 7,
    "valorTotalAcumuladoSimulado": 3311,
    "maiorPedidoSimulado": 562,
    "menorPedidoSimulado": 336,
    "ticketMedioSimuladoFmt": "R$ 473",
    "ticketMedianoSimuladoFmt": "R$ 461",
    "valorTotalAcumuladoSimuladoFmt": "R$ 3.311",
    "maiorPedidoSimuladoFmt": "R$ 562",
    "menorPedidoSimuladoFmt": "R$ 336",
    "primeiraCompraSimulada": "08/11/2025",
    "ultimaCompraSimulada": "25/02/2026",
    "diasDesdeUltimaCompraSimulado": 78,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode buscar organização da semana e praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente alta lealdade — sugerir assinatura e acomp. calórico (com G06).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0023"
  },
  {
    "clienteId": "CLI_0024",
    "clienteAnonimo": "23",
    "segmentoComercial": "Cliente recorrente",
    "ticketMedioSimulado": 399,
    "ticketMedianoSimulado": 380,
    "totalPedidosSimulado": 4,
    "valorTotalAcumuladoSimulado": 1596,
    "maiorPedidoSimulado": 438,
    "menorPedidoSimulado": 241,
    "ticketMedioSimuladoFmt": "R$ 399",
    "ticketMedianoSimuladoFmt": "R$ 380",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.596",
    "maiorPedidoSimuladoFmt": "R$ 438",
    "menorPedidoSimuladoFmt": "R$ 241",
    "primeiraCompraSimulada": "24/11/2025",
    "ultimaCompraSimulada": "12/04/2026",
    "diasDesdeUltimaCompraSimulado": 32,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar manter rotina alimentar",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0024"
  },
  {
    "clienteId": "CLI_0025",
    "clienteAnonimo": "24",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 228,
    "ticketMedianoSimulado": 219,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 228,
    "maiorPedidoSimulado": 249,
    "menorPedidoSimulado": 137,
    "ticketMedioSimuladoFmt": "R$ 228",
    "ticketMedianoSimuladoFmt": "R$ 219",
    "valorTotalAcumuladoSimuladoFmt": "R$ 228",
    "maiorPedidoSimuladoFmt": "R$ 249",
    "menorPedidoSimuladoFmt": "R$ 137",
    "primeiraCompraSimulada": "10/12/2025",
    "ultimaCompraSimulada": "02/05/2026",
    "diasDesdeUltimaCompraSimulado": 12,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0025"
  },
  {
    "clienteId": "CLI_0026",
    "clienteAnonimo": "25",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 247,
    "ticketMedianoSimulado": 239,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 247,
    "maiorPedidoSimulado": 292,
    "menorPedidoSimulado": 174,
    "ticketMedioSimuladoFmt": "R$ 247",
    "ticketMedianoSimuladoFmt": "R$ 239",
    "valorTotalAcumuladoSimuladoFmt": "R$ 247",
    "maiorPedidoSimuladoFmt": "R$ 292",
    "menorPedidoSimuladoFmt": "R$ 174",
    "primeiraCompraSimulada": "26/12/2025",
    "ultimaCompraSimulada": "02/04/2026",
    "diasDesdeUltimaCompraSimulado": 42,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0026"
  },
  {
    "clienteId": "CLI_0027",
    "clienteAnonimo": "26",
    "segmentoComercial": "Cliente fiel",
    "ticketMedioSimulado": 627,
    "ticketMedianoSimulado": 593,
    "totalPedidosSimulado": 5,
    "valorTotalAcumuladoSimulado": 3135,
    "maiorPedidoSimulado": 706,
    "menorPedidoSimulado": 401,
    "ticketMedioSimuladoFmt": "R$ 627",
    "ticketMedianoSimuladoFmt": "R$ 593",
    "valorTotalAcumuladoSimuladoFmt": "R$ 3.135",
    "maiorPedidoSimuladoFmt": "R$ 706",
    "menorPedidoSimuladoFmt": "R$ 401",
    "primeiraCompraSimulada": "11/01/2026",
    "ultimaCompraSimulada": "14/03/2026",
    "diasDesdeUltimaCompraSimulado": 61,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode buscar organização da semana e praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente alta lealdade — sugerir assinatura e acomp. calórico (com G06).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0027"
  },
  {
    "clienteId": "CLI_0028",
    "clienteAnonimo": "27",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 284,
    "ticketMedianoSimulado": 279,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 284,
    "maiorPedidoSimulado": 302,
    "menorPedidoSimulado": 161,
    "ticketMedioSimuladoFmt": "R$ 284",
    "ticketMedianoSimuladoFmt": "R$ 279",
    "valorTotalAcumuladoSimuladoFmt": "R$ 284",
    "maiorPedidoSimuladoFmt": "R$ 302",
    "menorPedidoSimuladoFmt": "R$ 161",
    "primeiraCompraSimulada": "27/01/2026",
    "ultimaCompraSimulada": "15/04/2026",
    "diasDesdeUltimaCompraSimulado": 29,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0028"
  },
  {
    "clienteId": "CLI_0029",
    "clienteAnonimo": "28",
    "segmentoComercial": "Cliente fiel",
    "ticketMedioSimulado": 696,
    "ticketMedianoSimulado": 648,
    "totalPedidosSimulado": 4,
    "valorTotalAcumuladoSimulado": 2784,
    "maiorPedidoSimulado": 803,
    "menorPedidoSimulado": 467,
    "ticketMedioSimuladoFmt": "R$ 696",
    "ticketMedianoSimuladoFmt": "R$ 648",
    "valorTotalAcumuladoSimuladoFmt": "R$ 2.784",
    "maiorPedidoSimuladoFmt": "R$ 803",
    "menorPedidoSimuladoFmt": "R$ 467",
    "primeiraCompraSimulada": "12/02/2026",
    "ultimaCompraSimulada": "10/05/2026",
    "diasDesdeUltimaCompraSimulado": 4,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode buscar organização da semana e praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente alta lealdade — sugerir assinatura e acomp. calórico (com G06).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0029"
  },
  {
    "clienteId": "CLI_0030",
    "clienteAnonimo": "29",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 266,
    "ticketMedianoSimulado": 245,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 266,
    "maiorPedidoSimulado": 314,
    "menorPedidoSimulado": 187,
    "ticketMedioSimuladoFmt": "R$ 266",
    "ticketMedianoSimuladoFmt": "R$ 245",
    "valorTotalAcumuladoSimuladoFmt": "R$ 266",
    "maiorPedidoSimuladoFmt": "R$ 314",
    "menorPedidoSimuladoFmt": "R$ 187",
    "primeiraCompraSimulada": "01/04/2026",
    "ultimaCompraSimulada": "23/04/2026",
    "diasDesdeUltimaCompraSimulado": 21,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0030"
  },
  {
    "clienteId": "CLI_0031",
    "clienteAnonimo": "30",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 285,
    "ticketMedianoSimulado": 282,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 285,
    "maiorPedidoSimulado": 311,
    "menorPedidoSimulado": 170,
    "ticketMedioSimuladoFmt": "R$ 285",
    "ticketMedianoSimuladoFmt": "R$ 282",
    "valorTotalAcumuladoSimuladoFmt": "R$ 285",
    "maiorPedidoSimuladoFmt": "R$ 311",
    "menorPedidoSimuladoFmt": "R$ 170",
    "primeiraCompraSimulada": "11/04/2026",
    "ultimaCompraSimulada": "04/05/2026",
    "diasDesdeUltimaCompraSimulado": 10,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0031"
  },
  {
    "clienteId": "CLI_0032",
    "clienteAnonimo": "31",
    "segmentoComercial": "Cliente fiel",
    "ticketMedioSimulado": 693,
    "ticketMedianoSimulado": 649,
    "totalPedidosSimulado": 6,
    "valorTotalAcumuladoSimulado": 4158,
    "maiorPedidoSimulado": 762,
    "menorPedidoSimulado": 421,
    "ticketMedioSimuladoFmt": "R$ 693",
    "ticketMedianoSimuladoFmt": "R$ 649",
    "valorTotalAcumuladoSimuladoFmt": "R$ 4.158",
    "maiorPedidoSimuladoFmt": "R$ 762",
    "menorPedidoSimuladoFmt": "R$ 421",
    "primeiraCompraSimulada": "26/03/2026",
    "ultimaCompraSimulada": "11/05/2026",
    "diasDesdeUltimaCompraSimulado": 3,
    "hipoteseDePerfil": "Compra compatível com abastecimento maior, família ou rotina intensa.",
    "objetivoProvavel": "Pode buscar organização da semana e praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente alta lealdade — sugerir assinatura e acomp. calórico (com G06).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0032"
  },
  {
    "clienteId": "CLI_0033",
    "clienteAnonimo": "32",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 278,
    "ticketMedianoSimulado": 271,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 278,
    "maiorPedidoSimulado": 331,
    "menorPedidoSimulado": 198,
    "ticketMedioSimuladoFmt": "R$ 278",
    "ticketMedianoSimuladoFmt": "R$ 271",
    "valorTotalAcumuladoSimuladoFmt": "R$ 278",
    "maiorPedidoSimuladoFmt": "R$ 331",
    "menorPedidoSimuladoFmt": "R$ 198",
    "primeiraCompraSimulada": "10/03/2026",
    "ultimaCompraSimulada": "27/04/2026",
    "diasDesdeUltimaCompraSimulado": 17,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0033"
  },
  {
    "clienteId": "CLI_0034",
    "clienteAnonimo": "33",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 260,
    "ticketMedianoSimulado": 247,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 260,
    "maiorPedidoSimulado": 291,
    "menorPedidoSimulado": 164,
    "ticketMedioSimuladoFmt": "R$ 260",
    "ticketMedianoSimuladoFmt": "R$ 247",
    "valorTotalAcumuladoSimuladoFmt": "R$ 260",
    "maiorPedidoSimuladoFmt": "R$ 291",
    "menorPedidoSimuladoFmt": "R$ 164",
    "primeiraCompraSimulada": "22/02/2026",
    "ultimaCompraSimulada": "05/04/2026",
    "diasDesdeUltimaCompraSimulado": 39,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0034"
  },
  {
    "clienteId": "CLI_0035",
    "clienteAnonimo": "34",
    "segmentoComercial": "Cliente fiel",
    "ticketMedioSimulado": 577,
    "ticketMedianoSimulado": 555,
    "totalPedidosSimulado": 6,
    "valorTotalAcumuladoSimulado": 3462,
    "maiorPedidoSimulado": 617,
    "menorPedidoSimulado": 331,
    "ticketMedioSimuladoFmt": "R$ 577",
    "ticketMedianoSimuladoFmt": "R$ 555",
    "valorTotalAcumuladoSimuladoFmt": "R$ 3.462",
    "maiorPedidoSimuladoFmt": "R$ 617",
    "menorPedidoSimuladoFmt": "R$ 331",
    "primeiraCompraSimulada": "06/02/2026",
    "ultimaCompraSimulada": "12/04/2026",
    "diasDesdeUltimaCompraSimulado": 32,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar organização da semana e praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente alta lealdade — sugerir assinatura e acomp. calórico (com G06).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0035"
  },
  {
    "clienteId": "CLI_0036",
    "clienteAnonimo": "35",
    "segmentoComercial": "Cliente recorrente",
    "ticketMedioSimulado": 421,
    "ticketMedianoSimulado": 406,
    "totalPedidosSimulado": 4,
    "valorTotalAcumuladoSimulado": 1684,
    "maiorPedidoSimulado": 488,
    "menorPedidoSimulado": 286,
    "ticketMedioSimuladoFmt": "R$ 421",
    "ticketMedianoSimuladoFmt": "R$ 406",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.684",
    "maiorPedidoSimuladoFmt": "R$ 488",
    "menorPedidoSimuladoFmt": "R$ 286",
    "primeiraCompraSimulada": "21/01/2026",
    "ultimaCompraSimulada": "03/05/2026",
    "diasDesdeUltimaCompraSimulado": 11,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode buscar manter rotina alimentar",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0036"
  },
  {
    "clienteId": "CLI_0037",
    "clienteAnonimo": "36",
    "segmentoComercial": "Cliente possível coletivo",
    "ticketMedioSimulado": 1562,
    "ticketMedianoSimulado": 1480,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 1562,
    "maiorPedidoSimulado": 1796,
    "menorPedidoSimulado": 1041,
    "ticketMedioSimuladoFmt": "R$ 1.562",
    "ticketMedianoSimuladoFmt": "R$ 1.480",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.562",
    "maiorPedidoSimuladoFmt": "R$ 1.796",
    "menorPedidoSimuladoFmt": "R$ 1.041",
    "primeiraCompraSimulada": "05/01/2026",
    "ultimaCompraSimulada": "21/04/2026",
    "diasDesdeUltimaCompraSimulado": 23,
    "hipoteseDePerfil": "Possível compra coletiva, familiar ampliada ou corporativa. Não afirmar sem confirmação.",
    "objetivoProvavel": "Pode comprar para mais de uma pessoa, família ou equipe",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Tratar como hipótese de compra coletiva — G09 ativo.",
    "alertaSimulacao": "Possível compra familiar, equipe ou coletiva. Confirmar antes de assumir.",
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0037"
  },
  {
    "clienteId": "CLI_0038",
    "clienteAnonimo": "37",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 186,
    "ticketMedianoSimulado": 182,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 186,
    "maiorPedidoSimulado": 197,
    "menorPedidoSimulado": 104,
    "ticketMedioSimuladoFmt": "R$ 186",
    "ticketMedianoSimuladoFmt": "R$ 182",
    "valorTotalAcumuladoSimuladoFmt": "R$ 186",
    "maiorPedidoSimuladoFmt": "R$ 197",
    "menorPedidoSimuladoFmt": "R$ 104",
    "primeiraCompraSimulada": "20/12/2025",
    "ultimaCompraSimulada": "17/03/2026",
    "diasDesdeUltimaCompraSimulado": 58,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0038"
  },
  {
    "clienteId": "CLI_0039",
    "clienteAnonimo": "38",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 193,
    "ticketMedianoSimulado": 180,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 193,
    "maiorPedidoSimulado": 218,
    "menorPedidoSimulado": 124,
    "ticketMedioSimuladoFmt": "R$ 193",
    "ticketMedianoSimuladoFmt": "R$ 180",
    "valorTotalAcumuladoSimuladoFmt": "R$ 193",
    "maiorPedidoSimuladoFmt": "R$ 218",
    "menorPedidoSimuladoFmt": "R$ 124",
    "primeiraCompraSimulada": "04/12/2025",
    "ultimaCompraSimulada": "12/03/2026",
    "diasDesdeUltimaCompraSimulado": 63,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0039"
  },
  {
    "clienteId": "CLI_0040",
    "clienteAnonimo": "39",
    "segmentoComercial": "Cliente fiel",
    "ticketMedioSimulado": 498,
    "ticketMedianoSimulado": 458,
    "totalPedidosSimulado": 5,
    "valorTotalAcumuladoSimulado": 2490,
    "maiorPedidoSimulado": 595,
    "menorPedidoSimulado": 359,
    "ticketMedioSimuladoFmt": "R$ 498",
    "ticketMedianoSimuladoFmt": "R$ 458",
    "valorTotalAcumuladoSimuladoFmt": "R$ 2.490",
    "maiorPedidoSimuladoFmt": "R$ 595",
    "menorPedidoSimuladoFmt": "R$ 359",
    "primeiraCompraSimulada": "09/11/2025",
    "ultimaCompraSimulada": "09/04/2026",
    "diasDesdeUltimaCompraSimulado": 35,
    "hipoteseDePerfil": "Compra compatível com abastecimento maior, família ou rotina intensa.",
    "objetivoProvavel": "Pode buscar organização da semana e praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente alta lealdade — sugerir assinatura e acomp. calórico (com G06).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0040"
  },
  {
    "clienteId": "CLI_0041",
    "clienteAnonimo": "40",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 184,
    "ticketMedianoSimulado": 183,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 184,
    "maiorPedidoSimulado": 205,
    "menorPedidoSimulado": 115,
    "ticketMedioSimuladoFmt": "R$ 184",
    "ticketMedianoSimuladoFmt": "R$ 183",
    "valorTotalAcumuladoSimuladoFmt": "R$ 184",
    "maiorPedidoSimuladoFmt": "R$ 205",
    "menorPedidoSimuladoFmt": "R$ 115",
    "primeiraCompraSimulada": "25/11/2025",
    "ultimaCompraSimulada": "04/03/2026",
    "diasDesdeUltimaCompraSimulado": 71,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0041"
  },
  {
    "clienteId": "CLI_0042",
    "clienteAnonimo": "41",
    "segmentoComercial": "Cliente fiel",
    "ticketMedioSimulado": 479,
    "ticketMedianoSimulado": 447,
    "totalPedidosSimulado": 6,
    "valorTotalAcumuladoSimulado": 2874,
    "maiorPedidoSimulado": 515,
    "menorPedidoSimulado": 278,
    "ticketMedioSimuladoFmt": "R$ 479",
    "ticketMedianoSimuladoFmt": "R$ 447",
    "valorTotalAcumuladoSimuladoFmt": "R$ 2.874",
    "maiorPedidoSimuladoFmt": "R$ 515",
    "menorPedidoSimuladoFmt": "R$ 278",
    "primeiraCompraSimulada": "11/12/2025",
    "ultimaCompraSimulada": "17/03/2026",
    "diasDesdeUltimaCompraSimulado": 58,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar organização da semana e praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente alta lealdade — sugerir assinatura e acomp. calórico (com G06).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0042"
  },
  {
    "clienteId": "CLI_0043",
    "clienteAnonimo": "42",
    "segmentoComercial": "Cliente fiel",
    "ticketMedioSimulado": 518,
    "ticketMedianoSimulado": 507,
    "totalPedidosSimulado": 7,
    "valorTotalAcumuladoSimulado": 3626,
    "maiorPedidoSimulado": 604,
    "menorPedidoSimulado": 355,
    "ticketMedioSimuladoFmt": "R$ 518",
    "ticketMedianoSimuladoFmt": "R$ 507",
    "valorTotalAcumuladoSimuladoFmt": "R$ 3.626",
    "maiorPedidoSimuladoFmt": "R$ 604",
    "menorPedidoSimuladoFmt": "R$ 355",
    "primeiraCompraSimulada": "27/12/2025",
    "ultimaCompraSimulada": "23/04/2026",
    "diasDesdeUltimaCompraSimulado": 21,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode buscar organização da semana e praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente alta lealdade — sugerir assinatura e acomp. calórico (com G06).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0043"
  },
  {
    "clienteId": "CLI_0044",
    "clienteAnonimo": "43",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 231,
    "ticketMedianoSimulado": 219,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 231,
    "maiorPedidoSimulado": 264,
    "menorPedidoSimulado": 152,
    "ticketMedioSimuladoFmt": "R$ 231",
    "ticketMedianoSimuladoFmt": "R$ 219",
    "valorTotalAcumuladoSimuladoFmt": "R$ 231",
    "maiorPedidoSimuladoFmt": "R$ 264",
    "menorPedidoSimuladoFmt": "R$ 152",
    "primeiraCompraSimulada": "12/01/2026",
    "ultimaCompraSimulada": "29/04/2026",
    "diasDesdeUltimaCompraSimulado": 15,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0044"
  },
  {
    "clienteId": "CLI_0045",
    "clienteAnonimo": "44",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 250,
    "ticketMedianoSimulado": 241,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 250,
    "maiorPedidoSimulado": 263,
    "menorPedidoSimulado": 138,
    "ticketMedioSimuladoFmt": "R$ 250",
    "ticketMedianoSimuladoFmt": "R$ 241",
    "valorTotalAcumuladoSimuladoFmt": "R$ 250",
    "maiorPedidoSimuladoFmt": "R$ 263",
    "menorPedidoSimuladoFmt": "R$ 138",
    "primeiraCompraSimulada": "28/01/2026",
    "ultimaCompraSimulada": "07/04/2026",
    "diasDesdeUltimaCompraSimulado": 37,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0045"
  },
  {
    "clienteId": "CLI_0046",
    "clienteAnonimo": "45",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 268,
    "ticketMedianoSimulado": 258,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 268,
    "maiorPedidoSimulado": 305,
    "menorPedidoSimulado": 175,
    "ticketMedioSimuladoFmt": "R$ 268",
    "ticketMedianoSimuladoFmt": "R$ 258",
    "valorTotalAcumuladoSimuladoFmt": "R$ 268",
    "maiorPedidoSimuladoFmt": "R$ 305",
    "menorPedidoSimuladoFmt": "R$ 175",
    "primeiraCompraSimulada": "13/02/2026",
    "ultimaCompraSimulada": "03/04/2026",
    "diasDesdeUltimaCompraSimulado": 41,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0046"
  },
  {
    "clienteId": "CLI_0047",
    "clienteAnonimo": "46",
    "segmentoComercial": "Cliente fiel",
    "ticketMedioSimulado": 672,
    "ticketMedianoSimulado": 639,
    "totalPedidosSimulado": 5,
    "valorTotalAcumuladoSimulado": 3360,
    "maiorPedidoSimulado": 788,
    "menorPedidoSimulado": 466,
    "ticketMedioSimuladoFmt": "R$ 672",
    "ticketMedianoSimuladoFmt": "R$ 639",
    "valorTotalAcumuladoSimuladoFmt": "R$ 3.360",
    "maiorPedidoSimuladoFmt": "R$ 788",
    "menorPedidoSimuladoFmt": "R$ 466",
    "primeiraCompraSimulada": "01/03/2026",
    "ultimaCompraSimulada": "27/04/2026",
    "diasDesdeUltimaCompraSimulado": 17,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode buscar organização da semana e praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente alta lealdade — sugerir assinatura e acomp. calórico (com G06).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0047"
  },
  {
    "clienteId": "CLI_0048",
    "clienteAnonimo": "47",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 295,
    "ticketMedianoSimulado": 288,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 295,
    "maiorPedidoSimulado": 319,
    "menorPedidoSimulado": 173,
    "ticketMedioSimuladoFmt": "R$ 295",
    "ticketMedianoSimuladoFmt": "R$ 288",
    "valorTotalAcumuladoSimuladoFmt": "R$ 295",
    "maiorPedidoSimuladoFmt": "R$ 319",
    "menorPedidoSimuladoFmt": "R$ 173",
    "primeiraCompraSimulada": "17/03/2026",
    "ultimaCompraSimulada": "09/05/2026",
    "diasDesdeUltimaCompraSimulado": 5,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0048"
  },
  {
    "clienteId": "CLI_0049",
    "clienteAnonimo": "48",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 276,
    "ticketMedianoSimulado": 258,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 276,
    "maiorPedidoSimulado": 306,
    "menorPedidoSimulado": 170,
    "ticketMedioSimuladoFmt": "R$ 276",
    "ticketMedianoSimuladoFmt": "R$ 258",
    "valorTotalAcumuladoSimuladoFmt": "R$ 276",
    "maiorPedidoSimuladoFmt": "R$ 306",
    "menorPedidoSimuladoFmt": "R$ 170",
    "primeiraCompraSimulada": "02/04/2026",
    "ultimaCompraSimulada": "01/05/2026",
    "diasDesdeUltimaCompraSimulado": 13,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0049"
  },
  {
    "clienteId": "CLI_0050",
    "clienteAnonimo": "49",
    "segmentoComercial": "Cliente recorrente",
    "ticketMedioSimulado": 530,
    "ticketMedianoSimulado": 489,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 1060,
    "maiorPedidoSimulado": 621,
    "menorPedidoSimulado": 367,
    "ticketMedioSimuladoFmt": "R$ 530",
    "ticketMedianoSimuladoFmt": "R$ 489",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.060",
    "maiorPedidoSimuladoFmt": "R$ 621",
    "menorPedidoSimuladoFmt": "R$ 367",
    "primeiraCompraSimulada": "09/03/2026",
    "ultimaCompraSimulada": "29/04/2026",
    "diasDesdeUltimaCompraSimulado": 15,
    "hipoteseDePerfil": "Compra compatível com abastecimento maior, família ou rotina intensa.",
    "objetivoProvavel": "Pode buscar manter rotina alimentar",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0050"
  },
  {
    "clienteId": "CLI_0051",
    "clienteAnonimo": "50",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 294,
    "ticketMedianoSimulado": 293,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 294,
    "maiorPedidoSimulado": 334,
    "menorPedidoSimulado": 192,
    "ticketMedioSimuladoFmt": "R$ 294",
    "ticketMedianoSimuladoFmt": "R$ 293",
    "valorTotalAcumuladoSimuladoFmt": "R$ 294",
    "maiorPedidoSimuladoFmt": "R$ 334",
    "menorPedidoSimuladoFmt": "R$ 192",
    "primeiraCompraSimulada": "21/02/2026",
    "ultimaCompraSimulada": "07/05/2026",
    "diasDesdeUltimaCompraSimulado": 7,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0051"
  },
  {
    "clienteId": "CLI_0052",
    "clienteAnonimo": "51",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 275,
    "ticketMedianoSimulado": 256,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 275,
    "maiorPedidoSimulado": 290,
    "menorPedidoSimulado": 152,
    "ticketMedioSimuladoFmt": "R$ 275",
    "ticketMedianoSimuladoFmt": "R$ 256",
    "valorTotalAcumuladoSimuladoFmt": "R$ 275",
    "maiorPedidoSimuladoFmt": "R$ 290",
    "menorPedidoSimuladoFmt": "R$ 152",
    "primeiraCompraSimulada": "05/02/2026",
    "ultimaCompraSimulada": "15/04/2026",
    "diasDesdeUltimaCompraSimulado": 29,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0052"
  },
  {
    "clienteId": "CLI_0053",
    "clienteAnonimo": "52",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 257,
    "ticketMedianoSimulado": 252,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 257,
    "maiorPedidoSimulado": 294,
    "menorPedidoSimulado": 169,
    "ticketMedioSimuladoFmt": "R$ 257",
    "ticketMedianoSimuladoFmt": "R$ 252",
    "valorTotalAcumuladoSimuladoFmt": "R$ 257",
    "maiorPedidoSimuladoFmt": "R$ 294",
    "menorPedidoSimuladoFmt": "R$ 169",
    "primeiraCompraSimulada": "20/01/2026",
    "ultimaCompraSimulada": "17/03/2026",
    "diasDesdeUltimaCompraSimulado": 58,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0053"
  },
  {
    "clienteId": "CLI_0054",
    "clienteAnonimo": "53",
    "segmentoComercial": "Cliente fiel",
    "ticketMedioSimulado": 571,
    "ticketMedianoSimulado": 540,
    "totalPedidosSimulado": 7,
    "valorTotalAcumuladoSimulado": 3997,
    "maiorPedidoSimulado": 666,
    "menorPedidoSimulado": 392,
    "ticketMedioSimuladoFmt": "R$ 571",
    "ticketMedianoSimuladoFmt": "R$ 540",
    "valorTotalAcumuladoSimuladoFmt": "R$ 3.997",
    "maiorPedidoSimuladoFmt": "R$ 666",
    "menorPedidoSimuladoFmt": "R$ 392",
    "primeiraCompraSimulada": "04/01/2026",
    "ultimaCompraSimulada": "08/04/2026",
    "diasDesdeUltimaCompraSimulado": 36,
    "hipoteseDePerfil": "Compra compatível com abastecimento maior, família ou rotina intensa.",
    "objetivoProvavel": "Pode buscar organização da semana e praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente alta lealdade — sugerir assinatura e acomp. calórico (com G06).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0054"
  },
  {
    "clienteId": "CLI_0055",
    "clienteAnonimo": "54",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 220,
    "ticketMedianoSimulado": 213,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 220,
    "maiorPedidoSimulado": 237,
    "menorPedidoSimulado": 128,
    "ticketMedioSimuladoFmt": "R$ 220",
    "ticketMedianoSimuladoFmt": "R$ 213",
    "valorTotalAcumuladoSimuladoFmt": "R$ 220",
    "maiorPedidoSimuladoFmt": "R$ 237",
    "menorPedidoSimuladoFmt": "R$ 128",
    "primeiraCompraSimulada": "19/12/2025",
    "ultimaCompraSimulada": "07/05/2026",
    "diasDesdeUltimaCompraSimulado": 7,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0055"
  },
  {
    "clienteId": "CLI_0056",
    "clienteAnonimo": "55",
    "segmentoComercial": "Cliente recorrente",
    "ticketMedioSimulado": 385,
    "ticketMedianoSimulado": 370,
    "totalPedidosSimulado": 4,
    "valorTotalAcumuladoSimulado": 1540,
    "maiorPedidoSimulado": 429,
    "menorPedidoSimulado": 240,
    "ticketMedioSimuladoFmt": "R$ 385",
    "ticketMedianoSimuladoFmt": "R$ 370",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.540",
    "maiorPedidoSimuladoFmt": "R$ 429",
    "menorPedidoSimuladoFmt": "R$ 240",
    "primeiraCompraSimulada": "03/12/2025",
    "ultimaCompraSimulada": "09/04/2026",
    "diasDesdeUltimaCompraSimulado": 35,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar manter rotina alimentar",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0056"
  },
  {
    "clienteId": "CLI_0057",
    "clienteAnonimo": "56",
    "segmentoComercial": "Cliente fiel",
    "ticketMedioSimulado": 455,
    "ticketMedianoSimulado": 433,
    "totalPedidosSimulado": 5,
    "valorTotalAcumuladoSimulado": 2275,
    "maiorPedidoSimulado": 544,
    "menorPedidoSimulado": 328,
    "ticketMedioSimuladoFmt": "R$ 455",
    "ticketMedianoSimuladoFmt": "R$ 433",
    "valorTotalAcumuladoSimuladoFmt": "R$ 2.275",
    "maiorPedidoSimuladoFmt": "R$ 544",
    "menorPedidoSimuladoFmt": "R$ 328",
    "primeiraCompraSimulada": "17/11/2025",
    "ultimaCompraSimulada": "24/02/2026",
    "diasDesdeUltimaCompraSimulado": 79,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode buscar organização da semana e praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente alta lealdade — sugerir assinatura e acomp. calórico (com G06).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0057"
  },
  {
    "clienteId": "CLI_0058",
    "clienteAnonimo": "57",
    "segmentoComercial": "Cliente recorrente",
    "ticketMedioSimulado": 377,
    "ticketMedianoSimulado": 367,
    "totalPedidosSimulado": 5,
    "valorTotalAcumuladoSimulado": 1885,
    "maiorPedidoSimulado": 417,
    "menorPedidoSimulado": 232,
    "ticketMedioSimuladoFmt": "R$ 377",
    "ticketMedianoSimuladoFmt": "R$ 367",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.885",
    "maiorPedidoSimuladoFmt": "R$ 417",
    "menorPedidoSimuladoFmt": "R$ 232",
    "primeiraCompraSimulada": "01/11/2025",
    "ultimaCompraSimulada": "08/03/2026",
    "diasDesdeUltimaCompraSimulado": 67,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar manter rotina alimentar",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0058"
  },
  {
    "clienteId": "CLI_0059",
    "clienteAnonimo": "58",
    "segmentoComercial": "Cliente alto valor",
    "ticketMedioSimulado": 943,
    "ticketMedianoSimulado": 885,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 2829,
    "maiorPedidoSimulado": 1023,
    "menorPedidoSimulado": 557,
    "ticketMedioSimuladoFmt": "R$ 943",
    "ticketMedianoSimuladoFmt": "R$ 885",
    "valorTotalAcumuladoSimuladoFmt": "R$ 2.829",
    "maiorPedidoSimuladoFmt": "R$ 1.023",
    "menorPedidoSimuladoFmt": "R$ 557",
    "primeiraCompraSimulada": "10/11/2025",
    "ultimaCompraSimulada": "22/04/2026",
    "diasDesdeUltimaCompraSimulado": 22,
    "hipoteseDePerfil": "Compra compatível com abastecimento maior, família ou rotina intensa.",
    "objetivoProvavel": "Pode buscar abastecimento maior ou comprar para várias pessoas",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0059"
  },
  {
    "clienteId": "CLI_0060",
    "clienteAnonimo": "59",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 181,
    "ticketMedianoSimulado": 168,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 181,
    "maiorPedidoSimulado": 208,
    "menorPedidoSimulado": 121,
    "ticketMedioSimuladoFmt": "R$ 181",
    "ticketMedianoSimuladoFmt": "R$ 168",
    "valorTotalAcumuladoSimuladoFmt": "R$ 181",
    "maiorPedidoSimuladoFmt": "R$ 208",
    "menorPedidoSimuladoFmt": "R$ 121",
    "primeiraCompraSimulada": "29/12/2025",
    "ultimaCompraSimulada": "12/03/2026",
    "diasDesdeUltimaCompraSimulado": 63,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0060"
  },
  {
    "clienteId": "CLI_0061",
    "clienteAnonimo": "60",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 197,
    "ticketMedianoSimulado": 197,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 197,
    "maiorPedidoSimulado": 229,
    "menorPedidoSimulado": 134,
    "ticketMedioSimuladoFmt": "R$ 197",
    "ticketMedianoSimuladoFmt": "R$ 197",
    "valorTotalAcumuladoSimuladoFmt": "R$ 197",
    "maiorPedidoSimuladoFmt": "R$ 229",
    "menorPedidoSimuladoFmt": "R$ 134",
    "primeiraCompraSimulada": "14/01/2026",
    "ultimaCompraSimulada": "04/04/2026",
    "diasDesdeUltimaCompraSimulado": 40,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0061"
  },
  {
    "clienteId": "CLI_0062",
    "clienteAnonimo": "61",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 216,
    "ticketMedianoSimulado": 201,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 216,
    "maiorPedidoSimulado": 231,
    "menorPedidoSimulado": 124,
    "ticketMedioSimuladoFmt": "R$ 216",
    "ticketMedianoSimuladoFmt": "R$ 201",
    "valorTotalAcumuladoSimuladoFmt": "R$ 216",
    "maiorPedidoSimuladoFmt": "R$ 231",
    "menorPedidoSimuladoFmt": "R$ 124",
    "primeiraCompraSimulada": "30/01/2026",
    "ultimaCompraSimulada": "02/05/2026",
    "diasDesdeUltimaCompraSimulado": 12,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0062"
  },
  {
    "clienteId": "CLI_0063",
    "clienteAnonimo": "62",
    "segmentoComercial": "Cliente fiel",
    "ticketMedioSimulado": 563,
    "ticketMedianoSimulado": 554,
    "totalPedidosSimulado": 7,
    "valorTotalAcumuladoSimulado": 3941,
    "maiorPedidoSimulado": 631,
    "menorPedidoSimulado": 356,
    "ticketMedioSimuladoFmt": "R$ 563",
    "ticketMedianoSimuladoFmt": "R$ 554",
    "valorTotalAcumuladoSimuladoFmt": "R$ 3.941",
    "maiorPedidoSimuladoFmt": "R$ 631",
    "menorPedidoSimuladoFmt": "R$ 356",
    "primeiraCompraSimulada": "15/02/2026",
    "ultimaCompraSimulada": "29/04/2026",
    "diasDesdeUltimaCompraSimulado": 15,
    "hipoteseDePerfil": "Compra compatível com abastecimento maior, família ou rotina intensa.",
    "objetivoProvavel": "Pode buscar organização da semana e praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente alta lealdade — sugerir assinatura e acomp. calórico (com G06).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0063"
  },
  {
    "clienteId": "CLI_0064",
    "clienteAnonimo": "63",
    "segmentoComercial": "Cliente alto valor",
    "ticketMedioSimulado": 1047,
    "ticketMedianoSimulado": 988,
    "totalPedidosSimulado": 5,
    "valorTotalAcumuladoSimulado": 5235,
    "maiorPedidoSimulado": 1246,
    "menorPedidoSimulado": 747,
    "ticketMedioSimuladoFmt": "R$ 1.047",
    "ticketMedianoSimuladoFmt": "R$ 988",
    "valorTotalAcumuladoSimuladoFmt": "R$ 5.235",
    "maiorPedidoSimuladoFmt": "R$ 1.246",
    "menorPedidoSimuladoFmt": "R$ 747",
    "primeiraCompraSimulada": "03/03/2026",
    "ultimaCompraSimulada": "15/04/2026",
    "diasDesdeUltimaCompraSimulado": 29,
    "hipoteseDePerfil": "Compra compatível com abastecimento maior, família ou rotina intensa.",
    "objetivoProvavel": "Pode buscar abastecimento maior ou comprar para várias pessoas",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0064"
  },
  {
    "clienteId": "CLI_0065",
    "clienteAnonimo": "64",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 271,
    "ticketMedianoSimulado": 263,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 271,
    "maiorPedidoSimulado": 298,
    "menorPedidoSimulado": 165,
    "ticketMedioSimuladoFmt": "R$ 271",
    "ticketMedianoSimuladoFmt": "R$ 263",
    "valorTotalAcumuladoSimuladoFmt": "R$ 271",
    "maiorPedidoSimuladoFmt": "R$ 298",
    "menorPedidoSimuladoFmt": "R$ 165",
    "primeiraCompraSimulada": "18/03/2026",
    "ultimaCompraSimulada": "20/04/2026",
    "diasDesdeUltimaCompraSimulado": 24,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0065"
  },
  {
    "clienteId": "CLI_0066",
    "clienteAnonimo": "65",
    "segmentoComercial": "Cliente recorrente",
    "ticketMedioSimulado": 533,
    "ticketMedianoSimulado": 510,
    "totalPedidosSimulado": 4,
    "valorTotalAcumuladoSimulado": 2132,
    "maiorPedidoSimulado": 581,
    "menorPedidoSimulado": 318,
    "ticketMedioSimuladoFmt": "R$ 533",
    "ticketMedianoSimuladoFmt": "R$ 510",
    "valorTotalAcumuladoSimuladoFmt": "R$ 2.132",
    "maiorPedidoSimuladoFmt": "R$ 581",
    "menorPedidoSimuladoFmt": "R$ 318",
    "primeiraCompraSimulada": "03/04/2026",
    "ultimaCompraSimulada": "05/05/2026",
    "diasDesdeUltimaCompraSimulado": 9,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode buscar manter rotina alimentar",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0066"
  },
  {
    "clienteId": "CLI_0067",
    "clienteAnonimo": "66",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 292,
    "ticketMedianoSimulado": 279,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 292,
    "maiorPedidoSimulado": 345,
    "menorPedidoSimulado": 205,
    "ticketMedioSimuladoFmt": "R$ 292",
    "ticketMedianoSimuladoFmt": "R$ 279",
    "valorTotalAcumuladoSimuladoFmt": "R$ 292",
    "maiorPedidoSimuladoFmt": "R$ 345",
    "menorPedidoSimuladoFmt": "R$ 205",
    "primeiraCompraSimulada": "09/04/2026",
    "ultimaCompraSimulada": "09/05/2026",
    "diasDesdeUltimaCompraSimulado": 5,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0067"
  },
  {
    "clienteId": "CLI_0068",
    "clienteAnonimo": "67",
    "segmentoComercial": "Cliente recorrente",
    "ticketMedioSimulado": 505,
    "ticketMedianoSimulado": 491,
    "totalPedidosSimulado": 5,
    "valorTotalAcumuladoSimulado": 2525,
    "maiorPedidoSimulado": 570,
    "menorPedidoSimulado": 324,
    "ticketMedioSimuladoFmt": "R$ 505",
    "ticketMedianoSimuladoFmt": "R$ 491",
    "valorTotalAcumuladoSimuladoFmt": "R$ 2.525",
    "maiorPedidoSimuladoFmt": "R$ 570",
    "menorPedidoSimuladoFmt": "R$ 324",
    "primeiraCompraSimulada": "24/03/2026",
    "ultimaCompraSimulada": "26/04/2026",
    "diasDesdeUltimaCompraSimulado": 18,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode buscar manter rotina alimentar",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0068"
  },
  {
    "clienteId": "CLI_0069",
    "clienteAnonimo": "68",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 255,
    "ticketMedianoSimulado": 240,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 255,
    "maiorPedidoSimulado": 271,
    "menorPedidoSimulado": 144,
    "ticketMedioSimuladoFmt": "R$ 255",
    "ticketMedianoSimuladoFmt": "R$ 240",
    "valorTotalAcumuladoSimuladoFmt": "R$ 255",
    "maiorPedidoSimuladoFmt": "R$ 271",
    "menorPedidoSimuladoFmt": "R$ 144",
    "primeiraCompraSimulada": "08/03/2026",
    "ultimaCompraSimulada": "11/04/2026",
    "diasDesdeUltimaCompraSimulado": 33,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0069"
  },
  {
    "clienteId": "CLI_0070",
    "clienteAnonimo": "69",
    "segmentoComercial": "Cliente fiel",
    "ticketMedioSimulado": 680,
    "ticketMedianoSimulado": 631,
    "totalPedidosSimulado": 5,
    "valorTotalAcumuladoSimulado": 3400,
    "maiorPedidoSimulado": 766,
    "menorPedidoSimulado": 435,
    "ticketMedioSimuladoFmt": "R$ 680",
    "ticketMedianoSimuladoFmt": "R$ 631",
    "valorTotalAcumuladoSimuladoFmt": "R$ 3.400",
    "maiorPedidoSimuladoFmt": "R$ 766",
    "menorPedidoSimuladoFmt": "R$ 435",
    "primeiraCompraSimulada": "18/01/2026",
    "ultimaCompraSimulada": "01/05/2026",
    "diasDesdeUltimaCompraSimulado": 13,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode buscar organização da semana e praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente alta lealdade — sugerir assinatura e acomp. calórico (com G06).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0070"
  },
  {
    "clienteId": "CLI_0071",
    "clienteAnonimo": "70",
    "segmentoComercial": "Cliente baixo ticket",
    "ticketMedioSimulado": 118,
    "ticketMedianoSimulado": 118,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 236,
    "maiorPedidoSimulado": 140,
    "menorPedidoSimulado": 83,
    "ticketMedioSimuladoFmt": "R$ 118",
    "ticketMedianoSimuladoFmt": "R$ 118",
    "valorTotalAcumuladoSimuladoFmt": "R$ 236",
    "maiorPedidoSimuladoFmt": "R$ 140",
    "menorPedidoSimuladoFmt": "R$ 83",
    "primeiraCompraSimulada": "02/01/2026",
    "ultimaCompraSimulada": "31/03/2026",
    "diasDesdeUltimaCompraSimulado": 44,
    "hipoteseDePerfil": "Cliente em fase de teste ou primeira experiência.",
    "objetivoProvavel": "Pode estar testando a marca",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0071"
  },
  {
    "clienteId": "CLI_0072",
    "clienteAnonimo": "71",
    "segmentoComercial": "Cliente fiel",
    "ticketMedioSimulado": 603,
    "ticketMedianoSimulado": 559,
    "totalPedidosSimulado": 6,
    "valorTotalAcumuladoSimulado": 3618,
    "maiorPedidoSimulado": 659,
    "menorPedidoSimulado": 362,
    "ticketMedioSimuladoFmt": "R$ 603",
    "ticketMedianoSimuladoFmt": "R$ 559",
    "valorTotalAcumuladoSimuladoFmt": "R$ 3.618",
    "maiorPedidoSimuladoFmt": "R$ 659",
    "menorPedidoSimuladoFmt": "R$ 362",
    "primeiraCompraSimulada": "17/12/2025",
    "ultimaCompraSimulada": "07/03/2026",
    "diasDesdeUltimaCompraSimulado": 68,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar organização da semana e praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente alta lealdade — sugerir assinatura e acomp. calórico (com G06).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0072"
  },
  {
    "clienteId": "CLI_0073",
    "clienteAnonimo": "72",
    "segmentoComercial": "Cliente recorrente",
    "ticketMedioSimulado": 442,
    "ticketMedianoSimulado": 436,
    "totalPedidosSimulado": 4,
    "valorTotalAcumuladoSimulado": 1768,
    "maiorPedidoSimulado": 485,
    "menorPedidoSimulado": 267,
    "ticketMedioSimuladoFmt": "R$ 442",
    "ticketMedianoSimuladoFmt": "R$ 436",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.768",
    "maiorPedidoSimuladoFmt": "R$ 485",
    "menorPedidoSimuladoFmt": "R$ 267",
    "primeiraCompraSimulada": "01/12/2025",
    "ultimaCompraSimulada": "06/04/2026",
    "diasDesdeUltimaCompraSimulado": 38,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode buscar manter rotina alimentar",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0073"
  },
  {
    "clienteId": "CLI_0074",
    "clienteAnonimo": "73",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 216,
    "ticketMedianoSimulado": 203,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 216,
    "maiorPedidoSimulado": 256,
    "menorPedidoSimulado": 153,
    "ticketMedioSimuladoFmt": "R$ 216",
    "ticketMedianoSimuladoFmt": "R$ 203",
    "valorTotalAcumuladoSimuladoFmt": "R$ 216",
    "maiorPedidoSimuladoFmt": "R$ 256",
    "menorPedidoSimuladoFmt": "R$ 153",
    "primeiraCompraSimulada": "15/11/2025",
    "ultimaCompraSimulada": "08/05/2026",
    "diasDesdeUltimaCompraSimulado": 6,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0074"
  },
  {
    "clienteId": "CLI_0075",
    "clienteAnonimo": "74",
    "segmentoComercial": "Cliente baixo ticket",
    "ticketMedioSimulado": 87,
    "ticketMedianoSimulado": 85,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 87,
    "maiorPedidoSimulado": 98,
    "menorPedidoSimulado": 55,
    "ticketMedioSimuladoFmt": "R$ 87",
    "ticketMedianoSimuladoFmt": "R$ 85",
    "valorTotalAcumuladoSimuladoFmt": "R$ 87",
    "maiorPedidoSimuladoFmt": "R$ 98",
    "menorPedidoSimuladoFmt": "R$ 55",
    "primeiraCompraSimulada": "30/10/2025",
    "ultimaCompraSimulada": "24/03/2026",
    "diasDesdeUltimaCompraSimulado": 51,
    "hipoteseDePerfil": "Cliente em fase de teste ou primeira experiência.",
    "objetivoProvavel": "Pode estar testando a marca",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0075"
  },
  {
    "clienteId": "CLI_0076",
    "clienteAnonimo": "75",
    "segmentoComercial": "Cliente baixo ticket",
    "ticketMedioSimulado": 80,
    "ticketMedianoSimulado": 76,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 160,
    "maiorPedidoSimulado": 85,
    "menorPedidoSimulado": 46,
    "ticketMedioSimuladoFmt": "R$ 80",
    "ticketMedianoSimuladoFmt": "R$ 76",
    "valorTotalAcumuladoSimuladoFmt": "R$ 160",
    "maiorPedidoSimuladoFmt": "R$ 85",
    "menorPedidoSimuladoFmt": "R$ 46",
    "primeiraCompraSimulada": "12/11/2025",
    "ultimaCompraSimulada": "14/02/2026",
    "diasDesdeUltimaCompraSimulado": 89,
    "hipoteseDePerfil": "Cliente em fase de teste ou primeira experiência.",
    "objetivoProvavel": "Pode estar testando a marca",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0076"
  },
  {
    "clienteId": "CLI_0077",
    "clienteAnonimo": "76",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 199,
    "ticketMedianoSimulado": 191,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 199,
    "maiorPedidoSimulado": 230,
    "menorPedidoSimulado": 134,
    "ticketMedioSimuladoFmt": "R$ 199",
    "ticketMedianoSimuladoFmt": "R$ 191",
    "valorTotalAcumuladoSimuladoFmt": "R$ 199",
    "maiorPedidoSimuladoFmt": "R$ 230",
    "menorPedidoSimuladoFmt": "R$ 134",
    "primeiraCompraSimulada": "28/11/2025",
    "ultimaCompraSimulada": "24/03/2026",
    "diasDesdeUltimaCompraSimulado": 51,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0077"
  },
  {
    "clienteId": "CLI_0078",
    "clienteAnonimo": "77",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 218,
    "ticketMedianoSimulado": 211,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 218,
    "maiorPedidoSimulado": 251,
    "menorPedidoSimulado": 146,
    "ticketMedioSimuladoFmt": "R$ 218",
    "ticketMedianoSimuladoFmt": "R$ 211",
    "valorTotalAcumuladoSimuladoFmt": "R$ 218",
    "maiorPedidoSimuladoFmt": "R$ 251",
    "menorPedidoSimuladoFmt": "R$ 146",
    "primeiraCompraSimulada": "14/12/2025",
    "ultimaCompraSimulada": "02/05/2026",
    "diasDesdeUltimaCompraSimulado": 12,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0078"
  },
  {
    "clienteId": "CLI_0079",
    "clienteAnonimo": "78",
    "segmentoComercial": "Cliente recorrente",
    "ticketMedioSimulado": 443,
    "ticketMedianoSimulado": 418,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 886,
    "maiorPedidoSimulado": 470,
    "menorPedidoSimulado": 250,
    "ticketMedioSimuladoFmt": "R$ 443",
    "ticketMedianoSimuladoFmt": "R$ 418",
    "valorTotalAcumuladoSimuladoFmt": "R$ 886",
    "maiorPedidoSimuladoFmt": "R$ 470",
    "menorPedidoSimuladoFmt": "R$ 250",
    "primeiraCompraSimulada": "30/12/2025",
    "ultimaCompraSimulada": "18/04/2026",
    "diasDesdeUltimaCompraSimulado": 26,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode buscar manter rotina alimentar",
    "propensaoARecompra": "Alta",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0079"
  },
  {
    "clienteId": "CLI_0080",
    "clienteAnonimo": "79",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 200,
    "ticketMedianoSimulado": 186,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 200,
    "maiorPedidoSimulado": 221,
    "menorPedidoSimulado": 122,
    "ticketMedioSimuladoFmt": "R$ 200",
    "ticketMedianoSimuladoFmt": "R$ 186",
    "valorTotalAcumuladoSimuladoFmt": "R$ 200",
    "maiorPedidoSimuladoFmt": "R$ 221",
    "menorPedidoSimuladoFmt": "R$ 122",
    "primeiraCompraSimulada": "16/02/2026",
    "ultimaCompraSimulada": "18/04/2026",
    "diasDesdeUltimaCompraSimulado": 26,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0080"
  },
  {
    "clienteId": "CLI_0081",
    "clienteAnonimo": "80",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 219,
    "ticketMedianoSimulado": 218,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 219,
    "maiorPedidoSimulado": 261,
    "menorPedidoSimulado": 157,
    "ticketMedioSimuladoFmt": "R$ 219",
    "ticketMedianoSimuladoFmt": "R$ 218",
    "valorTotalAcumuladoSimuladoFmt": "R$ 219",
    "maiorPedidoSimuladoFmt": "R$ 261",
    "menorPedidoSimuladoFmt": "R$ 157",
    "primeiraCompraSimulada": "04/03/2026",
    "ultimaCompraSimulada": "08/05/2026",
    "diasDesdeUltimaCompraSimulado": 6,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0081"
  },
  {
    "clienteId": "CLI_0082",
    "clienteAnonimo": "81",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 237,
    "ticketMedianoSimulado": 219,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 237,
    "maiorPedidoSimulado": 265,
    "menorPedidoSimulado": 149,
    "ticketMedioSimuladoFmt": "R$ 237",
    "ticketMedianoSimuladoFmt": "R$ 219",
    "valorTotalAcumuladoSimuladoFmt": "R$ 237",
    "maiorPedidoSimuladoFmt": "R$ 265",
    "menorPedidoSimuladoFmt": "R$ 149",
    "primeiraCompraSimulada": "20/03/2026",
    "ultimaCompraSimulada": "01/05/2026",
    "diasDesdeUltimaCompraSimulado": 13,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0082"
  },
  {
    "clienteId": "CLI_0083",
    "clienteAnonimo": "82",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 256,
    "ticketMedianoSimulado": 253,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 256,
    "maiorPedidoSimulado": 275,
    "menorPedidoSimulado": 148,
    "ticketMedioSimuladoFmt": "R$ 256",
    "ticketMedianoSimuladoFmt": "R$ 253",
    "valorTotalAcumuladoSimuladoFmt": "R$ 256",
    "maiorPedidoSimuladoFmt": "R$ 275",
    "menorPedidoSimuladoFmt": "R$ 148",
    "primeiraCompraSimulada": "05/04/2026",
    "ultimaCompraSimulada": "26/04/2026",
    "diasDesdeUltimaCompraSimulado": 18,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0083"
  },
  {
    "clienteId": "CLI_0084",
    "clienteAnonimo": "83",
    "segmentoComercial": "Cliente fiel",
    "ticketMedioSimulado": 647,
    "ticketMedianoSimulado": 607,
    "totalPedidosSimulado": 6,
    "valorTotalAcumuladoSimulado": 3882,
    "maiorPedidoSimulado": 753,
    "menorPedidoSimulado": 442,
    "ticketMedioSimuladoFmt": "R$ 647",
    "ticketMedianoSimuladoFmt": "R$ 607",
    "valorTotalAcumuladoSimuladoFmt": "R$ 3.882",
    "maiorPedidoSimuladoFmt": "R$ 753",
    "menorPedidoSimuladoFmt": "R$ 442",
    "primeiraCompraSimulada": "07/04/2026",
    "ultimaCompraSimulada": "29/04/2026",
    "diasDesdeUltimaCompraSimulado": 15,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar organização da semana e praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente alta lealdade — sugerir assinatura e acomp. calórico (com G06).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0084"
  },
  {
    "clienteId": "CLI_0085",
    "clienteAnonimo": "84",
    "segmentoComercial": "Cliente fiel",
    "ticketMedioSimulado": 685,
    "ticketMedianoSimulado": 668,
    "totalPedidosSimulado": 7,
    "valorTotalAcumuladoSimulado": 4795,
    "maiorPedidoSimulado": 785,
    "menorPedidoSimulado": 453,
    "ticketMedioSimuladoFmt": "R$ 685",
    "ticketMedianoSimuladoFmt": "R$ 668",
    "valorTotalAcumuladoSimuladoFmt": "R$ 4.795",
    "maiorPedidoSimuladoFmt": "R$ 785",
    "menorPedidoSimuladoFmt": "R$ 453",
    "primeiraCompraSimulada": "22/03/2026",
    "ultimaCompraSimulada": "05/05/2026",
    "diasDesdeUltimaCompraSimulado": 9,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode buscar organização da semana e praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente alta lealdade — sugerir assinatura e acomp. calórico (com G06).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0085"
  },
  {
    "clienteId": "CLI_0086",
    "clienteAnonimo": "85",
    "segmentoComercial": "Cliente fiel",
    "ticketMedioSimulado": 676,
    "ticketMedianoSimulado": 644,
    "totalPedidosSimulado": 7,
    "valorTotalAcumuladoSimulado": 4732,
    "maiorPedidoSimulado": 714,
    "menorPedidoSimulado": 376,
    "ticketMedioSimuladoFmt": "R$ 676",
    "ticketMedianoSimuladoFmt": "R$ 644",
    "valorTotalAcumuladoSimuladoFmt": "R$ 4.732",
    "maiorPedidoSimuladoFmt": "R$ 714",
    "menorPedidoSimuladoFmt": "R$ 376",
    "primeiraCompraSimulada": "06/03/2026",
    "ultimaCompraSimulada": "03/05/2026",
    "diasDesdeUltimaCompraSimulado": 11,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar organização da semana e praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente alta lealdade — sugerir assinatura e acomp. calórico (com G06).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0086"
  },
  {
    "clienteId": "CLI_0087",
    "clienteAnonimo": "86",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 270,
    "ticketMedianoSimulado": 259,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 270,
    "maiorPedidoSimulado": 306,
    "menorPedidoSimulado": 175,
    "ticketMedioSimuladoFmt": "R$ 270",
    "ticketMedianoSimuladoFmt": "R$ 259",
    "valorTotalAcumuladoSimuladoFmt": "R$ 270",
    "maiorPedidoSimuladoFmt": "R$ 306",
    "menorPedidoSimuladoFmt": "R$ 175",
    "primeiraCompraSimulada": "18/02/2026",
    "ultimaCompraSimulada": "13/04/2026",
    "diasDesdeUltimaCompraSimulado": 31,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0087"
  },
  {
    "clienteId": "CLI_0088",
    "clienteAnonimo": "87",
    "segmentoComercial": "Cliente alto valor",
    "ticketMedioSimulado": 1044,
    "ticketMedianoSimulado": 1009,
    "totalPedidosSimulado": 7,
    "valorTotalAcumuladoSimulado": 7308,
    "maiorPedidoSimulado": 1227,
    "menorPedidoSimulado": 727,
    "ticketMedioSimuladoFmt": "R$ 1.044",
    "ticketMedianoSimuladoFmt": "R$ 1.009",
    "valorTotalAcumuladoSimuladoFmt": "R$ 7.308",
    "maiorPedidoSimuladoFmt": "R$ 1.227",
    "menorPedidoSimuladoFmt": "R$ 727",
    "primeiraCompraSimulada": "02/02/2026",
    "ultimaCompraSimulada": "31/03/2026",
    "diasDesdeUltimaCompraSimulado": 44,
    "hipoteseDePerfil": "Compra compatível com abastecimento maior, família ou rotina intensa.",
    "objetivoProvavel": "Pode buscar abastecimento maior ou comprar para várias pessoas",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0088"
  },
  {
    "clienteId": "CLI_0089",
    "clienteAnonimo": "88",
    "segmentoComercial": "Cliente recorrente",
    "ticketMedioSimulado": 439,
    "ticketMedianoSimulado": 415,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 878,
    "maiorPedidoSimulado": 476,
    "menorPedidoSimulado": 259,
    "ticketMedioSimuladoFmt": "R$ 439",
    "ticketMedianoSimuladoFmt": "R$ 415",
    "valorTotalAcumuladoSimuladoFmt": "R$ 878",
    "maiorPedidoSimuladoFmt": "R$ 476",
    "menorPedidoSimuladoFmt": "R$ 259",
    "primeiraCompraSimulada": "17/01/2026",
    "ultimaCompraSimulada": "19/04/2026",
    "diasDesdeUltimaCompraSimulado": 25,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode buscar manter rotina alimentar",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0089"
  },
  {
    "clienteId": "CLI_0090",
    "clienteAnonimo": "89",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 269,
    "ticketMedianoSimulado": 251,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 269,
    "maiorPedidoSimulado": 291,
    "menorPedidoSimulado": 157,
    "ticketMedioSimuladoFmt": "R$ 269",
    "ticketMedianoSimuladoFmt": "R$ 251",
    "valorTotalAcumuladoSimuladoFmt": "R$ 269",
    "maiorPedidoSimuladoFmt": "R$ 291",
    "menorPedidoSimuladoFmt": "R$ 157",
    "primeiraCompraSimulada": "30/11/2025",
    "ultimaCompraSimulada": "13/03/2026",
    "diasDesdeUltimaCompraSimulado": 62,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0090"
  },
  {
    "clienteId": "CLI_0091",
    "clienteAnonimo": "90",
    "segmentoComercial": "Cliente recorrente",
    "ticketMedioSimulado": 467,
    "ticketMedianoSimulado": 464,
    "totalPedidosSimulado": 5,
    "valorTotalAcumuladoSimulado": 2335,
    "maiorPedidoSimulado": 547,
    "menorPedidoSimulado": 322,
    "ticketMedioSimuladoFmt": "R$ 467",
    "ticketMedianoSimuladoFmt": "R$ 464",
    "valorTotalAcumuladoSimuladoFmt": "R$ 2.335",
    "maiorPedidoSimuladoFmt": "R$ 547",
    "menorPedidoSimuladoFmt": "R$ 322",
    "primeiraCompraSimulada": "14/11/2025",
    "ultimaCompraSimulada": "28/02/2026",
    "diasDesdeUltimaCompraSimulado": 75,
    "hipoteseDePerfil": "Compra compatível com abastecimento maior, família ou rotina intensa.",
    "objetivoProvavel": "Pode buscar manter rotina alimentar",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0091"
  },
  {
    "clienteId": "CLI_0092",
    "clienteAnonimo": "91",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 232,
    "ticketMedianoSimulado": 214,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 232,
    "maiorPedidoSimulado": 264,
    "menorPedidoSimulado": 152,
    "ticketMedioSimuladoFmt": "R$ 232",
    "ticketMedianoSimuladoFmt": "R$ 214",
    "valorTotalAcumuladoSimuladoFmt": "R$ 232",
    "maiorPedidoSimuladoFmt": "R$ 264",
    "menorPedidoSimuladoFmt": "R$ 152",
    "primeiraCompraSimulada": "29/10/2025",
    "ultimaCompraSimulada": "08/04/2026",
    "diasDesdeUltimaCompraSimulado": 36,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0092"
  },
  {
    "clienteId": "CLI_0093",
    "clienteAnonimo": "92",
    "segmentoComercial": "Cliente fiel",
    "ticketMedioSimulado": 520,
    "ticketMedianoSimulado": 516,
    "totalPedidosSimulado": 8,
    "valorTotalAcumuladoSimulado": 4160,
    "maiorPedidoSimulado": 546,
    "menorPedidoSimulado": 286,
    "ticketMedioSimuladoFmt": "R$ 520",
    "ticketMedianoSimuladoFmt": "R$ 516",
    "valorTotalAcumuladoSimuladoFmt": "R$ 4.160",
    "maiorPedidoSimuladoFmt": "R$ 546",
    "menorPedidoSimuladoFmt": "R$ 286",
    "primeiraCompraSimulada": "13/11/2025",
    "ultimaCompraSimulada": "30/04/2026",
    "diasDesdeUltimaCompraSimulado": 14,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar organização da semana e praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente alta lealdade — sugerir assinatura e acomp. calórico (com G06).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0093"
  },
  {
    "clienteId": "CLI_0094",
    "clienteAnonimo": "93",
    "segmentoComercial": "Cliente fiel",
    "ticketMedioSimulado": 481,
    "ticketMedianoSimulado": 450,
    "totalPedidosSimulado": 6,
    "valorTotalAcumuladoSimulado": 2886,
    "maiorPedidoSimulado": 549,
    "menorPedidoSimulado": 316,
    "ticketMedioSimuladoFmt": "R$ 481",
    "ticketMedianoSimuladoFmt": "R$ 450",
    "valorTotalAcumuladoSimuladoFmt": "R$ 2.886",
    "maiorPedidoSimuladoFmt": "R$ 549",
    "menorPedidoSimuladoFmt": "R$ 316",
    "primeiraCompraSimulada": "29/11/2025",
    "ultimaCompraSimulada": "25/03/2026",
    "diasDesdeUltimaCompraSimulado": 50,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar organização da semana e praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente alta lealdade — sugerir assinatura e acomp. calórico (com G06).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0094"
  },
  {
    "clienteId": "CLI_0095",
    "clienteAnonimo": "94",
    "segmentoComercial": "Cliente recorrente",
    "ticketMedioSimulado": 356,
    "ticketMedianoSimulado": 348,
    "totalPedidosSimulado": 4,
    "valorTotalAcumuladoSimulado": 1424,
    "maiorPedidoSimulado": 416,
    "menorPedidoSimulado": 245,
    "ticketMedioSimuladoFmt": "R$ 356",
    "ticketMedianoSimuladoFmt": "R$ 348",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.424",
    "maiorPedidoSimuladoFmt": "R$ 416",
    "menorPedidoSimuladoFmt": "R$ 245",
    "primeiraCompraSimulada": "15/12/2025",
    "ultimaCompraSimulada": "02/03/2026",
    "diasDesdeUltimaCompraSimulado": 73,
    "hipoteseDePerfil": "Compra compatível com abastecimento maior, família ou rotina intensa.",
    "objetivoProvavel": "Pode buscar manter rotina alimentar",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0095"
  },
  {
    "clienteId": "CLI_0096",
    "clienteAnonimo": "95",
    "segmentoComercial": "Cliente fiel",
    "ticketMedioSimulado": 496,
    "ticketMedianoSimulado": 471,
    "totalPedidosSimulado": 7,
    "valorTotalAcumuladoSimulado": 3472,
    "maiorPedidoSimulado": 535,
    "menorPedidoSimulado": 289,
    "ticketMedioSimuladoFmt": "R$ 496",
    "ticketMedianoSimuladoFmt": "R$ 471",
    "valorTotalAcumuladoSimuladoFmt": "R$ 3.472",
    "maiorPedidoSimuladoFmt": "R$ 535",
    "menorPedidoSimuladoFmt": "R$ 289",
    "primeiraCompraSimulada": "31/12/2025",
    "ultimaCompraSimulada": "09/04/2026",
    "diasDesdeUltimaCompraSimulado": 35,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode buscar organização da semana e praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente alta lealdade — sugerir assinatura e acomp. calórico (com G06).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0096"
  },
  {
    "clienteId": "CLI_0097",
    "clienteAnonimo": "96",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 221,
    "ticketMedianoSimulado": 213,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 221,
    "maiorPedidoSimulado": 246,
    "menorPedidoSimulado": 137,
    "ticketMedioSimuladoFmt": "R$ 221",
    "ticketMedianoSimuladoFmt": "R$ 213",
    "valorTotalAcumuladoSimuladoFmt": "R$ 221",
    "maiorPedidoSimuladoFmt": "R$ 246",
    "menorPedidoSimuladoFmt": "R$ 137",
    "primeiraCompraSimulada": "16/01/2026",
    "ultimaCompraSimulada": "09/05/2026",
    "diasDesdeUltimaCompraSimulado": 5,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0097"
  },
  {
    "clienteId": "CLI_0098",
    "clienteAnonimo": "97",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 239,
    "ticketMedianoSimulado": 230,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 239,
    "maiorPedidoSimulado": 286,
    "menorPedidoSimulado": 173,
    "ticketMedioSimuladoFmt": "R$ 239",
    "ticketMedianoSimuladoFmt": "R$ 230",
    "valorTotalAcumuladoSimuladoFmt": "R$ 239",
    "maiorPedidoSimuladoFmt": "R$ 286",
    "menorPedidoSimuladoFmt": "R$ 173",
    "primeiraCompraSimulada": "01/02/2026",
    "ultimaCompraSimulada": "20/04/2026",
    "diasDesdeUltimaCompraSimulado": 24,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0098"
  },
  {
    "clienteId": "CLI_0099",
    "clienteAnonimo": "98",
    "segmentoComercial": "Cliente alto valor",
    "ticketMedioSimulado": 1060,
    "ticketMedianoSimulado": 1005,
    "totalPedidosSimulado": 4,
    "valorTotalAcumuladoSimulado": 4240,
    "maiorPedidoSimulado": 1175,
    "menorPedidoSimulado": 655,
    "ticketMedioSimuladoFmt": "R$ 1.060",
    "ticketMedianoSimuladoFmt": "R$ 1.005",
    "valorTotalAcumuladoSimuladoFmt": "R$ 4.240",
    "maiorPedidoSimuladoFmt": "R$ 1.175",
    "menorPedidoSimuladoFmt": "R$ 655",
    "primeiraCompraSimulada": "17/02/2026",
    "ultimaCompraSimulada": "04/04/2026",
    "diasDesdeUltimaCompraSimulado": 40,
    "hipoteseDePerfil": "Compra compatível com abastecimento maior, família ou rotina intensa.",
    "objetivoProvavel": "Pode buscar abastecimento maior ou comprar para várias pessoas",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0099"
  },
  {
    "clienteId": "CLI_0100",
    "clienteAnonimo": "99",
    "segmentoComercial": "Cliente fiel",
    "ticketMedioSimulado": 595,
    "ticketMedianoSimulado": 591,
    "totalPedidosSimulado": 8,
    "valorTotalAcumuladoSimulado": 4760,
    "maiorPedidoSimulado": 669,
    "menorPedidoSimulado": 379,
    "ticketMedioSimuladoFmt": "R$ 595",
    "ticketMedianoSimuladoFmt": "R$ 591",
    "valorTotalAcumuladoSimuladoFmt": "R$ 4.760",
    "maiorPedidoSimuladoFmt": "R$ 669",
    "menorPedidoSimuladoFmt": "R$ 379",
    "primeiraCompraSimulada": "16/02/2026",
    "ultimaCompraSimulada": "13/04/2026",
    "diasDesdeUltimaCompraSimulado": 31,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode buscar organização da semana e praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente alta lealdade — sugerir assinatura e acomp. calórico (com G06).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0100"
  },
  {
    "clienteId": "CLI_0101",
    "clienteAnonimo": "100",
    "segmentoComercial": "Cliente recorrente",
    "ticketMedioSimulado": 436,
    "ticketMedianoSimulado": 407,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1308,
    "maiorPedidoSimulado": 517,
    "menorPedidoSimulado": 308,
    "ticketMedioSimuladoFmt": "R$ 436",
    "ticketMedianoSimuladoFmt": "R$ 407",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.308",
    "maiorPedidoSimuladoFmt": "R$ 517",
    "menorPedidoSimuladoFmt": "R$ 308",
    "primeiraCompraSimulada": "31/01/2026",
    "ultimaCompraSimulada": "01/05/2026",
    "diasDesdeUltimaCompraSimulado": 13,
    "hipoteseDePerfil": "Compra compatível com abastecimento maior, família ou rotina intensa.",
    "objetivoProvavel": "Pode buscar manter rotina alimentar",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0101"
  },
  {
    "clienteId": "CLI_0102",
    "clienteAnonimo": "101",
    "segmentoComercial": "Cliente recorrente",
    "ticketMedioSimulado": 405,
    "ticketMedianoSimulado": 397,
    "totalPedidosSimulado": 4,
    "valorTotalAcumuladoSimulado": 1620,
    "maiorPedidoSimulado": 443,
    "menorPedidoSimulado": 244,
    "ticketMedioSimuladoFmt": "R$ 405",
    "ticketMedianoSimuladoFmt": "R$ 397",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.620",
    "maiorPedidoSimuladoFmt": "R$ 443",
    "menorPedidoSimuladoFmt": "R$ 244",
    "primeiraCompraSimulada": "15/01/2026",
    "ultimaCompraSimulada": "25/04/2026",
    "diasDesdeUltimaCompraSimulado": 19,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar manter rotina alimentar",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0102"
  },
  {
    "clienteId": "CLI_0103",
    "clienteAnonimo": "102",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 194,
    "ticketMedianoSimulado": 184,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 194,
    "maiorPedidoSimulado": 213,
    "menorPedidoSimulado": 117,
    "ticketMedioSimuladoFmt": "R$ 194",
    "ticketMedianoSimuladoFmt": "R$ 184",
    "valorTotalAcumuladoSimuladoFmt": "R$ 194",
    "maiorPedidoSimuladoFmt": "R$ 213",
    "menorPedidoSimuladoFmt": "R$ 117",
    "primeiraCompraSimulada": "30/12/2025",
    "ultimaCompraSimulada": "24/03/2026",
    "diasDesdeUltimaCompraSimulado": 51,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0103"
  },
  {
    "clienteId": "CLI_0104",
    "clienteAnonimo": "103",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 184,
    "ticketMedianoSimulado": 178,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 184,
    "maiorPedidoSimulado": 218,
    "menorPedidoSimulado": 130,
    "ticketMedioSimuladoFmt": "R$ 184",
    "ticketMedianoSimuladoFmt": "R$ 178",
    "valorTotalAcumuladoSimuladoFmt": "R$ 184",
    "maiorPedidoSimuladoFmt": "R$ 218",
    "menorPedidoSimuladoFmt": "R$ 130",
    "primeiraCompraSimulada": "14/12/2025",
    "ultimaCompraSimulada": "13/03/2026",
    "diasDesdeUltimaCompraSimulado": 62,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0104"
  },
  {
    "clienteId": "CLI_0105",
    "clienteAnonimo": "104",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 203,
    "ticketMedianoSimulado": 195,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 203,
    "maiorPedidoSimulado": 228,
    "menorPedidoSimulado": 129,
    "ticketMedioSimuladoFmt": "R$ 203",
    "ticketMedianoSimuladoFmt": "R$ 195",
    "valorTotalAcumuladoSimuladoFmt": "R$ 203",
    "maiorPedidoSimuladoFmt": "R$ 228",
    "menorPedidoSimuladoFmt": "R$ 129",
    "primeiraCompraSimulada": "28/11/2025",
    "ultimaCompraSimulada": "13/04/2026",
    "diasDesdeUltimaCompraSimulado": 31,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0105"
  },
  {
    "clienteId": "CLI_0106",
    "clienteAnonimo": "105",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 221,
    "ticketMedianoSimulado": 210,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 221,
    "maiorPedidoSimulado": 236,
    "menorPedidoSimulado": 126,
    "ticketMedioSimuladoFmt": "R$ 221",
    "ticketMedianoSimuladoFmt": "R$ 210",
    "valorTotalAcumuladoSimuladoFmt": "R$ 221",
    "maiorPedidoSimuladoFmt": "R$ 236",
    "menorPedidoSimuladoFmt": "R$ 126",
    "primeiraCompraSimulada": "12/11/2025",
    "ultimaCompraSimulada": "30/04/2026",
    "diasDesdeUltimaCompraSimulado": 14,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0106"
  },
  {
    "clienteId": "CLI_0107",
    "clienteAnonimo": "106",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 240,
    "ticketMedianoSimulado": 234,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 240,
    "maiorPedidoSimulado": 277,
    "menorPedidoSimulado": 162,
    "ticketMedioSimuladoFmt": "R$ 240",
    "ticketMedianoSimuladoFmt": "R$ 234",
    "valorTotalAcumuladoSimuladoFmt": "R$ 240",
    "maiorPedidoSimuladoFmt": "R$ 277",
    "menorPedidoSimuladoFmt": "R$ 162",
    "primeiraCompraSimulada": "30/10/2025",
    "ultimaCompraSimulada": "16/03/2026",
    "diasDesdeUltimaCompraSimulado": 59,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0107"
  },
  {
    "clienteId": "CLI_0108",
    "clienteAnonimo": "107",
    "segmentoComercial": "Cliente recorrente",
    "ticketMedioSimulado": 480,
    "ticketMedianoSimulado": 449,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 960,
    "maiorPedidoSimulado": 554,
    "menorPedidoSimulado": 322,
    "ticketMedioSimuladoFmt": "R$ 480",
    "ticketMedianoSimuladoFmt": "R$ 449",
    "valorTotalAcumuladoSimuladoFmt": "R$ 960",
    "maiorPedidoSimuladoFmt": "R$ 554",
    "menorPedidoSimuladoFmt": "R$ 322",
    "primeiraCompraSimulada": "15/11/2025",
    "ultimaCompraSimulada": "16/02/2026",
    "diasDesdeUltimaCompraSimulado": 87,
    "hipoteseDePerfil": "Compra compatível com abastecimento maior, família ou rotina intensa.",
    "objetivoProvavel": "Pode buscar manter rotina alimentar",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0108"
  },
  {
    "clienteId": "CLI_0109",
    "clienteAnonimo": "108",
    "segmentoComercial": "Cliente fiel",
    "ticketMedioSimulado": 652,
    "ticketMedianoSimulado": 646,
    "totalPedidosSimulado": 9,
    "valorTotalAcumuladoSimulado": 5868,
    "maiorPedidoSimulado": 693,
    "menorPedidoSimulado": 369,
    "ticketMedioSimuladoFmt": "R$ 652",
    "ticketMedianoSimuladoFmt": "R$ 646",
    "valorTotalAcumuladoSimuladoFmt": "R$ 5.868",
    "maiorPedidoSimuladoFmt": "R$ 693",
    "menorPedidoSimuladoFmt": "R$ 369",
    "primeiraCompraSimulada": "01/12/2025",
    "ultimaCompraSimulada": "02/04/2026",
    "diasDesdeUltimaCompraSimulado": 42,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode buscar organização da semana e praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente alta lealdade — sugerir assinatura e acomp. calórico (com G06).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0109"
  },
  {
    "clienteId": "CLI_0110",
    "clienteAnonimo": "109",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 241,
    "ticketMedianoSimulado": 240,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 241,
    "maiorPedidoSimulado": 265,
    "menorPedidoSimulado": 147,
    "ticketMedioSimuladoFmt": "R$ 241",
    "ticketMedianoSimuladoFmt": "R$ 240",
    "valorTotalAcumuladoSimuladoFmt": "R$ 241",
    "maiorPedidoSimuladoFmt": "R$ 265",
    "menorPedidoSimuladoFmt": "R$ 147",
    "primeiraCompraSimulada": "18/01/2026",
    "ultimaCompraSimulada": "06/04/2026",
    "diasDesdeUltimaCompraSimulado": 38,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0110"
  },
  {
    "clienteId": "CLI_0111",
    "clienteAnonimo": "110",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 259,
    "ticketMedianoSimulado": 241,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 259,
    "maiorPedidoSimulado": 309,
    "menorPedidoSimulado": 185,
    "ticketMedioSimuladoFmt": "R$ 259",
    "ticketMedianoSimuladoFmt": "R$ 241",
    "valorTotalAcumuladoSimuladoFmt": "R$ 259",
    "maiorPedidoSimuladoFmt": "R$ 309",
    "menorPedidoSimuladoFmt": "R$ 185",
    "primeiraCompraSimulada": "03/02/2026",
    "ultimaCompraSimulada": "28/03/2026",
    "diasDesdeUltimaCompraSimulado": 47,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0111"
  },
  {
    "clienteId": "CLI_0112",
    "clienteAnonimo": "111",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 278,
    "ticketMedianoSimulado": 273,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 278,
    "maiorPedidoSimulado": 311,
    "menorPedidoSimulado": 175,
    "ticketMedioSimuladoFmt": "R$ 278",
    "ticketMedianoSimuladoFmt": "R$ 273",
    "valorTotalAcumuladoSimuladoFmt": "R$ 278",
    "maiorPedidoSimuladoFmt": "R$ 311",
    "menorPedidoSimuladoFmt": "R$ 175",
    "primeiraCompraSimulada": "19/02/2026",
    "ultimaCompraSimulada": "23/04/2026",
    "diasDesdeUltimaCompraSimulado": 21,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0112"
  },
  {
    "clienteId": "CLI_0113",
    "clienteAnonimo": "112",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 296,
    "ticketMedianoSimulado": 280,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 296,
    "maiorPedidoSimulado": 317,
    "menorPedidoSimulado": 170,
    "ticketMedioSimuladoFmt": "R$ 296",
    "ticketMedianoSimuladoFmt": "R$ 280",
    "valorTotalAcumuladoSimuladoFmt": "R$ 296",
    "maiorPedidoSimuladoFmt": "R$ 317",
    "menorPedidoSimuladoFmt": "R$ 170",
    "primeiraCompraSimulada": "07/03/2026",
    "ultimaCompraSimulada": "11/05/2026",
    "diasDesdeUltimaCompraSimulado": 3,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0113"
  },
  {
    "clienteId": "CLI_0114",
    "clienteAnonimo": "113",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 285,
    "ticketMedianoSimulado": 276,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 285,
    "maiorPedidoSimulado": 331,
    "menorPedidoSimulado": 194,
    "ticketMedioSimuladoFmt": "R$ 285",
    "ticketMedianoSimuladoFmt": "R$ 276",
    "valorTotalAcumuladoSimuladoFmt": "R$ 285",
    "maiorPedidoSimuladoFmt": "R$ 331",
    "menorPedidoSimuladoFmt": "R$ 194",
    "primeiraCompraSimulada": "23/03/2026",
    "ultimaCompraSimulada": "29/04/2026",
    "diasDesdeUltimaCompraSimulado": 15,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0114"
  },
  {
    "clienteId": "CLI_0115",
    "clienteAnonimo": "114",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 266,
    "ticketMedianoSimulado": 255,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 266,
    "maiorPedidoSimulado": 305,
    "menorPedidoSimulado": 176,
    "ticketMedioSimuladoFmt": "R$ 266",
    "ticketMedianoSimuladoFmt": "R$ 255",
    "valorTotalAcumuladoSimuladoFmt": "R$ 266",
    "maiorPedidoSimuladoFmt": "R$ 305",
    "menorPedidoSimuladoFmt": "R$ 176",
    "primeiraCompraSimulada": "08/04/2026",
    "ultimaCompraSimulada": "26/04/2026",
    "diasDesdeUltimaCompraSimulado": 18,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0115"
  },
  {
    "clienteId": "CLI_0116",
    "clienteAnonimo": "115",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 248,
    "ticketMedianoSimulado": 236,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 248,
    "maiorPedidoSimulado": 262,
    "menorPedidoSimulado": 138,
    "ticketMedioSimuladoFmt": "R$ 248",
    "ticketMedianoSimuladoFmt": "R$ 236",
    "valorTotalAcumuladoSimuladoFmt": "R$ 248",
    "maiorPedidoSimuladoFmt": "R$ 262",
    "menorPedidoSimuladoFmt": "R$ 138",
    "primeiraCompraSimulada": "04/04/2026",
    "ultimaCompraSimulada": "30/04/2026",
    "diasDesdeUltimaCompraSimulado": 14,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0116"
  },
  {
    "clienteId": "CLI_0117",
    "clienteAnonimo": "116",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 229,
    "ticketMedianoSimulado": 223,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 229,
    "maiorPedidoSimulado": 259,
    "menorPedidoSimulado": 148,
    "ticketMedioSimuladoFmt": "R$ 229",
    "ticketMedianoSimuladoFmt": "R$ 223",
    "valorTotalAcumuladoSimuladoFmt": "R$ 229",
    "maiorPedidoSimuladoFmt": "R$ 259",
    "menorPedidoSimuladoFmt": "R$ 148",
    "primeiraCompraSimulada": "19/03/2026",
    "ultimaCompraSimulada": "07/05/2026",
    "diasDesdeUltimaCompraSimulado": 7,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0117"
  },
  {
    "clienteId": "CLI_0118",
    "clienteAnonimo": "117",
    "segmentoComercial": "Cliente recorrente",
    "ticketMedioSimulado": 402,
    "ticketMedianoSimulado": 377,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 804,
    "maiorPedidoSimulado": 473,
    "menorPedidoSimulado": 281,
    "ticketMedioSimuladoFmt": "R$ 402",
    "ticketMedianoSimuladoFmt": "R$ 377",
    "valorTotalAcumuladoSimuladoFmt": "R$ 804",
    "maiorPedidoSimuladoFmt": "R$ 473",
    "menorPedidoSimuladoFmt": "R$ 281",
    "primeiraCompraSimulada": "03/03/2026",
    "ultimaCompraSimulada": "30/04/2026",
    "diasDesdeUltimaCompraSimulado": 14,
    "hipoteseDePerfil": "Compra compatível com abastecimento maior, família ou rotina intensa.",
    "objetivoProvavel": "Pode buscar manter rotina alimentar",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0118"
  },
  {
    "clienteId": "CLI_0119",
    "clienteAnonimo": "118",
    "segmentoComercial": "Cliente fiel",
    "ticketMedioSimulado": 476,
    "ticketMedianoSimulado": 471,
    "totalPedidosSimulado": 9,
    "valorTotalAcumuladoSimulado": 4284,
    "maiorPedidoSimulado": 517,
    "menorPedidoSimulado": 282,
    "ticketMedioSimuladoFmt": "R$ 476",
    "ticketMedianoSimuladoFmt": "R$ 471",
    "valorTotalAcumuladoSimuladoFmt": "R$ 4.284",
    "maiorPedidoSimuladoFmt": "R$ 517",
    "menorPedidoSimuladoFmt": "R$ 282",
    "primeiraCompraSimulada": "15/02/2026",
    "ultimaCompraSimulada": "08/04/2026",
    "diasDesdeUltimaCompraSimulado": 36,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar organização da semana e praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente alta lealdade — sugerir assinatura e acomp. calórico (com G06).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0119"
  },
  {
    "clienteId": "CLI_0120",
    "clienteAnonimo": "119",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 228,
    "ticketMedianoSimulado": 228,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 228,
    "maiorPedidoSimulado": 246,
    "menorPedidoSimulado": 133,
    "ticketMedioSimuladoFmt": "R$ 228",
    "ticketMedianoSimuladoFmt": "R$ 228",
    "valorTotalAcumuladoSimuladoFmt": "R$ 228",
    "maiorPedidoSimuladoFmt": "R$ 246",
    "menorPedidoSimuladoFmt": "R$ 133",
    "primeiraCompraSimulada": "29/12/2025",
    "ultimaCompraSimulada": "04/05/2026",
    "diasDesdeUltimaCompraSimulado": 10,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0120"
  },
  {
    "clienteId": "CLI_0121",
    "clienteAnonimo": "120",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 210,
    "ticketMedianoSimulado": 195,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 210,
    "maiorPedidoSimulado": 245,
    "menorPedidoSimulado": 145,
    "ticketMedioSimuladoFmt": "R$ 210",
    "ticketMedianoSimuladoFmt": "R$ 195",
    "valorTotalAcumuladoSimuladoFmt": "R$ 210",
    "maiorPedidoSimuladoFmt": "R$ 245",
    "menorPedidoSimuladoFmt": "R$ 145",
    "primeiraCompraSimulada": "13/12/2025",
    "ultimaCompraSimulada": "14/04/2026",
    "diasDesdeUltimaCompraSimulado": 30,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0121"
  },
  {
    "clienteId": "CLI_0122",
    "clienteAnonimo": "121",
    "segmentoComercial": "Cliente recorrente",
    "ticketMedioSimulado": 369,
    "ticketMedianoSimulado": 363,
    "totalPedidosSimulado": 4,
    "valorTotalAcumuladoSimulado": 1476,
    "maiorPedidoSimulado": 421,
    "menorPedidoSimulado": 242,
    "ticketMedioSimuladoFmt": "R$ 369",
    "ticketMedianoSimuladoFmt": "R$ 363",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.476",
    "maiorPedidoSimuladoFmt": "R$ 421",
    "menorPedidoSimuladoFmt": "R$ 242",
    "primeiraCompraSimulada": "27/11/2025",
    "ultimaCompraSimulada": "04/03/2026",
    "diasDesdeUltimaCompraSimulado": 71,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode buscar manter rotina alimentar",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0122"
  },
  {
    "clienteId": "CLI_0123",
    "clienteAnonimo": "122",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 187,
    "ticketMedianoSimulado": 176,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 187,
    "maiorPedidoSimulado": 197,
    "menorPedidoSimulado": 103,
    "ticketMedioSimuladoFmt": "R$ 187",
    "ticketMedianoSimuladoFmt": "R$ 176",
    "valorTotalAcumuladoSimuladoFmt": "R$ 187",
    "maiorPedidoSimuladoFmt": "R$ 197",
    "menorPedidoSimuladoFmt": "R$ 103",
    "primeiraCompraSimulada": "11/11/2025",
    "ultimaCompraSimulada": "07/03/2026",
    "diasDesdeUltimaCompraSimulado": 68,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0123"
  },
  {
    "clienteId": "CLI_0124",
    "clienteAnonimo": "123",
    "segmentoComercial": "Cliente baixo ticket",
    "ticketMedioSimulado": 91,
    "ticketMedianoSimulado": 88,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 91,
    "maiorPedidoSimulado": 104,
    "menorPedidoSimulado": 60,
    "ticketMedioSimuladoFmt": "R$ 91",
    "ticketMedianoSimuladoFmt": "R$ 88",
    "valorTotalAcumuladoSimuladoFmt": "R$ 91",
    "maiorPedidoSimuladoFmt": "R$ 104",
    "menorPedidoSimuladoFmt": "R$ 60",
    "primeiraCompraSimulada": "31/10/2025",
    "ultimaCompraSimulada": "17/04/2026",
    "diasDesdeUltimaCompraSimulado": 27,
    "hipoteseDePerfil": "Cliente em fase de teste ou primeira experiência.",
    "objetivoProvavel": "Pode estar testando a marca",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0124"
  },
  {
    "clienteId": "CLI_0125",
    "clienteAnonimo": "124",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 224,
    "ticketMedianoSimulado": 214,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 224,
    "maiorPedidoSimulado": 262,
    "menorPedidoSimulado": 155,
    "ticketMedioSimuladoFmt": "R$ 224",
    "ticketMedianoSimuladoFmt": "R$ 214",
    "valorTotalAcumuladoSimuladoFmt": "R$ 224",
    "maiorPedidoSimuladoFmt": "R$ 262",
    "menorPedidoSimuladoFmt": "R$ 155",
    "primeiraCompraSimulada": "16/11/2025",
    "ultimaCompraSimulada": "22/04/2026",
    "diasDesdeUltimaCompraSimulado": 22,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0125"
  },
  {
    "clienteId": "CLI_0126",
    "clienteAnonimo": "125",
    "segmentoComercial": "Cliente fiel",
    "ticketMedioSimulado": 581,
    "ticketMedianoSimulado": 555,
    "totalPedidosSimulado": 5,
    "valorTotalAcumuladoSimulado": 2905,
    "maiorPedidoSimulado": 628,
    "menorPedidoSimulado": 340,
    "ticketMedioSimuladoFmt": "R$ 581",
    "ticketMedianoSimuladoFmt": "R$ 555",
    "valorTotalAcumuladoSimuladoFmt": "R$ 2.905",
    "maiorPedidoSimuladoFmt": "R$ 628",
    "menorPedidoSimuladoFmt": "R$ 340",
    "primeiraCompraSimulada": "02/12/2025",
    "ultimaCompraSimulada": "18/03/2026",
    "diasDesdeUltimaCompraSimulado": 57,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode buscar organização da semana e praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente alta lealdade — sugerir assinatura e acomp. calórico (com G06).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0126"
  },
  {
    "clienteId": "CLI_0127",
    "clienteAnonimo": "126",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 261,
    "ticketMedianoSimulado": 254,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 261,
    "maiorPedidoSimulado": 290,
    "menorPedidoSimulado": 162,
    "ticketMedioSimuladoFmt": "R$ 261",
    "ticketMedianoSimuladoFmt": "R$ 254",
    "valorTotalAcumuladoSimuladoFmt": "R$ 261",
    "maiorPedidoSimuladoFmt": "R$ 290",
    "menorPedidoSimuladoFmt": "R$ 162",
    "primeiraCompraSimulada": "18/12/2025",
    "ultimaCompraSimulada": "10/03/2026",
    "diasDesdeUltimaCompraSimulado": 65,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0127"
  },
  {
    "clienteId": "CLI_0128",
    "clienteAnonimo": "127",
    "segmentoComercial": "Cliente fiel",
    "ticketMedioSimulado": 658,
    "ticketMedianoSimulado": 619,
    "totalPedidosSimulado": 4,
    "valorTotalAcumuladoSimulado": 2632,
    "maiorPedidoSimulado": 789,
    "menorPedidoSimulado": 477,
    "ticketMedioSimuladoFmt": "R$ 658",
    "ticketMedianoSimuladoFmt": "R$ 619",
    "valorTotalAcumuladoSimuladoFmt": "R$ 2.632",
    "maiorPedidoSimuladoFmt": "R$ 789",
    "menorPedidoSimuladoFmt": "R$ 477",
    "primeiraCompraSimulada": "03/01/2026",
    "ultimaCompraSimulada": "15/04/2026",
    "diasDesdeUltimaCompraSimulado": 29,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode buscar organização da semana e praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente alta lealdade — sugerir assinatura e acomp. calórico (com G06).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0128"
  },
  {
    "clienteId": "CLI_0129",
    "clienteAnonimo": "128",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 298,
    "ticketMedianoSimulado": 294,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 298,
    "maiorPedidoSimulado": 331,
    "menorPedidoSimulado": 185,
    "ticketMedioSimuladoFmt": "R$ 298",
    "ticketMedianoSimuladoFmt": "R$ 294",
    "valorTotalAcumuladoSimuladoFmt": "R$ 298",
    "maiorPedidoSimuladoFmt": "R$ 331",
    "menorPedidoSimuladoFmt": "R$ 185",
    "primeiraCompraSimulada": "19/01/2026",
    "ultimaCompraSimulada": "08/05/2026",
    "diasDesdeUltimaCompraSimulado": 6,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0129"
  },
  {
    "clienteId": "CLI_0130",
    "clienteAnonimo": "129",
    "segmentoComercial": "Cliente fiel",
    "ticketMedioSimulado": 622,
    "ticketMedianoSimulado": 621,
    "totalPedidosSimulado": 9,
    "valorTotalAcumuladoSimulado": 5598,
    "maiorPedidoSimulado": 656,
    "menorPedidoSimulado": 346,
    "ticketMedioSimuladoFmt": "R$ 622",
    "ticketMedianoSimuladoFmt": "R$ 621",
    "valorTotalAcumuladoSimuladoFmt": "R$ 5.598",
    "maiorPedidoSimuladoFmt": "R$ 656",
    "menorPedidoSimuladoFmt": "R$ 346",
    "primeiraCompraSimulada": "09/03/2026",
    "ultimaCompraSimulada": "15/04/2026",
    "diasDesdeUltimaCompraSimulado": 29,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar organização da semana e praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente alta lealdade — sugerir assinatura e acomp. calórico (com G06).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0130"
  },
  {
    "clienteId": "CLI_0131",
    "clienteAnonimo": "130",
    "segmentoComercial": "Cliente recorrente",
    "ticketMedioSimulado": 518,
    "ticketMedianoSimulado": 480,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1554,
    "maiorPedidoSimulado": 593,
    "menorPedidoSimulado": 343,
    "ticketMedioSimuladoFmt": "R$ 518",
    "ticketMedianoSimuladoFmt": "R$ 480",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.554",
    "maiorPedidoSimuladoFmt": "R$ 593",
    "menorPedidoSimuladoFmt": "R$ 343",
    "primeiraCompraSimulada": "25/03/2026",
    "ultimaCompraSimulada": "02/05/2026",
    "diasDesdeUltimaCompraSimulado": 12,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode buscar manter rotina alimentar",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0131"
  },
  {
    "clienteId": "CLI_0132",
    "clienteAnonimo": "131",
    "segmentoComercial": "Cliente novo",
    "ticketMedioSimulado": 300,
    "ticketMedianoSimulado": 296,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 300,
    "maiorPedidoSimulado": 349,
    "menorPedidoSimulado": 205,
    "ticketMedioSimuladoFmt": "R$ 300",
    "ticketMedianoSimuladoFmt": "R$ 296",
    "valorTotalAcumuladoSimuladoFmt": "R$ 300",
    "maiorPedidoSimuladoFmt": "R$ 349",
    "menorPedidoSimuladoFmt": "R$ 205",
    "primeiraCompraSimulada": "10/04/2026",
    "ultimaCompraSimulada": "09/05/2026",
    "diasDesdeUltimaCompraSimulado": 5,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Onboarding: explicar combos, perguntar restrições (G03).",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0132"
  },
  {
    "clienteId": "CLI_0133",
    "clienteAnonimo": "132",
    "segmentoComercial": "Cliente recorrente",
    "ticketMedioSimulado": 520,
    "ticketMedianoSimulado": 489,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1560,
    "maiorPedidoSimulado": 558,
    "menorPedidoSimulado": 301,
    "ticketMedioSimuladoFmt": "R$ 520",
    "ticketMedianoSimuladoFmt": "R$ 489",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.560",
    "maiorPedidoSimuladoFmt": "R$ 558",
    "menorPedidoSimuladoFmt": "R$ 301",
    "primeiraCompraSimulada": "02/04/2026",
    "ultimaCompraSimulada": "30/04/2026",
    "diasDesdeUltimaCompraSimulado": 14,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode buscar manter rotina alimentar",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0133"
  },
  {
    "clienteId": "CLI_0134",
    "clienteAnonimo": "133",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 389,
    "ticketMedianoSimulado": 378,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 778,
    "maiorPedidoSimulado": 434,
    "menorPedidoSimulado": 244,
    "ticketMedioSimuladoFmt": "R$ 389",
    "ticketMedianoSimuladoFmt": "R$ 378",
    "valorTotalAcumuladoSimuladoFmt": "R$ 778",
    "maiorPedidoSimuladoFmt": "R$ 434",
    "menorPedidoSimuladoFmt": "R$ 244",
    "primeiraCompraSimulada": "17/03/2026",
    "ultimaCompraSimulada": "14/04/2026",
    "diasDesdeUltimaCompraSimulado": 30,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0134"
  },
  {
    "clienteId": "CLI_0135",
    "clienteAnonimo": "134",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 358,
    "ticketMedianoSimulado": 342,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 716,
    "maiorPedidoSimulado": 427,
    "menorPedidoSimulado": 257,
    "ticketMedioSimuladoFmt": "R$ 358",
    "ticketMedianoSimuladoFmt": "R$ 342",
    "valorTotalAcumuladoSimuladoFmt": "R$ 716",
    "maiorPedidoSimuladoFmt": "R$ 427",
    "menorPedidoSimuladoFmt": "R$ 257",
    "primeiraCompraSimulada": "01/03/2026",
    "ultimaCompraSimulada": "23/04/2026",
    "diasDesdeUltimaCompraSimulado": 21,
    "hipoteseDePerfil": "Cliente em fase de teste ou primeira experiência.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0135"
  },
  {
    "clienteId": "CLI_0136",
    "clienteAnonimo": "135",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 327,
    "ticketMedianoSimulado": 313,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 327,
    "maiorPedidoSimulado": 361,
    "menorPedidoSimulado": 200,
    "ticketMedioSimuladoFmt": "R$ 327",
    "ticketMedianoSimuladoFmt": "R$ 313",
    "valorTotalAcumuladoSimuladoFmt": "R$ 327",
    "maiorPedidoSimuladoFmt": "R$ 361",
    "menorPedidoSimuladoFmt": "R$ 200",
    "primeiraCompraSimulada": "13/02/2026",
    "ultimaCompraSimulada": "09/05/2026",
    "diasDesdeUltimaCompraSimulado": 5,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0136"
  },
  {
    "clienteId": "CLI_0137",
    "clienteAnonimo": "136",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 296,
    "ticketMedianoSimulado": 287,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 592,
    "maiorPedidoSimulado": 322,
    "menorPedidoSimulado": 176,
    "ticketMedioSimuladoFmt": "R$ 296",
    "ticketMedianoSimuladoFmt": "R$ 287",
    "valorTotalAcumuladoSimuladoFmt": "R$ 592",
    "maiorPedidoSimuladoFmt": "R$ 322",
    "menorPedidoSimuladoFmt": "R$ 176",
    "primeiraCompraSimulada": "29/01/2026",
    "ultimaCompraSimulada": "20/04/2026",
    "diasDesdeUltimaCompraSimulado": 24,
    "hipoteseDePerfil": "Cliente em fase de teste ou primeira experiência.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0137"
  },
  {
    "clienteId": "CLI_0138",
    "clienteAnonimo": "137",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 266,
    "ticketMedianoSimulado": 251,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 266,
    "maiorPedidoSimulado": 313,
    "menorPedidoSimulado": 186,
    "ticketMedioSimuladoFmt": "R$ 266",
    "ticketMedianoSimuladoFmt": "R$ 251",
    "valorTotalAcumuladoSimuladoFmt": "R$ 266",
    "maiorPedidoSimuladoFmt": "R$ 313",
    "menorPedidoSimuladoFmt": "R$ 186",
    "primeiraCompraSimulada": "13/01/2026",
    "ultimaCompraSimulada": "20/03/2026",
    "diasDesdeUltimaCompraSimulado": 55,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0138"
  },
  {
    "clienteId": "CLI_0139",
    "clienteAnonimo": "138",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 265,
    "ticketMedianoSimulado": 261,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 530,
    "maiorPedidoSimulado": 300,
    "menorPedidoSimulado": 171,
    "ticketMedioSimuladoFmt": "R$ 265",
    "ticketMedianoSimuladoFmt": "R$ 261",
    "valorTotalAcumuladoSimuladoFmt": "R$ 530",
    "maiorPedidoSimuladoFmt": "R$ 300",
    "menorPedidoSimuladoFmt": "R$ 171",
    "primeiraCompraSimulada": "28/12/2025",
    "ultimaCompraSimulada": "28/03/2026",
    "diasDesdeUltimaCompraSimulado": 47,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0139"
  },
  {
    "clienteId": "CLI_0140",
    "clienteAnonimo": "139",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 294,
    "ticketMedianoSimulado": 293,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 588,
    "maiorPedidoSimulado": 314,
    "menorPedidoSimulado": 168,
    "ticketMedioSimuladoFmt": "R$ 294",
    "ticketMedianoSimuladoFmt": "R$ 293",
    "valorTotalAcumuladoSimuladoFmt": "R$ 588",
    "maiorPedidoSimuladoFmt": "R$ 314",
    "menorPedidoSimuladoFmt": "R$ 168",
    "primeiraCompraSimulada": "09/11/2025",
    "ultimaCompraSimulada": "31/03/2026",
    "diasDesdeUltimaCompraSimulado": 44,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Média",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0140"
  },
  {
    "clienteId": "CLI_0141",
    "clienteAnonimo": "140",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 264,
    "ticketMedianoSimulado": 244,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 264,
    "maiorPedidoSimulado": 296,
    "menorPedidoSimulado": 168,
    "ticketMedioSimuladoFmt": "R$ 264",
    "ticketMedianoSimuladoFmt": "R$ 244",
    "valorTotalAcumuladoSimuladoFmt": "R$ 264",
    "maiorPedidoSimuladoFmt": "R$ 296",
    "menorPedidoSimuladoFmt": "R$ 168",
    "primeiraCompraSimulada": "02/11/2025",
    "ultimaCompraSimulada": "14/02/2026",
    "diasDesdeUltimaCompraSimulado": 89,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Baixa",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0141"
  },
  {
    "clienteId": "CLI_0142",
    "clienteAnonimo": "141",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 267,
    "ticketMedianoSimulado": 264,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 534,
    "maiorPedidoSimulado": 317,
    "menorPedidoSimulado": 190,
    "ticketMedioSimuladoFmt": "R$ 267",
    "ticketMedianoSimuladoFmt": "R$ 264",
    "valorTotalAcumuladoSimuladoFmt": "R$ 534",
    "maiorPedidoSimuladoFmt": "R$ 317",
    "menorPedidoSimuladoFmt": "R$ 190",
    "primeiraCompraSimulada": "18/11/2025",
    "ultimaCompraSimulada": "17/03/2026",
    "diasDesdeUltimaCompraSimulado": 58,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Baixa",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0142"
  },
  {
    "clienteId": "CLI_0143",
    "clienteAnonimo": "142",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 298,
    "ticketMedianoSimulado": 279,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 596,
    "maiorPedidoSimulado": 327,
    "menorPedidoSimulado": 180,
    "ticketMedioSimuladoFmt": "R$ 298",
    "ticketMedianoSimuladoFmt": "R$ 279",
    "valorTotalAcumuladoSimuladoFmt": "R$ 596",
    "maiorPedidoSimuladoFmt": "R$ 327",
    "menorPedidoSimuladoFmt": "R$ 180",
    "primeiraCompraSimulada": "04/12/2025",
    "ultimaCompraSimulada": "28/04/2026",
    "diasDesdeUltimaCompraSimulado": 16,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Baixa",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0143"
  },
  {
    "clienteId": "CLI_0144",
    "clienteAnonimo": "143",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 329,
    "ticketMedianoSimulado": 321,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 658,
    "maiorPedidoSimulado": 360,
    "menorPedidoSimulado": 197,
    "ticketMedioSimuladoFmt": "R$ 329",
    "ticketMedianoSimuladoFmt": "R$ 321",
    "valorTotalAcumuladoSimuladoFmt": "R$ 658",
    "maiorPedidoSimuladoFmt": "R$ 360",
    "menorPedidoSimuladoFmt": "R$ 197",
    "primeiraCompraSimulada": "20/12/2025",
    "ultimaCompraSimulada": "20/04/2026",
    "diasDesdeUltimaCompraSimulado": 24,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Baixa",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0144"
  },
  {
    "clienteId": "CLI_0145",
    "clienteAnonimo": "144",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 360,
    "ticketMedianoSimulado": 343,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 720,
    "maiorPedidoSimulado": 426,
    "menorPedidoSimulado": 254,
    "ticketMedioSimuladoFmt": "R$ 360",
    "ticketMedianoSimuladoFmt": "R$ 343",
    "valorTotalAcumuladoSimuladoFmt": "R$ 720",
    "maiorPedidoSimuladoFmt": "R$ 426",
    "menorPedidoSimuladoFmt": "R$ 254",
    "primeiraCompraSimulada": "05/01/2026",
    "ultimaCompraSimulada": "24/03/2026",
    "diasDesdeUltimaCompraSimulado": 51,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Baixa",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0145"
  },
  {
    "clienteId": "CLI_0146",
    "clienteAnonimo": "145",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 391,
    "ticketMedianoSimulado": 376,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 391,
    "maiorPedidoSimulado": 440,
    "menorPedidoSimulado": 250,
    "ticketMedioSimuladoFmt": "R$ 391",
    "ticketMedianoSimuladoFmt": "R$ 376",
    "valorTotalAcumuladoSimuladoFmt": "R$ 391",
    "maiorPedidoSimuladoFmt": "R$ 440",
    "menorPedidoSimuladoFmt": "R$ 250",
    "primeiraCompraSimulada": "21/01/2026",
    "ultimaCompraSimulada": "29/03/2026",
    "diasDesdeUltimaCompraSimulado": 46,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Baixa",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0146"
  },
  {
    "clienteId": "CLI_0147",
    "clienteAnonimo": "146",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 422,
    "ticketMedianoSimulado": 408,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 844,
    "maiorPedidoSimulado": 449,
    "menorPedidoSimulado": 239,
    "ticketMedioSimuladoFmt": "R$ 422",
    "ticketMedianoSimuladoFmt": "R$ 408",
    "valorTotalAcumuladoSimuladoFmt": "R$ 844",
    "maiorPedidoSimuladoFmt": "R$ 449",
    "menorPedidoSimuladoFmt": "R$ 239",
    "primeiraCompraSimulada": "06/02/2026",
    "ultimaCompraSimulada": "26/04/2026",
    "diasDesdeUltimaCompraSimulado": 18,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Baixa",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0147"
  },
  {
    "clienteId": "CLI_0148",
    "clienteAnonimo": "147",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 448,
    "ticketMedianoSimulado": 424,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 448,
    "maiorPedidoSimulado": 517,
    "menorPedidoSimulado": 301,
    "ticketMedioSimuladoFmt": "R$ 448",
    "ticketMedianoSimuladoFmt": "R$ 424",
    "valorTotalAcumuladoSimuladoFmt": "R$ 448",
    "maiorPedidoSimuladoFmt": "R$ 517",
    "menorPedidoSimuladoFmt": "R$ 301",
    "primeiraCompraSimulada": "22/02/2026",
    "ultimaCompraSimulada": "05/05/2026",
    "diasDesdeUltimaCompraSimulado": 9,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Baixa",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0148"
  },
  {
    "clienteId": "CLI_0149",
    "clienteAnonimo": "148",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 417,
    "ticketMedianoSimulado": 409,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 834,
    "maiorPedidoSimulado": 482,
    "menorPedidoSimulado": 281,
    "ticketMedioSimuladoFmt": "R$ 417",
    "ticketMedianoSimuladoFmt": "R$ 409",
    "valorTotalAcumuladoSimuladoFmt": "R$ 834",
    "maiorPedidoSimuladoFmt": "R$ 482",
    "menorPedidoSimuladoFmt": "R$ 281",
    "primeiraCompraSimulada": "10/03/2026",
    "ultimaCompraSimulada": "22/04/2026",
    "diasDesdeUltimaCompraSimulado": 22,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Baixa",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0149"
  },
  {
    "clienteId": "CLI_0150",
    "clienteAnonimo": "149",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 424,
    "ticketMedianoSimulado": 421,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 848,
    "maiorPedidoSimulado": 463,
    "menorPedidoSimulado": 253,
    "ticketMedioSimuladoFmt": "R$ 424",
    "ticketMedianoSimuladoFmt": "R$ 421",
    "valorTotalAcumuladoSimuladoFmt": "R$ 848",
    "maiorPedidoSimuladoFmt": "R$ 463",
    "menorPedidoSimuladoFmt": "R$ 253",
    "primeiraCompraSimulada": "01/04/2026",
    "ultimaCompraSimulada": "05/05/2026",
    "diasDesdeUltimaCompraSimulado": 9,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Baixa",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0150"
  },
  {
    "clienteId": "CLI_0151",
    "clienteAnonimo": "150",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 446,
    "ticketMedianoSimulado": 411,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 446,
    "maiorPedidoSimulado": 490,
    "menorPedidoSimulado": 271,
    "ticketMedioSimuladoFmt": "R$ 446",
    "ticketMedianoSimuladoFmt": "R$ 411",
    "valorTotalAcumuladoSimuladoFmt": "R$ 446",
    "maiorPedidoSimuladoFmt": "R$ 490",
    "menorPedidoSimuladoFmt": "R$ 271",
    "primeiraCompraSimulada": "16/03/2026",
    "ultimaCompraSimulada": "06/05/2026",
    "diasDesdeUltimaCompraSimulado": 8,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Baixa",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0151"
  },
  {
    "clienteId": "CLI_0152",
    "clienteAnonimo": "151",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 415,
    "ticketMedianoSimulado": 412,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 830,
    "maiorPedidoSimulado": 494,
    "menorPedidoSimulado": 296,
    "ticketMedioSimuladoFmt": "R$ 415",
    "ticketMedianoSimuladoFmt": "R$ 412",
    "valorTotalAcumuladoSimuladoFmt": "R$ 830",
    "maiorPedidoSimuladoFmt": "R$ 494",
    "menorPedidoSimuladoFmt": "R$ 296",
    "primeiraCompraSimulada": "28/02/2026",
    "ultimaCompraSimulada": "18/04/2026",
    "diasDesdeUltimaCompraSimulado": 26,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Baixa",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0152"
  },
  {
    "clienteId": "CLI_0153",
    "clienteAnonimo": "152",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 384,
    "ticketMedianoSimulado": 359,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 768,
    "maiorPedidoSimulado": 430,
    "menorPedidoSimulado": 243,
    "ticketMedioSimuladoFmt": "R$ 384",
    "ticketMedianoSimuladoFmt": "R$ 359",
    "valorTotalAcumuladoSimuladoFmt": "R$ 768",
    "maiorPedidoSimuladoFmt": "R$ 430",
    "menorPedidoSimuladoFmt": "R$ 243",
    "primeiraCompraSimulada": "12/02/2026",
    "ultimaCompraSimulada": "02/04/2026",
    "diasDesdeUltimaCompraSimulado": 42,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Baixa",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0153"
  },
  {
    "clienteId": "CLI_0154",
    "clienteAnonimo": "153",
    "segmentoComercial": "Cliente alto valor",
    "ticketMedioSimulado": 1017,
    "ticketMedianoSimulado": 994,
    "totalPedidosSimulado": 5,
    "valorTotalAcumuladoSimulado": 5085,
    "maiorPedidoSimulado": 1088,
    "menorPedidoSimulado": 583,
    "ticketMedioSimuladoFmt": "R$ 1.017",
    "ticketMedianoSimuladoFmt": "R$ 994",
    "valorTotalAcumuladoSimuladoFmt": "R$ 5.085",
    "maiorPedidoSimuladoFmt": "R$ 1.088",
    "menorPedidoSimuladoFmt": "R$ 583",
    "primeiraCompraSimulada": "27/01/2026",
    "ultimaCompraSimulada": "19/04/2026",
    "diasDesdeUltimaCompraSimulado": 25,
    "hipoteseDePerfil": "Compra compatível com abastecimento maior, família ou rotina intensa.",
    "objetivoProvavel": "Pode buscar abastecimento maior ou comprar para várias pessoas",
    "propensaoARecompra": "Baixa",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0154"
  },
  {
    "clienteId": "CLI_0155",
    "clienteAnonimo": "154",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 322,
    "ticketMedianoSimulado": 306,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 644,
    "maiorPedidoSimulado": 374,
    "menorPedidoSimulado": 218,
    "ticketMedioSimuladoFmt": "R$ 322",
    "ticketMedianoSimuladoFmt": "R$ 306",
    "valorTotalAcumuladoSimuladoFmt": "R$ 644",
    "maiorPedidoSimuladoFmt": "R$ 374",
    "menorPedidoSimuladoFmt": "R$ 218",
    "primeiraCompraSimulada": "11/01/2026",
    "ultimaCompraSimulada": "09/05/2026",
    "diasDesdeUltimaCompraSimulado": 5,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Baixa",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0155"
  },
  {
    "clienteId": "CLI_0156",
    "clienteAnonimo": "155",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 291,
    "ticketMedianoSimulado": 280,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 582,
    "maiorPedidoSimulado": 335,
    "menorPedidoSimulado": 194,
    "ticketMedioSimuladoFmt": "R$ 291",
    "ticketMedianoSimuladoFmt": "R$ 280",
    "valorTotalAcumuladoSimuladoFmt": "R$ 582",
    "maiorPedidoSimuladoFmt": "R$ 335",
    "menorPedidoSimuladoFmt": "R$ 194",
    "primeiraCompraSimulada": "26/12/2025",
    "ultimaCompraSimulada": "07/04/2026",
    "diasDesdeUltimaCompraSimulado": 37,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Baixa",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0156"
  },
  {
    "clienteId": "CLI_0157",
    "clienteAnonimo": "156",
    "segmentoComercial": "Cliente alto valor",
    "ticketMedioSimulado": 867,
    "ticketMedianoSimulado": 836,
    "totalPedidosSimulado": 6,
    "valorTotalAcumuladoSimulado": 5202,
    "maiorPedidoSimulado": 919,
    "menorPedidoSimulado": 486,
    "ticketMedioSimuladoFmt": "R$ 867",
    "ticketMedianoSimuladoFmt": "R$ 836",
    "valorTotalAcumuladoSimuladoFmt": "R$ 5.202",
    "maiorPedidoSimuladoFmt": "R$ 919",
    "menorPedidoSimuladoFmt": "R$ 486",
    "primeiraCompraSimulada": "10/12/2025",
    "ultimaCompraSimulada": "27/02/2026",
    "diasDesdeUltimaCompraSimulado": 76,
    "hipoteseDePerfil": "Compra compatível com abastecimento maior, família ou rotina intensa.",
    "objetivoProvavel": "Pode buscar abastecimento maior ou comprar para várias pessoas",
    "propensaoARecompra": "Baixa",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0157"
  },
  {
    "clienteId": "CLI_0158",
    "clienteAnonimo": "157",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 270,
    "ticketMedianoSimulado": 256,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 270,
    "maiorPedidoSimulado": 305,
    "menorPedidoSimulado": 174,
    "ticketMedioSimuladoFmt": "R$ 270",
    "ticketMedianoSimuladoFmt": "R$ 256",
    "valorTotalAcumuladoSimuladoFmt": "R$ 270",
    "maiorPedidoSimuladoFmt": "R$ 305",
    "menorPedidoSimuladoFmt": "R$ 174",
    "primeiraCompraSimulada": "24/11/2025",
    "ultimaCompraSimulada": "24/03/2026",
    "diasDesdeUltimaCompraSimulado": 51,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Baixa",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0158"
  },
  {
    "clienteId": "CLI_0159",
    "clienteAnonimo": "158",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 301,
    "ticketMedianoSimulado": 294,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 602,
    "maiorPedidoSimulado": 355,
    "menorPedidoSimulado": 211,
    "ticketMedioSimuladoFmt": "R$ 301",
    "ticketMedianoSimuladoFmt": "R$ 294",
    "valorTotalAcumuladoSimuladoFmt": "R$ 602",
    "maiorPedidoSimuladoFmt": "R$ 355",
    "menorPedidoSimuladoFmt": "R$ 211",
    "primeiraCompraSimulada": "08/11/2025",
    "ultimaCompraSimulada": "01/05/2026",
    "diasDesdeUltimaCompraSimulado": 13,
    "hipoteseDePerfil": "Cliente em fase de teste ou primeira experiência.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Baixa",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0159"
  },
  {
    "clienteId": "CLI_0160",
    "clienteAnonimo": "159",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 258,
    "ticketMedianoSimulado": 256,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 516,
    "maiorPedidoSimulado": 287,
    "menorPedidoSimulado": 161,
    "ticketMedioSimuladoFmt": "R$ 258",
    "ticketMedianoSimuladoFmt": "R$ 256",
    "valorTotalAcumuladoSimuladoFmt": "R$ 516",
    "maiorPedidoSimuladoFmt": "R$ 287",
    "menorPedidoSimuladoFmt": "R$ 161",
    "primeiraCompraSimulada": "05/12/2025",
    "ultimaCompraSimulada": "22/02/2026",
    "diasDesdeUltimaCompraSimulado": 81,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Baixa",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0160"
  },
  {
    "clienteId": "CLI_0161",
    "clienteAnonimo": "160",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 272,
    "ticketMedianoSimulado": 251,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 272,
    "maiorPedidoSimulado": 293,
    "menorPedidoSimulado": 158,
    "ticketMedioSimuladoFmt": "R$ 272",
    "ticketMedianoSimuladoFmt": "R$ 251",
    "valorTotalAcumuladoSimuladoFmt": "R$ 272",
    "maiorPedidoSimuladoFmt": "R$ 293",
    "menorPedidoSimuladoFmt": "R$ 158",
    "primeiraCompraSimulada": "21/12/2025",
    "ultimaCompraSimulada": "03/04/2026",
    "diasDesdeUltimaCompraSimulado": 41,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Baixa",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0161"
  },
  {
    "clienteId": "CLI_0162",
    "clienteAnonimo": "161",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 303,
    "ticketMedianoSimulado": 301,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 606,
    "maiorPedidoSimulado": 353,
    "menorPedidoSimulado": 208,
    "ticketMedioSimuladoFmt": "R$ 303",
    "ticketMedianoSimuladoFmt": "R$ 301",
    "valorTotalAcumuladoSimuladoFmt": "R$ 606",
    "maiorPedidoSimuladoFmt": "R$ 353",
    "menorPedidoSimuladoFmt": "R$ 208",
    "primeiraCompraSimulada": "06/01/2026",
    "ultimaCompraSimulada": "06/05/2026",
    "diasDesdeUltimaCompraSimulado": 8,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Baixa",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0162"
  },
  {
    "clienteId": "CLI_0163",
    "clienteAnonimo": "162",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 334,
    "ticketMedianoSimulado": 312,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 668,
    "maiorPedidoSimulado": 382,
    "menorPedidoSimulado": 220,
    "ticketMedioSimuladoFmt": "R$ 334",
    "ticketMedianoSimuladoFmt": "R$ 312",
    "valorTotalAcumuladoSimuladoFmt": "R$ 668",
    "maiorPedidoSimuladoFmt": "R$ 382",
    "menorPedidoSimuladoFmt": "R$ 220",
    "primeiraCompraSimulada": "22/01/2026",
    "ultimaCompraSimulada": "20/04/2026",
    "diasDesdeUltimaCompraSimulado": 24,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Baixa",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0163"
  },
  {
    "clienteId": "CLI_0164",
    "clienteAnonimo": "163",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 365,
    "ticketMedianoSimulado": 358,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 730,
    "maiorPedidoSimulado": 384,
    "menorPedidoSimulado": 202,
    "ticketMedioSimuladoFmt": "R$ 365",
    "ticketMedianoSimuladoFmt": "R$ 358",
    "valorTotalAcumuladoSimuladoFmt": "R$ 730",
    "maiorPedidoSimuladoFmt": "R$ 384",
    "menorPedidoSimuladoFmt": "R$ 202",
    "primeiraCompraSimulada": "07/02/2026",
    "ultimaCompraSimulada": "01/04/2026",
    "diasDesdeUltimaCompraSimulado": 43,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Baixa",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0164"
  },
  {
    "clienteId": "CLI_0165",
    "clienteAnonimo": "164",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 396,
    "ticketMedianoSimulado": 375,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 792,
    "maiorPedidoSimulado": 450,
    "menorPedidoSimulado": 258,
    "ticketMedioSimuladoFmt": "R$ 396",
    "ticketMedianoSimuladoFmt": "R$ 375",
    "valorTotalAcumuladoSimuladoFmt": "R$ 792",
    "maiorPedidoSimuladoFmt": "R$ 450",
    "menorPedidoSimuladoFmt": "R$ 258",
    "primeiraCompraSimulada": "23/02/2026",
    "ultimaCompraSimulada": "15/04/2026",
    "diasDesdeUltimaCompraSimulado": 29,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Baixa",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0165"
  },
  {
    "clienteId": "CLI_0166",
    "clienteAnonimo": "165",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 427,
    "ticketMedianoSimulado": 412,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 854,
    "maiorPedidoSimulado": 501,
    "menorPedidoSimulado": 296,
    "ticketMedioSimuladoFmt": "R$ 427",
    "ticketMedianoSimuladoFmt": "R$ 412",
    "valorTotalAcumuladoSimuladoFmt": "R$ 854",
    "maiorPedidoSimuladoFmt": "R$ 501",
    "menorPedidoSimuladoFmt": "R$ 296",
    "primeiraCompraSimulada": "11/03/2026",
    "ultimaCompraSimulada": "04/05/2026",
    "diasDesdeUltimaCompraSimulado": 10,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Baixa",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0166"
  },
  {
    "clienteId": "CLI_0167",
    "clienteAnonimo": "166",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 443,
    "ticketMedianoSimulado": 426,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 886,
    "maiorPedidoSimulado": 480,
    "menorPedidoSimulado": 260,
    "ticketMedioSimuladoFmt": "R$ 443",
    "ticketMedianoSimuladoFmt": "R$ 426",
    "valorTotalAcumuladoSimuladoFmt": "R$ 886",
    "maiorPedidoSimuladoFmt": "R$ 480",
    "menorPedidoSimuladoFmt": "R$ 260",
    "primeiraCompraSimulada": "27/03/2026",
    "ultimaCompraSimulada": "06/05/2026",
    "diasDesdeUltimaCompraSimulado": 8,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Baixa",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0167"
  },
  {
    "clienteId": "CLI_0168",
    "clienteAnonimo": "167",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 412,
    "ticketMedianoSimulado": 392,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 412,
    "maiorPedidoSimulado": 456,
    "menorPedidoSimulado": 254,
    "ticketMedioSimuladoFmt": "R$ 412",
    "ticketMedianoSimuladoFmt": "R$ 392",
    "valorTotalAcumuladoSimuladoFmt": "R$ 412",
    "maiorPedidoSimuladoFmt": "R$ 456",
    "menorPedidoSimuladoFmt": "R$ 254",
    "primeiraCompraSimulada": "12/04/2026",
    "ultimaCompraSimulada": "01/05/2026",
    "diasDesdeUltimaCompraSimulado": 13,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Baixa",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0168"
  },
  {
    "clienteId": "CLI_0169",
    "clienteAnonimo": "168",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 381,
    "ticketMedianoSimulado": 372,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 762,
    "maiorPedidoSimulado": 456,
    "menorPedidoSimulado": 275,
    "ticketMedioSimuladoFmt": "R$ 381",
    "ticketMedianoSimuladoFmt": "R$ 372",
    "valorTotalAcumuladoSimuladoFmt": "R$ 762",
    "maiorPedidoSimuladoFmt": "R$ 456",
    "menorPedidoSimuladoFmt": "R$ 275",
    "primeiraCompraSimulada": "31/03/2026",
    "ultimaCompraSimulada": "24/04/2026",
    "diasDesdeUltimaCompraSimulado": 20,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Baixa",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0169"
  },
  {
    "clienteId": "CLI_0170",
    "clienteAnonimo": "169",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 440,
    "ticketMedianoSimulado": 435,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 880,
    "maiorPedidoSimulado": 500,
    "menorPedidoSimulado": 287,
    "ticketMedioSimuladoFmt": "R$ 440",
    "ticketMedianoSimuladoFmt": "R$ 435",
    "valorTotalAcumuladoSimuladoFmt": "R$ 880",
    "maiorPedidoSimuladoFmt": "R$ 500",
    "menorPedidoSimuladoFmt": "R$ 287",
    "primeiraCompraSimulada": "11/02/2026",
    "ultimaCompraSimulada": "29/04/2026",
    "diasDesdeUltimaCompraSimulado": 15,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Baixa",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0170"
  },
  {
    "clienteId": "CLI_0171",
    "clienteAnonimo": "170",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 410,
    "ticketMedianoSimulado": 379,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 410,
    "maiorPedidoSimulado": 432,
    "menorPedidoSimulado": 227,
    "ticketMedioSimuladoFmt": "R$ 410",
    "ticketMedianoSimuladoFmt": "R$ 379",
    "valorTotalAcumuladoSimuladoFmt": "R$ 410",
    "maiorPedidoSimuladoFmt": "R$ 432",
    "menorPedidoSimuladoFmt": "R$ 227",
    "primeiraCompraSimulada": "26/01/2026",
    "ultimaCompraSimulada": "02/04/2026",
    "diasDesdeUltimaCompraSimulado": 42,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Baixa",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0171"
  },
  {
    "clienteId": "CLI_0172",
    "clienteAnonimo": "171",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 379,
    "ticketMedianoSimulado": 378,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 758,
    "maiorPedidoSimulado": 433,
    "menorPedidoSimulado": 250,
    "ticketMedioSimuladoFmt": "R$ 379",
    "ticketMedianoSimuladoFmt": "R$ 378",
    "valorTotalAcumuladoSimuladoFmt": "R$ 758",
    "maiorPedidoSimuladoFmt": "R$ 433",
    "menorPedidoSimuladoFmt": "R$ 250",
    "primeiraCompraSimulada": "10/01/2026",
    "ultimaCompraSimulada": "24/03/2026",
    "diasDesdeUltimaCompraSimulado": 51,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Baixa",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0172"
  },
  {
    "clienteId": "CLI_0173",
    "clienteAnonimo": "172",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 348,
    "ticketMedianoSimulado": 324,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 348,
    "maiorPedidoSimulado": 406,
    "menorPedidoSimulado": 239,
    "ticketMedioSimuladoFmt": "R$ 348",
    "ticketMedianoSimuladoFmt": "R$ 324",
    "valorTotalAcumuladoSimuladoFmt": "R$ 348",
    "maiorPedidoSimuladoFmt": "R$ 406",
    "menorPedidoSimuladoFmt": "R$ 239",
    "primeiraCompraSimulada": "25/12/2025",
    "ultimaCompraSimulada": "18/04/2026",
    "diasDesdeUltimaCompraSimulado": 26,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Baixa",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0173"
  },
  {
    "clienteId": "CLI_0174",
    "clienteAnonimo": "173",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 317,
    "ticketMedianoSimulado": 312,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 634,
    "maiorPedidoSimulado": 341,
    "menorPedidoSimulado": 184,
    "ticketMedioSimuladoFmt": "R$ 317",
    "ticketMedianoSimuladoFmt": "R$ 312",
    "valorTotalAcumuladoSimuladoFmt": "R$ 634",
    "maiorPedidoSimuladoFmt": "R$ 341",
    "menorPedidoSimuladoFmt": "R$ 184",
    "primeiraCompraSimulada": "09/12/2025",
    "ultimaCompraSimulada": "01/05/2026",
    "diasDesdeUltimaCompraSimulado": 13,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Baixa",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0174"
  },
  {
    "clienteId": "CLI_0175",
    "clienteAnonimo": "174",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 286,
    "ticketMedianoSimulado": 270,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 572,
    "maiorPedidoSimulado": 319,
    "menorPedidoSimulado": 179,
    "ticketMedioSimuladoFmt": "R$ 286",
    "ticketMedianoSimuladoFmt": "R$ 270",
    "valorTotalAcumuladoSimuladoFmt": "R$ 572",
    "maiorPedidoSimuladoFmt": "R$ 319",
    "menorPedidoSimuladoFmt": "R$ 179",
    "primeiraCompraSimulada": "23/11/2025",
    "ultimaCompraSimulada": "22/03/2026",
    "diasDesdeUltimaCompraSimulado": 53,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Baixa",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0175"
  },
  {
    "clienteId": "CLI_0176",
    "clienteAnonimo": "175",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 255,
    "ticketMedianoSimulado": 247,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 510,
    "maiorPedidoSimulado": 305,
    "menorPedidoSimulado": 184,
    "ticketMedioSimuladoFmt": "R$ 255",
    "ticketMedianoSimuladoFmt": "R$ 247",
    "valorTotalAcumuladoSimuladoFmt": "R$ 510",
    "maiorPedidoSimuladoFmt": "R$ 305",
    "menorPedidoSimuladoFmt": "R$ 184",
    "primeiraCompraSimulada": "07/11/2025",
    "ultimaCompraSimulada": "12/02/2026",
    "diasDesdeUltimaCompraSimulado": 91,
    "hipoteseDePerfil": "Compra compatível com abastecimento maior, família ou rotina intensa.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Baixa",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0176"
  },
  {
    "clienteId": "CLI_0177",
    "clienteAnonimo": "176",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 275,
    "ticketMedianoSimulado": 264,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 550,
    "maiorPedidoSimulado": 304,
    "menorPedidoSimulado": 169,
    "ticketMedioSimuladoFmt": "R$ 275",
    "ticketMedianoSimuladoFmt": "R$ 264",
    "valorTotalAcumuladoSimuladoFmt": "R$ 550",
    "maiorPedidoSimuladoFmt": "R$ 304",
    "menorPedidoSimuladoFmt": "R$ 169",
    "primeiraCompraSimulada": "04/11/2025",
    "ultimaCompraSimulada": "26/03/2026",
    "diasDesdeUltimaCompraSimulado": 49,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Baixa",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0177"
  },
  {
    "clienteId": "CLI_0178",
    "clienteAnonimo": "177",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 306,
    "ticketMedianoSimulado": 292,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 306,
    "maiorPedidoSimulado": 332,
    "menorPedidoSimulado": 181,
    "ticketMedioSimuladoFmt": "R$ 306",
    "ticketMedianoSimuladoFmt": "R$ 292",
    "valorTotalAcumuladoSimuladoFmt": "R$ 306",
    "maiorPedidoSimuladoFmt": "R$ 332",
    "menorPedidoSimuladoFmt": "R$ 181",
    "primeiraCompraSimulada": "20/11/2025",
    "ultimaCompraSimulada": "09/05/2026",
    "diasDesdeUltimaCompraSimulado": 5,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Baixa",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0178"
  },
  {
    "clienteId": "CLI_0179",
    "clienteAnonimo": "178",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 337,
    "ticketMedianoSimulado": 328,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 674,
    "maiorPedidoSimulado": 396,
    "menorPedidoSimulado": 234,
    "ticketMedioSimuladoFmt": "R$ 337",
    "ticketMedianoSimuladoFmt": "R$ 328",
    "valorTotalAcumuladoSimuladoFmt": "R$ 674",
    "maiorPedidoSimuladoFmt": "R$ 396",
    "menorPedidoSimuladoFmt": "R$ 234",
    "primeiraCompraSimulada": "06/12/2025",
    "ultimaCompraSimulada": "07/04/2026",
    "diasDesdeUltimaCompraSimulado": 37,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Baixa",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0179"
  },
  {
    "clienteId": "CLI_0180",
    "clienteAnonimo": "179",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 278,
    "ticketMedianoSimulado": 274,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 556,
    "maiorPedidoSimulado": 323,
    "menorPedidoSimulado": 189,
    "ticketMedioSimuladoFmt": "R$ 278",
    "ticketMedianoSimuladoFmt": "R$ 274",
    "valorTotalAcumuladoSimuladoFmt": "R$ 556",
    "maiorPedidoSimuladoFmt": "R$ 323",
    "menorPedidoSimuladoFmt": "R$ 189",
    "primeiraCompraSimulada": "23/01/2026",
    "ultimaCompraSimulada": "17/04/2026",
    "diasDesdeUltimaCompraSimulado": 27,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Baixa",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0180"
  },
  {
    "clienteId": "CLI_0181",
    "clienteAnonimo": "180",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 308,
    "ticketMedianoSimulado": 285,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 308,
    "maiorPedidoSimulado": 330,
    "menorPedidoSimulado": 177,
    "ticketMedioSimuladoFmt": "R$ 308",
    "ticketMedianoSimuladoFmt": "R$ 285",
    "valorTotalAcumuladoSimuladoFmt": "R$ 308",
    "maiorPedidoSimuladoFmt": "R$ 330",
    "menorPedidoSimuladoFmt": "R$ 177",
    "primeiraCompraSimulada": "08/02/2026",
    "ultimaCompraSimulada": "10/05/2026",
    "diasDesdeUltimaCompraSimulado": 4,
    "hipoteseDePerfil": "Comportamento de compra típico do mix observado.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Baixa",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0181"
  },
  {
    "clienteId": "CLI_0182",
    "clienteAnonimo": "181",
    "segmentoComercial": "Cliente em atenção",
    "ticketMedioSimulado": 339,
    "ticketMedianoSimulado": 339,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 678,
    "maiorPedidoSimulado": 380,
    "menorPedidoSimulado": 214,
    "ticketMedioSimuladoFmt": "R$ 339",
    "ticketMedianoSimuladoFmt": "R$ 339",
    "valorTotalAcumuladoSimuladoFmt": "R$ 678",
    "maiorPedidoSimuladoFmt": "R$ 380",
    "menorPedidoSimuladoFmt": "R$ 214",
    "primeiraCompraSimulada": "24/02/2026",
    "ultimaCompraSimulada": "23/04/2026",
    "diasDesdeUltimaCompraSimulado": 21,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode buscar praticidade",
    "propensaoARecompra": "Baixa",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0182"
  },
  {
    "clienteId": "CLI_0183",
    "clienteAnonimo": "182",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 382,
    "ticketMedianoSimulado": 354,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 764,
    "maiorPedidoSimulado": 454,
    "menorPedidoSimulado": 272,
    "ticketMedioSimuladoFmt": "R$ 382",
    "ticketMedianoSimuladoFmt": "R$ 354",
    "valorTotalAcumuladoSimuladoFmt": "R$ 764",
    "maiorPedidoSimuladoFmt": "R$ 454",
    "menorPedidoSimuladoFmt": "R$ 272",
    "primeiraCompraSimulada": "12/03/2026",
    "ultimaCompraSimulada": "13/04/2026",
    "diasDesdeUltimaCompraSimulado": 31,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0183"
  },
  {
    "clienteId": "CLI_0184",
    "clienteAnonimo": "183",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 408,
    "ticketMedianoSimulado": 402,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 816,
    "maiorPedidoSimulado": 449,
    "menorPedidoSimulado": 248,
    "ticketMedioSimuladoFmt": "R$ 408",
    "ticketMedianoSimuladoFmt": "R$ 402",
    "valorTotalAcumuladoSimuladoFmt": "R$ 816",
    "maiorPedidoSimuladoFmt": "R$ 449",
    "menorPedidoSimuladoFmt": "R$ 248",
    "primeiraCompraSimulada": "28/03/2026",
    "ultimaCompraSimulada": "28/04/2026",
    "diasDesdeUltimaCompraSimulado": 16,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0184"
  },
  {
    "clienteId": "CLI_0185",
    "clienteAnonimo": "184",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 435,
    "ticketMedianoSimulado": 410,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 870,
    "maiorPedidoSimulado": 474,
    "menorPedidoSimulado": 260,
    "ticketMedioSimuladoFmt": "R$ 435",
    "ticketMedianoSimuladoFmt": "R$ 410",
    "valorTotalAcumuladoSimuladoFmt": "R$ 870",
    "maiorPedidoSimuladoFmt": "R$ 474",
    "menorPedidoSimuladoFmt": "R$ 260",
    "primeiraCompraSimulada": "13/04/2026",
    "ultimaCompraSimulada": "09/05/2026",
    "diasDesdeUltimaCompraSimulado": 5,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0185"
  },
  {
    "clienteId": "CLI_0186",
    "clienteAnonimo": "185",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 439,
    "ticketMedianoSimulado": 426,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 878,
    "maiorPedidoSimulado": 518,
    "menorPedidoSimulado": 309,
    "ticketMedioSimuladoFmt": "R$ 439",
    "ticketMedianoSimuladoFmt": "R$ 426",
    "valorTotalAcumuladoSimuladoFmt": "R$ 878",
    "maiorPedidoSimuladoFmt": "R$ 518",
    "menorPedidoSimuladoFmt": "R$ 309",
    "primeiraCompraSimulada": "30/03/2026",
    "ultimaCompraSimulada": "04/05/2026",
    "diasDesdeUltimaCompraSimulado": 10,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0186"
  },
  {
    "clienteId": "CLI_0187",
    "clienteAnonimo": "186",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 413,
    "ticketMedianoSimulado": 395,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 826,
    "maiorPedidoSimulado": 466,
    "menorPedidoSimulado": 265,
    "ticketMedioSimuladoFmt": "R$ 413",
    "ticketMedianoSimuladoFmt": "R$ 395",
    "valorTotalAcumuladoSimuladoFmt": "R$ 826",
    "maiorPedidoSimuladoFmt": "R$ 466",
    "menorPedidoSimuladoFmt": "R$ 265",
    "primeiraCompraSimulada": "14/03/2026",
    "ultimaCompraSimulada": "18/04/2026",
    "diasDesdeUltimaCompraSimulado": 26,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0187"
  },
  {
    "clienteId": "CLI_0188",
    "clienteAnonimo": "187",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 387,
    "ticketMedianoSimulado": 370,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 774,
    "maiorPedidoSimulado": 411,
    "menorPedidoSimulado": 218,
    "ticketMedioSimuladoFmt": "R$ 387",
    "ticketMedianoSimuladoFmt": "R$ 370",
    "valorTotalAcumuladoSimuladoFmt": "R$ 774",
    "maiorPedidoSimuladoFmt": "R$ 411",
    "menorPedidoSimuladoFmt": "R$ 218",
    "primeiraCompraSimulada": "26/02/2026",
    "ultimaCompraSimulada": "13/04/2026",
    "diasDesdeUltimaCompraSimulado": 31,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0188"
  },
  {
    "clienteId": "CLI_0189",
    "clienteAnonimo": "188",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 361,
    "ticketMedianoSimulado": 350,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1083,
    "maiorPedidoSimulado": 416,
    "menorPedidoSimulado": 241,
    "ticketMedioSimuladoFmt": "R$ 361",
    "ticketMedianoSimuladoFmt": "R$ 350",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.083",
    "maiorPedidoSimuladoFmt": "R$ 416",
    "menorPedidoSimuladoFmt": "R$ 241",
    "primeiraCompraSimulada": "10/02/2026",
    "ultimaCompraSimulada": "28/04/2026",
    "diasDesdeUltimaCompraSimulado": 16,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0189"
  },
  {
    "clienteId": "CLI_0190",
    "clienteAnonimo": "189",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 411,
    "ticketMedianoSimulado": 404,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1233,
    "maiorPedidoSimulado": 486,
    "menorPedidoSimulado": 290,
    "ticketMedioSimuladoFmt": "R$ 411",
    "ticketMedianoSimuladoFmt": "R$ 404",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.233",
    "maiorPedidoSimuladoFmt": "R$ 486",
    "menorPedidoSimuladoFmt": "R$ 290",
    "primeiraCompraSimulada": "23/12/2025",
    "ultimaCompraSimulada": "15/03/2026",
    "diasDesdeUltimaCompraSimulado": 60,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0190"
  },
  {
    "clienteId": "CLI_0191",
    "clienteAnonimo": "190",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 385,
    "ticketMedianoSimulado": 358,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 385,
    "maiorPedidoSimulado": 421,
    "menorPedidoSimulado": 231,
    "ticketMedioSimuladoFmt": "R$ 385",
    "ticketMedianoSimuladoFmt": "R$ 358",
    "valorTotalAcumuladoSimuladoFmt": "R$ 385",
    "maiorPedidoSimuladoFmt": "R$ 421",
    "menorPedidoSimuladoFmt": "R$ 231",
    "primeiraCompraSimulada": "07/12/2025",
    "ultimaCompraSimulada": "17/03/2026",
    "diasDesdeUltimaCompraSimulado": 58,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0191"
  },
  {
    "clienteId": "CLI_0192",
    "clienteAnonimo": "191",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 359,
    "ticketMedianoSimulado": 358,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1077,
    "maiorPedidoSimulado": 394,
    "menorPedidoSimulado": 217,
    "ticketMedioSimuladoFmt": "R$ 359",
    "ticketMedianoSimuladoFmt": "R$ 358",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.077",
    "maiorPedidoSimuladoFmt": "R$ 394",
    "menorPedidoSimuladoFmt": "R$ 217",
    "primeiraCompraSimulada": "21/11/2025",
    "ultimaCompraSimulada": "20/04/2026",
    "diasDesdeUltimaCompraSimulado": 24,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0192"
  },
  {
    "clienteId": "CLI_0193",
    "clienteAnonimo": "192",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 333,
    "ticketMedianoSimulado": 308,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 666,
    "maiorPedidoSimulado": 395,
    "menorPedidoSimulado": 236,
    "ticketMedioSimuladoFmt": "R$ 333",
    "ticketMedianoSimuladoFmt": "R$ 308",
    "valorTotalAcumuladoSimuladoFmt": "R$ 666",
    "maiorPedidoSimuladoFmt": "R$ 395",
    "menorPedidoSimuladoFmt": "R$ 236",
    "primeiraCompraSimulada": "05/11/2025",
    "ultimaCompraSimulada": "21/04/2026",
    "diasDesdeUltimaCompraSimulado": 23,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0193"
  },
  {
    "clienteId": "CLI_0194",
    "clienteAnonimo": "193",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 306,
    "ticketMedianoSimulado": 302,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 612,
    "maiorPedidoSimulado": 344,
    "menorPedidoSimulado": 194,
    "ticketMedioSimuladoFmt": "R$ 306",
    "ticketMedianoSimuladoFmt": "R$ 302",
    "valorTotalAcumuladoSimuladoFmt": "R$ 612",
    "maiorPedidoSimuladoFmt": "R$ 344",
    "menorPedidoSimuladoFmt": "R$ 194",
    "primeiraCompraSimulada": "06/11/2025",
    "ultimaCompraSimulada": "09/03/2026",
    "diasDesdeUltimaCompraSimulado": 66,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0194"
  },
  {
    "clienteId": "CLI_0195",
    "clienteAnonimo": "194",
    "segmentoComercial": "Cliente alto valor",
    "ticketMedioSimulado": 850,
    "ticketMedianoSimulado": 799,
    "totalPedidosSimulado": 5,
    "valorTotalAcumuladoSimulado": 4250,
    "maiorPedidoSimulado": 907,
    "menorPedidoSimulado": 485,
    "ticketMedioSimuladoFmt": "R$ 850",
    "ticketMedianoSimuladoFmt": "R$ 799",
    "valorTotalAcumuladoSimuladoFmt": "R$ 4.250",
    "maiorPedidoSimuladoFmt": "R$ 907",
    "menorPedidoSimuladoFmt": "R$ 485",
    "primeiraCompraSimulada": "22/11/2025",
    "ultimaCompraSimulada": "27/02/2026",
    "diasDesdeUltimaCompraSimulado": 76,
    "hipoteseDePerfil": "Compra compatível com abastecimento maior, família ou rotina intensa.",
    "objetivoProvavel": "Pode buscar abastecimento maior ou comprar para várias pessoas",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0195"
  },
  {
    "clienteId": "CLI_0196",
    "clienteAnonimo": "195",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 306,
    "ticketMedianoSimulado": 298,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 612,
    "maiorPedidoSimulado": 354,
    "menorPedidoSimulado": 207,
    "ticketMedioSimuladoFmt": "R$ 306",
    "ticketMedianoSimuladoFmt": "R$ 298",
    "valorTotalAcumuladoSimuladoFmt": "R$ 612",
    "maiorPedidoSimuladoFmt": "R$ 354",
    "menorPedidoSimuladoFmt": "R$ 207",
    "primeiraCompraSimulada": "08/12/2025",
    "ultimaCompraSimulada": "10/04/2026",
    "diasDesdeUltimaCompraSimulado": 34,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0196"
  },
  {
    "clienteId": "CLI_0197",
    "clienteAnonimo": "196",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 332,
    "ticketMedianoSimulado": 317,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 664,
    "maiorPedidoSimulado": 382,
    "menorPedidoSimulado": 222,
    "ticketMedioSimuladoFmt": "R$ 332",
    "ticketMedianoSimuladoFmt": "R$ 317",
    "valorTotalAcumuladoSimuladoFmt": "R$ 664",
    "maiorPedidoSimuladoFmt": "R$ 382",
    "menorPedidoSimuladoFmt": "R$ 222",
    "primeiraCompraSimulada": "23/12/2025",
    "ultimaCompraSimulada": "06/05/2026",
    "diasDesdeUltimaCompraSimulado": 8,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0197"
  },
  {
    "clienteId": "CLI_0198",
    "clienteAnonimo": "197",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 358,
    "ticketMedianoSimulado": 343,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 716,
    "maiorPedidoSimulado": 380,
    "menorPedidoSimulado": 202,
    "ticketMedioSimuladoFmt": "R$ 358",
    "ticketMedianoSimuladoFmt": "R$ 343",
    "valorTotalAcumuladoSimuladoFmt": "R$ 716",
    "maiorPedidoSimuladoFmt": "R$ 380",
    "menorPedidoSimuladoFmt": "R$ 202",
    "primeiraCompraSimulada": "08/01/2026",
    "ultimaCompraSimulada": "09/04/2026",
    "diasDesdeUltimaCompraSimulado": 35,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0198"
  },
  {
    "clienteId": "CLI_0199",
    "clienteAnonimo": "198",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 385,
    "ticketMedianoSimulado": 373,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1155,
    "maiorPedidoSimulado": 434,
    "menorPedidoSimulado": 247,
    "ticketMedioSimuladoFmt": "R$ 385",
    "ticketMedianoSimuladoFmt": "R$ 373",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.155",
    "maiorPedidoSimuladoFmt": "R$ 434",
    "menorPedidoSimuladoFmt": "R$ 247",
    "primeiraCompraSimulada": "24/01/2026",
    "ultimaCompraSimulada": "19/03/2026",
    "diasDesdeUltimaCompraSimulado": 56,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0199"
  },
  {
    "clienteId": "CLI_0200",
    "clienteAnonimo": "199",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 384,
    "ticketMedianoSimulado": 354,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 384,
    "maiorPedidoSimulado": 437,
    "menorPedidoSimulado": 251,
    "ticketMedioSimuladoFmt": "R$ 384",
    "ticketMedianoSimuladoFmt": "R$ 354",
    "valorTotalAcumuladoSimuladoFmt": "R$ 384",
    "maiorPedidoSimuladoFmt": "R$ 437",
    "menorPedidoSimuladoFmt": "R$ 251",
    "primeiraCompraSimulada": "11/03/2026",
    "ultimaCompraSimulada": "24/04/2026",
    "diasDesdeUltimaCompraSimulado": 20,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0200"
  },
  {
    "clienteId": "CLI_0201",
    "clienteAnonimo": "200",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 358,
    "ticketMedianoSimulado": 354,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 716,
    "maiorPedidoSimulado": 376,
    "menorPedidoSimulado": 198,
    "ticketMedioSimuladoFmt": "R$ 358",
    "ticketMedianoSimuladoFmt": "R$ 354",
    "valorTotalAcumuladoSimuladoFmt": "R$ 716",
    "maiorPedidoSimuladoFmt": "R$ 376",
    "menorPedidoSimuladoFmt": "R$ 198",
    "primeiraCompraSimulada": "23/02/2026",
    "ultimaCompraSimulada": "07/05/2026",
    "diasDesdeUltimaCompraSimulado": 7,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0201"
  },
  {
    "clienteId": "CLI_0202",
    "clienteAnonimo": "201",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 332,
    "ticketMedianoSimulado": 311,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 664,
    "maiorPedidoSimulado": 379,
    "menorPedidoSimulado": 218,
    "ticketMedioSimuladoFmt": "R$ 332",
    "ticketMedianoSimuladoFmt": "R$ 311",
    "valorTotalAcumuladoSimuladoFmt": "R$ 664",
    "maiorPedidoSimuladoFmt": "R$ 379",
    "menorPedidoSimuladoFmt": "R$ 218",
    "primeiraCompraSimulada": "07/02/2026",
    "ultimaCompraSimulada": "24/04/2026",
    "diasDesdeUltimaCompraSimulado": 20,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0202"
  },
  {
    "clienteId": "CLI_0203",
    "clienteAnonimo": "202",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 306,
    "ticketMedianoSimulado": 299,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 612,
    "maiorPedidoSimulado": 357,
    "menorPedidoSimulado": 210,
    "ticketMedioSimuladoFmt": "R$ 306",
    "ticketMedianoSimuladoFmt": "R$ 299",
    "valorTotalAcumuladoSimuladoFmt": "R$ 612",
    "maiorPedidoSimuladoFmt": "R$ 357",
    "menorPedidoSimuladoFmt": "R$ 210",
    "primeiraCompraSimulada": "22/01/2026",
    "ultimaCompraSimulada": "27/03/2026",
    "diasDesdeUltimaCompraSimulado": 48,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0203"
  },
  {
    "clienteId": "CLI_0204",
    "clienteAnonimo": "203",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 281,
    "ticketMedianoSimulado": 267,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 562,
    "maiorPedidoSimulado": 303,
    "menorPedidoSimulado": 164,
    "ticketMedioSimuladoFmt": "R$ 281",
    "ticketMedianoSimuladoFmt": "R$ 267",
    "valorTotalAcumuladoSimuladoFmt": "R$ 562",
    "maiorPedidoSimuladoFmt": "R$ 303",
    "menorPedidoSimuladoFmt": "R$ 164",
    "primeiraCompraSimulada": "06/01/2026",
    "ultimaCompraSimulada": "28/03/2026",
    "diasDesdeUltimaCompraSimulado": 47,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0204"
  },
  {
    "clienteId": "CLI_0205",
    "clienteAnonimo": "204",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 307,
    "ticketMedianoSimulado": 295,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 614,
    "maiorPedidoSimulado": 341,
    "menorPedidoSimulado": 191,
    "ticketMedioSimuladoFmt": "R$ 307",
    "ticketMedianoSimuladoFmt": "R$ 295",
    "valorTotalAcumuladoSimuladoFmt": "R$ 614",
    "maiorPedidoSimuladoFmt": "R$ 341",
    "menorPedidoSimuladoFmt": "R$ 191",
    "primeiraCompraSimulada": "21/12/2025",
    "ultimaCompraSimulada": "24/04/2026",
    "diasDesdeUltimaCompraSimulado": 20,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0205"
  },
  {
    "clienteId": "CLI_0206",
    "clienteAnonimo": "205",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 333,
    "ticketMedianoSimulado": 322,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 999,
    "maiorPedidoSimulado": 399,
    "menorPedidoSimulado": 240,
    "ticketMedioSimuladoFmt": "R$ 333",
    "ticketMedianoSimuladoFmt": "R$ 322",
    "valorTotalAcumuladoSimuladoFmt": "R$ 999",
    "maiorPedidoSimuladoFmt": "R$ 399",
    "menorPedidoSimuladoFmt": "R$ 240",
    "primeiraCompraSimulada": "05/12/2025",
    "ultimaCompraSimulada": "24/04/2026",
    "diasDesdeUltimaCompraSimulado": 20,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0206"
  },
  {
    "clienteId": "CLI_0207",
    "clienteAnonimo": "206",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 359,
    "ticketMedianoSimulado": 340,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 359,
    "maiorPedidoSimulado": 398,
    "menorPedidoSimulado": 221,
    "ticketMedioSimuladoFmt": "R$ 359",
    "ticketMedianoSimuladoFmt": "R$ 340",
    "valorTotalAcumuladoSimuladoFmt": "R$ 359",
    "maiorPedidoSimuladoFmt": "R$ 398",
    "menorPedidoSimuladoFmt": "R$ 221",
    "primeiraCompraSimulada": "19/11/2025",
    "ultimaCompraSimulada": "13/03/2026",
    "diasDesdeUltimaCompraSimulado": 62,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0207"
  },
  {
    "clienteId": "CLI_0208",
    "clienteAnonimo": "207",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 385,
    "ticketMedianoSimulado": 377,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1155,
    "maiorPedidoSimulado": 417,
    "menorPedidoSimulado": 227,
    "ticketMedioSimuladoFmt": "R$ 385",
    "ticketMedianoSimuladoFmt": "R$ 377",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.155",
    "maiorPedidoSimuladoFmt": "R$ 417",
    "menorPedidoSimuladoFmt": "R$ 227",
    "primeiraCompraSimulada": "03/11/2025",
    "ultimaCompraSimulada": "19/02/2026",
    "diasDesdeUltimaCompraSimulado": 84,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0208"
  },
  {
    "clienteId": "CLI_0209",
    "clienteAnonimo": "208",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 412,
    "ticketMedianoSimulado": 384,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 412,
    "maiorPedidoSimulado": 483,
    "menorPedidoSimulado": 286,
    "ticketMedioSimuladoFmt": "R$ 412",
    "ticketMedianoSimuladoFmt": "R$ 384",
    "valorTotalAcumuladoSimuladoFmt": "R$ 412",
    "maiorPedidoSimuladoFmt": "R$ 483",
    "menorPedidoSimuladoFmt": "R$ 286",
    "primeiraCompraSimulada": "07/11/2025",
    "ultimaCompraSimulada": "05/04/2026",
    "diasDesdeUltimaCompraSimulado": 39,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0209"
  },
  {
    "clienteId": "CLI_0210",
    "clienteAnonimo": "209",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 361,
    "ticketMedianoSimulado": 332,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 361,
    "maiorPedidoSimulado": 419,
    "menorPedidoSimulado": 246,
    "ticketMedioSimuladoFmt": "R$ 361",
    "ticketMedianoSimuladoFmt": "R$ 332",
    "valorTotalAcumuladoSimuladoFmt": "R$ 361",
    "maiorPedidoSimuladoFmt": "R$ 419",
    "menorPedidoSimuladoFmt": "R$ 246",
    "primeiraCompraSimulada": "26/12/2025",
    "ultimaCompraSimulada": "23/03/2026",
    "diasDesdeUltimaCompraSimulado": 52,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0210"
  },
  {
    "clienteId": "CLI_0211",
    "clienteAnonimo": "210",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 387,
    "ticketMedianoSimulado": 384,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 774,
    "maiorPedidoSimulado": 415,
    "menorPedidoSimulado": 223,
    "ticketMedioSimuladoFmt": "R$ 387",
    "ticketMedianoSimuladoFmt": "R$ 384",
    "valorTotalAcumuladoSimuladoFmt": "R$ 774",
    "maiorPedidoSimuladoFmt": "R$ 415",
    "menorPedidoSimuladoFmt": "R$ 223",
    "primeiraCompraSimulada": "11/01/2026",
    "ultimaCompraSimulada": "23/03/2026",
    "diasDesdeUltimaCompraSimulado": 52,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0211"
  },
  {
    "clienteId": "CLI_0212",
    "clienteAnonimo": "211",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 413,
    "ticketMedianoSimulado": 386,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 826,
    "maiorPedidoSimulado": 462,
    "menorPedidoSimulado": 260,
    "ticketMedioSimuladoFmt": "R$ 413",
    "ticketMedianoSimuladoFmt": "R$ 386",
    "valorTotalAcumuladoSimuladoFmt": "R$ 826",
    "maiorPedidoSimuladoFmt": "R$ 462",
    "menorPedidoSimuladoFmt": "R$ 260",
    "primeiraCompraSimulada": "27/01/2026",
    "ultimaCompraSimulada": "22/04/2026",
    "diasDesdeUltimaCompraSimulado": 22,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0212"
  },
  {
    "clienteId": "CLI_0213",
    "clienteAnonimo": "212",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 440,
    "ticketMedianoSimulado": 430,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 880,
    "maiorPedidoSimulado": 524,
    "menorPedidoSimulado": 314,
    "ticketMedioSimuladoFmt": "R$ 440",
    "ticketMedianoSimuladoFmt": "R$ 430",
    "valorTotalAcumuladoSimuladoFmt": "R$ 880",
    "maiorPedidoSimuladoFmt": "R$ 524",
    "menorPedidoSimuladoFmt": "R$ 314",
    "primeiraCompraSimulada": "12/02/2026",
    "ultimaCompraSimulada": "06/05/2026",
    "diasDesdeUltimaCompraSimulado": 8,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0213"
  },
  {
    "clienteId": "CLI_0214",
    "clienteAnonimo": "213",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 434,
    "ticketMedianoSimulado": 412,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 868,
    "maiorPedidoSimulado": 478,
    "menorPedidoSimulado": 265,
    "ticketMedioSimuladoFmt": "R$ 434",
    "ticketMedianoSimuladoFmt": "R$ 412",
    "valorTotalAcumuladoSimuladoFmt": "R$ 868",
    "maiorPedidoSimuladoFmt": "R$ 478",
    "menorPedidoSimuladoFmt": "R$ 265",
    "primeiraCompraSimulada": "28/02/2026",
    "ultimaCompraSimulada": "21/04/2026",
    "diasDesdeUltimaCompraSimulado": 23,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0214"
  },
  {
    "clienteId": "CLI_0215",
    "clienteAnonimo": "214",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 408,
    "ticketMedianoSimulado": 393,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 816,
    "maiorPedidoSimulado": 444,
    "menorPedidoSimulado": 243,
    "ticketMedioSimuladoFmt": "R$ 408",
    "ticketMedianoSimuladoFmt": "R$ 393",
    "valorTotalAcumuladoSimuladoFmt": "R$ 816",
    "maiorPedidoSimuladoFmt": "R$ 444",
    "menorPedidoSimuladoFmt": "R$ 243",
    "primeiraCompraSimulada": "16/03/2026",
    "ultimaCompraSimulada": "14/04/2026",
    "diasDesdeUltimaCompraSimulado": 30,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0215"
  },
  {
    "clienteId": "CLI_0216",
    "clienteAnonimo": "215",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 382,
    "ticketMedianoSimulado": 368,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 764,
    "maiorPedidoSimulado": 451,
    "menorPedidoSimulado": 268,
    "ticketMedioSimuladoFmt": "R$ 382",
    "ticketMedianoSimuladoFmt": "R$ 368",
    "valorTotalAcumuladoSimuladoFmt": "R$ 764",
    "maiorPedidoSimuladoFmt": "R$ 451",
    "menorPedidoSimuladoFmt": "R$ 268",
    "primeiraCompraSimulada": "01/04/2026",
    "ultimaCompraSimulada": "01/05/2026",
    "diasDesdeUltimaCompraSimulado": 13,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0216"
  },
  {
    "clienteId": "CLI_0217",
    "clienteAnonimo": "216",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 355,
    "ticketMedianoSimulado": 337,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 355,
    "maiorPedidoSimulado": 401,
    "menorPedidoSimulado": 229,
    "ticketMedioSimuladoFmt": "R$ 355",
    "ticketMedianoSimuladoFmt": "R$ 337",
    "valorTotalAcumuladoSimuladoFmt": "R$ 355",
    "maiorPedidoSimuladoFmt": "R$ 401",
    "menorPedidoSimuladoFmt": "R$ 229",
    "primeiraCompraSimulada": "11/04/2026",
    "ultimaCompraSimulada": "10/05/2026",
    "diasDesdeUltimaCompraSimulado": 4,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0217"
  },
  {
    "clienteId": "CLI_0218",
    "clienteAnonimo": "217",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 329,
    "ticketMedianoSimulado": 322,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 987,
    "maiorPedidoSimulado": 349,
    "menorPedidoSimulado": 185,
    "ticketMedioSimuladoFmt": "R$ 329",
    "ticketMedianoSimuladoFmt": "R$ 322",
    "valorTotalAcumuladoSimuladoFmt": "R$ 987",
    "maiorPedidoSimuladoFmt": "R$ 349",
    "menorPedidoSimuladoFmt": "R$ 185",
    "primeiraCompraSimulada": "26/03/2026",
    "ultimaCompraSimulada": "01/05/2026",
    "diasDesdeUltimaCompraSimulado": 13,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0218"
  },
  {
    "clienteId": "CLI_0219",
    "clienteAnonimo": "218",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 303,
    "ticketMedianoSimulado": 283,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 303,
    "maiorPedidoSimulado": 348,
    "menorPedidoSimulado": 202,
    "ticketMedioSimuladoFmt": "R$ 303",
    "ticketMedianoSimuladoFmt": "R$ 283",
    "valorTotalAcumuladoSimuladoFmt": "R$ 303",
    "maiorPedidoSimuladoFmt": "R$ 348",
    "menorPedidoSimuladoFmt": "R$ 202",
    "primeiraCompraSimulada": "10/03/2026",
    "ultimaCompraSimulada": "14/04/2026",
    "diasDesdeUltimaCompraSimulado": 30,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0219"
  },
  {
    "clienteId": "CLI_0220",
    "clienteAnonimo": "219",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 354,
    "ticketMedianoSimulado": 326,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 354,
    "maiorPedidoSimulado": 419,
    "menorPedidoSimulado": 250,
    "ticketMedioSimuladoFmt": "R$ 354",
    "ticketMedianoSimuladoFmt": "R$ 326",
    "valorTotalAcumuladoSimuladoFmt": "R$ 354",
    "maiorPedidoSimuladoFmt": "R$ 419",
    "menorPedidoSimuladoFmt": "R$ 250",
    "primeiraCompraSimulada": "21/01/2026",
    "ultimaCompraSimulada": "11/05/2026",
    "diasDesdeUltimaCompraSimulado": 3,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0220"
  },
  {
    "clienteId": "CLI_0221",
    "clienteAnonimo": "220",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 327,
    "ticketMedianoSimulado": 325,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 654,
    "maiorPedidoSimulado": 358,
    "menorPedidoSimulado": 197,
    "ticketMedioSimuladoFmt": "R$ 327",
    "ticketMedianoSimuladoFmt": "R$ 325",
    "valorTotalAcumuladoSimuladoFmt": "R$ 654",
    "maiorPedidoSimuladoFmt": "R$ 358",
    "menorPedidoSimuladoFmt": "R$ 197",
    "primeiraCompraSimulada": "05/01/2026",
    "ultimaCompraSimulada": "12/04/2026",
    "diasDesdeUltimaCompraSimulado": 32,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0221"
  },
  {
    "clienteId": "CLI_0222",
    "clienteAnonimo": "221",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 301,
    "ticketMedianoSimulado": 281,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 602,
    "maiorPedidoSimulado": 330,
    "menorPedidoSimulado": 182,
    "ticketMedioSimuladoFmt": "R$ 301",
    "ticketMedianoSimuladoFmt": "R$ 281",
    "valorTotalAcumuladoSimuladoFmt": "R$ 602",
    "maiorPedidoSimuladoFmt": "R$ 330",
    "menorPedidoSimuladoFmt": "R$ 182",
    "primeiraCompraSimulada": "20/12/2025",
    "ultimaCompraSimulada": "07/03/2026",
    "diasDesdeUltimaCompraSimulado": 68,
    "hipoteseDePerfil": "Compra compatível com abastecimento maior, família ou rotina intensa.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0222"
  },
  {
    "clienteId": "CLI_0223",
    "clienteAnonimo": "222",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 285,
    "ticketMedianoSimulado": 279,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 570,
    "maiorPedidoSimulado": 338,
    "menorPedidoSimulado": 202,
    "ticketMedioSimuladoFmt": "R$ 285",
    "ticketMedianoSimuladoFmt": "R$ 279",
    "valorTotalAcumuladoSimuladoFmt": "R$ 570",
    "maiorPedidoSimuladoFmt": "R$ 338",
    "menorPedidoSimuladoFmt": "R$ 202",
    "primeiraCompraSimulada": "04/12/2025",
    "ultimaCompraSimulada": "23/03/2026",
    "diasDesdeUltimaCompraSimulado": 52,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0223"
  },
  {
    "clienteId": "CLI_0224",
    "clienteAnonimo": "223",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 311,
    "ticketMedianoSimulado": 294,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 622,
    "maiorPedidoSimulado": 350,
    "menorPedidoSimulado": 198,
    "ticketMedioSimuladoFmt": "R$ 311",
    "ticketMedianoSimuladoFmt": "R$ 294",
    "valorTotalAcumuladoSimuladoFmt": "R$ 622",
    "maiorPedidoSimuladoFmt": "R$ 350",
    "menorPedidoSimuladoFmt": "R$ 198",
    "primeiraCompraSimulada": "18/11/2025",
    "ultimaCompraSimulada": "27/04/2026",
    "diasDesdeUltimaCompraSimulado": 17,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0224"
  },
  {
    "clienteId": "CLI_0225",
    "clienteAnonimo": "224",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 337,
    "ticketMedianoSimulado": 326,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 674,
    "maiorPedidoSimulado": 359,
    "menorPedidoSimulado": 192,
    "ticketMedioSimuladoFmt": "R$ 337",
    "ticketMedianoSimuladoFmt": "R$ 326",
    "valorTotalAcumuladoSimuladoFmt": "R$ 674",
    "maiorPedidoSimuladoFmt": "R$ 359",
    "menorPedidoSimuladoFmt": "R$ 192",
    "primeiraCompraSimulada": "02/11/2025",
    "ultimaCompraSimulada": "12/04/2026",
    "diasDesdeUltimaCompraSimulado": 32,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0225"
  },
  {
    "clienteId": "CLI_0226",
    "clienteAnonimo": "225",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 364,
    "ticketMedianoSimulado": 350,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 728,
    "maiorPedidoSimulado": 421,
    "menorPedidoSimulado": 245,
    "ticketMedioSimuladoFmt": "R$ 364",
    "ticketMedianoSimuladoFmt": "R$ 350",
    "valorTotalAcumuladoSimuladoFmt": "R$ 728",
    "maiorPedidoSimuladoFmt": "R$ 421",
    "menorPedidoSimuladoFmt": "R$ 245",
    "primeiraCompraSimulada": "09/11/2025",
    "ultimaCompraSimulada": "02/03/2026",
    "diasDesdeUltimaCompraSimulado": 73,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0226"
  },
  {
    "clienteId": "CLI_0227",
    "clienteAnonimo": "226",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 390,
    "ticketMedianoSimulado": 371,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 390,
    "maiorPedidoSimulado": 450,
    "menorPedidoSimulado": 262,
    "ticketMedioSimuladoFmt": "R$ 390",
    "ticketMedianoSimuladoFmt": "R$ 371",
    "valorTotalAcumuladoSimuladoFmt": "R$ 390",
    "maiorPedidoSimuladoFmt": "R$ 450",
    "menorPedidoSimuladoFmt": "R$ 262",
    "primeiraCompraSimulada": "25/11/2025",
    "ultimaCompraSimulada": "08/03/2026",
    "diasDesdeUltimaCompraSimulado": 67,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0227"
  },
  {
    "clienteId": "CLI_0228",
    "clienteAnonimo": "227",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 416,
    "ticketMedianoSimulado": 406,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1248,
    "maiorPedidoSimulado": 442,
    "menorPedidoSimulado": 235,
    "ticketMedioSimuladoFmt": "R$ 416",
    "ticketMedianoSimuladoFmt": "R$ 406",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.248",
    "maiorPedidoSimuladoFmt": "R$ 442",
    "menorPedidoSimuladoFmt": "R$ 235",
    "primeiraCompraSimulada": "11/12/2025",
    "ultimaCompraSimulada": "18/04/2026",
    "diasDesdeUltimaCompraSimulado": 26,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0228"
  },
  {
    "clienteId": "CLI_0229",
    "clienteAnonimo": "228",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 442,
    "ticketMedianoSimulado": 414,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 442,
    "maiorPedidoSimulado": 498,
    "menorPedidoSimulado": 283,
    "ticketMedioSimuladoFmt": "R$ 442",
    "ticketMedianoSimuladoFmt": "R$ 414",
    "valorTotalAcumuladoSimuladoFmt": "R$ 442",
    "maiorPedidoSimuladoFmt": "R$ 498",
    "menorPedidoSimuladoFmt": "R$ 283",
    "primeiraCompraSimulada": "27/12/2025",
    "ultimaCompraSimulada": "30/04/2026",
    "diasDesdeUltimaCompraSimulado": 14,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0229"
  },
  {
    "clienteId": "CLI_0230",
    "clienteAnonimo": "229",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 392,
    "ticketMedianoSimulado": 362,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 392,
    "maiorPedidoSimulado": 467,
    "menorPedidoSimulado": 280,
    "ticketMedioSimuladoFmt": "R$ 392",
    "ticketMedianoSimuladoFmt": "R$ 362",
    "valorTotalAcumuladoSimuladoFmt": "R$ 392",
    "maiorPedidoSimuladoFmt": "R$ 467",
    "menorPedidoSimuladoFmt": "R$ 280",
    "primeiraCompraSimulada": "13/02/2026",
    "ultimaCompraSimulada": "09/04/2026",
    "diasDesdeUltimaCompraSimulado": 35,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0230"
  },
  {
    "clienteId": "CLI_0231",
    "clienteAnonimo": "230",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 418,
    "ticketMedianoSimulado": 417,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1254,
    "maiorPedidoSimulado": 467,
    "menorPedidoSimulado": 263,
    "ticketMedioSimuladoFmt": "R$ 418",
    "ticketMedianoSimuladoFmt": "R$ 417",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.254",
    "maiorPedidoSimuladoFmt": "R$ 467",
    "menorPedidoSimuladoFmt": "R$ 263",
    "primeiraCompraSimulada": "01/03/2026",
    "ultimaCompraSimulada": "01/05/2026",
    "diasDesdeUltimaCompraSimulado": 13,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0231"
  },
  {
    "clienteId": "CLI_0232",
    "clienteAnonimo": "231",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 444,
    "ticketMedianoSimulado": 413,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 888,
    "maiorPedidoSimulado": 476,
    "menorPedidoSimulado": 256,
    "ticketMedioSimuladoFmt": "R$ 444",
    "ticketMedianoSimuladoFmt": "R$ 413",
    "valorTotalAcumuladoSimuladoFmt": "R$ 888",
    "maiorPedidoSimuladoFmt": "R$ 476",
    "menorPedidoSimuladoFmt": "R$ 256",
    "primeiraCompraSimulada": "17/03/2026",
    "ultimaCompraSimulada": "06/05/2026",
    "diasDesdeUltimaCompraSimulado": 8,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0232"
  },
  {
    "clienteId": "CLI_0233",
    "clienteAnonimo": "232",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 430,
    "ticketMedianoSimulado": 423,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 860,
    "maiorPedidoSimulado": 500,
    "menorPedidoSimulado": 293,
    "ticketMedioSimuladoFmt": "R$ 430",
    "ticketMedianoSimuladoFmt": "R$ 423",
    "valorTotalAcumuladoSimuladoFmt": "R$ 860",
    "maiorPedidoSimuladoFmt": "R$ 500",
    "menorPedidoSimuladoFmt": "R$ 293",
    "primeiraCompraSimulada": "02/04/2026",
    "ultimaCompraSimulada": "28/04/2026",
    "diasDesdeUltimaCompraSimulado": 16,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0233"
  },
  {
    "clienteId": "CLI_0234",
    "clienteAnonimo": "233",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 404,
    "ticketMedianoSimulado": 381,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 808,
    "maiorPedidoSimulado": 464,
    "menorPedidoSimulado": 268,
    "ticketMedioSimuladoFmt": "R$ 404",
    "ticketMedianoSimuladoFmt": "R$ 381",
    "valorTotalAcumuladoSimuladoFmt": "R$ 808",
    "maiorPedidoSimuladoFmt": "R$ 464",
    "menorPedidoSimuladoFmt": "R$ 268",
    "primeiraCompraSimulada": "10/04/2026",
    "ultimaCompraSimulada": "27/04/2026",
    "diasDesdeUltimaCompraSimulado": 17,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0234"
  },
  {
    "clienteId": "CLI_0235",
    "clienteAnonimo": "234",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 377,
    "ticketMedianoSimulado": 365,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 754,
    "maiorPedidoSimulado": 399,
    "menorPedidoSimulado": 210,
    "ticketMedioSimuladoFmt": "R$ 377",
    "ticketMedianoSimuladoFmt": "R$ 365",
    "valorTotalAcumuladoSimuladoFmt": "R$ 754",
    "maiorPedidoSimuladoFmt": "R$ 399",
    "menorPedidoSimuladoFmt": "R$ 210",
    "primeiraCompraSimulada": "25/03/2026",
    "ultimaCompraSimulada": "01/05/2026",
    "diasDesdeUltimaCompraSimulado": 13,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0235"
  },
  {
    "clienteId": "CLI_0236",
    "clienteAnonimo": "235",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 351,
    "ticketMedianoSimulado": 336,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 702,
    "maiorPedidoSimulado": 398,
    "menorPedidoSimulado": 227,
    "ticketMedioSimuladoFmt": "R$ 351",
    "ticketMedianoSimuladoFmt": "R$ 336",
    "valorTotalAcumuladoSimuladoFmt": "R$ 702",
    "maiorPedidoSimuladoFmt": "R$ 398",
    "menorPedidoSimuladoFmt": "R$ 227",
    "primeiraCompraSimulada": "09/03/2026",
    "ultimaCompraSimulada": "10/05/2026",
    "diasDesdeUltimaCompraSimulado": 4,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0236"
  },
  {
    "clienteId": "CLI_0237",
    "clienteAnonimo": "236",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 325,
    "ticketMedianoSimulado": 310,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 325,
    "maiorPedidoSimulado": 382,
    "menorPedidoSimulado": 227,
    "ticketMedioSimuladoFmt": "R$ 325",
    "ticketMedianoSimuladoFmt": "R$ 310",
    "valorTotalAcumuladoSimuladoFmt": "R$ 325",
    "maiorPedidoSimuladoFmt": "R$ 382",
    "menorPedidoSimuladoFmt": "R$ 227",
    "primeiraCompraSimulada": "21/02/2026",
    "ultimaCompraSimulada": "21/04/2026",
    "diasDesdeUltimaCompraSimulado": 23,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0237"
  },
  {
    "clienteId": "CLI_0238",
    "clienteAnonimo": "237",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 299,
    "ticketMedianoSimulado": 291,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 897,
    "maiorPedidoSimulado": 325,
    "menorPedidoSimulado": 177,
    "ticketMedioSimuladoFmt": "R$ 299",
    "ticketMedianoSimuladoFmt": "R$ 291",
    "valorTotalAcumuladoSimuladoFmt": "R$ 897",
    "maiorPedidoSimuladoFmt": "R$ 325",
    "menorPedidoSimuladoFmt": "R$ 177",
    "primeiraCompraSimulada": "05/02/2026",
    "ultimaCompraSimulada": "26/03/2026",
    "diasDesdeUltimaCompraSimulado": 49,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0238"
  },
  {
    "clienteId": "CLI_0239",
    "clienteAnonimo": "238",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 288,
    "ticketMedianoSimulado": 271,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 288,
    "maiorPedidoSimulado": 318,
    "menorPedidoSimulado": 176,
    "ticketMedioSimuladoFmt": "R$ 288",
    "ticketMedianoSimuladoFmt": "R$ 271",
    "valorTotalAcumuladoSimuladoFmt": "R$ 288",
    "maiorPedidoSimuladoFmt": "R$ 318",
    "menorPedidoSimuladoFmt": "R$ 176",
    "primeiraCompraSimulada": "20/01/2026",
    "ultimaCompraSimulada": "10/04/2026",
    "diasDesdeUltimaCompraSimulado": 34,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0239"
  },
  {
    "clienteId": "CLI_0240",
    "clienteAnonimo": "239",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 323,
    "ticketMedianoSimulado": 299,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 323,
    "maiorPedidoSimulado": 378,
    "menorPedidoSimulado": 222,
    "ticketMedioSimuladoFmt": "R$ 323",
    "ticketMedianoSimuladoFmt": "R$ 299",
    "valorTotalAcumuladoSimuladoFmt": "R$ 323",
    "maiorPedidoSimuladoFmt": "R$ 378",
    "menorPedidoSimuladoFmt": "R$ 222",
    "primeiraCompraSimulada": "03/12/2025",
    "ultimaCompraSimulada": "29/03/2026",
    "diasDesdeUltimaCompraSimulado": 46,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0240"
  },
  {
    "clienteId": "CLI_0241",
    "clienteAnonimo": "240",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 297,
    "ticketMedianoSimulado": 297,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 891,
    "maiorPedidoSimulado": 339,
    "menorPedidoSimulado": 195,
    "ticketMedioSimuladoFmt": "R$ 297",
    "ticketMedianoSimuladoFmt": "R$ 297",
    "valorTotalAcumuladoSimuladoFmt": "R$ 891",
    "maiorPedidoSimuladoFmt": "R$ 339",
    "menorPedidoSimuladoFmt": "R$ 195",
    "primeiraCompraSimulada": "17/11/2025",
    "ultimaCompraSimulada": "13/02/2026",
    "diasDesdeUltimaCompraSimulado": 90,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0241"
  },
  {
    "clienteId": "CLI_0242",
    "clienteAnonimo": "241",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 289,
    "ticketMedianoSimulado": 268,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 578,
    "maiorPedidoSimulado": 304,
    "menorPedidoSimulado": 159,
    "ticketMedioSimuladoFmt": "R$ 289",
    "ticketMedianoSimuladoFmt": "R$ 268",
    "valorTotalAcumuladoSimuladoFmt": "R$ 578",
    "maiorPedidoSimuladoFmt": "R$ 304",
    "menorPedidoSimuladoFmt": "R$ 159",
    "primeiraCompraSimulada": "01/11/2025",
    "ultimaCompraSimulada": "21/03/2026",
    "diasDesdeUltimaCompraSimulado": 54,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0242"
  },
  {
    "clienteId": "CLI_0243",
    "clienteAnonimo": "242",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 316,
    "ticketMedianoSimulado": 311,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 632,
    "maiorPedidoSimulado": 360,
    "menorPedidoSimulado": 207,
    "ticketMedioSimuladoFmt": "R$ 316",
    "ticketMedianoSimuladoFmt": "R$ 311",
    "valorTotalAcumuladoSimuladoFmt": "R$ 632",
    "maiorPedidoSimuladoFmt": "R$ 360",
    "menorPedidoSimuladoFmt": "R$ 207",
    "primeiraCompraSimulada": "10/11/2025",
    "ultimaCompraSimulada": "05/05/2026",
    "diasDesdeUltimaCompraSimulado": 9,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0243"
  },
  {
    "clienteId": "CLI_0244",
    "clienteAnonimo": "243",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 342,
    "ticketMedianoSimulado": 322,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 684,
    "maiorPedidoSimulado": 400,
    "menorPedidoSimulado": 236,
    "ticketMedioSimuladoFmt": "R$ 342",
    "ticketMedianoSimuladoFmt": "R$ 322",
    "valorTotalAcumuladoSimuladoFmt": "R$ 684",
    "maiorPedidoSimuladoFmt": "R$ 400",
    "menorPedidoSimuladoFmt": "R$ 236",
    "primeiraCompraSimulada": "26/11/2025",
    "ultimaCompraSimulada": "08/04/2026",
    "diasDesdeUltimaCompraSimulado": 36,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0244"
  },
  {
    "clienteId": "CLI_0245",
    "clienteAnonimo": "244",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 368,
    "ticketMedianoSimulado": 357,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 736,
    "maiorPedidoSimulado": 398,
    "menorPedidoSimulado": 215,
    "ticketMedioSimuladoFmt": "R$ 368",
    "ticketMedianoSimuladoFmt": "R$ 357",
    "valorTotalAcumuladoSimuladoFmt": "R$ 736",
    "maiorPedidoSimuladoFmt": "R$ 398",
    "menorPedidoSimuladoFmt": "R$ 215",
    "primeiraCompraSimulada": "12/12/2025",
    "ultimaCompraSimulada": "08/03/2026",
    "diasDesdeUltimaCompraSimulado": 67,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0245"
  },
  {
    "clienteId": "CLI_0246",
    "clienteAnonimo": "245",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 394,
    "ticketMedianoSimulado": 377,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 788,
    "maiorPedidoSimulado": 437,
    "menorPedidoSimulado": 244,
    "ticketMedioSimuladoFmt": "R$ 394",
    "ticketMedianoSimuladoFmt": "R$ 377",
    "valorTotalAcumuladoSimuladoFmt": "R$ 788",
    "maiorPedidoSimuladoFmt": "R$ 437",
    "menorPedidoSimuladoFmt": "R$ 244",
    "primeiraCompraSimulada": "28/12/2025",
    "ultimaCompraSimulada": "26/03/2026",
    "diasDesdeUltimaCompraSimulado": 49,
    "hipoteseDePerfil": "Compra compatível com abastecimento maior, família ou rotina intensa.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0246"
  },
  {
    "clienteId": "CLI_0247",
    "clienteAnonimo": "246",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 420,
    "ticketMedianoSimulado": 402,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 840,
    "maiorPedidoSimulado": 504,
    "menorPedidoSimulado": 304,
    "ticketMedioSimuladoFmt": "R$ 420",
    "ticketMedianoSimuladoFmt": "R$ 402",
    "valorTotalAcumuladoSimuladoFmt": "R$ 840",
    "maiorPedidoSimuladoFmt": "R$ 504",
    "menorPedidoSimuladoFmt": "R$ 304",
    "primeiraCompraSimulada": "13/01/2026",
    "ultimaCompraSimulada": "28/04/2026",
    "diasDesdeUltimaCompraSimulado": 16,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0247"
  },
  {
    "clienteId": "CLI_0248",
    "clienteAnonimo": "247",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 447,
    "ticketMedianoSimulado": 434,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1341,
    "maiorPedidoSimulado": 496,
    "menorPedidoSimulado": 277,
    "ticketMedioSimuladoFmt": "R$ 447",
    "ticketMedianoSimuladoFmt": "R$ 434",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.341",
    "maiorPedidoSimuladoFmt": "R$ 496",
    "menorPedidoSimuladoFmt": "R$ 277",
    "primeiraCompraSimulada": "29/01/2026",
    "ultimaCompraSimulada": "28/04/2026",
    "diasDesdeUltimaCompraSimulado": 16,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0248"
  },
  {
    "clienteId": "CLI_0249",
    "clienteAnonimo": "248",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 427,
    "ticketMedianoSimulado": 402,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 427,
    "maiorPedidoSimulado": 461,
    "menorPedidoSimulado": 250,
    "ticketMedioSimuladoFmt": "R$ 427",
    "ticketMedianoSimuladoFmt": "R$ 402",
    "valorTotalAcumuladoSimuladoFmt": "R$ 427",
    "maiorPedidoSimuladoFmt": "R$ 461",
    "menorPedidoSimuladoFmt": "R$ 250",
    "primeiraCompraSimulada": "14/02/2026",
    "ultimaCompraSimulada": "11/04/2026",
    "diasDesdeUltimaCompraSimulado": 33,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0249"
  },
  {
    "clienteId": "CLI_0250",
    "clienteAnonimo": "249",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 422,
    "ticketMedianoSimulado": 392,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 422,
    "maiorPedidoSimulado": 483,
    "menorPedidoSimulado": 279,
    "ticketMedioSimuladoFmt": "R$ 422",
    "ticketMedianoSimuladoFmt": "R$ 392",
    "valorTotalAcumuladoSimuladoFmt": "R$ 422",
    "maiorPedidoSimuladoFmt": "R$ 483",
    "menorPedidoSimuladoFmt": "R$ 279",
    "primeiraCompraSimulada": "04/04/2026",
    "ultimaCompraSimulada": "08/05/2026",
    "diasDesdeUltimaCompraSimulado": 6,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0250"
  },
  {
    "clienteId": "CLI_0251",
    "clienteAnonimo": "250",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 448,
    "ticketMedianoSimulado": 447,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1344,
    "maiorPedidoSimulado": 522,
    "menorPedidoSimulado": 306,
    "ticketMedioSimuladoFmt": "R$ 448",
    "ticketMedianoSimuladoFmt": "R$ 447",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.344",
    "maiorPedidoSimuladoFmt": "R$ 522",
    "menorPedidoSimuladoFmt": "R$ 306",
    "primeiraCompraSimulada": "08/04/2026",
    "ultimaCompraSimulada": "06/05/2026",
    "diasDesdeUltimaCompraSimulado": 8,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0251"
  },
  {
    "clienteId": "CLI_0252",
    "clienteAnonimo": "251",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 425,
    "ticketMedianoSimulado": 393,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 850,
    "maiorPedidoSimulado": 456,
    "menorPedidoSimulado": 246,
    "ticketMedioSimuladoFmt": "R$ 425",
    "ticketMedianoSimuladoFmt": "R$ 393",
    "valorTotalAcumuladoSimuladoFmt": "R$ 850",
    "maiorPedidoSimuladoFmt": "R$ 456",
    "menorPedidoSimuladoFmt": "R$ 246",
    "primeiraCompraSimulada": "23/03/2026",
    "ultimaCompraSimulada": "23/04/2026",
    "diasDesdeUltimaCompraSimulado": 21,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0252"
  },
  {
    "clienteId": "CLI_0253",
    "clienteAnonimo": "252",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 399,
    "ticketMedianoSimulado": 394,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 798,
    "maiorPedidoSimulado": 445,
    "menorPedidoSimulado": 250,
    "ticketMedioSimuladoFmt": "R$ 399",
    "ticketMedianoSimuladoFmt": "R$ 394",
    "valorTotalAcumuladoSimuladoFmt": "R$ 798",
    "maiorPedidoSimuladoFmt": "R$ 445",
    "menorPedidoSimuladoFmt": "R$ 250",
    "primeiraCompraSimulada": "08/03/2026",
    "ultimaCompraSimulada": "16/04/2026",
    "diasDesdeUltimaCompraSimulado": 28,
    "hipoteseDePerfil": "Compra compatível com abastecimento maior, família ou rotina intensa.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0253"
  },
  {
    "clienteId": "CLI_0254",
    "clienteAnonimo": "253",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 373,
    "ticketMedianoSimulado": 350,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 746,
    "maiorPedidoSimulado": 445,
    "menorPedidoSimulado": 268,
    "ticketMedioSimuladoFmt": "R$ 373",
    "ticketMedianoSimuladoFmt": "R$ 350",
    "valorTotalAcumuladoSimuladoFmt": "R$ 746",
    "maiorPedidoSimuladoFmt": "R$ 445",
    "menorPedidoSimuladoFmt": "R$ 268",
    "primeiraCompraSimulada": "20/02/2026",
    "ultimaCompraSimulada": "28/04/2026",
    "diasDesdeUltimaCompraSimulado": 16,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0254"
  },
  {
    "clienteId": "CLI_0255",
    "clienteAnonimo": "254",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 347,
    "ticketMedianoSimulado": 338,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 694,
    "maiorPedidoSimulado": 383,
    "menorPedidoSimulado": 212,
    "ticketMedioSimuladoFmt": "R$ 347",
    "ticketMedianoSimuladoFmt": "R$ 338",
    "valorTotalAcumuladoSimuladoFmt": "R$ 694",
    "maiorPedidoSimuladoFmt": "R$ 383",
    "menorPedidoSimuladoFmt": "R$ 212",
    "primeiraCompraSimulada": "04/02/2026",
    "ultimaCompraSimulada": "05/05/2026",
    "diasDesdeUltimaCompraSimulado": 9,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0255"
  },
  {
    "clienteId": "CLI_0256",
    "clienteAnonimo": "255",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 321,
    "ticketMedianoSimulado": 306,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 642,
    "maiorPedidoSimulado": 349,
    "menorPedidoSimulado": 190,
    "ticketMedioSimuladoFmt": "R$ 321",
    "ticketMedianoSimuladoFmt": "R$ 306",
    "valorTotalAcumuladoSimuladoFmt": "R$ 642",
    "maiorPedidoSimuladoFmt": "R$ 349",
    "menorPedidoSimuladoFmt": "R$ 190",
    "primeiraCompraSimulada": "19/01/2026",
    "ultimaCompraSimulada": "08/04/2026",
    "diasDesdeUltimaCompraSimulado": 36,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0256"
  },
  {
    "clienteId": "CLI_0257",
    "clienteAnonimo": "256",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 294,
    "ticketMedianoSimulado": 282,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 588,
    "maiorPedidoSimulado": 346,
    "menorPedidoSimulado": 205,
    "ticketMedioSimuladoFmt": "R$ 294",
    "ticketMedianoSimuladoFmt": "R$ 282",
    "valorTotalAcumuladoSimuladoFmt": "R$ 588",
    "maiorPedidoSimuladoFmt": "R$ 346",
    "menorPedidoSimuladoFmt": "R$ 205",
    "primeiraCompraSimulada": "03/01/2026",
    "ultimaCompraSimulada": "12/03/2026",
    "diasDesdeUltimaCompraSimulado": 63,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0257"
  },
  {
    "clienteId": "CLI_0258",
    "clienteAnonimo": "257",
    "segmentoComercial": "Cliente possível coletivo",
    "ticketMedioSimulado": 1326,
    "ticketMedianoSimulado": 1283,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 3978,
    "maiorPedidoSimulado": 1502,
    "menorPedidoSimulado": 857,
    "ticketMedioSimuladoFmt": "R$ 1.326",
    "ticketMedianoSimuladoFmt": "R$ 1.283",
    "valorTotalAcumuladoSimuladoFmt": "R$ 3.978",
    "maiorPedidoSimuladoFmt": "R$ 1.502",
    "menorPedidoSimuladoFmt": "R$ 857",
    "primeiraCompraSimulada": "18/12/2025",
    "ultimaCompraSimulada": "07/04/2026",
    "diasDesdeUltimaCompraSimulado": 37,
    "hipoteseDePerfil": "Possível compra coletiva, familiar ampliada ou corporativa. Não afirmar sem confirmação.",
    "objetivoProvavel": "Pode comprar para mais de uma pessoa, família ou equipe",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Tratar como hipótese de compra coletiva — G09 ativo.",
    "alertaSimulacao": "Possível compra familiar, equipe ou coletiva. Confirmar antes de assumir.",
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0258"
  },
  {
    "clienteId": "CLI_0259",
    "clienteAnonimo": "258",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 318,
    "ticketMedianoSimulado": 301,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 318,
    "maiorPedidoSimulado": 336,
    "menorPedidoSimulado": 178,
    "ticketMedioSimuladoFmt": "R$ 318",
    "ticketMedianoSimuladoFmt": "R$ 301",
    "valorTotalAcumuladoSimuladoFmt": "R$ 318",
    "maiorPedidoSimuladoFmt": "R$ 336",
    "menorPedidoSimuladoFmt": "R$ 178",
    "primeiraCompraSimulada": "02/12/2025",
    "ultimaCompraSimulada": "10/05/2026",
    "diasDesdeUltimaCompraSimulado": 4,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0259"
  },
  {
    "clienteId": "CLI_0260",
    "clienteAnonimo": "259",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 293,
    "ticketMedianoSimulado": 273,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 293,
    "maiorPedidoSimulado": 329,
    "menorPedidoSimulado": 186,
    "ticketMedioSimuladoFmt": "R$ 293",
    "ticketMedianoSimuladoFmt": "R$ 273",
    "valorTotalAcumuladoSimuladoFmt": "R$ 293",
    "maiorPedidoSimuladoFmt": "R$ 329",
    "menorPedidoSimuladoFmt": "R$ 186",
    "primeiraCompraSimulada": "12/11/2025",
    "ultimaCompraSimulada": "18/02/2026",
    "diasDesdeUltimaCompraSimulado": 85,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0260"
  },
  {
    "clienteId": "CLI_0261",
    "clienteAnonimo": "260",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 294,
    "ticketMedianoSimulado": 293,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 882,
    "maiorPedidoSimulado": 349,
    "menorPedidoSimulado": 209,
    "ticketMedioSimuladoFmt": "R$ 294",
    "ticketMedianoSimuladoFmt": "R$ 293",
    "valorTotalAcumuladoSimuladoFmt": "R$ 882",
    "maiorPedidoSimuladoFmt": "R$ 349",
    "menorPedidoSimuladoFmt": "R$ 209",
    "primeiraCompraSimulada": "28/11/2025",
    "ultimaCompraSimulada": "05/04/2026",
    "diasDesdeUltimaCompraSimulado": 39,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0261"
  },
  {
    "clienteId": "CLI_0262",
    "clienteAnonimo": "261",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 320,
    "ticketMedianoSimulado": 295,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 320,
    "maiorPedidoSimulado": 351,
    "menorPedidoSimulado": 194,
    "ticketMedioSimuladoFmt": "R$ 320",
    "ticketMedianoSimuladoFmt": "R$ 295",
    "valorTotalAcumuladoSimuladoFmt": "R$ 320",
    "maiorPedidoSimuladoFmt": "R$ 351",
    "menorPedidoSimuladoFmt": "R$ 194",
    "primeiraCompraSimulada": "14/12/2025",
    "ultimaCompraSimulada": "10/05/2026",
    "diasDesdeUltimaCompraSimulado": 4,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0262"
  },
  {
    "clienteId": "CLI_0263",
    "clienteAnonimo": "262",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 346,
    "ticketMedianoSimulado": 343,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 692,
    "maiorPedidoSimulado": 378,
    "menorPedidoSimulado": 208,
    "ticketMedioSimuladoFmt": "R$ 346",
    "ticketMedianoSimuladoFmt": "R$ 343",
    "valorTotalAcumuladoSimuladoFmt": "R$ 692",
    "maiorPedidoSimuladoFmt": "R$ 378",
    "menorPedidoSimuladoFmt": "R$ 208",
    "primeiraCompraSimulada": "30/12/2025",
    "ultimaCompraSimulada": "09/04/2026",
    "diasDesdeUltimaCompraSimulado": 35,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0263"
  },
  {
    "clienteId": "CLI_0264",
    "clienteAnonimo": "263",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 372,
    "ticketMedianoSimulado": 348,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 744,
    "maiorPedidoSimulado": 440,
    "menorPedidoSimulado": 262,
    "ticketMedioSimuladoFmt": "R$ 372",
    "ticketMedianoSimuladoFmt": "R$ 348",
    "valorTotalAcumuladoSimuladoFmt": "R$ 744",
    "maiorPedidoSimuladoFmt": "R$ 440",
    "menorPedidoSimuladoFmt": "R$ 262",
    "primeiraCompraSimulada": "15/01/2026",
    "ultimaCompraSimulada": "17/03/2026",
    "diasDesdeUltimaCompraSimulado": 58,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0264"
  },
  {
    "clienteId": "CLI_0265",
    "clienteAnonimo": "264",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 399,
    "ticketMedianoSimulado": 390,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 798,
    "maiorPedidoSimulado": 449,
    "menorPedidoSimulado": 255,
    "ticketMedioSimuladoFmt": "R$ 399",
    "ticketMedianoSimuladoFmt": "R$ 390",
    "valorTotalAcumuladoSimuladoFmt": "R$ 798",
    "maiorPedidoSimuladoFmt": "R$ 449",
    "menorPedidoSimuladoFmt": "R$ 255",
    "primeiraCompraSimulada": "31/01/2026",
    "ultimaCompraSimulada": "11/04/2026",
    "diasDesdeUltimaCompraSimulado": 33,
    "hipoteseDePerfil": "Compra compatível com abastecimento maior, família ou rotina intensa.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0265"
  },
  {
    "clienteId": "CLI_0266",
    "clienteAnonimo": "265",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 425,
    "ticketMedianoSimulado": 404,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 850,
    "maiorPedidoSimulado": 452,
    "menorPedidoSimulado": 241,
    "ticketMedioSimuladoFmt": "R$ 425",
    "ticketMedianoSimuladoFmt": "R$ 404",
    "valorTotalAcumuladoSimuladoFmt": "R$ 850",
    "maiorPedidoSimuladoFmt": "R$ 452",
    "menorPedidoSimuladoFmt": "R$ 241",
    "primeiraCompraSimulada": "16/02/2026",
    "ultimaCompraSimulada": "06/05/2026",
    "diasDesdeUltimaCompraSimulado": 8,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0266"
  },
  {
    "clienteId": "CLI_0267",
    "clienteAnonimo": "266",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 449,
    "ticketMedianoSimulado": 432,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 898,
    "maiorPedidoSimulado": 518,
    "menorPedidoSimulado": 301,
    "ticketMedioSimuladoFmt": "R$ 449",
    "ticketMedianoSimuladoFmt": "R$ 432",
    "valorTotalAcumuladoSimuladoFmt": "R$ 898",
    "maiorPedidoSimuladoFmt": "R$ 518",
    "menorPedidoSimuladoFmt": "R$ 301",
    "primeiraCompraSimulada": "04/03/2026",
    "ultimaCompraSimulada": "30/04/2026",
    "diasDesdeUltimaCompraSimulado": 14,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0267"
  },
  {
    "clienteId": "CLI_0268",
    "clienteAnonimo": "267",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 423,
    "ticketMedianoSimulado": 408,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1269,
    "maiorPedidoSimulado": 489,
    "menorPedidoSimulado": 285,
    "ticketMedioSimuladoFmt": "R$ 423",
    "ticketMedianoSimuladoFmt": "R$ 408",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.269",
    "maiorPedidoSimuladoFmt": "R$ 489",
    "menorPedidoSimuladoFmt": "R$ 285",
    "primeiraCompraSimulada": "20/03/2026",
    "ultimaCompraSimulada": "20/04/2026",
    "diasDesdeUltimaCompraSimulado": 24,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0268"
  },
  {
    "clienteId": "CLI_0269",
    "clienteAnonimo": "268",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 397,
    "ticketMedianoSimulado": 376,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 397,
    "maiorPedidoSimulado": 423,
    "menorPedidoSimulado": 226,
    "ticketMedioSimuladoFmt": "R$ 397",
    "ticketMedianoSimuladoFmt": "R$ 376",
    "valorTotalAcumuladoSimuladoFmt": "R$ 397",
    "maiorPedidoSimuladoFmt": "R$ 423",
    "menorPedidoSimuladoFmt": "R$ 226",
    "primeiraCompraSimulada": "04/04/2026",
    "ultimaCompraSimulada": "27/04/2026",
    "diasDesdeUltimaCompraSimulado": 17,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0269"
  },
  {
    "clienteId": "CLI_0270",
    "clienteAnonimo": "269",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 447,
    "ticketMedianoSimulado": 418,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 447,
    "maiorPedidoSimulado": 491,
    "menorPedidoSimulado": 272,
    "ticketMedioSimuladoFmt": "R$ 447",
    "ticketMedianoSimuladoFmt": "R$ 418",
    "valorTotalAcumuladoSimuladoFmt": "R$ 447",
    "maiorPedidoSimuladoFmt": "R$ 491",
    "menorPedidoSimuladoFmt": "R$ 272",
    "primeiraCompraSimulada": "06/03/2026",
    "ultimaCompraSimulada": "29/04/2026",
    "diasDesdeUltimaCompraSimulado": 15,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0270"
  },
  {
    "clienteId": "CLI_0271",
    "clienteAnonimo": "270",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 421,
    "ticketMedianoSimulado": 418,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1263,
    "maiorPedidoSimulado": 501,
    "menorPedidoSimulado": 300,
    "ticketMedioSimuladoFmt": "R$ 421",
    "ticketMedianoSimuladoFmt": "R$ 418",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.263",
    "maiorPedidoSimuladoFmt": "R$ 501",
    "menorPedidoSimuladoFmt": "R$ 300",
    "primeiraCompraSimulada": "18/02/2026",
    "ultimaCompraSimulada": "07/04/2026",
    "diasDesdeUltimaCompraSimulado": 37,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0271"
  },
  {
    "clienteId": "CLI_0272",
    "clienteAnonimo": "271",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 395,
    "ticketMedianoSimulado": 364,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 395,
    "maiorPedidoSimulado": 443,
    "menorPedidoSimulado": 250,
    "ticketMedioSimuladoFmt": "R$ 395",
    "ticketMedianoSimuladoFmt": "R$ 364",
    "valorTotalAcumuladoSimuladoFmt": "R$ 395",
    "maiorPedidoSimuladoFmt": "R$ 443",
    "menorPedidoSimuladoFmt": "R$ 250",
    "primeiraCompraSimulada": "02/02/2026",
    "ultimaCompraSimulada": "06/04/2026",
    "diasDesdeUltimaCompraSimulado": 38,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0272"
  },
  {
    "clienteId": "CLI_0273",
    "clienteAnonimo": "272",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 369,
    "ticketMedianoSimulado": 367,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 738,
    "maiorPedidoSimulado": 395,
    "menorPedidoSimulado": 212,
    "ticketMedioSimuladoFmt": "R$ 369",
    "ticketMedianoSimuladoFmt": "R$ 367",
    "valorTotalAcumuladoSimuladoFmt": "R$ 738",
    "maiorPedidoSimuladoFmt": "R$ 395",
    "menorPedidoSimuladoFmt": "R$ 212",
    "primeiraCompraSimulada": "17/01/2026",
    "ultimaCompraSimulada": "27/04/2026",
    "diasDesdeUltimaCompraSimulado": 17,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0273"
  },
  {
    "clienteId": "CLI_0274",
    "clienteAnonimo": "273",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 342,
    "ticketMedianoSimulado": 319,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 684,
    "maiorPedidoSimulado": 397,
    "menorPedidoSimulado": 232,
    "ticketMedioSimuladoFmt": "R$ 342",
    "ticketMedianoSimuladoFmt": "R$ 319",
    "valorTotalAcumuladoSimuladoFmt": "R$ 684",
    "maiorPedidoSimuladoFmt": "R$ 397",
    "menorPedidoSimuladoFmt": "R$ 232",
    "primeiraCompraSimulada": "01/01/2026",
    "ultimaCompraSimulada": "27/04/2026",
    "diasDesdeUltimaCompraSimulado": 17,
    "hipoteseDePerfil": "Compra compatível com abastecimento maior, família ou rotina intensa.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0274"
  },
  {
    "clienteId": "CLI_0275",
    "clienteAnonimo": "274",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 316,
    "ticketMedianoSimulado": 309,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 632,
    "maiorPedidoSimulado": 363,
    "menorPedidoSimulado": 211,
    "ticketMedioSimuladoFmt": "R$ 316",
    "ticketMedianoSimuladoFmt": "R$ 309",
    "valorTotalAcumuladoSimuladoFmt": "R$ 632",
    "maiorPedidoSimuladoFmt": "R$ 363",
    "menorPedidoSimuladoFmt": "R$ 211",
    "primeiraCompraSimulada": "16/12/2025",
    "ultimaCompraSimulada": "22/03/2026",
    "diasDesdeUltimaCompraSimulado": 53,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0275"
  },
  {
    "clienteId": "CLI_0276",
    "clienteAnonimo": "275",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 290,
    "ticketMedianoSimulado": 275,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 580,
    "maiorPedidoSimulado": 307,
    "menorPedidoSimulado": 163,
    "ticketMedioSimuladoFmt": "R$ 290",
    "ticketMedianoSimuladoFmt": "R$ 275",
    "valorTotalAcumuladoSimuladoFmt": "R$ 580",
    "maiorPedidoSimuladoFmt": "R$ 307",
    "menorPedidoSimuladoFmt": "R$ 163",
    "primeiraCompraSimulada": "30/11/2025",
    "ultimaCompraSimulada": "03/03/2026",
    "diasDesdeUltimaCompraSimulado": 72,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0276"
  },
  {
    "clienteId": "CLI_0277",
    "clienteAnonimo": "276",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 296,
    "ticketMedianoSimulado": 285,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 592,
    "maiorPedidoSimulado": 335,
    "menorPedidoSimulado": 191,
    "ticketMedioSimuladoFmt": "R$ 296",
    "ticketMedianoSimuladoFmt": "R$ 285",
    "valorTotalAcumuladoSimuladoFmt": "R$ 592",
    "maiorPedidoSimuladoFmt": "R$ 335",
    "menorPedidoSimuladoFmt": "R$ 191",
    "primeiraCompraSimulada": "14/11/2025",
    "ultimaCompraSimulada": "06/04/2026",
    "diasDesdeUltimaCompraSimulado": 38,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0277"
  },
  {
    "clienteId": "CLI_0278",
    "clienteAnonimo": "277",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 323,
    "ticketMedianoSimulado": 311,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 646,
    "maiorPedidoSimulado": 381,
    "menorPedidoSimulado": 226,
    "ticketMedioSimuladoFmt": "R$ 323",
    "ticketMedianoSimuladoFmt": "R$ 311",
    "valorTotalAcumuladoSimuladoFmt": "R$ 646",
    "maiorPedidoSimuladoFmt": "R$ 381",
    "menorPedidoSimuladoFmt": "R$ 226",
    "primeiraCompraSimulada": "29/10/2025",
    "ultimaCompraSimulada": "04/05/2026",
    "diasDesdeUltimaCompraSimulado": 10,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0278"
  },
  {
    "clienteId": "CLI_0279",
    "clienteAnonimo": "278",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 349,
    "ticketMedianoSimulado": 332,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 349,
    "maiorPedidoSimulado": 380,
    "menorPedidoSimulado": 208,
    "ticketMedioSimuladoFmt": "R$ 349",
    "ticketMedianoSimuladoFmt": "R$ 332",
    "valorTotalAcumuladoSimuladoFmt": "R$ 349",
    "maiorPedidoSimuladoFmt": "R$ 380",
    "menorPedidoSimuladoFmt": "R$ 208",
    "primeiraCompraSimulada": "13/11/2025",
    "ultimaCompraSimulada": "24/03/2026",
    "diasDesdeUltimaCompraSimulado": 51,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0279"
  },
  {
    "clienteId": "CLI_0280",
    "clienteAnonimo": "279",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 298,
    "ticketMedianoSimulado": 279,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 298,
    "maiorPedidoSimulado": 321,
    "menorPedidoSimulado": 173,
    "ticketMedioSimuladoFmt": "R$ 298",
    "ticketMedianoSimuladoFmt": "R$ 279",
    "valorTotalAcumuladoSimuladoFmt": "R$ 298",
    "maiorPedidoSimuladoFmt": "R$ 321",
    "menorPedidoSimuladoFmt": "R$ 173",
    "primeiraCompraSimulada": "31/12/2025",
    "ultimaCompraSimulada": "18/04/2026",
    "diasDesdeUltimaCompraSimulado": 26,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0280"
  },
  {
    "clienteId": "CLI_0281",
    "clienteAnonimo": "280",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 324,
    "ticketMedianoSimulado": 321,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 972,
    "maiorPedidoSimulado": 378,
    "menorPedidoSimulado": 222,
    "ticketMedioSimuladoFmt": "R$ 324",
    "ticketMedianoSimuladoFmt": "R$ 321",
    "valorTotalAcumuladoSimuladoFmt": "R$ 972",
    "maiorPedidoSimuladoFmt": "R$ 378",
    "menorPedidoSimuladoFmt": "R$ 222",
    "primeiraCompraSimulada": "16/01/2026",
    "ultimaCompraSimulada": "05/05/2026",
    "diasDesdeUltimaCompraSimulado": 9,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0281"
  },
  {
    "clienteId": "CLI_0282",
    "clienteAnonimo": "281",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 350,
    "ticketMedianoSimulado": 323,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 350,
    "maiorPedidoSimulado": 400,
    "menorPedidoSimulado": 231,
    "ticketMedioSimuladoFmt": "R$ 350",
    "ticketMedianoSimuladoFmt": "R$ 323",
    "valorTotalAcumuladoSimuladoFmt": "R$ 350",
    "maiorPedidoSimuladoFmt": "R$ 400",
    "menorPedidoSimuladoFmt": "R$ 231",
    "primeiraCompraSimulada": "01/02/2026",
    "ultimaCompraSimulada": "13/04/2026",
    "diasDesdeUltimaCompraSimulado": 31,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0282"
  },
  {
    "clienteId": "CLI_0283",
    "clienteAnonimo": "282",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 377,
    "ticketMedianoSimulado": 375,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1131,
    "maiorPedidoSimulado": 397,
    "menorPedidoSimulado": 209,
    "ticketMedioSimuladoFmt": "R$ 377",
    "ticketMedianoSimuladoFmt": "R$ 375",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.131",
    "maiorPedidoSimuladoFmt": "R$ 397",
    "menorPedidoSimuladoFmt": "R$ 209",
    "primeiraCompraSimulada": "17/02/2026",
    "ultimaCompraSimulada": "01/04/2026",
    "diasDesdeUltimaCompraSimulado": 43,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0283"
  },
  {
    "clienteId": "CLI_0284",
    "clienteAnonimo": "283",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 403,
    "ticketMedianoSimulado": 375,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 806,
    "maiorPedidoSimulado": 458,
    "menorPedidoSimulado": 263,
    "ticketMedioSimuladoFmt": "R$ 403",
    "ticketMedianoSimuladoFmt": "R$ 375",
    "valorTotalAcumuladoSimuladoFmt": "R$ 806",
    "maiorPedidoSimuladoFmt": "R$ 458",
    "menorPedidoSimuladoFmt": "R$ 263",
    "primeiraCompraSimulada": "05/03/2026",
    "ultimaCompraSimulada": "24/04/2026",
    "diasDesdeUltimaCompraSimulado": 20,
    "hipoteseDePerfil": "Compra compatível com abastecimento maior, família ou rotina intensa.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0284"
  },
  {
    "clienteId": "CLI_0285",
    "clienteAnonimo": "284",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 429,
    "ticketMedianoSimulado": 421,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 858,
    "maiorPedidoSimulado": 503,
    "menorPedidoSimulado": 297,
    "ticketMedioSimuladoFmt": "R$ 429",
    "ticketMedianoSimuladoFmt": "R$ 421",
    "valorTotalAcumuladoSimuladoFmt": "R$ 858",
    "maiorPedidoSimuladoFmt": "R$ 503",
    "menorPedidoSimuladoFmt": "R$ 297",
    "primeiraCompraSimulada": "21/03/2026",
    "ultimaCompraSimulada": "10/05/2026",
    "diasDesdeUltimaCompraSimulado": 4,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0285"
  },
  {
    "clienteId": "CLI_0286",
    "clienteAnonimo": "285",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 445,
    "ticketMedianoSimulado": 421,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 890,
    "maiorPedidoSimulado": 482,
    "menorPedidoSimulado": 262,
    "ticketMedioSimuladoFmt": "R$ 445",
    "ticketMedianoSimuladoFmt": "R$ 421",
    "valorTotalAcumuladoSimuladoFmt": "R$ 890",
    "maiorPedidoSimuladoFmt": "R$ 482",
    "menorPedidoSimuladoFmt": "R$ 262",
    "primeiraCompraSimulada": "06/04/2026",
    "ultimaCompraSimulada": "04/05/2026",
    "diasDesdeUltimaCompraSimulado": 10,
    "hipoteseDePerfil": "Compra compatível com abastecimento maior, família ou rotina intensa.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0286"
  },
  {
    "clienteId": "CLI_0287",
    "clienteAnonimo": "286",
    "segmentoComercial": "Cliente possível coletivo",
    "ticketMedioSimulado": 2666,
    "ticketMedianoSimulado": 2578,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 5332,
    "maiorPedidoSimulado": 2953,
    "menorPedidoSimulado": 1646,
    "ticketMedioSimuladoFmt": "R$ 2.666",
    "ticketMedianoSimuladoFmt": "R$ 2.578",
    "valorTotalAcumuladoSimuladoFmt": "R$ 5.332",
    "maiorPedidoSimuladoFmt": "R$ 2.953",
    "menorPedidoSimuladoFmt": "R$ 1.646",
    "primeiraCompraSimulada": "06/04/2026",
    "ultimaCompraSimulada": "26/04/2026",
    "diasDesdeUltimaCompraSimulado": 18,
    "hipoteseDePerfil": "Possível compra coletiva, familiar ampliada ou corporativa. Não afirmar sem confirmação.",
    "objetivoProvavel": "Pode comprar para mais de uma pessoa, família ou equipe",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Tratar como hipótese de compra coletiva — G09 ativo.",
    "alertaSimulacao": "Possível compra familiar, equipe ou coletiva. Confirmar antes de assumir.",
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0287"
  },
  {
    "clienteId": "CLI_0288",
    "clienteAnonimo": "287",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 392,
    "ticketMedianoSimulado": 376,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 784,
    "maiorPedidoSimulado": 470,
    "menorPedidoSimulado": 283,
    "ticketMedioSimuladoFmt": "R$ 392",
    "ticketMedianoSimuladoFmt": "R$ 376",
    "valorTotalAcumuladoSimuladoFmt": "R$ 784",
    "maiorPedidoSimuladoFmt": "R$ 470",
    "menorPedidoSimuladoFmt": "R$ 283",
    "primeiraCompraSimulada": "21/03/2026",
    "ultimaCompraSimulada": "24/04/2026",
    "diasDesdeUltimaCompraSimulado": 20,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0288"
  },
  {
    "clienteId": "CLI_0289",
    "clienteAnonimo": "288",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 366,
    "ticketMedianoSimulado": 349,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 366,
    "maiorPedidoSimulado": 407,
    "menorPedidoSimulado": 228,
    "ticketMedioSimuladoFmt": "R$ 366",
    "ticketMedianoSimuladoFmt": "R$ 349",
    "valorTotalAcumuladoSimuladoFmt": "R$ 366",
    "maiorPedidoSimuladoFmt": "R$ 407",
    "menorPedidoSimuladoFmt": "R$ 228",
    "primeiraCompraSimulada": "05/03/2026",
    "ultimaCompraSimulada": "05/05/2026",
    "diasDesdeUltimaCompraSimulado": 9,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0289"
  },
  {
    "clienteId": "CLI_0290",
    "clienteAnonimo": "289",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 417,
    "ticketMedianoSimulado": 392,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 417,
    "maiorPedidoSimulado": 439,
    "menorPedidoSimulado": 231,
    "ticketMedioSimuladoFmt": "R$ 417",
    "ticketMedianoSimuladoFmt": "R$ 392",
    "valorTotalAcumuladoSimuladoFmt": "R$ 417",
    "maiorPedidoSimuladoFmt": "R$ 439",
    "menorPedidoSimuladoFmt": "R$ 231",
    "primeiraCompraSimulada": "16/01/2026",
    "ultimaCompraSimulada": "19/03/2026",
    "diasDesdeUltimaCompraSimulado": 56,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0290"
  },
  {
    "clienteId": "CLI_0291",
    "clienteAnonimo": "290",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 390,
    "ticketMedianoSimulado": 385,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1170,
    "maiorPedidoSimulado": 446,
    "menorPedidoSimulado": 257,
    "ticketMedioSimuladoFmt": "R$ 390",
    "ticketMedianoSimuladoFmt": "R$ 385",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.170",
    "maiorPedidoSimuladoFmt": "R$ 446",
    "menorPedidoSimuladoFmt": "R$ 257",
    "primeiraCompraSimulada": "31/12/2025",
    "ultimaCompraSimulada": "01/04/2026",
    "diasDesdeUltimaCompraSimulado": 43,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0291"
  },
  {
    "clienteId": "CLI_0292",
    "clienteAnonimo": "291",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 364,
    "ticketMedianoSimulado": 337,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 364,
    "maiorPedidoSimulado": 425,
    "menorPedidoSimulado": 250,
    "ticketMedioSimuladoFmt": "R$ 364",
    "ticketMedianoSimuladoFmt": "R$ 337",
    "valorTotalAcumuladoSimuladoFmt": "R$ 364",
    "maiorPedidoSimuladoFmt": "R$ 425",
    "menorPedidoSimuladoFmt": "R$ 250",
    "primeiraCompraSimulada": "15/12/2025",
    "ultimaCompraSimulada": "30/04/2026",
    "diasDesdeUltimaCompraSimulado": 14,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0292"
  },
  {
    "clienteId": "CLI_0293",
    "clienteAnonimo": "292",
    "segmentoComercial": "Cliente possível coletivo",
    "ticketMedioSimulado": 1814,
    "ticketMedianoSimulado": 1811,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 5442,
    "maiorPedidoSimulado": 1952,
    "menorPedidoSimulado": 1053,
    "ticketMedioSimuladoFmt": "R$ 1.814",
    "ticketMedianoSimuladoFmt": "R$ 1.811",
    "valorTotalAcumuladoSimuladoFmt": "R$ 5.442",
    "maiorPedidoSimuladoFmt": "R$ 1.952",
    "menorPedidoSimuladoFmt": "R$ 1.053",
    "primeiraCompraSimulada": "29/11/2025",
    "ultimaCompraSimulada": "16/04/2026",
    "diasDesdeUltimaCompraSimulado": 28,
    "hipoteseDePerfil": "Possível compra coletiva, familiar ampliada ou corporativa. Não afirmar sem confirmação.",
    "objetivoProvavel": "Pode comprar para mais de uma pessoa, família ou equipe",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Tratar como hipótese de compra coletiva — G09 ativo.",
    "alertaSimulacao": "Possível compra familiar, equipe ou coletiva. Confirmar antes de assumir.",
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0293"
  },
  {
    "clienteId": "CLI_0294",
    "clienteAnonimo": "293",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 312,
    "ticketMedianoSimulado": 290,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 624,
    "maiorPedidoSimulado": 348,
    "menorPedidoSimulado": 195,
    "ticketMedioSimuladoFmt": "R$ 312",
    "ticketMedianoSimuladoFmt": "R$ 290",
    "valorTotalAcumuladoSimuladoFmt": "R$ 624",
    "maiorPedidoSimuladoFmt": "R$ 348",
    "menorPedidoSimuladoFmt": "R$ 195",
    "primeiraCompraSimulada": "13/11/2025",
    "ultimaCompraSimulada": "03/03/2026",
    "diasDesdeUltimaCompraSimulado": 72,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0294"
  },
  {
    "clienteId": "CLI_0295",
    "clienteAnonimo": "294",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 286,
    "ticketMedianoSimulado": 281,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 572,
    "maiorPedidoSimulado": 342,
    "menorPedidoSimulado": 206,
    "ticketMedioSimuladoFmt": "R$ 286",
    "ticketMedianoSimuladoFmt": "R$ 281",
    "valorTotalAcumuladoSimuladoFmt": "R$ 572",
    "maiorPedidoSimuladoFmt": "R$ 342",
    "menorPedidoSimuladoFmt": "R$ 206",
    "primeiraCompraSimulada": "29/10/2025",
    "ultimaCompraSimulada": "26/02/2026",
    "diasDesdeUltimaCompraSimulado": 77,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0295"
  },
  {
    "clienteId": "CLI_0296",
    "clienteAnonimo": "295",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 301,
    "ticketMedianoSimulado": 284,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 602,
    "maiorPedidoSimulado": 333,
    "menorPedidoSimulado": 185,
    "ticketMedioSimuladoFmt": "R$ 301",
    "ticketMedianoSimuladoFmt": "R$ 284",
    "valorTotalAcumuladoSimuladoFmt": "R$ 602",
    "maiorPedidoSimuladoFmt": "R$ 333",
    "menorPedidoSimuladoFmt": "R$ 185",
    "primeiraCompraSimulada": "14/11/2025",
    "ultimaCompraSimulada": "14/04/2026",
    "diasDesdeUltimaCompraSimulado": 30,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0296"
  },
  {
    "clienteId": "CLI_0297",
    "clienteAnonimo": "296",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 327,
    "ticketMedianoSimulado": 317,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 654,
    "maiorPedidoSimulado": 355,
    "menorPedidoSimulado": 193,
    "ticketMedioSimuladoFmt": "R$ 327",
    "ticketMedianoSimuladoFmt": "R$ 317",
    "valorTotalAcumuladoSimuladoFmt": "R$ 654",
    "maiorPedidoSimuladoFmt": "R$ 355",
    "menorPedidoSimuladoFmt": "R$ 193",
    "primeiraCompraSimulada": "30/11/2025",
    "ultimaCompraSimulada": "28/04/2026",
    "diasDesdeUltimaCompraSimulado": 16,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0297"
  },
  {
    "clienteId": "CLI_0298",
    "clienteAnonimo": "297",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 353,
    "ticketMedianoSimulado": 338,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 706,
    "maiorPedidoSimulado": 415,
    "menorPedidoSimulado": 246,
    "ticketMedioSimuladoFmt": "R$ 353",
    "ticketMedianoSimuladoFmt": "R$ 338",
    "valorTotalAcumuladoSimuladoFmt": "R$ 706",
    "maiorPedidoSimuladoFmt": "R$ 415",
    "menorPedidoSimuladoFmt": "R$ 246",
    "primeiraCompraSimulada": "16/12/2025",
    "ultimaCompraSimulada": "26/03/2026",
    "diasDesdeUltimaCompraSimulado": 49,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0298"
  },
  {
    "clienteId": "CLI_0299",
    "clienteAnonimo": "298",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 379,
    "ticketMedianoSimulado": 362,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 379,
    "maiorPedidoSimulado": 430,
    "menorPedidoSimulado": 246,
    "ticketMedioSimuladoFmt": "R$ 379",
    "ticketMedianoSimuladoFmt": "R$ 362",
    "valorTotalAcumuladoSimuladoFmt": "R$ 379",
    "maiorPedidoSimuladoFmt": "R$ 430",
    "menorPedidoSimuladoFmt": "R$ 246",
    "primeiraCompraSimulada": "01/01/2026",
    "ultimaCompraSimulada": "13/03/2026",
    "diasDesdeUltimaCompraSimulado": 62,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0299"
  },
  {
    "clienteId": "CLI_0300",
    "clienteAnonimo": "299",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 390,
    "ticketMedianoSimulado": 390,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1170,
    "maiorPedidoSimulado": 428,
    "menorPedidoSimulado": 236,
    "ticketMedioSimuladoFmt": "R$ 390",
    "ticketMedianoSimuladoFmt": "R$ 390",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.170",
    "maiorPedidoSimuladoFmt": "R$ 428",
    "menorPedidoSimuladoFmt": "R$ 236",
    "primeiraCompraSimulada": "04/04/2026",
    "ultimaCompraSimulada": "02/05/2026",
    "diasDesdeUltimaCompraSimulado": 12,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0300"
  },
  {
    "clienteId": "CLI_0301",
    "clienteAnonimo": "300",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 363,
    "ticketMedianoSimulado": 336,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 726,
    "maiorPedidoSimulado": 431,
    "menorPedidoSimulado": 258,
    "ticketMedioSimuladoFmt": "R$ 363",
    "ticketMedianoSimuladoFmt": "R$ 336",
    "valorTotalAcumuladoSimuladoFmt": "R$ 726",
    "maiorPedidoSimuladoFmt": "R$ 431",
    "menorPedidoSimuladoFmt": "R$ 258",
    "primeiraCompraSimulada": "19/03/2026",
    "ultimaCompraSimulada": "11/05/2026",
    "diasDesdeUltimaCompraSimulado": 3,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0301"
  },
  {
    "clienteId": "CLI_0302",
    "clienteAnonimo": "301",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 337,
    "ticketMedianoSimulado": 332,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 674,
    "maiorPedidoSimulado": 378,
    "menorPedidoSimulado": 214,
    "ticketMedioSimuladoFmt": "R$ 337",
    "ticketMedianoSimuladoFmt": "R$ 332",
    "valorTotalAcumuladoSimuladoFmt": "R$ 674",
    "maiorPedidoSimuladoFmt": "R$ 378",
    "menorPedidoSimuladoFmt": "R$ 214",
    "primeiraCompraSimulada": "03/03/2026",
    "ultimaCompraSimulada": "25/04/2026",
    "diasDesdeUltimaCompraSimulado": 19,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0302"
  },
  {
    "clienteId": "CLI_0303",
    "clienteAnonimo": "302",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 311,
    "ticketMedianoSimulado": 293,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 622,
    "maiorPedidoSimulado": 332,
    "menorPedidoSimulado": 178,
    "ticketMedioSimuladoFmt": "R$ 311",
    "ticketMedianoSimuladoFmt": "R$ 293",
    "valorTotalAcumuladoSimuladoFmt": "R$ 622",
    "maiorPedidoSimuladoFmt": "R$ 332",
    "menorPedidoSimuladoFmt": "R$ 178",
    "primeiraCompraSimulada": "15/02/2026",
    "ultimaCompraSimulada": "02/04/2026",
    "diasDesdeUltimaCompraSimulado": 42,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0303"
  },
  {
    "clienteId": "CLI_0304",
    "clienteAnonimo": "303",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 285,
    "ticketMedianoSimulado": 277,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 570,
    "maiorPedidoSimulado": 330,
    "menorPedidoSimulado": 193,
    "ticketMedioSimuladoFmt": "R$ 285",
    "ticketMedianoSimuladoFmt": "R$ 277",
    "valorTotalAcumuladoSimuladoFmt": "R$ 570",
    "maiorPedidoSimuladoFmt": "R$ 330",
    "menorPedidoSimuladoFmt": "R$ 193",
    "primeiraCompraSimulada": "30/01/2026",
    "ultimaCompraSimulada": "10/04/2026",
    "diasDesdeUltimaCompraSimulado": 34,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0304"
  },
  {
    "clienteId": "CLI_0305",
    "clienteAnonimo": "304",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 301,
    "ticketMedianoSimulado": 288,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 602,
    "maiorPedidoSimulado": 347,
    "menorPedidoSimulado": 201,
    "ticketMedioSimuladoFmt": "R$ 301",
    "ticketMedianoSimuladoFmt": "R$ 288",
    "valorTotalAcumuladoSimuladoFmt": "R$ 602",
    "maiorPedidoSimuladoFmt": "R$ 347",
    "menorPedidoSimuladoFmt": "R$ 201",
    "primeiraCompraSimulada": "14/01/2026",
    "ultimaCompraSimulada": "02/05/2026",
    "diasDesdeUltimaCompraSimulado": 12,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0305"
  },
  {
    "clienteId": "CLI_0306",
    "clienteAnonimo": "305",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 328,
    "ticketMedianoSimulado": 314,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 656,
    "maiorPedidoSimulado": 348,
    "menorPedidoSimulado": 185,
    "ticketMedioSimuladoFmt": "R$ 328",
    "ticketMedianoSimuladoFmt": "R$ 314",
    "valorTotalAcumuladoSimuladoFmt": "R$ 656",
    "maiorPedidoSimuladoFmt": "R$ 348",
    "menorPedidoSimuladoFmt": "R$ 185",
    "primeiraCompraSimulada": "29/12/2025",
    "ultimaCompraSimulada": "20/04/2026",
    "diasDesdeUltimaCompraSimulado": 24,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0306"
  },
  {
    "clienteId": "CLI_0307",
    "clienteAnonimo": "306",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 354,
    "ticketMedianoSimulado": 343,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1062,
    "maiorPedidoSimulado": 400,
    "menorPedidoSimulado": 227,
    "ticketMedioSimuladoFmt": "R$ 354",
    "ticketMedianoSimuladoFmt": "R$ 343",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.062",
    "maiorPedidoSimuladoFmt": "R$ 400",
    "menorPedidoSimuladoFmt": "R$ 227",
    "primeiraCompraSimulada": "13/12/2025",
    "ultimaCompraSimulada": "14/03/2026",
    "diasDesdeUltimaCompraSimulado": 61,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0307"
  },
  {
    "clienteId": "CLI_0308",
    "clienteAnonimo": "307",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 380,
    "ticketMedianoSimulado": 358,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 380,
    "maiorPedidoSimulado": 449,
    "menorPedidoSimulado": 267,
    "ticketMedioSimuladoFmt": "R$ 380",
    "ticketMedianoSimuladoFmt": "R$ 358",
    "valorTotalAcumuladoSimuladoFmt": "R$ 380",
    "maiorPedidoSimuladoFmt": "R$ 449",
    "menorPedidoSimuladoFmt": "R$ 267",
    "primeiraCompraSimulada": "27/11/2025",
    "ultimaCompraSimulada": "09/03/2026",
    "diasDesdeUltimaCompraSimulado": 66,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0308"
  },
  {
    "clienteId": "CLI_0309",
    "clienteAnonimo": "308",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 406,
    "ticketMedianoSimulado": 400,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1218,
    "maiorPedidoSimulado": 443,
    "menorPedidoSimulado": 242,
    "ticketMedioSimuladoFmt": "R$ 406",
    "ticketMedianoSimuladoFmt": "R$ 400",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.218",
    "maiorPedidoSimuladoFmt": "R$ 443",
    "menorPedidoSimuladoFmt": "R$ 242",
    "primeiraCompraSimulada": "11/11/2025",
    "ultimaCompraSimulada": "14/04/2026",
    "diasDesdeUltimaCompraSimulado": 30,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0309"
  },
  {
    "clienteId": "CLI_0310",
    "clienteAnonimo": "309",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 356,
    "ticketMedianoSimulado": 355,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1068,
    "maiorPedidoSimulado": 383,
    "menorPedidoSimulado": 206,
    "ticketMedioSimuladoFmt": "R$ 356",
    "ticketMedianoSimuladoFmt": "R$ 355",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.068",
    "maiorPedidoSimuladoFmt": "R$ 383",
    "menorPedidoSimuladoFmt": "R$ 206",
    "primeiraCompraSimulada": "02/12/2025",
    "ultimaCompraSimulada": "07/03/2026",
    "diasDesdeUltimaCompraSimulado": 68,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0310"
  },
  {
    "clienteId": "CLI_0311",
    "clienteAnonimo": "310",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 382,
    "ticketMedianoSimulado": 353,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 382,
    "maiorPedidoSimulado": 445,
    "menorPedidoSimulado": 261,
    "ticketMedioSimuladoFmt": "R$ 382",
    "ticketMedianoSimuladoFmt": "R$ 353",
    "valorTotalAcumuladoSimuladoFmt": "R$ 382",
    "maiorPedidoSimuladoFmt": "R$ 445",
    "menorPedidoSimuladoFmt": "R$ 261",
    "primeiraCompraSimulada": "18/12/2025",
    "ultimaCompraSimulada": "20/03/2026",
    "diasDesdeUltimaCompraSimulado": 55,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0311"
  },
  {
    "clienteId": "CLI_0312",
    "clienteAnonimo": "311",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 408,
    "ticketMedianoSimulado": 403,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 816,
    "maiorPedidoSimulado": 467,
    "menorPedidoSimulado": 270,
    "ticketMedioSimuladoFmt": "R$ 408",
    "ticketMedianoSimuladoFmt": "R$ 403",
    "valorTotalAcumuladoSimuladoFmt": "R$ 816",
    "maiorPedidoSimuladoFmt": "R$ 467",
    "menorPedidoSimuladoFmt": "R$ 270",
    "primeiraCompraSimulada": "03/01/2026",
    "ultimaCompraSimulada": "24/04/2026",
    "diasDesdeUltimaCompraSimulado": 20,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0312"
  },
  {
    "clienteId": "CLI_0313",
    "clienteAnonimo": "312",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 434,
    "ticketMedianoSimulado": 407,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 868,
    "maiorPedidoSimulado": 458,
    "menorPedidoSimulado": 241,
    "ticketMedioSimuladoFmt": "R$ 434",
    "ticketMedianoSimuladoFmt": "R$ 407",
    "valorTotalAcumuladoSimuladoFmt": "R$ 868",
    "maiorPedidoSimuladoFmt": "R$ 458",
    "menorPedidoSimuladoFmt": "R$ 241",
    "primeiraCompraSimulada": "19/01/2026",
    "ultimaCompraSimulada": "30/04/2026",
    "diasDesdeUltimaCompraSimulado": 14,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0313"
  },
  {
    "clienteId": "CLI_0314",
    "clienteAnonimo": "313",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 439,
    "ticketMedianoSimulado": 428,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 878,
    "maiorPedidoSimulado": 498,
    "menorPedidoSimulado": 285,
    "ticketMedioSimuladoFmt": "R$ 439",
    "ticketMedianoSimuladoFmt": "R$ 428",
    "valorTotalAcumuladoSimuladoFmt": "R$ 878",
    "maiorPedidoSimuladoFmt": "R$ 498",
    "menorPedidoSimuladoFmt": "R$ 285",
    "primeiraCompraSimulada": "04/02/2026",
    "ultimaCompraSimulada": "09/04/2026",
    "diasDesdeUltimaCompraSimulado": 35,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0314"
  },
  {
    "clienteId": "CLI_0315",
    "clienteAnonimo": "314",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 413,
    "ticketMedianoSimulado": 394,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 826,
    "maiorPedidoSimulado": 485,
    "menorPedidoSimulado": 287,
    "ticketMedioSimuladoFmt": "R$ 413",
    "ticketMedianoSimuladoFmt": "R$ 394",
    "valorTotalAcumuladoSimuladoFmt": "R$ 826",
    "maiorPedidoSimuladoFmt": "R$ 485",
    "menorPedidoSimuladoFmt": "R$ 287",
    "primeiraCompraSimulada": "20/02/2026",
    "ultimaCompraSimulada": "06/04/2026",
    "diasDesdeUltimaCompraSimulado": 38,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0315"
  },
  {
    "clienteId": "CLI_0316",
    "clienteAnonimo": "315",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 387,
    "ticketMedianoSimulado": 371,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 774,
    "maiorPedidoSimulado": 420,
    "menorPedidoSimulado": 228,
    "ticketMedioSimuladoFmt": "R$ 387",
    "ticketMedianoSimuladoFmt": "R$ 371",
    "valorTotalAcumuladoSimuladoFmt": "R$ 774",
    "maiorPedidoSimuladoFmt": "R$ 420",
    "menorPedidoSimuladoFmt": "R$ 228",
    "primeiraCompraSimulada": "08/03/2026",
    "ultimaCompraSimulada": "28/04/2026",
    "diasDesdeUltimaCompraSimulado": 16,
    "hipoteseDePerfil": "Compra compatível com abastecimento maior, família ou rotina intensa.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0316"
  },
  {
    "clienteId": "CLI_0317",
    "clienteAnonimo": "316",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 361,
    "ticketMedianoSimulado": 349,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1083,
    "maiorPedidoSimulado": 399,
    "menorPedidoSimulado": 222,
    "ticketMedioSimuladoFmt": "R$ 361",
    "ticketMedianoSimuladoFmt": "R$ 349",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.083",
    "maiorPedidoSimuladoFmt": "R$ 399",
    "menorPedidoSimuladoFmt": "R$ 222",
    "primeiraCompraSimulada": "24/03/2026",
    "ultimaCompraSimulada": "10/05/2026",
    "diasDesdeUltimaCompraSimulado": 4,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0317"
  },
  {
    "clienteId": "CLI_0318",
    "clienteAnonimo": "317",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 335,
    "ticketMedianoSimulado": 317,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 335,
    "maiorPedidoSimulado": 401,
    "menorPedidoSimulado": 241,
    "ticketMedioSimuladoFmt": "R$ 335",
    "ticketMedianoSimuladoFmt": "R$ 317",
    "valorTotalAcumuladoSimuladoFmt": "R$ 335",
    "maiorPedidoSimuladoFmt": "R$ 401",
    "menorPedidoSimuladoFmt": "R$ 241",
    "primeiraCompraSimulada": "09/04/2026",
    "ultimaCompraSimulada": "03/05/2026",
    "diasDesdeUltimaCompraSimulado": 11,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0318"
  },
  {
    "clienteId": "CLI_0319",
    "clienteAnonimo": "318",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 308,
    "ticketMedianoSimulado": 302,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 924,
    "maiorPedidoSimulado": 343,
    "menorPedidoSimulado": 192,
    "ticketMedioSimuladoFmt": "R$ 308",
    "ticketMedianoSimuladoFmt": "R$ 302",
    "valorTotalAcumuladoSimuladoFmt": "R$ 924",
    "maiorPedidoSimuladoFmt": "R$ 343",
    "menorPedidoSimuladoFmt": "R$ 192",
    "primeiraCompraSimulada": "03/04/2026",
    "ultimaCompraSimulada": "22/04/2026",
    "diasDesdeUltimaCompraSimulado": 22,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0319"
  },
  {
    "clienteId": "CLI_0320",
    "clienteAnonimo": "319",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 359,
    "ticketMedianoSimulado": 357,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1077,
    "maiorPedidoSimulado": 377,
    "menorPedidoSimulado": 198,
    "ticketMedioSimuladoFmt": "R$ 359",
    "ticketMedianoSimuladoFmt": "R$ 357",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.077",
    "maiorPedidoSimuladoFmt": "R$ 377",
    "menorPedidoSimuladoFmt": "R$ 198",
    "primeiraCompraSimulada": "13/02/2026",
    "ultimaCompraSimulada": "07/05/2026",
    "diasDesdeUltimaCompraSimulado": 7,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0320"
  },
  {
    "clienteId": "CLI_0321",
    "clienteAnonimo": "320",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 333,
    "ticketMedianoSimulado": 307,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 333,
    "maiorPedidoSimulado": 380,
    "menorPedidoSimulado": 219,
    "ticketMedioSimuladoFmt": "R$ 333",
    "ticketMedianoSimuladoFmt": "R$ 307",
    "valorTotalAcumuladoSimuladoFmt": "R$ 333",
    "maiorPedidoSimuladoFmt": "R$ 380",
    "menorPedidoSimuladoFmt": "R$ 219",
    "primeiraCompraSimulada": "28/01/2026",
    "ultimaCompraSimulada": "13/04/2026",
    "diasDesdeUltimaCompraSimulado": 31,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0321"
  },
  {
    "clienteId": "CLI_0322",
    "clienteAnonimo": "321",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 307,
    "ticketMedianoSimulado": 304,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 614,
    "maiorPedidoSimulado": 359,
    "menorPedidoSimulado": 211,
    "ticketMedioSimuladoFmt": "R$ 307",
    "ticketMedianoSimuladoFmt": "R$ 304",
    "valorTotalAcumuladoSimuladoFmt": "R$ 614",
    "maiorPedidoSimuladoFmt": "R$ 359",
    "menorPedidoSimuladoFmt": "R$ 211",
    "primeiraCompraSimulada": "12/01/2026",
    "ultimaCompraSimulada": "13/03/2026",
    "diasDesdeUltimaCompraSimulado": 62,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0322"
  },
  {
    "clienteId": "CLI_0323",
    "clienteAnonimo": "322",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 280,
    "ticketMedianoSimulado": 262,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 560,
    "maiorPedidoSimulado": 302,
    "menorPedidoSimulado": 163,
    "ticketMedioSimuladoFmt": "R$ 280",
    "ticketMedianoSimuladoFmt": "R$ 262",
    "valorTotalAcumuladoSimuladoFmt": "R$ 560",
    "maiorPedidoSimuladoFmt": "R$ 302",
    "menorPedidoSimuladoFmt": "R$ 163",
    "primeiraCompraSimulada": "27/12/2025",
    "ultimaCompraSimulada": "06/04/2026",
    "diasDesdeUltimaCompraSimulado": 38,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0323"
  },
  {
    "clienteId": "CLI_0324",
    "clienteAnonimo": "323",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 306,
    "ticketMedianoSimulado": 299,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 612,
    "maiorPedidoSimulado": 340,
    "menorPedidoSimulado": 191,
    "ticketMedioSimuladoFmt": "R$ 306",
    "ticketMedianoSimuladoFmt": "R$ 299",
    "valorTotalAcumuladoSimuladoFmt": "R$ 612",
    "maiorPedidoSimuladoFmt": "R$ 340",
    "menorPedidoSimuladoFmt": "R$ 191",
    "primeiraCompraSimulada": "11/12/2025",
    "ultimaCompraSimulada": "06/05/2026",
    "diasDesdeUltimaCompraSimulado": 8,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0324"
  },
  {
    "clienteId": "CLI_0325",
    "clienteAnonimo": "324",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 332,
    "ticketMedianoSimulado": 316,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 664,
    "maiorPedidoSimulado": 398,
    "menorPedidoSimulado": 240,
    "ticketMedioSimuladoFmt": "R$ 332",
    "ticketMedianoSimuladoFmt": "R$ 316",
    "valorTotalAcumuladoSimuladoFmt": "R$ 664",
    "maiorPedidoSimuladoFmt": "R$ 398",
    "menorPedidoSimuladoFmt": "R$ 240",
    "primeiraCompraSimulada": "26/11/2025",
    "ultimaCompraSimulada": "08/04/2026",
    "diasDesdeUltimaCompraSimulado": 36,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0325"
  },
  {
    "clienteId": "CLI_0326",
    "clienteAnonimo": "325",
    "segmentoComercial": "Cliente alto valor",
    "ticketMedioSimulado": 1000,
    "ticketMedianoSimulado": 962,
    "totalPedidosSimulado": 5,
    "valorTotalAcumuladoSimulado": 5000,
    "maiorPedidoSimulado": 1107,
    "menorPedidoSimulado": 617,
    "ticketMedioSimuladoFmt": "R$ 1.000",
    "ticketMedianoSimuladoFmt": "R$ 962",
    "valorTotalAcumuladoSimuladoFmt": "R$ 5.000",
    "maiorPedidoSimuladoFmt": "R$ 1.107",
    "menorPedidoSimuladoFmt": "R$ 617",
    "primeiraCompraSimulada": "10/11/2025",
    "ultimaCompraSimulada": "21/02/2026",
    "diasDesdeUltimaCompraSimulado": 82,
    "hipoteseDePerfil": "Compra compatível com abastecimento maior, família ou rotina intensa.",
    "objetivoProvavel": "Pode buscar abastecimento maior ou comprar para várias pessoas",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0326"
  },
  {
    "clienteId": "CLI_0327",
    "clienteAnonimo": "326",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 384,
    "ticketMedianoSimulado": 370,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1152,
    "maiorPedidoSimulado": 416,
    "menorPedidoSimulado": 226,
    "ticketMedioSimuladoFmt": "R$ 384",
    "ticketMedianoSimuladoFmt": "R$ 370",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.152",
    "maiorPedidoSimuladoFmt": "R$ 416",
    "menorPedidoSimuladoFmt": "R$ 226",
    "primeiraCompraSimulada": "01/11/2025",
    "ultimaCompraSimulada": "08/03/2026",
    "diasDesdeUltimaCompraSimulado": 67,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0327"
  },
  {
    "clienteId": "CLI_0328",
    "clienteAnonimo": "327",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 411,
    "ticketMedianoSimulado": 390,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 411,
    "maiorPedidoSimulado": 482,
    "menorPedidoSimulado": 285,
    "ticketMedioSimuladoFmt": "R$ 411",
    "ticketMedianoSimuladoFmt": "R$ 390",
    "valorTotalAcumuladoSimuladoFmt": "R$ 411",
    "maiorPedidoSimuladoFmt": "R$ 482",
    "menorPedidoSimuladoFmt": "R$ 285",
    "primeiraCompraSimulada": "17/11/2025",
    "ultimaCompraSimulada": "23/04/2026",
    "diasDesdeUltimaCompraSimulado": 21,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0328"
  },
  {
    "clienteId": "CLI_0329",
    "clienteAnonimo": "328",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 437,
    "ticketMedianoSimulado": 428,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1311,
    "maiorPedidoSimulado": 497,
    "menorPedidoSimulado": 285,
    "ticketMedioSimuladoFmt": "R$ 437",
    "ticketMedianoSimuladoFmt": "R$ 428",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.311",
    "maiorPedidoSimuladoFmt": "R$ 497",
    "menorPedidoSimuladoFmt": "R$ 285",
    "primeiraCompraSimulada": "03/12/2025",
    "ultimaCompraSimulada": "21/04/2026",
    "diasDesdeUltimaCompraSimulado": 23,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0329"
  },
  {
    "clienteId": "CLI_0330",
    "clienteAnonimo": "329",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 386,
    "ticketMedianoSimulado": 383,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1158,
    "maiorPedidoSimulado": 414,
    "menorPedidoSimulado": 222,
    "ticketMedioSimuladoFmt": "R$ 386",
    "ticketMedianoSimuladoFmt": "R$ 383",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.158",
    "maiorPedidoSimuladoFmt": "R$ 414",
    "menorPedidoSimuladoFmt": "R$ 222",
    "primeiraCompraSimulada": "21/01/2026",
    "ultimaCompraSimulada": "06/04/2026",
    "diasDesdeUltimaCompraSimulado": 38,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0330"
  },
  {
    "clienteId": "CLI_0331",
    "clienteAnonimo": "330",
    "segmentoComercial": "Cliente alto valor",
    "ticketMedioSimulado": 1103,
    "ticketMedianoSimulado": 1016,
    "totalPedidosSimulado": 4,
    "valorTotalAcumuladoSimulado": 4412,
    "maiorPedidoSimulado": 1234,
    "menorPedidoSimulado": 695,
    "ticketMedioSimuladoFmt": "R$ 1.103",
    "ticketMedianoSimuladoFmt": "R$ 1.016",
    "valorTotalAcumuladoSimuladoFmt": "R$ 4.412",
    "maiorPedidoSimuladoFmt": "R$ 1.234",
    "menorPedidoSimuladoFmt": "R$ 695",
    "primeiraCompraSimulada": "06/02/2026",
    "ultimaCompraSimulada": "03/05/2026",
    "diasDesdeUltimaCompraSimulado": 11,
    "hipoteseDePerfil": "Compra compatível com abastecimento maior, família ou rotina intensa.",
    "objetivoProvavel": "Pode buscar abastecimento maior ou comprar para várias pessoas",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0331"
  },
  {
    "clienteId": "CLI_0332",
    "clienteAnonimo": "331",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 439,
    "ticketMedianoSimulado": 436,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 878,
    "maiorPedidoSimulado": 523,
    "menorPedidoSimulado": 314,
    "ticketMedioSimuladoFmt": "R$ 439",
    "ticketMedianoSimuladoFmt": "R$ 436",
    "valorTotalAcumuladoSimuladoFmt": "R$ 878",
    "maiorPedidoSimuladoFmt": "R$ 523",
    "menorPedidoSimuladoFmt": "R$ 314",
    "primeiraCompraSimulada": "22/02/2026",
    "ultimaCompraSimulada": "30/04/2026",
    "diasDesdeUltimaCompraSimulado": 14,
    "hipoteseDePerfil": "Compra compatível com abastecimento maior, família ou rotina intensa.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0332"
  },
  {
    "clienteId": "CLI_0333",
    "clienteAnonimo": "332",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 435,
    "ticketMedianoSimulado": 406,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 870,
    "maiorPedidoSimulado": 479,
    "menorPedidoSimulado": 265,
    "ticketMedioSimuladoFmt": "R$ 435",
    "ticketMedianoSimuladoFmt": "R$ 406",
    "valorTotalAcumuladoSimuladoFmt": "R$ 870",
    "maiorPedidoSimuladoFmt": "R$ 479",
    "menorPedidoSimuladoFmt": "R$ 265",
    "primeiraCompraSimulada": "10/03/2026",
    "ultimaCompraSimulada": "18/04/2026",
    "diasDesdeUltimaCompraSimulado": 26,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0333"
  },
  {
    "clienteId": "CLI_0334",
    "clienteAnonimo": "333",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 409,
    "ticketMedianoSimulado": 401,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 818,
    "maiorPedidoSimulado": 445,
    "menorPedidoSimulado": 244,
    "ticketMedioSimuladoFmt": "R$ 409",
    "ticketMedianoSimuladoFmt": "R$ 401",
    "valorTotalAcumuladoSimuladoFmt": "R$ 818",
    "maiorPedidoSimuladoFmt": "R$ 445",
    "menorPedidoSimuladoFmt": "R$ 244",
    "primeiraCompraSimulada": "26/03/2026",
    "ultimaCompraSimulada": "23/04/2026",
    "diasDesdeUltimaCompraSimulado": 21,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0334"
  },
  {
    "clienteId": "CLI_0335",
    "clienteAnonimo": "334",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 383,
    "ticketMedianoSimulado": 363,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 766,
    "maiorPedidoSimulado": 452,
    "menorPedidoSimulado": 268,
    "ticketMedioSimuladoFmt": "R$ 383",
    "ticketMedianoSimuladoFmt": "R$ 363",
    "valorTotalAcumuladoSimuladoFmt": "R$ 766",
    "maiorPedidoSimuladoFmt": "R$ 452",
    "menorPedidoSimuladoFmt": "R$ 268",
    "primeiraCompraSimulada": "11/04/2026",
    "ultimaCompraSimulada": "06/05/2026",
    "diasDesdeUltimaCompraSimulado": 8,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0335"
  },
  {
    "clienteId": "CLI_0336",
    "clienteAnonimo": "335",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 356,
    "ticketMedianoSimulado": 344,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 712,
    "maiorPedidoSimulado": 402,
    "menorPedidoSimulado": 229,
    "ticketMedioSimuladoFmt": "R$ 356",
    "ticketMedianoSimuladoFmt": "R$ 344",
    "valorTotalAcumuladoSimuladoFmt": "R$ 712",
    "maiorPedidoSimuladoFmt": "R$ 402",
    "menorPedidoSimuladoFmt": "R$ 229",
    "primeiraCompraSimulada": "01/04/2026",
    "ultimaCompraSimulada": "08/05/2026",
    "diasDesdeUltimaCompraSimulado": 6,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0336"
  },
  {
    "clienteId": "CLI_0337",
    "clienteAnonimo": "336",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 330,
    "ticketMedianoSimulado": 318,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 660,
    "maiorPedidoSimulado": 350,
    "menorPedidoSimulado": 185,
    "ticketMedioSimuladoFmt": "R$ 330",
    "ticketMedianoSimuladoFmt": "R$ 318",
    "valorTotalAcumuladoSimuladoFmt": "R$ 660",
    "maiorPedidoSimuladoFmt": "R$ 350",
    "menorPedidoSimuladoFmt": "R$ 185",
    "primeiraCompraSimulada": "16/03/2026",
    "ultimaCompraSimulada": "24/04/2026",
    "diasDesdeUltimaCompraSimulado": 20,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0337"
  },
  {
    "clienteId": "CLI_0338",
    "clienteAnonimo": "337",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 304,
    "ticketMedianoSimulado": 289,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 304,
    "maiorPedidoSimulado": 350,
    "menorPedidoSimulado": 203,
    "ticketMedioSimuladoFmt": "R$ 304",
    "ticketMedianoSimuladoFmt": "R$ 289",
    "valorTotalAcumuladoSimuladoFmt": "R$ 304",
    "maiorPedidoSimuladoFmt": "R$ 350",
    "menorPedidoSimuladoFmt": "R$ 203",
    "primeiraCompraSimulada": "28/02/2026",
    "ultimaCompraSimulada": "07/04/2026",
    "diasDesdeUltimaCompraSimulado": 37,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0338"
  },
  {
    "clienteId": "CLI_0339",
    "clienteAnonimo": "338",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 282,
    "ticketMedianoSimulado": 275,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 846,
    "maiorPedidoSimulado": 327,
    "menorPedidoSimulado": 191,
    "ticketMedioSimuladoFmt": "R$ 282",
    "ticketMedianoSimuladoFmt": "R$ 275",
    "valorTotalAcumuladoSimuladoFmt": "R$ 846",
    "maiorPedidoSimuladoFmt": "R$ 327",
    "menorPedidoSimuladoFmt": "R$ 191",
    "primeiraCompraSimulada": "12/02/2026",
    "ultimaCompraSimulada": "20/04/2026",
    "diasDesdeUltimaCompraSimulado": 24,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0339"
  },
  {
    "clienteId": "CLI_0340",
    "clienteAnonimo": "339",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 328,
    "ticketMedianoSimulado": 325,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 984,
    "maiorPedidoSimulado": 359,
    "menorPedidoSimulado": 198,
    "ticketMedioSimuladoFmt": "R$ 328",
    "ticketMedianoSimuladoFmt": "R$ 325",
    "valorTotalAcumuladoSimuladoFmt": "R$ 984",
    "maiorPedidoSimuladoFmt": "R$ 359",
    "menorPedidoSimuladoFmt": "R$ 198",
    "primeiraCompraSimulada": "26/12/2025",
    "ultimaCompraSimulada": "29/03/2026",
    "diasDesdeUltimaCompraSimulado": 46,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0340"
  },
  {
    "clienteId": "CLI_0341",
    "clienteAnonimo": "340",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 302,
    "ticketMedianoSimulado": 279,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 302,
    "maiorPedidoSimulado": 331,
    "menorPedidoSimulado": 182,
    "ticketMedioSimuladoFmt": "R$ 302",
    "ticketMedianoSimuladoFmt": "R$ 279",
    "valorTotalAcumuladoSimuladoFmt": "R$ 302",
    "maiorPedidoSimuladoFmt": "R$ 331",
    "menorPedidoSimuladoFmt": "R$ 182",
    "primeiraCompraSimulada": "10/12/2025",
    "ultimaCompraSimulada": "04/03/2026",
    "diasDesdeUltimaCompraSimulado": 71,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0341"
  },
  {
    "clienteId": "CLI_0342",
    "clienteAnonimo": "341",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 284,
    "ticketMedianoSimulado": 283,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 852,
    "maiorPedidoSimulado": 337,
    "menorPedidoSimulado": 201,
    "ticketMedioSimuladoFmt": "R$ 284",
    "ticketMedianoSimuladoFmt": "R$ 283",
    "valorTotalAcumuladoSimuladoFmt": "R$ 852",
    "maiorPedidoSimuladoFmt": "R$ 337",
    "menorPedidoSimuladoFmt": "R$ 201",
    "primeiraCompraSimulada": "24/11/2025",
    "ultimaCompraSimulada": "04/04/2026",
    "diasDesdeUltimaCompraSimulado": 40,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0342"
  },
  {
    "clienteId": "CLI_0343",
    "clienteAnonimo": "342",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 310,
    "ticketMedianoSimulado": 289,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 620,
    "maiorPedidoSimulado": 348,
    "menorPedidoSimulado": 197,
    "ticketMedioSimuladoFmt": "R$ 310",
    "ticketMedianoSimuladoFmt": "R$ 289",
    "valorTotalAcumuladoSimuladoFmt": "R$ 620",
    "maiorPedidoSimuladoFmt": "R$ 348",
    "menorPedidoSimuladoFmt": "R$ 197",
    "primeiraCompraSimulada": "08/11/2025",
    "ultimaCompraSimulada": "09/05/2026",
    "diasDesdeUltimaCompraSimulado": 5,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0343"
  },
  {
    "clienteId": "CLI_0344",
    "clienteAnonimo": "343",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 336,
    "ticketMedianoSimulado": 330,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 672,
    "maiorPedidoSimulado": 358,
    "menorPedidoSimulado": 191,
    "ticketMedioSimuladoFmt": "R$ 336",
    "ticketMedianoSimuladoFmt": "R$ 330",
    "valorTotalAcumuladoSimuladoFmt": "R$ 672",
    "maiorPedidoSimuladoFmt": "R$ 358",
    "menorPedidoSimuladoFmt": "R$ 191",
    "primeiraCompraSimulada": "03/11/2025",
    "ultimaCompraSimulada": "26/03/2026",
    "diasDesdeUltimaCompraSimulado": 49,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0344"
  },
  {
    "clienteId": "CLI_0345",
    "clienteAnonimo": "344",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 363,
    "ticketMedianoSimulado": 343,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 726,
    "maiorPedidoSimulado": 420,
    "menorPedidoSimulado": 245,
    "ticketMedioSimuladoFmt": "R$ 363",
    "ticketMedianoSimuladoFmt": "R$ 343",
    "valorTotalAcumuladoSimuladoFmt": "R$ 726",
    "maiorPedidoSimuladoFmt": "R$ 420",
    "menorPedidoSimuladoFmt": "R$ 245",
    "primeiraCompraSimulada": "19/11/2025",
    "ultimaCompraSimulada": "18/02/2026",
    "diasDesdeUltimaCompraSimulado": 85,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0345"
  },
  {
    "clienteId": "CLI_0346",
    "clienteAnonimo": "345",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 389,
    "ticketMedianoSimulado": 376,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 778,
    "maiorPedidoSimulado": 449,
    "menorPedidoSimulado": 261,
    "ticketMedioSimuladoFmt": "R$ 389",
    "ticketMedianoSimuladoFmt": "R$ 376",
    "valorTotalAcumuladoSimuladoFmt": "R$ 778",
    "maiorPedidoSimuladoFmt": "R$ 449",
    "menorPedidoSimuladoFmt": "R$ 261",
    "primeiraCompraSimulada": "05/12/2025",
    "ultimaCompraSimulada": "26/03/2026",
    "diasDesdeUltimaCompraSimulado": 49,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0346"
  },
  {
    "clienteId": "CLI_0347",
    "clienteAnonimo": "346",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 415,
    "ticketMedianoSimulado": 398,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 830,
    "maiorPedidoSimulado": 441,
    "menorPedidoSimulado": 235,
    "ticketMedioSimuladoFmt": "R$ 415",
    "ticketMedianoSimuladoFmt": "R$ 398",
    "valorTotalAcumuladoSimuladoFmt": "R$ 830",
    "maiorPedidoSimuladoFmt": "R$ 441",
    "menorPedidoSimuladoFmt": "R$ 235",
    "primeiraCompraSimulada": "21/12/2025",
    "ultimaCompraSimulada": "02/05/2026",
    "diasDesdeUltimaCompraSimulado": 12,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0347"
  },
  {
    "clienteId": "CLI_0348",
    "clienteAnonimo": "347",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 441,
    "ticketMedianoSimulado": 420,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 441,
    "maiorPedidoSimulado": 497,
    "menorPedidoSimulado": 282,
    "ticketMedioSimuladoFmt": "R$ 441",
    "ticketMedianoSimuladoFmt": "R$ 420",
    "valorTotalAcumuladoSimuladoFmt": "R$ 441",
    "maiorPedidoSimuladoFmt": "R$ 497",
    "menorPedidoSimuladoFmt": "R$ 282",
    "primeiraCompraSimulada": "06/01/2026",
    "ultimaCompraSimulada": "20/04/2026",
    "diasDesdeUltimaCompraSimulado": 24,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0348"
  },
  {
    "clienteId": "CLI_0349",
    "clienteAnonimo": "348",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 433,
    "ticketMedianoSimulado": 422,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1299,
    "maiorPedidoSimulado": 512,
    "menorPedidoSimulado": 305,
    "ticketMedioSimuladoFmt": "R$ 433",
    "ticketMedianoSimuladoFmt": "R$ 422",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.299",
    "maiorPedidoSimuladoFmt": "R$ 512",
    "menorPedidoSimuladoFmt": "R$ 305",
    "primeiraCompraSimulada": "22/01/2026",
    "ultimaCompraSimulada": "28/03/2026",
    "diasDesdeUltimaCompraSimulado": 47,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0349"
  },
  {
    "clienteId": "CLI_0350",
    "clienteAnonimo": "349",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 417,
    "ticketMedianoSimulado": 412,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1251,
    "maiorPedidoSimulado": 466,
    "menorPedidoSimulado": 262,
    "ticketMedioSimuladoFmt": "R$ 417",
    "ticketMedianoSimuladoFmt": "R$ 412",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.251",
    "maiorPedidoSimuladoFmt": "R$ 466",
    "menorPedidoSimuladoFmt": "R$ 262",
    "primeiraCompraSimulada": "11/03/2026",
    "ultimaCompraSimulada": "08/05/2026",
    "diasDesdeUltimaCompraSimulado": 6,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0350"
  },
  {
    "clienteId": "CLI_0351",
    "clienteAnonimo": "350",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 443,
    "ticketMedianoSimulado": 410,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 443,
    "maiorPedidoSimulado": 475,
    "menorPedidoSimulado": 255,
    "ticketMedioSimuladoFmt": "R$ 443",
    "ticketMedianoSimuladoFmt": "R$ 410",
    "valorTotalAcumuladoSimuladoFmt": "R$ 443",
    "maiorPedidoSimuladoFmt": "R$ 475",
    "menorPedidoSimuladoFmt": "R$ 255",
    "primeiraCompraSimulada": "27/03/2026",
    "ultimaCompraSimulada": "03/05/2026",
    "diasDesdeUltimaCompraSimulado": 11,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0351"
  },
  {
    "clienteId": "CLI_0352",
    "clienteAnonimo": "351",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 431,
    "ticketMedianoSimulado": 430,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1293,
    "maiorPedidoSimulado": 501,
    "menorPedidoSimulado": 294,
    "ticketMedioSimuladoFmt": "R$ 431",
    "ticketMedianoSimuladoFmt": "R$ 430",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.293",
    "maiorPedidoSimuladoFmt": "R$ 501",
    "menorPedidoSimuladoFmt": "R$ 294",
    "primeiraCompraSimulada": "12/04/2026",
    "ultimaCompraSimulada": "29/04/2026",
    "diasDesdeUltimaCompraSimulado": 15,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0352"
  },
  {
    "clienteId": "CLI_0353",
    "clienteAnonimo": "352",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 405,
    "ticketMedianoSimulado": 376,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 810,
    "maiorPedidoSimulado": 465,
    "menorPedidoSimulado": 269,
    "ticketMedioSimuladoFmt": "R$ 405",
    "ticketMedianoSimuladoFmt": "R$ 376",
    "valorTotalAcumuladoSimuladoFmt": "R$ 810",
    "maiorPedidoSimuladoFmt": "R$ 465",
    "menorPedidoSimuladoFmt": "R$ 269",
    "primeiraCompraSimulada": "31/03/2026",
    "ultimaCompraSimulada": "27/04/2026",
    "diasDesdeUltimaCompraSimulado": 17,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0353"
  },
  {
    "clienteId": "CLI_0354",
    "clienteAnonimo": "353",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 378,
    "ticketMedianoSimulado": 372,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 756,
    "maiorPedidoSimulado": 400,
    "menorPedidoSimulado": 211,
    "ticketMedioSimuladoFmt": "R$ 378",
    "ticketMedianoSimuladoFmt": "R$ 372",
    "valorTotalAcumuladoSimuladoFmt": "R$ 756",
    "maiorPedidoSimuladoFmt": "R$ 400",
    "menorPedidoSimuladoFmt": "R$ 211",
    "primeiraCompraSimulada": "15/03/2026",
    "ultimaCompraSimulada": "04/05/2026",
    "diasDesdeUltimaCompraSimulado": 10,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0354"
  },
  {
    "clienteId": "CLI_0355",
    "clienteAnonimo": "354",
    "segmentoComercial": "Cliente alto valor",
    "ticketMedioSimulado": 988,
    "ticketMedianoSimulado": 932,
    "totalPedidosSimulado": 5,
    "valorTotalAcumuladoSimulado": 4940,
    "maiorPedidoSimulado": 1120,
    "menorPedidoSimulado": 639,
    "ticketMedioSimuladoFmt": "R$ 988",
    "ticketMedianoSimuladoFmt": "R$ 932",
    "valorTotalAcumuladoSimuladoFmt": "R$ 4.940",
    "maiorPedidoSimuladoFmt": "R$ 1.120",
    "menorPedidoSimuladoFmt": "R$ 639",
    "primeiraCompraSimulada": "27/02/2026",
    "ultimaCompraSimulada": "03/05/2026",
    "diasDesdeUltimaCompraSimulado": 11,
    "hipoteseDePerfil": "Compra compatível com abastecimento maior, família ou rotina intensa.",
    "objetivoProvavel": "Pode buscar abastecimento maior ou comprar para várias pessoas",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0355"
  },
  {
    "clienteId": "CLI_0356",
    "clienteAnonimo": "355",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 326,
    "ticketMedianoSimulado": 316,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 652,
    "maiorPedidoSimulado": 384,
    "menorPedidoSimulado": 227,
    "ticketMedioSimuladoFmt": "R$ 326",
    "ticketMedianoSimuladoFmt": "R$ 316",
    "valorTotalAcumuladoSimuladoFmt": "R$ 652",
    "maiorPedidoSimuladoFmt": "R$ 384",
    "menorPedidoSimuladoFmt": "R$ 227",
    "primeiraCompraSimulada": "11/02/2026",
    "ultimaCompraSimulada": "10/04/2026",
    "diasDesdeUltimaCompraSimulado": 34,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0356"
  },
  {
    "clienteId": "CLI_0357",
    "clienteAnonimo": "356",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 300,
    "ticketMedianoSimulado": 287,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 600,
    "maiorPedidoSimulado": 326,
    "menorPedidoSimulado": 178,
    "ticketMedioSimuladoFmt": "R$ 300",
    "ticketMedianoSimuladoFmt": "R$ 287",
    "valorTotalAcumuladoSimuladoFmt": "R$ 600",
    "maiorPedidoSimuladoFmt": "R$ 326",
    "menorPedidoSimuladoFmt": "R$ 178",
    "primeiraCompraSimulada": "26/01/2026",
    "ultimaCompraSimulada": "28/03/2026",
    "diasDesdeUltimaCompraSimulado": 47,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0357"
  },
  {
    "clienteId": "CLI_0358",
    "clienteAnonimo": "357",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 287,
    "ticketMedianoSimulado": 274,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 287,
    "maiorPedidoSimulado": 317,
    "menorPedidoSimulado": 176,
    "ticketMedioSimuladoFmt": "R$ 287",
    "ticketMedianoSimuladoFmt": "R$ 274",
    "valorTotalAcumuladoSimuladoFmt": "R$ 287",
    "maiorPedidoSimuladoFmt": "R$ 317",
    "menorPedidoSimuladoFmt": "R$ 176",
    "primeiraCompraSimulada": "10/01/2026",
    "ultimaCompraSimulada": "18/04/2026",
    "diasDesdeUltimaCompraSimulado": 26,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0358"
  },
  {
    "clienteId": "CLI_0359",
    "clienteAnonimo": "358",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 313,
    "ticketMedianoSimulado": 304,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 939,
    "maiorPedidoSimulado": 374,
    "menorPedidoSimulado": 225,
    "ticketMedioSimuladoFmt": "R$ 313",
    "ticketMedianoSimuladoFmt": "R$ 304",
    "valorTotalAcumuladoSimuladoFmt": "R$ 939",
    "maiorPedidoSimuladoFmt": "R$ 374",
    "menorPedidoSimuladoFmt": "R$ 225",
    "primeiraCompraSimulada": "25/12/2025",
    "ultimaCompraSimulada": "06/05/2026",
    "diasDesdeUltimaCompraSimulado": 8,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0359"
  },
  {
    "clienteId": "CLI_0360",
    "clienteAnonimo": "359",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 298,
    "ticketMedianoSimulado": 293,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 894,
    "maiorPedidoSimulado": 340,
    "menorPedidoSimulado": 196,
    "ticketMedioSimuladoFmt": "R$ 298",
    "ticketMedianoSimuladoFmt": "R$ 293",
    "valorTotalAcumuladoSimuladoFmt": "R$ 894",
    "maiorPedidoSimuladoFmt": "R$ 340",
    "menorPedidoSimuladoFmt": "R$ 196",
    "primeiraCompraSimulada": "07/11/2025",
    "ultimaCompraSimulada": "25/02/2026",
    "diasDesdeUltimaCompraSimulado": 78,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0360"
  },
  {
    "clienteId": "CLI_0361",
    "clienteAnonimo": "360",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 288,
    "ticketMedianoSimulado": 267,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 288,
    "maiorPedidoSimulado": 303,
    "menorPedidoSimulado": 159,
    "ticketMedioSimuladoFmt": "R$ 288",
    "ticketMedianoSimuladoFmt": "R$ 267",
    "valorTotalAcumuladoSimuladoFmt": "R$ 288",
    "maiorPedidoSimuladoFmt": "R$ 303",
    "menorPedidoSimuladoFmt": "R$ 159",
    "primeiraCompraSimulada": "04/11/2025",
    "ultimaCompraSimulada": "08/04/2026",
    "diasDesdeUltimaCompraSimulado": 36,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0361"
  },
  {
    "clienteId": "CLI_0362",
    "clienteAnonimo": "361",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 315,
    "ticketMedianoSimulado": 315,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 945,
    "maiorPedidoSimulado": 359,
    "menorPedidoSimulado": 206,
    "ticketMedioSimuladoFmt": "R$ 315",
    "ticketMedianoSimuladoFmt": "R$ 315",
    "valorTotalAcumuladoSimuladoFmt": "R$ 945",
    "maiorPedidoSimuladoFmt": "R$ 359",
    "menorPedidoSimuladoFmt": "R$ 206",
    "primeiraCompraSimulada": "20/11/2025",
    "ultimaCompraSimulada": "01/05/2026",
    "diasDesdeUltimaCompraSimulado": 13,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0362"
  },
  {
    "clienteId": "CLI_0363",
    "clienteAnonimo": "362",
    "segmentoComercial": "Cliente possível coletivo",
    "ticketMedioSimulado": 1843,
    "ticketMedianoSimulado": 1707,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 3686,
    "maiorPedidoSimulado": 2157,
    "menorPedidoSimulado": 1273,
    "ticketMedioSimuladoFmt": "R$ 1.843",
    "ticketMedianoSimuladoFmt": "R$ 1.707",
    "valorTotalAcumuladoSimuladoFmt": "R$ 3.686",
    "maiorPedidoSimuladoFmt": "R$ 2.157",
    "menorPedidoSimuladoFmt": "R$ 1.273",
    "primeiraCompraSimulada": "06/12/2025",
    "ultimaCompraSimulada": "27/03/2026",
    "diasDesdeUltimaCompraSimulado": 48,
    "hipoteseDePerfil": "Possível compra coletiva, familiar ampliada ou corporativa. Não afirmar sem confirmação.",
    "objetivoProvavel": "Pode comprar para mais de uma pessoa, família ou equipe",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Tratar como hipótese de compra coletiva — G09 ativo.",
    "alertaSimulacao": "Possível compra familiar, equipe ou coletiva. Confirmar antes de assumir.",
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0363"
  },
  {
    "clienteId": "CLI_0364",
    "clienteAnonimo": "363",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 367,
    "ticketMedianoSimulado": 362,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 734,
    "maiorPedidoSimulado": 396,
    "menorPedidoSimulado": 215,
    "ticketMedioSimuladoFmt": "R$ 367",
    "ticketMedianoSimuladoFmt": "R$ 362",
    "valorTotalAcumuladoSimuladoFmt": "R$ 734",
    "maiorPedidoSimuladoFmt": "R$ 396",
    "menorPedidoSimuladoFmt": "R$ 215",
    "primeiraCompraSimulada": "22/12/2025",
    "ultimaCompraSimulada": "05/03/2026",
    "diasDesdeUltimaCompraSimulado": 70,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0364"
  },
  {
    "clienteId": "CLI_0365",
    "clienteAnonimo": "364",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 393,
    "ticketMedianoSimulado": 370,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 786,
    "maiorPedidoSimulado": 436,
    "menorPedidoSimulado": 244,
    "ticketMedioSimuladoFmt": "R$ 393",
    "ticketMedianoSimuladoFmt": "R$ 370",
    "valorTotalAcumuladoSimuladoFmt": "R$ 786",
    "maiorPedidoSimuladoFmt": "R$ 436",
    "menorPedidoSimuladoFmt": "R$ 244",
    "primeiraCompraSimulada": "07/01/2026",
    "ultimaCompraSimulada": "10/04/2026",
    "diasDesdeUltimaCompraSimulado": 34,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0365"
  },
  {
    "clienteId": "CLI_0366",
    "clienteAnonimo": "365",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 419,
    "ticketMedianoSimulado": 407,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 838,
    "maiorPedidoSimulado": 503,
    "menorPedidoSimulado": 304,
    "ticketMedioSimuladoFmt": "R$ 419",
    "ticketMedianoSimuladoFmt": "R$ 407",
    "valorTotalAcumuladoSimuladoFmt": "R$ 838",
    "maiorPedidoSimuladoFmt": "R$ 503",
    "menorPedidoSimuladoFmt": "R$ 304",
    "primeiraCompraSimulada": "23/01/2026",
    "ultimaCompraSimulada": "09/05/2026",
    "diasDesdeUltimaCompraSimulado": 5,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0366"
  },
  {
    "clienteId": "CLI_0367",
    "clienteAnonimo": "366",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 446,
    "ticketMedianoSimulado": 426,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 892,
    "maiorPedidoSimulado": 495,
    "menorPedidoSimulado": 276,
    "ticketMedioSimuladoFmt": "R$ 446",
    "ticketMedianoSimuladoFmt": "R$ 426",
    "valorTotalAcumuladoSimuladoFmt": "R$ 892",
    "maiorPedidoSimuladoFmt": "R$ 495",
    "menorPedidoSimuladoFmt": "R$ 276",
    "primeiraCompraSimulada": "08/02/2026",
    "ultimaCompraSimulada": "21/04/2026",
    "diasDesdeUltimaCompraSimulado": 23,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0367"
  },
  {
    "clienteId": "CLI_0368",
    "clienteAnonimo": "367",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 428,
    "ticketMedianoSimulado": 410,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 856,
    "maiorPedidoSimulado": 463,
    "menorPedidoSimulado": 251,
    "ticketMedioSimuladoFmt": "R$ 428",
    "ticketMedianoSimuladoFmt": "R$ 410",
    "valorTotalAcumuladoSimuladoFmt": "R$ 856",
    "maiorPedidoSimuladoFmt": "R$ 463",
    "menorPedidoSimuladoFmt": "R$ 251",
    "primeiraCompraSimulada": "24/02/2026",
    "ultimaCompraSimulada": "07/04/2026",
    "diasDesdeUltimaCompraSimulado": 37,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0368"
  },
  {
    "clienteId": "CLI_0369",
    "clienteAnonimo": "368",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 402,
    "ticketMedianoSimulado": 390,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1206,
    "maiorPedidoSimulado": 471,
    "menorPedidoSimulado": 278,
    "ticketMedioSimuladoFmt": "R$ 402",
    "ticketMedianoSimuladoFmt": "R$ 390",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.206",
    "maiorPedidoSimuladoFmt": "R$ 471",
    "menorPedidoSimuladoFmt": "R$ 278",
    "primeiraCompraSimulada": "12/03/2026",
    "ultimaCompraSimulada": "22/04/2026",
    "diasDesdeUltimaCompraSimulado": 22,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0369"
  },
  {
    "clienteId": "CLI_0370",
    "clienteAnonimo": "369",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 447,
    "ticketMedianoSimulado": 439,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1341,
    "maiorPedidoSimulado": 520,
    "menorPedidoSimulado": 305,
    "ticketMedioSimuladoFmt": "R$ 447",
    "ticketMedianoSimuladoFmt": "R$ 439",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.341",
    "maiorPedidoSimuladoFmt": "R$ 520",
    "menorPedidoSimuladoFmt": "R$ 305",
    "primeiraCompraSimulada": "30/03/2026",
    "ultimaCompraSimulada": "01/05/2026",
    "diasDesdeUltimaCompraSimulado": 13,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0370"
  },
  {
    "clienteId": "CLI_0371",
    "clienteAnonimo": "370",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 426,
    "ticketMedianoSimulado": 397,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 426,
    "maiorPedidoSimulado": 458,
    "menorPedidoSimulado": 246,
    "ticketMedioSimuladoFmt": "R$ 426",
    "ticketMedianoSimuladoFmt": "R$ 397",
    "valorTotalAcumuladoSimuladoFmt": "R$ 426",
    "maiorPedidoSimuladoFmt": "R$ 458",
    "menorPedidoSimuladoFmt": "R$ 246",
    "primeiraCompraSimulada": "14/03/2026",
    "ultimaCompraSimulada": "14/04/2026",
    "diasDesdeUltimaCompraSimulado": 30,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0371"
  },
  {
    "clienteId": "CLI_0372",
    "clienteAnonimo": "371",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 400,
    "ticketMedianoSimulado": 398,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1200,
    "maiorPedidoSimulado": 447,
    "menorPedidoSimulado": 251,
    "ticketMedioSimuladoFmt": "R$ 400",
    "ticketMedianoSimuladoFmt": "R$ 398",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.200",
    "maiorPedidoSimuladoFmt": "R$ 447",
    "menorPedidoSimuladoFmt": "R$ 251",
    "primeiraCompraSimulada": "26/02/2026",
    "ultimaCompraSimulada": "18/04/2026",
    "diasDesdeUltimaCompraSimulado": 26,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0372"
  },
  {
    "clienteId": "CLI_0373",
    "clienteAnonimo": "372",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 374,
    "ticketMedianoSimulado": 345,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 374,
    "maiorPedidoSimulado": 446,
    "menorPedidoSimulado": 268,
    "ticketMedioSimuladoFmt": "R$ 374",
    "ticketMedianoSimuladoFmt": "R$ 345",
    "valorTotalAcumuladoSimuladoFmt": "R$ 374",
    "maiorPedidoSimuladoFmt": "R$ 446",
    "menorPedidoSimuladoFmt": "R$ 268",
    "primeiraCompraSimulada": "10/02/2026",
    "ultimaCompraSimulada": "04/05/2026",
    "diasDesdeUltimaCompraSimulado": 10,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0373"
  },
  {
    "clienteId": "CLI_0374",
    "clienteAnonimo": "373",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 348,
    "ticketMedianoSimulado": 344,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 696,
    "maiorPedidoSimulado": 384,
    "menorPedidoSimulado": 213,
    "ticketMedioSimuladoFmt": "R$ 348",
    "ticketMedianoSimuladoFmt": "R$ 344",
    "valorTotalAcumuladoSimuladoFmt": "R$ 696",
    "maiorPedidoSimuladoFmt": "R$ 384",
    "menorPedidoSimuladoFmt": "R$ 213",
    "primeiraCompraSimulada": "25/01/2026",
    "ultimaCompraSimulada": "24/04/2026",
    "diasDesdeUltimaCompraSimulado": 20,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0374"
  },
  {
    "clienteId": "CLI_0375",
    "clienteAnonimo": "374",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 322,
    "ticketMedianoSimulado": 302,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 644,
    "maiorPedidoSimulado": 350,
    "menorPedidoSimulado": 191,
    "ticketMedioSimuladoFmt": "R$ 322",
    "ticketMedianoSimuladoFmt": "R$ 302",
    "valorTotalAcumuladoSimuladoFmt": "R$ 644",
    "maiorPedidoSimuladoFmt": "R$ 350",
    "menorPedidoSimuladoFmt": "R$ 191",
    "primeiraCompraSimulada": "09/01/2026",
    "ultimaCompraSimulada": "24/03/2026",
    "diasDesdeUltimaCompraSimulado": 51,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0375"
  },
  {
    "clienteId": "CLI_0376",
    "clienteAnonimo": "375",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 295,
    "ticketMedianoSimulado": 288,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 590,
    "maiorPedidoSimulado": 347,
    "menorPedidoSimulado": 206,
    "ticketMedioSimuladoFmt": "R$ 295",
    "ticketMedianoSimuladoFmt": "R$ 288",
    "valorTotalAcumuladoSimuladoFmt": "R$ 590",
    "maiorPedidoSimuladoFmt": "R$ 347",
    "menorPedidoSimuladoFmt": "R$ 206",
    "primeiraCompraSimulada": "24/12/2025",
    "ultimaCompraSimulada": "20/03/2026",
    "diasDesdeUltimaCompraSimulado": 55,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0376"
  },
  {
    "clienteId": "CLI_0377",
    "clienteAnonimo": "376",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 291,
    "ticketMedianoSimulado": 277,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 582,
    "maiorPedidoSimulado": 330,
    "menorPedidoSimulado": 188,
    "ticketMedioSimuladoFmt": "R$ 291",
    "ticketMedianoSimuladoFmt": "R$ 277",
    "valorTotalAcumuladoSimuladoFmt": "R$ 582",
    "maiorPedidoSimuladoFmt": "R$ 330",
    "menorPedidoSimuladoFmt": "R$ 188",
    "primeiraCompraSimulada": "08/12/2025",
    "ultimaCompraSimulada": "18/04/2026",
    "diasDesdeUltimaCompraSimulado": 26,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0377"
  },
  {
    "clienteId": "CLI_0378",
    "clienteAnonimo": "377",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 317,
    "ticketMedianoSimulado": 305,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 634,
    "maiorPedidoSimulado": 335,
    "menorPedidoSimulado": 177,
    "ticketMedioSimuladoFmt": "R$ 317",
    "ticketMedianoSimuladoFmt": "R$ 305",
    "valorTotalAcumuladoSimuladoFmt": "R$ 634",
    "maiorPedidoSimuladoFmt": "R$ 335",
    "menorPedidoSimuladoFmt": "R$ 177",
    "primeiraCompraSimulada": "22/11/2025",
    "ultimaCompraSimulada": "27/04/2026",
    "diasDesdeUltimaCompraSimulado": 17,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0378"
  },
  {
    "clienteId": "CLI_0379",
    "clienteAnonimo": "378",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 343,
    "ticketMedianoSimulado": 332,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1029,
    "maiorPedidoSimulado": 394,
    "menorPedidoSimulado": 228,
    "ticketMedioSimuladoFmt": "R$ 343",
    "ticketMedianoSimuladoFmt": "R$ 332",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.029",
    "maiorPedidoSimuladoFmt": "R$ 394",
    "menorPedidoSimuladoFmt": "R$ 228",
    "primeiraCompraSimulada": "06/11/2025",
    "ultimaCompraSimulada": "13/03/2026",
    "diasDesdeUltimaCompraSimulado": 62,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0379"
  },
  {
    "clienteId": "CLI_0380",
    "clienteAnonimo": "379",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 293,
    "ticketMedianoSimulado": 287,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 879,
    "maiorPedidoSimulado": 348,
    "menorPedidoSimulado": 208,
    "ticketMedioSimuladoFmt": "R$ 293",
    "ticketMedianoSimuladoFmt": "R$ 287",
    "valorTotalAcumuladoSimuladoFmt": "R$ 879",
    "maiorPedidoSimuladoFmt": "R$ 348",
    "menorPedidoSimuladoFmt": "R$ 208",
    "primeiraCompraSimulada": "08/12/2025",
    "ultimaCompraSimulada": "21/04/2026",
    "diasDesdeUltimaCompraSimulado": 23,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0380"
  },
  {
    "clienteId": "CLI_0381",
    "clienteAnonimo": "380",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 319,
    "ticketMedianoSimulado": 298,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 319,
    "maiorPedidoSimulado": 350,
    "menorPedidoSimulado": 193,
    "ticketMedioSimuladoFmt": "R$ 319",
    "ticketMedianoSimuladoFmt": "R$ 298",
    "valorTotalAcumuladoSimuladoFmt": "R$ 319",
    "maiorPedidoSimuladoFmt": "R$ 350",
    "menorPedidoSimuladoFmt": "R$ 193",
    "primeiraCompraSimulada": "24/12/2025",
    "ultimaCompraSimulada": "27/04/2026",
    "diasDesdeUltimaCompraSimulado": 17,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0381"
  },
  {
    "clienteId": "CLI_0382",
    "clienteAnonimo": "381",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 345,
    "ticketMedianoSimulado": 343,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1035,
    "maiorPedidoSimulado": 377,
    "menorPedidoSimulado": 207,
    "ticketMedioSimuladoFmt": "R$ 345",
    "ticketMedianoSimuladoFmt": "R$ 343",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.035",
    "maiorPedidoSimuladoFmt": "R$ 377",
    "menorPedidoSimuladoFmt": "R$ 207",
    "primeiraCompraSimulada": "09/01/2026",
    "ultimaCompraSimulada": "31/03/2026",
    "diasDesdeUltimaCompraSimulado": 44,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0382"
  },
  {
    "clienteId": "CLI_0383",
    "clienteAnonimo": "382",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 371,
    "ticketMedianoSimulado": 342,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 371,
    "maiorPedidoSimulado": 439,
    "menorPedidoSimulado": 262,
    "ticketMedioSimuladoFmt": "R$ 371",
    "ticketMedianoSimuladoFmt": "R$ 342",
    "valorTotalAcumuladoSimuladoFmt": "R$ 371",
    "maiorPedidoSimuladoFmt": "R$ 439",
    "menorPedidoSimuladoFmt": "R$ 262",
    "primeiraCompraSimulada": "25/01/2026",
    "ultimaCompraSimulada": "26/03/2026",
    "diasDesdeUltimaCompraSimulado": 49,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0383"
  },
  {
    "clienteId": "CLI_0384",
    "clienteAnonimo": "383",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 398,
    "ticketMedianoSimulado": 395,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 796,
    "maiorPedidoSimulado": 448,
    "menorPedidoSimulado": 254,
    "ticketMedioSimuladoFmt": "R$ 398",
    "ticketMedianoSimuladoFmt": "R$ 395",
    "valorTotalAcumuladoSimuladoFmt": "R$ 796",
    "maiorPedidoSimuladoFmt": "R$ 448",
    "menorPedidoSimuladoFmt": "R$ 254",
    "primeiraCompraSimulada": "10/02/2026",
    "ultimaCompraSimulada": "23/04/2026",
    "diasDesdeUltimaCompraSimulado": 21,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0384"
  },
  {
    "clienteId": "CLI_0385",
    "clienteAnonimo": "384",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 424,
    "ticketMedianoSimulado": 397,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 848,
    "maiorPedidoSimulado": 451,
    "menorPedidoSimulado": 240,
    "ticketMedioSimuladoFmt": "R$ 424",
    "ticketMedianoSimuladoFmt": "R$ 397",
    "valorTotalAcumuladoSimuladoFmt": "R$ 848",
    "maiorPedidoSimuladoFmt": "R$ 451",
    "menorPedidoSimuladoFmt": "R$ 240",
    "primeiraCompraSimulada": "25/02/2026",
    "ultimaCompraSimulada": "09/05/2026",
    "diasDesdeUltimaCompraSimulado": 5,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0385"
  },
  {
    "clienteId": "CLI_0386",
    "clienteAnonimo": "385",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 450,
    "ticketMedianoSimulado": 440,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 900,
    "maiorPedidoSimulado": 519,
    "menorPedidoSimulado": 302,
    "ticketMedioSimuladoFmt": "R$ 450",
    "ticketMedianoSimuladoFmt": "R$ 440",
    "valorTotalAcumuladoSimuladoFmt": "R$ 900",
    "maiorPedidoSimuladoFmt": "R$ 519",
    "menorPedidoSimuladoFmt": "R$ 302",
    "primeiraCompraSimulada": "13/03/2026",
    "ultimaCompraSimulada": "26/04/2026",
    "diasDesdeUltimaCompraSimulado": 18,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0386"
  },
  {
    "clienteId": "CLI_0387",
    "clienteAnonimo": "386",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 424,
    "ticketMedianoSimulado": 403,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 848,
    "maiorPedidoSimulado": 490,
    "menorPedidoSimulado": 286,
    "ticketMedioSimuladoFmt": "R$ 424",
    "ticketMedianoSimuladoFmt": "R$ 403",
    "valorTotalAcumuladoSimuladoFmt": "R$ 848",
    "maiorPedidoSimuladoFmt": "R$ 490",
    "menorPedidoSimuladoFmt": "R$ 286",
    "primeiraCompraSimulada": "29/03/2026",
    "ultimaCompraSimulada": "20/04/2026",
    "diasDesdeUltimaCompraSimulado": 24,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0387"
  },
  {
    "clienteId": "CLI_0388",
    "clienteAnonimo": "387",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 398,
    "ticketMedianoSimulado": 383,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 796,
    "maiorPedidoSimulado": 424,
    "menorPedidoSimulado": 226,
    "ticketMedioSimuladoFmt": "R$ 398",
    "ticketMedianoSimuladoFmt": "R$ 383",
    "valorTotalAcumuladoSimuladoFmt": "R$ 796",
    "maiorPedidoSimuladoFmt": "R$ 424",
    "menorPedidoSimuladoFmt": "R$ 226",
    "primeiraCompraSimulada": "14/04/2026",
    "ultimaCompraSimulada": "03/05/2026",
    "diasDesdeUltimaCompraSimulado": 11,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0388"
  },
  {
    "clienteId": "CLI_0389",
    "clienteAnonimo": "388",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 371,
    "ticketMedianoSimulado": 358,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 742,
    "maiorPedidoSimulado": 417,
    "menorPedidoSimulado": 236,
    "ticketMedioSimuladoFmt": "R$ 371",
    "ticketMedianoSimuladoFmt": "R$ 358",
    "valorTotalAcumuladoSimuladoFmt": "R$ 742",
    "maiorPedidoSimuladoFmt": "R$ 417",
    "menorPedidoSimuladoFmt": "R$ 236",
    "primeiraCompraSimulada": "29/03/2026",
    "ultimaCompraSimulada": "09/05/2026",
    "diasDesdeUltimaCompraSimulado": 5,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0389"
  },
  {
    "clienteId": "CLI_0390",
    "clienteAnonimo": "389",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 422,
    "ticketMedianoSimulado": 412,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1266,
    "maiorPedidoSimulado": 502,
    "menorPedidoSimulado": 301,
    "ticketMedioSimuladoFmt": "R$ 422",
    "ticketMedianoSimuladoFmt": "R$ 412",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.266",
    "maiorPedidoSimuladoFmt": "R$ 502",
    "menorPedidoSimuladoFmt": "R$ 301",
    "primeiraCompraSimulada": "08/02/2026",
    "ultimaCompraSimulada": "27/03/2026",
    "diasDesdeUltimaCompraSimulado": 48,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0390"
  },
  {
    "clienteId": "CLI_0391",
    "clienteAnonimo": "390",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 396,
    "ticketMedianoSimulado": 371,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 396,
    "maiorPedidoSimulado": 444,
    "menorPedidoSimulado": 250,
    "ticketMedioSimuladoFmt": "R$ 396",
    "ticketMedianoSimuladoFmt": "R$ 371",
    "valorTotalAcumuladoSimuladoFmt": "R$ 396",
    "maiorPedidoSimuladoFmt": "R$ 444",
    "menorPedidoSimuladoFmt": "R$ 250",
    "primeiraCompraSimulada": "23/01/2026",
    "ultimaCompraSimulada": "13/04/2026",
    "diasDesdeUltimaCompraSimulado": 31,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0391"
  },
  {
    "clienteId": "CLI_0392",
    "clienteAnonimo": "391",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 370,
    "ticketMedianoSimulado": 367,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1110,
    "maiorPedidoSimulado": 396,
    "menorPedidoSimulado": 212,
    "ticketMedioSimuladoFmt": "R$ 370",
    "ticketMedianoSimuladoFmt": "R$ 367",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.110",
    "maiorPedidoSimuladoFmt": "R$ 396",
    "menorPedidoSimuladoFmt": "R$ 212",
    "primeiraCompraSimulada": "07/01/2026",
    "ultimaCompraSimulada": "07/05/2026",
    "diasDesdeUltimaCompraSimulado": 7,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0392"
  },
  {
    "clienteId": "CLI_0393",
    "clienteAnonimo": "392",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 343,
    "ticketMedianoSimulado": 316,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 343,
    "maiorPedidoSimulado": 398,
    "menorPedidoSimulado": 233,
    "ticketMedioSimuladoFmt": "R$ 343",
    "ticketMedianoSimuladoFmt": "R$ 316",
    "valorTotalAcumuladoSimuladoFmt": "R$ 343",
    "maiorPedidoSimuladoFmt": "R$ 398",
    "menorPedidoSimuladoFmt": "R$ 233",
    "primeiraCompraSimulada": "22/12/2025",
    "ultimaCompraSimulada": "13/04/2026",
    "diasDesdeUltimaCompraSimulado": 31,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0393"
  },
  {
    "clienteId": "CLI_0394",
    "clienteAnonimo": "393",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 317,
    "ticketMedianoSimulado": 315,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 634,
    "maiorPedidoSimulado": 364,
    "menorPedidoSimulado": 211,
    "ticketMedioSimuladoFmt": "R$ 317",
    "ticketMedianoSimuladoFmt": "R$ 315",
    "valorTotalAcumuladoSimuladoFmt": "R$ 634",
    "maiorPedidoSimuladoFmt": "R$ 364",
    "menorPedidoSimuladoFmt": "R$ 211",
    "primeiraCompraSimulada": "06/12/2025",
    "ultimaCompraSimulada": "04/03/2026",
    "diasDesdeUltimaCompraSimulado": 71,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0394"
  },
  {
    "clienteId": "CLI_0395",
    "clienteAnonimo": "394",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 291,
    "ticketMedianoSimulado": 271,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 582,
    "maiorPedidoSimulado": 308,
    "menorPedidoSimulado": 163,
    "ticketMedioSimuladoFmt": "R$ 291",
    "ticketMedianoSimuladoFmt": "R$ 271",
    "valorTotalAcumuladoSimuladoFmt": "R$ 582",
    "maiorPedidoSimuladoFmt": "R$ 308",
    "menorPedidoSimuladoFmt": "R$ 163",
    "primeiraCompraSimulada": "20/11/2025",
    "ultimaCompraSimulada": "14/03/2026",
    "diasDesdeUltimaCompraSimulado": 61,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0395"
  },
  {
    "clienteId": "CLI_0396",
    "clienteAnonimo": "395",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 295,
    "ticketMedianoSimulado": 289,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 590,
    "maiorPedidoSimulado": 334,
    "menorPedidoSimulado": 190,
    "ticketMedioSimuladoFmt": "R$ 295",
    "ticketMedianoSimuladoFmt": "R$ 289",
    "valorTotalAcumuladoSimuladoFmt": "R$ 590",
    "maiorPedidoSimuladoFmt": "R$ 334",
    "menorPedidoSimuladoFmt": "R$ 190",
    "primeiraCompraSimulada": "04/11/2025",
    "ultimaCompraSimulada": "22/04/2026",
    "diasDesdeUltimaCompraSimulado": 22,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0396"
  },
  {
    "clienteId": "CLI_0397",
    "clienteAnonimo": "396",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 322,
    "ticketMedianoSimulado": 305,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 644,
    "maiorPedidoSimulado": 380,
    "menorPedidoSimulado": 226,
    "ticketMedioSimuladoFmt": "R$ 322",
    "ticketMedianoSimuladoFmt": "R$ 305",
    "valorTotalAcumuladoSimuladoFmt": "R$ 644",
    "maiorPedidoSimuladoFmt": "R$ 380",
    "menorPedidoSimuladoFmt": "R$ 226",
    "primeiraCompraSimulada": "07/11/2025",
    "ultimaCompraSimulada": "17/04/2026",
    "diasDesdeUltimaCompraSimulado": 27,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0397"
  },
  {
    "clienteId": "CLI_0398",
    "clienteAnonimo": "397",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 348,
    "ticketMedianoSimulado": 336,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 696,
    "maiorPedidoSimulado": 379,
    "menorPedidoSimulado": 207,
    "ticketMedioSimuladoFmt": "R$ 348",
    "ticketMedianoSimuladoFmt": "R$ 336",
    "valorTotalAcumuladoSimuladoFmt": "R$ 696",
    "maiorPedidoSimuladoFmt": "R$ 379",
    "menorPedidoSimuladoFmt": "R$ 207",
    "primeiraCompraSimulada": "23/11/2025",
    "ultimaCompraSimulada": "11/03/2026",
    "diasDesdeUltimaCompraSimulado": 64,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0398"
  },
  {
    "clienteId": "CLI_0399",
    "clienteAnonimo": "398",
    "segmentoComercial": "Cliente alto valor",
    "ticketMedioSimulado": 1030,
    "ticketMedianoSimulado": 990,
    "totalPedidosSimulado": 6,
    "valorTotalAcumuladoSimulado": 6180,
    "maiorPedidoSimulado": 1134,
    "menorPedidoSimulado": 628,
    "ticketMedioSimuladoFmt": "R$ 1.030",
    "ticketMedianoSimuladoFmt": "R$ 990",
    "valorTotalAcumuladoSimuladoFmt": "R$ 6.180",
    "maiorPedidoSimuladoFmt": "R$ 1.134",
    "menorPedidoSimuladoFmt": "R$ 628",
    "primeiraCompraSimulada": "09/12/2025",
    "ultimaCompraSimulada": "09/03/2026",
    "diasDesdeUltimaCompraSimulado": 66,
    "hipoteseDePerfil": "Compra compatível com abastecimento maior, família ou rotina intensa.",
    "objetivoProvavel": "Pode buscar abastecimento maior ou comprar para várias pessoas",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0399"
  },
  {
    "clienteId": "CLI_0400",
    "clienteAnonimo": "399",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 395,
    "ticketMedianoSimulado": 365,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 395,
    "maiorPedidoSimulado": 460,
    "menorPedidoSimulado": 271,
    "ticketMedioSimuladoFmt": "R$ 395",
    "ticketMedianoSimuladoFmt": "R$ 365",
    "valorTotalAcumuladoSimuladoFmt": "R$ 395",
    "maiorPedidoSimuladoFmt": "R$ 460",
    "menorPedidoSimuladoFmt": "R$ 271",
    "primeiraCompraSimulada": "01/04/2026",
    "ultimaCompraSimulada": "04/05/2026",
    "diasDesdeUltimaCompraSimulado": 10,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0400"
  },
  {
    "clienteId": "CLI_0401",
    "clienteAnonimo": "400",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 369,
    "ticketMedianoSimulado": 368,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1107,
    "maiorPedidoSimulado": 397,
    "menorPedidoSimulado": 214,
    "ticketMedioSimuladoFmt": "R$ 369",
    "ticketMedianoSimuladoFmt": "R$ 368",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.107",
    "maiorPedidoSimuladoFmt": "R$ 397",
    "menorPedidoSimuladoFmt": "R$ 214",
    "primeiraCompraSimulada": "11/04/2026",
    "ultimaCompraSimulada": "10/05/2026",
    "diasDesdeUltimaCompraSimulado": 4,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0401"
  },
  {
    "clienteId": "CLI_0402",
    "clienteAnonimo": "401",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 343,
    "ticketMedianoSimulado": 319,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 686,
    "maiorPedidoSimulado": 382,
    "menorPedidoSimulado": 215,
    "ticketMedioSimuladoFmt": "R$ 343",
    "ticketMedianoSimuladoFmt": "R$ 319",
    "valorTotalAcumuladoSimuladoFmt": "R$ 686",
    "maiorPedidoSimuladoFmt": "R$ 382",
    "menorPedidoSimuladoFmt": "R$ 215",
    "primeiraCompraSimulada": "26/03/2026",
    "ultimaCompraSimulada": "28/04/2026",
    "diasDesdeUltimaCompraSimulado": 16,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0402"
  },
  {
    "clienteId": "CLI_0403",
    "clienteAnonimo": "402",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 316,
    "ticketMedianoSimulado": 310,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 632,
    "maiorPedidoSimulado": 378,
    "menorPedidoSimulado": 227,
    "ticketMedioSimuladoFmt": "R$ 316",
    "ticketMedianoSimuladoFmt": "R$ 310",
    "valorTotalAcumuladoSimuladoFmt": "R$ 632",
    "maiorPedidoSimuladoFmt": "R$ 378",
    "menorPedidoSimuladoFmt": "R$ 227",
    "primeiraCompraSimulada": "10/03/2026",
    "ultimaCompraSimulada": "11/04/2026",
    "diasDesdeUltimaCompraSimulado": 33,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0403"
  },
  {
    "clienteId": "CLI_0404",
    "clienteAnonimo": "403",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 290,
    "ticketMedianoSimulado": 274,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 580,
    "maiorPedidoSimulado": 320,
    "menorPedidoSimulado": 178,
    "ticketMedioSimuladoFmt": "R$ 290",
    "ticketMedianoSimuladoFmt": "R$ 274",
    "valorTotalAcumuladoSimuladoFmt": "R$ 580",
    "maiorPedidoSimuladoFmt": "R$ 320",
    "menorPedidoSimuladoFmt": "R$ 178",
    "primeiraCompraSimulada": "22/02/2026",
    "ultimaCompraSimulada": "21/04/2026",
    "diasDesdeUltimaCompraSimulado": 23,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0404"
  },
  {
    "clienteId": "CLI_0405",
    "clienteAnonimo": "404",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 296,
    "ticketMedianoSimulado": 286,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 592,
    "maiorPedidoSimulado": 321,
    "menorPedidoSimulado": 175,
    "ticketMedioSimuladoFmt": "R$ 296",
    "ticketMedianoSimuladoFmt": "R$ 286",
    "valorTotalAcumuladoSimuladoFmt": "R$ 592",
    "maiorPedidoSimuladoFmt": "R$ 321",
    "menorPedidoSimuladoFmt": "R$ 175",
    "primeiraCompraSimulada": "06/02/2026",
    "ultimaCompraSimulada": "08/05/2026",
    "diasDesdeUltimaCompraSimulado": 6,
    "hipoteseDePerfil": "Compra compatível com abastecimento maior, família ou rotina intensa.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0405"
  },
  {
    "clienteId": "CLI_0406",
    "clienteAnonimo": "405",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 322,
    "ticketMedianoSimulado": 309,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 644,
    "maiorPedidoSimulado": 379,
    "menorPedidoSimulado": 224,
    "ticketMedioSimuladoFmt": "R$ 322",
    "ticketMedianoSimuladoFmt": "R$ 309",
    "valorTotalAcumuladoSimuladoFmt": "R$ 644",
    "maiorPedidoSimuladoFmt": "R$ 379",
    "menorPedidoSimuladoFmt": "R$ 224",
    "primeiraCompraSimulada": "21/01/2026",
    "ultimaCompraSimulada": "19/04/2026",
    "diasDesdeUltimaCompraSimulado": 25,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0406"
  },
  {
    "clienteId": "CLI_0407",
    "clienteAnonimo": "406",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 349,
    "ticketMedianoSimulado": 333,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 349,
    "maiorPedidoSimulado": 396,
    "menorPedidoSimulado": 226,
    "ticketMedioSimuladoFmt": "R$ 349",
    "ticketMedianoSimuladoFmt": "R$ 333",
    "valorTotalAcumuladoSimuladoFmt": "R$ 349",
    "maiorPedidoSimuladoFmt": "R$ 396",
    "menorPedidoSimuladoFmt": "R$ 226",
    "primeiraCompraSimulada": "05/01/2026",
    "ultimaCompraSimulada": "17/03/2026",
    "diasDesdeUltimaCompraSimulado": 58,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0407"
  },
  {
    "clienteId": "CLI_0408",
    "clienteAnonimo": "407",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 375,
    "ticketMedianoSimulado": 365,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1125,
    "maiorPedidoSimulado": 396,
    "menorPedidoSimulado": 209,
    "ticketMedioSimuladoFmt": "R$ 375",
    "ticketMedianoSimuladoFmt": "R$ 365",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.125",
    "maiorPedidoSimuladoFmt": "R$ 396",
    "menorPedidoSimuladoFmt": "R$ 209",
    "primeiraCompraSimulada": "20/12/2025",
    "ultimaCompraSimulada": "25/03/2026",
    "diasDesdeUltimaCompraSimulado": 50,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0408"
  },
  {
    "clienteId": "CLI_0409",
    "clienteAnonimo": "408",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 401,
    "ticketMedianoSimulado": 377,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 401,
    "maiorPedidoSimulado": 460,
    "menorPedidoSimulado": 266,
    "ticketMedioSimuladoFmt": "R$ 401",
    "ticketMedianoSimuladoFmt": "R$ 377",
    "valorTotalAcumuladoSimuladoFmt": "R$ 401",
    "maiorPedidoSimuladoFmt": "R$ 460",
    "menorPedidoSimuladoFmt": "R$ 266",
    "primeiraCompraSimulada": "04/12/2025",
    "ultimaCompraSimulada": "25/04/2026",
    "diasDesdeUltimaCompraSimulado": 19,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0409"
  },
  {
    "clienteId": "CLI_0410",
    "clienteAnonimo": "409",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 350,
    "ticketMedianoSimulado": 324,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 350,
    "maiorPedidoSimulado": 416,
    "menorPedidoSimulado": 249,
    "ticketMedioSimuladoFmt": "R$ 350",
    "ticketMedianoSimuladoFmt": "R$ 324",
    "valorTotalAcumuladoSimuladoFmt": "R$ 350",
    "maiorPedidoSimuladoFmt": "R$ 416",
    "menorPedidoSimuladoFmt": "R$ 249",
    "primeiraCompraSimulada": "09/11/2025",
    "ultimaCompraSimulada": "17/02/2026",
    "diasDesdeUltimaCompraSimulado": 86,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0410"
  },
  {
    "clienteId": "CLI_0411",
    "clienteAnonimo": "410",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 376,
    "ticketMedianoSimulado": 376,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1128,
    "maiorPedidoSimulado": 413,
    "menorPedidoSimulado": 228,
    "ticketMedioSimuladoFmt": "R$ 376",
    "ticketMedianoSimuladoFmt": "R$ 376",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.128",
    "maiorPedidoSimuladoFmt": "R$ 413",
    "menorPedidoSimuladoFmt": "R$ 228",
    "primeiraCompraSimulada": "25/11/2025",
    "ultimaCompraSimulada": "19/03/2026",
    "diasDesdeUltimaCompraSimulado": 56,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0411"
  },
  {
    "clienteId": "CLI_0412",
    "clienteAnonimo": "411",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 403,
    "ticketMedianoSimulado": 374,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 806,
    "maiorPedidoSimulado": 440,
    "menorPedidoSimulado": 241,
    "ticketMedioSimuladoFmt": "R$ 403",
    "ticketMedianoSimuladoFmt": "R$ 374",
    "valorTotalAcumuladoSimuladoFmt": "R$ 806",
    "maiorPedidoSimuladoFmt": "R$ 440",
    "menorPedidoSimuladoFmt": "R$ 241",
    "primeiraCompraSimulada": "11/12/2025",
    "ultimaCompraSimulada": "28/04/2026",
    "diasDesdeUltimaCompraSimulado": 16,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0412"
  },
  {
    "clienteId": "CLI_0413",
    "clienteAnonimo": "412",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 429,
    "ticketMedianoSimulado": 422,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 858,
    "maiorPedidoSimulado": 507,
    "menorPedidoSimulado": 302,
    "ticketMedioSimuladoFmt": "R$ 429",
    "ticketMedianoSimuladoFmt": "R$ 422",
    "valorTotalAcumuladoSimuladoFmt": "R$ 858",
    "maiorPedidoSimuladoFmt": "R$ 507",
    "menorPedidoSimuladoFmt": "R$ 302",
    "primeiraCompraSimulada": "27/12/2025",
    "ultimaCompraSimulada": "21/04/2026",
    "diasDesdeUltimaCompraSimulado": 23,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0413"
  },
  {
    "clienteId": "CLI_0414",
    "clienteAnonimo": "413",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 445,
    "ticketMedianoSimulado": 419,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 890,
    "maiorPedidoSimulado": 502,
    "menorPedidoSimulado": 285,
    "ticketMedioSimuladoFmt": "R$ 445",
    "ticketMedianoSimuladoFmt": "R$ 419",
    "valorTotalAcumuladoSimuladoFmt": "R$ 890",
    "maiorPedidoSimuladoFmt": "R$ 502",
    "menorPedidoSimuladoFmt": "R$ 285",
    "primeiraCompraSimulada": "12/01/2026",
    "ultimaCompraSimulada": "27/03/2026",
    "diasDesdeUltimaCompraSimulado": 48,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0414"
  },
  {
    "clienteId": "CLI_0415",
    "clienteAnonimo": "414",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 419,
    "ticketMedianoSimulado": 407,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 838,
    "maiorPedidoSimulado": 445,
    "menorPedidoSimulado": 236,
    "ticketMedioSimuladoFmt": "R$ 419",
    "ticketMedianoSimuladoFmt": "R$ 407",
    "valorTotalAcumuladoSimuladoFmt": "R$ 838",
    "maiorPedidoSimuladoFmt": "R$ 445",
    "menorPedidoSimuladoFmt": "R$ 236",
    "primeiraCompraSimulada": "28/01/2026",
    "ultimaCompraSimulada": "01/04/2026",
    "diasDesdeUltimaCompraSimulado": 43,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0415"
  },
  {
    "clienteId": "CLI_0416",
    "clienteAnonimo": "415",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 392,
    "ticketMedianoSimulado": 375,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 784,
    "maiorPedidoSimulado": 452,
    "menorPedidoSimulado": 262,
    "ticketMedioSimuladoFmt": "R$ 392",
    "ticketMedianoSimuladoFmt": "R$ 375",
    "valorTotalAcumuladoSimuladoFmt": "R$ 784",
    "maiorPedidoSimuladoFmt": "R$ 452",
    "menorPedidoSimuladoFmt": "R$ 262",
    "primeiraCompraSimulada": "13/02/2026",
    "ultimaCompraSimulada": "27/04/2026",
    "diasDesdeUltimaCompraSimulado": 17,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0416"
  },
  {
    "clienteId": "CLI_0417",
    "clienteAnonimo": "416",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 366,
    "ticketMedianoSimulado": 350,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 732,
    "maiorPedidoSimulado": 424,
    "menorPedidoSimulado": 247,
    "ticketMedioSimuladoFmt": "R$ 366",
    "ticketMedianoSimuladoFmt": "R$ 350",
    "valorTotalAcumuladoSimuladoFmt": "R$ 732",
    "maiorPedidoSimuladoFmt": "R$ 424",
    "menorPedidoSimuladoFmt": "R$ 247",
    "primeiraCompraSimulada": "01/03/2026",
    "ultimaCompraSimulada": "06/05/2026",
    "diasDesdeUltimaCompraSimulado": 8,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0417"
  },
  {
    "clienteId": "CLI_0418",
    "clienteAnonimo": "417",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 340,
    "ticketMedianoSimulado": 330,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1020,
    "maiorPedidoSimulado": 363,
    "menorPedidoSimulado": 194,
    "ticketMedioSimuladoFmt": "R$ 340",
    "ticketMedianoSimuladoFmt": "R$ 330",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.020",
    "maiorPedidoSimuladoFmt": "R$ 363",
    "menorPedidoSimuladoFmt": "R$ 194",
    "primeiraCompraSimulada": "17/03/2026",
    "ultimaCompraSimulada": "24/04/2026",
    "diasDesdeUltimaCompraSimulado": 20,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0418"
  },
  {
    "clienteId": "CLI_0419",
    "clienteAnonimo": "418",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 314,
    "ticketMedianoSimulado": 296,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 314,
    "maiorPedidoSimulado": 353,
    "menorPedidoSimulado": 199,
    "ticketMedioSimuladoFmt": "R$ 314",
    "ticketMedianoSimuladoFmt": "R$ 296",
    "valorTotalAcumuladoSimuladoFmt": "R$ 314",
    "maiorPedidoSimuladoFmt": "R$ 353",
    "menorPedidoSimuladoFmt": "R$ 199",
    "primeiraCompraSimulada": "02/04/2026",
    "ultimaCompraSimulada": "23/04/2026",
    "diasDesdeUltimaCompraSimulado": 21,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0419"
  },
  {
    "clienteId": "CLI_0420",
    "clienteAnonimo": "419",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 364,
    "ticketMedianoSimulado": 338,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 364,
    "maiorPedidoSimulado": 432,
    "menorPedidoSimulado": 259,
    "ticketMedioSimuladoFmt": "R$ 364",
    "ticketMedianoSimuladoFmt": "R$ 338",
    "valorTotalAcumuladoSimuladoFmt": "R$ 364",
    "maiorPedidoSimuladoFmt": "R$ 432",
    "menorPedidoSimuladoFmt": "R$ 259",
    "primeiraCompraSimulada": "09/03/2026",
    "ultimaCompraSimulada": "05/05/2026",
    "diasDesdeUltimaCompraSimulado": 9,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0420"
  },
  {
    "clienteId": "CLI_0421",
    "clienteAnonimo": "420",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 338,
    "ticketMedianoSimulado": 337,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1014,
    "maiorPedidoSimulado": 379,
    "menorPedidoSimulado": 214,
    "ticketMedioSimuladoFmt": "R$ 338",
    "ticketMedianoSimuladoFmt": "R$ 337",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.014",
    "maiorPedidoSimuladoFmt": "R$ 379",
    "menorPedidoSimuladoFmt": "R$ 214",
    "primeiraCompraSimulada": "21/02/2026",
    "ultimaCompraSimulada": "16/04/2026",
    "diasDesdeUltimaCompraSimulado": 28,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0421"
  },
  {
    "clienteId": "CLI_0422",
    "clienteAnonimo": "421",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 312,
    "ticketMedianoSimulado": 289,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 624,
    "maiorPedidoSimulado": 333,
    "menorPedidoSimulado": 178,
    "ticketMedioSimuladoFmt": "R$ 312",
    "ticketMedianoSimuladoFmt": "R$ 289",
    "valorTotalAcumuladoSimuladoFmt": "R$ 624",
    "maiorPedidoSimuladoFmt": "R$ 333",
    "menorPedidoSimuladoFmt": "R$ 178",
    "primeiraCompraSimulada": "05/02/2026",
    "ultimaCompraSimulada": "30/03/2026",
    "diasDesdeUltimaCompraSimulado": 45,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0422"
  },
  {
    "clienteId": "CLI_0423",
    "clienteAnonimo": "422",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 286,
    "ticketMedianoSimulado": 282,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 572,
    "maiorPedidoSimulado": 331,
    "menorPedidoSimulado": 194,
    "ticketMedioSimuladoFmt": "R$ 286",
    "ticketMedianoSimuladoFmt": "R$ 282",
    "valorTotalAcumuladoSimuladoFmt": "R$ 572",
    "maiorPedidoSimuladoFmt": "R$ 331",
    "menorPedidoSimuladoFmt": "R$ 194",
    "primeiraCompraSimulada": "20/01/2026",
    "ultimaCompraSimulada": "17/04/2026",
    "diasDesdeUltimaCompraSimulado": 27,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0423"
  },
  {
    "clienteId": "CLI_0424",
    "clienteAnonimo": "423",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 300,
    "ticketMedianoSimulado": 282,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 600,
    "maiorPedidoSimulado": 345,
    "menorPedidoSimulado": 200,
    "ticketMedioSimuladoFmt": "R$ 300",
    "ticketMedianoSimuladoFmt": "R$ 282",
    "valorTotalAcumuladoSimuladoFmt": "R$ 600",
    "maiorPedidoSimuladoFmt": "R$ 345",
    "menorPedidoSimuladoFmt": "R$ 200",
    "primeiraCompraSimulada": "04/01/2026",
    "ultimaCompraSimulada": "09/05/2026",
    "diasDesdeUltimaCompraSimulado": 5,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0424"
  },
  {
    "clienteId": "CLI_0425",
    "clienteAnonimo": "424",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 327,
    "ticketMedianoSimulado": 318,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 654,
    "maiorPedidoSimulado": 347,
    "menorPedidoSimulado": 184,
    "ticketMedioSimuladoFmt": "R$ 327",
    "ticketMedianoSimuladoFmt": "R$ 318",
    "valorTotalAcumuladoSimuladoFmt": "R$ 654",
    "maiorPedidoSimuladoFmt": "R$ 347",
    "menorPedidoSimuladoFmt": "R$ 184",
    "primeiraCompraSimulada": "19/12/2025",
    "ultimaCompraSimulada": "05/04/2026",
    "diasDesdeUltimaCompraSimulado": 39,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0425"
  },
  {
    "clienteId": "CLI_0426",
    "clienteAnonimo": "425",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 353,
    "ticketMedianoSimulado": 337,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 706,
    "maiorPedidoSimulado": 399,
    "menorPedidoSimulado": 227,
    "ticketMedioSimuladoFmt": "R$ 353",
    "ticketMedianoSimuladoFmt": "R$ 337",
    "valorTotalAcumuladoSimuladoFmt": "R$ 706",
    "maiorPedidoSimuladoFmt": "R$ 399",
    "menorPedidoSimuladoFmt": "R$ 227",
    "primeiraCompraSimulada": "03/12/2025",
    "ultimaCompraSimulada": "24/02/2026",
    "diasDesdeUltimaCompraSimulado": 79,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0426"
  },
  {
    "clienteId": "CLI_0427",
    "clienteAnonimo": "426",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 379,
    "ticketMedianoSimulado": 363,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 758,
    "maiorPedidoSimulado": 447,
    "menorPedidoSimulado": 266,
    "ticketMedioSimuladoFmt": "R$ 379",
    "ticketMedianoSimuladoFmt": "R$ 363",
    "valorTotalAcumuladoSimuladoFmt": "R$ 758",
    "maiorPedidoSimuladoFmt": "R$ 447",
    "menorPedidoSimuladoFmt": "R$ 266",
    "primeiraCompraSimulada": "17/11/2025",
    "ultimaCompraSimulada": "21/03/2026",
    "diasDesdeUltimaCompraSimulado": 54,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0427"
  },
  {
    "clienteId": "CLI_0428",
    "clienteAnonimo": "427",
    "segmentoComercial": "Cliente alto valor",
    "ticketMedioSimulado": 1090,
    "ticketMedianoSimulado": 1056,
    "totalPedidosSimulado": 7,
    "valorTotalAcumuladoSimulado": 7630,
    "maiorPedidoSimulado": 1188,
    "menorPedidoSimulado": 651,
    "ticketMedioSimuladoFmt": "R$ 1.090",
    "ticketMedianoSimuladoFmt": "R$ 1.056",
    "valorTotalAcumuladoSimuladoFmt": "R$ 7.630",
    "maiorPedidoSimuladoFmt": "R$ 1.188",
    "menorPedidoSimuladoFmt": "R$ 651",
    "primeiraCompraSimulada": "01/11/2025",
    "ultimaCompraSimulada": "30/04/2026",
    "diasDesdeUltimaCompraSimulado": 14,
    "hipoteseDePerfil": "Compra compatível com abastecimento maior, família ou rotina intensa.",
    "objetivoProvavel": "Pode buscar abastecimento maior ou comprar para várias pessoas",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0428"
  },
  {
    "clienteId": "CLI_0429",
    "clienteAnonimo": "428",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 432,
    "ticketMedianoSimulado": 408,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 432,
    "maiorPedidoSimulado": 475,
    "menorPedidoSimulado": 263,
    "ticketMedioSimuladoFmt": "R$ 432",
    "ticketMedianoSimuladoFmt": "R$ 408",
    "valorTotalAcumuladoSimuladoFmt": "R$ 432",
    "maiorPedidoSimuladoFmt": "R$ 475",
    "menorPedidoSimuladoFmt": "R$ 263",
    "primeiraCompraSimulada": "10/11/2025",
    "ultimaCompraSimulada": "09/04/2026",
    "diasDesdeUltimaCompraSimulado": 35,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0429"
  },
  {
    "clienteId": "CLI_0430",
    "clienteAnonimo": "429",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 381,
    "ticketMedianoSimulado": 355,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 381,
    "maiorPedidoSimulado": 444,
    "menorPedidoSimulado": 261,
    "ticketMedioSimuladoFmt": "R$ 381",
    "ticketMedianoSimuladoFmt": "R$ 355",
    "valorTotalAcumuladoSimuladoFmt": "R$ 381",
    "maiorPedidoSimuladoFmt": "R$ 444",
    "menorPedidoSimuladoFmt": "R$ 261",
    "primeiraCompraSimulada": "28/12/2025",
    "ultimaCompraSimulada": "05/04/2026",
    "diasDesdeUltimaCompraSimulado": 39,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0430"
  },
  {
    "clienteId": "CLI_0431",
    "clienteAnonimo": "430",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 407,
    "ticketMedianoSimulado": 405,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1221,
    "maiorPedidoSimulado": 466,
    "menorPedidoSimulado": 269,
    "ticketMedioSimuladoFmt": "R$ 407",
    "ticketMedianoSimuladoFmt": "R$ 405",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.221",
    "maiorPedidoSimuladoFmt": "R$ 466",
    "menorPedidoSimuladoFmt": "R$ 269",
    "primeiraCompraSimulada": "13/01/2026",
    "ultimaCompraSimulada": "06/05/2026",
    "diasDesdeUltimaCompraSimulado": 8,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0431"
  },
  {
    "clienteId": "CLI_0432",
    "clienteAnonimo": "431",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 433,
    "ticketMedianoSimulado": 400,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 433,
    "maiorPedidoSimulado": 457,
    "menorPedidoSimulado": 241,
    "ticketMedioSimuladoFmt": "R$ 433",
    "ticketMedianoSimuladoFmt": "R$ 400",
    "valorTotalAcumuladoSimuladoFmt": "R$ 433",
    "maiorPedidoSimuladoFmt": "R$ 457",
    "menorPedidoSimuladoFmt": "R$ 241",
    "primeiraCompraSimulada": "29/01/2026",
    "ultimaCompraSimulada": "21/04/2026",
    "diasDesdeUltimaCompraSimulado": 23,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0432"
  },
  {
    "clienteId": "CLI_0433",
    "clienteAnonimo": "432",
    "segmentoComercial": "Cliente possível coletivo",
    "ticketMedioSimulado": 2899,
    "ticketMedianoSimulado": 2870,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 8697,
    "maiorPedidoSimulado": 3292,
    "menorPedidoSimulado": 1884,
    "ticketMedioSimuladoFmt": "R$ 2.899",
    "ticketMedianoSimuladoFmt": "R$ 2.870",
    "valorTotalAcumuladoSimuladoFmt": "R$ 8.697",
    "maiorPedidoSimuladoFmt": "R$ 3.292",
    "menorPedidoSimuladoFmt": "R$ 1.884",
    "primeiraCompraSimulada": "14/02/2026",
    "ultimaCompraSimulada": "05/04/2026",
    "diasDesdeUltimaCompraSimulado": 39,
    "hipoteseDePerfil": "Possível compra coletiva, familiar ampliada ou corporativa. Não afirmar sem confirmação.",
    "objetivoProvavel": "Pode comprar para mais de uma pessoa, família ou equipe",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Tratar como hipótese de compra coletiva — G09 ativo.",
    "alertaSimulacao": "Possível compra familiar, equipe ou coletiva. Confirmar antes de assumir.",
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0433"
  },
  {
    "clienteId": "CLI_0434",
    "clienteAnonimo": "433",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 414,
    "ticketMedianoSimulado": 388,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 828,
    "maiorPedidoSimulado": 486,
    "menorPedidoSimulado": 288,
    "ticketMedioSimuladoFmt": "R$ 414",
    "ticketMedianoSimuladoFmt": "R$ 388",
    "valorTotalAcumuladoSimuladoFmt": "R$ 828",
    "maiorPedidoSimuladoFmt": "R$ 486",
    "menorPedidoSimuladoFmt": "R$ 288",
    "primeiraCompraSimulada": "02/03/2026",
    "ultimaCompraSimulada": "17/04/2026",
    "diasDesdeUltimaCompraSimulado": 27,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0434"
  },
  {
    "clienteId": "CLI_0435",
    "clienteAnonimo": "434",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 388,
    "ticketMedianoSimulado": 378,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 776,
    "maiorPedidoSimulado": 421,
    "menorPedidoSimulado": 229,
    "ticketMedioSimuladoFmt": "R$ 388",
    "ticketMedianoSimuladoFmt": "R$ 378",
    "valorTotalAcumuladoSimuladoFmt": "R$ 776",
    "maiorPedidoSimuladoFmt": "R$ 421",
    "menorPedidoSimuladoFmt": "R$ 229",
    "primeiraCompraSimulada": "18/03/2026",
    "ultimaCompraSimulada": "05/05/2026",
    "diasDesdeUltimaCompraSimulado": 9,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0435"
  },
  {
    "clienteId": "CLI_0436",
    "clienteAnonimo": "435",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 362,
    "ticketMedianoSimulado": 345,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 724,
    "maiorPedidoSimulado": 400,
    "menorPedidoSimulado": 223,
    "ticketMedioSimuladoFmt": "R$ 362",
    "ticketMedianoSimuladoFmt": "R$ 345",
    "valorTotalAcumuladoSimuladoFmt": "R$ 724",
    "maiorPedidoSimuladoFmt": "R$ 400",
    "menorPedidoSimuladoFmt": "R$ 223",
    "primeiraCompraSimulada": "03/04/2026",
    "ultimaCompraSimulada": "07/05/2026",
    "diasDesdeUltimaCompraSimulado": 7,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0436"
  },
  {
    "clienteId": "CLI_0437",
    "clienteAnonimo": "436",
    "segmentoComercial": "Cliente alto valor",
    "ticketMedioSimulado": 956,
    "ticketMedianoSimulado": 919,
    "totalPedidosSimulado": 4,
    "valorTotalAcumuladoSimulado": 3824,
    "maiorPedidoSimulado": 1144,
    "menorPedidoSimulado": 689,
    "ticketMedioSimuladoFmt": "R$ 956",
    "ticketMedianoSimuladoFmt": "R$ 919",
    "valorTotalAcumuladoSimuladoFmt": "R$ 3.824",
    "maiorPedidoSimuladoFmt": "R$ 1.144",
    "menorPedidoSimuladoFmt": "R$ 689",
    "primeiraCompraSimulada": "09/04/2026",
    "ultimaCompraSimulada": "30/04/2026",
    "diasDesdeUltimaCompraSimulado": 14,
    "hipoteseDePerfil": "Compra compatível com abastecimento maior, família ou rotina intensa.",
    "objetivoProvavel": "Pode buscar abastecimento maior ou comprar para várias pessoas",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0437"
  },
  {
    "clienteId": "CLI_0438",
    "clienteAnonimo": "437",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 309,
    "ticketMedianoSimulado": 299,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 927,
    "maiorPedidoSimulado": 344,
    "menorPedidoSimulado": 193,
    "ticketMedioSimuladoFmt": "R$ 309",
    "ticketMedianoSimuladoFmt": "R$ 299",
    "valorTotalAcumuladoSimuladoFmt": "R$ 927",
    "maiorPedidoSimuladoFmt": "R$ 344",
    "menorPedidoSimuladoFmt": "R$ 193",
    "primeiraCompraSimulada": "24/03/2026",
    "ultimaCompraSimulada": "21/04/2026",
    "diasDesdeUltimaCompraSimulado": 23,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0438"
  },
  {
    "clienteId": "CLI_0439",
    "clienteAnonimo": "438",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 283,
    "ticketMedianoSimulado": 268,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 283,
    "maiorPedidoSimulado": 305,
    "menorPedidoSimulado": 164,
    "ticketMedioSimuladoFmt": "R$ 283",
    "ticketMedianoSimuladoFmt": "R$ 268",
    "valorTotalAcumuladoSimuladoFmt": "R$ 283",
    "maiorPedidoSimuladoFmt": "R$ 305",
    "menorPedidoSimuladoFmt": "R$ 164",
    "primeiraCompraSimulada": "08/03/2026",
    "ultimaCompraSimulada": "29/04/2026",
    "diasDesdeUltimaCompraSimulado": 15,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0439"
  },
  {
    "clienteId": "CLI_0440",
    "clienteAnonimo": "439",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 334,
    "ticketMedianoSimulado": 312,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 334,
    "maiorPedidoSimulado": 381,
    "menorPedidoSimulado": 219,
    "ticketMedioSimuladoFmt": "R$ 334",
    "ticketMedianoSimuladoFmt": "R$ 312",
    "valorTotalAcumuladoSimuladoFmt": "R$ 334",
    "maiorPedidoSimuladoFmt": "R$ 381",
    "menorPedidoSimuladoFmt": "R$ 219",
    "primeiraCompraSimulada": "19/01/2026",
    "ultimaCompraSimulada": "31/03/2026",
    "diasDesdeUltimaCompraSimulado": 44,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0440"
  },
  {
    "clienteId": "CLI_0441",
    "clienteAnonimo": "440",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 308,
    "ticketMedianoSimulado": 306,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 924,
    "maiorPedidoSimulado": 360,
    "menorPedidoSimulado": 212,
    "ticketMedioSimuladoFmt": "R$ 308",
    "ticketMedianoSimuladoFmt": "R$ 306",
    "valorTotalAcumuladoSimuladoFmt": "R$ 924",
    "maiorPedidoSimuladoFmt": "R$ 360",
    "menorPedidoSimuladoFmt": "R$ 212",
    "primeiraCompraSimulada": "03/01/2026",
    "ultimaCompraSimulada": "21/03/2026",
    "diasDesdeUltimaCompraSimulado": 54,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0441"
  },
  {
    "clienteId": "CLI_0442",
    "clienteAnonimo": "441",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 281,
    "ticketMedianoSimulado": 259,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 281,
    "maiorPedidoSimulado": 303,
    "menorPedidoSimulado": 164,
    "ticketMedioSimuladoFmt": "R$ 281",
    "ticketMedianoSimuladoFmt": "R$ 259",
    "valorTotalAcumuladoSimuladoFmt": "R$ 281",
    "maiorPedidoSimuladoFmt": "R$ 303",
    "menorPedidoSimuladoFmt": "R$ 164",
    "primeiraCompraSimulada": "18/12/2025",
    "ultimaCompraSimulada": "16/04/2026",
    "diasDesdeUltimaCompraSimulado": 28,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0442"
  },
  {
    "clienteId": "CLI_0443",
    "clienteAnonimo": "442",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 305,
    "ticketMedianoSimulado": 303,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 610,
    "maiorPedidoSimulado": 339,
    "menorPedidoSimulado": 190,
    "ticketMedioSimuladoFmt": "R$ 305",
    "ticketMedianoSimuladoFmt": "R$ 303",
    "valorTotalAcumuladoSimuladoFmt": "R$ 610",
    "maiorPedidoSimuladoFmt": "R$ 339",
    "menorPedidoSimuladoFmt": "R$ 190",
    "primeiraCompraSimulada": "02/12/2025",
    "ultimaCompraSimulada": "01/05/2026",
    "diasDesdeUltimaCompraSimulado": 13,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0443"
  },
  {
    "clienteId": "CLI_0444",
    "clienteAnonimo": "443",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 331,
    "ticketMedianoSimulado": 309,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 662,
    "maiorPedidoSimulado": 396,
    "menorPedidoSimulado": 239,
    "ticketMedioSimuladoFmt": "R$ 331",
    "ticketMedianoSimuladoFmt": "R$ 309",
    "valorTotalAcumuladoSimuladoFmt": "R$ 662",
    "maiorPedidoSimuladoFmt": "R$ 396",
    "menorPedidoSimuladoFmt": "R$ 239",
    "primeiraCompraSimulada": "16/11/2025",
    "ultimaCompraSimulada": "21/03/2026",
    "diasDesdeUltimaCompraSimulado": 54,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0444"
  },
  {
    "clienteId": "CLI_0445",
    "clienteAnonimo": "444",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 357,
    "ticketMedianoSimulado": 349,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 714,
    "maiorPedidoSimulado": 395,
    "menorPedidoSimulado": 220,
    "ticketMedioSimuladoFmt": "R$ 357",
    "ticketMedianoSimuladoFmt": "R$ 349",
    "valorTotalAcumuladoSimuladoFmt": "R$ 714",
    "maiorPedidoSimuladoFmt": "R$ 395",
    "menorPedidoSimuladoFmt": "R$ 220",
    "primeiraCompraSimulada": "31/10/2025",
    "ultimaCompraSimulada": "09/02/2026",
    "diasDesdeUltimaCompraSimulado": 94,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0445"
  },
  {
    "clienteId": "CLI_0446",
    "clienteAnonimo": "445",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 383,
    "ticketMedianoSimulado": 364,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 766,
    "maiorPedidoSimulado": 415,
    "menorPedidoSimulado": 225,
    "ticketMedioSimuladoFmt": "R$ 383",
    "ticketMedianoSimuladoFmt": "R$ 364",
    "valorTotalAcumuladoSimuladoFmt": "R$ 766",
    "maiorPedidoSimuladoFmt": "R$ 415",
    "menorPedidoSimuladoFmt": "R$ 225",
    "primeiraCompraSimulada": "11/11/2025",
    "ultimaCompraSimulada": "28/03/2026",
    "diasDesdeUltimaCompraSimulado": 47,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0446"
  },
  {
    "clienteId": "CLI_0447",
    "clienteAnonimo": "446",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 410,
    "ticketMedianoSimulado": 395,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 820,
    "maiorPedidoSimulado": 481,
    "menorPedidoSimulado": 284,
    "ticketMedioSimuladoFmt": "R$ 410",
    "ticketMedianoSimuladoFmt": "R$ 395",
    "valorTotalAcumuladoSimuladoFmt": "R$ 820",
    "maiorPedidoSimuladoFmt": "R$ 481",
    "menorPedidoSimuladoFmt": "R$ 284",
    "primeiraCompraSimulada": "27/11/2025",
    "ultimaCompraSimulada": "09/05/2026",
    "diasDesdeUltimaCompraSimulado": 5,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0447"
  },
  {
    "clienteId": "CLI_0448",
    "clienteAnonimo": "447",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 436,
    "ticketMedianoSimulado": 420,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 872,
    "maiorPedidoSimulado": 496,
    "menorPedidoSimulado": 284,
    "ticketMedioSimuladoFmt": "R$ 436",
    "ticketMedianoSimuladoFmt": "R$ 420",
    "valorTotalAcumuladoSimuladoFmt": "R$ 872",
    "maiorPedidoSimuladoFmt": "R$ 496",
    "menorPedidoSimuladoFmt": "R$ 284",
    "primeiraCompraSimulada": "13/12/2025",
    "ultimaCompraSimulada": "08/04/2026",
    "diasDesdeUltimaCompraSimulado": 36,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0448"
  },
  {
    "clienteId": "CLI_0449",
    "clienteAnonimo": "448",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 438,
    "ticketMedianoSimulado": 416,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 438,
    "maiorPedidoSimulado": 461,
    "menorPedidoSimulado": 243,
    "ticketMedioSimuladoFmt": "R$ 438",
    "ticketMedianoSimuladoFmt": "R$ 416",
    "valorTotalAcumuladoSimuladoFmt": "R$ 438",
    "maiorPedidoSimuladoFmt": "R$ 461",
    "menorPedidoSimuladoFmt": "R$ 243",
    "primeiraCompraSimulada": "29/12/2025",
    "ultimaCompraSimulada": "12/03/2026",
    "diasDesdeUltimaCompraSimulado": 63,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0449"
  },
  {
    "clienteId": "CLI_0450",
    "clienteAnonimo": "449",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 411,
    "ticketMedianoSimulado": 385,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 411,
    "maiorPedidoSimulado": 460,
    "menorPedidoSimulado": 259,
    "ticketMedioSimuladoFmt": "R$ 411",
    "ticketMedianoSimuladoFmt": "R$ 385",
    "valorTotalAcumuladoSimuladoFmt": "R$ 411",
    "maiorPedidoSimuladoFmt": "R$ 460",
    "menorPedidoSimuladoFmt": "R$ 259",
    "primeiraCompraSimulada": "16/02/2026",
    "ultimaCompraSimulada": "11/05/2026",
    "diasDesdeUltimaCompraSimulado": 3,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0450"
  },
  {
    "clienteId": "CLI_0451",
    "clienteAnonimo": "450",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 438,
    "ticketMedianoSimulado": 434,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1314,
    "maiorPedidoSimulado": 522,
    "menorPedidoSimulado": 313,
    "ticketMedioSimuladoFmt": "R$ 438",
    "ticketMedianoSimuladoFmt": "R$ 434",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.314",
    "maiorPedidoSimuladoFmt": "R$ 522",
    "menorPedidoSimuladoFmt": "R$ 313",
    "primeiraCompraSimulada": "04/03/2026",
    "ultimaCompraSimulada": "25/04/2026",
    "diasDesdeUltimaCompraSimulado": 19,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0451"
  },
  {
    "clienteId": "CLI_0452",
    "clienteAnonimo": "451",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 436,
    "ticketMedianoSimulado": 402,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 436,
    "maiorPedidoSimulado": 480,
    "menorPedidoSimulado": 266,
    "ticketMedioSimuladoFmt": "R$ 436",
    "ticketMedianoSimuladoFmt": "R$ 402",
    "valorTotalAcumuladoSimuladoFmt": "R$ 436",
    "maiorPedidoSimuladoFmt": "R$ 480",
    "menorPedidoSimuladoFmt": "R$ 266",
    "primeiraCompraSimulada": "20/03/2026",
    "ultimaCompraSimulada": "17/04/2026",
    "diasDesdeUltimaCompraSimulado": 27,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0452"
  },
  {
    "clienteId": "CLI_0453",
    "clienteAnonimo": "452",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 410,
    "ticketMedianoSimulado": 408,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 820,
    "maiorPedidoSimulado": 447,
    "menorPedidoSimulado": 244,
    "ticketMedioSimuladoFmt": "R$ 410",
    "ticketMedianoSimuladoFmt": "R$ 408",
    "valorTotalAcumuladoSimuladoFmt": "R$ 820",
    "maiorPedidoSimuladoFmt": "R$ 447",
    "menorPedidoSimuladoFmt": "R$ 244",
    "primeiraCompraSimulada": "05/04/2026",
    "ultimaCompraSimulada": "30/04/2026",
    "diasDesdeUltimaCompraSimulado": 14,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0453"
  },
  {
    "clienteId": "CLI_0454",
    "clienteAnonimo": "453",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 384,
    "ticketMedianoSimulado": 358,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 768,
    "maiorPedidoSimulado": 453,
    "menorPedidoSimulado": 269,
    "ticketMedioSimuladoFmt": "R$ 384",
    "ticketMedianoSimuladoFmt": "R$ 358",
    "valorTotalAcumuladoSimuladoFmt": "R$ 768",
    "maiorPedidoSimuladoFmt": "R$ 453",
    "menorPedidoSimuladoFmt": "R$ 269",
    "primeiraCompraSimulada": "07/04/2026",
    "ultimaCompraSimulada": "09/05/2026",
    "diasDesdeUltimaCompraSimulado": 5,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0454"
  },
  {
    "clienteId": "CLI_0455",
    "clienteAnonimo": "454",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 357,
    "ticketMedianoSimulado": 350,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 714,
    "maiorPedidoSimulado": 404,
    "menorPedidoSimulado": 230,
    "ticketMedioSimuladoFmt": "R$ 357",
    "ticketMedianoSimuladoFmt": "R$ 350",
    "valorTotalAcumuladoSimuladoFmt": "R$ 714",
    "maiorPedidoSimuladoFmt": "R$ 404",
    "menorPedidoSimuladoFmt": "R$ 230",
    "primeiraCompraSimulada": "22/03/2026",
    "ultimaCompraSimulada": "03/05/2026",
    "diasDesdeUltimaCompraSimulado": 11,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0455"
  },
  {
    "clienteId": "CLI_0456",
    "clienteAnonimo": "455",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 331,
    "ticketMedianoSimulado": 313,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 662,
    "maiorPedidoSimulado": 351,
    "menorPedidoSimulado": 186,
    "ticketMedioSimuladoFmt": "R$ 331",
    "ticketMedianoSimuladoFmt": "R$ 313",
    "valorTotalAcumuladoSimuladoFmt": "R$ 662",
    "maiorPedidoSimuladoFmt": "R$ 351",
    "menorPedidoSimuladoFmt": "R$ 186",
    "primeiraCompraSimulada": "06/03/2026",
    "ultimaCompraSimulada": "15/04/2026",
    "diasDesdeUltimaCompraSimulado": 29,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0456"
  },
  {
    "clienteId": "CLI_0457",
    "clienteAnonimo": "456",
    "segmentoComercial": "Cliente possível coletivo",
    "ticketMedioSimulado": 1465,
    "ticketMedianoSimulado": 1415,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 2930,
    "maiorPedidoSimulado": 1685,
    "menorPedidoSimulado": 977,
    "ticketMedioSimuladoFmt": "R$ 1.465",
    "ticketMedianoSimuladoFmt": "R$ 1.415",
    "valorTotalAcumuladoSimuladoFmt": "R$ 2.930",
    "maiorPedidoSimuladoFmt": "R$ 1.685",
    "menorPedidoSimuladoFmt": "R$ 977",
    "primeiraCompraSimulada": "19/02/2026",
    "ultimaCompraSimulada": "11/04/2026",
    "diasDesdeUltimaCompraSimulado": 33,
    "hipoteseDePerfil": "Possível compra coletiva, familiar ampliada ou corporativa. Não afirmar sem confirmação.",
    "objetivoProvavel": "Pode comprar para mais de uma pessoa, família ou equipe",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Tratar como hipótese de compra coletiva — G09 ativo.",
    "alertaSimulacao": "Possível compra familiar, equipe ou coletiva. Confirmar antes de assumir.",
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0457"
  },
  {
    "clienteId": "CLI_0458",
    "clienteAnonimo": "457",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 281,
    "ticketMedianoSimulado": 270,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 562,
    "maiorPedidoSimulado": 326,
    "menorPedidoSimulado": 191,
    "ticketMedioSimuladoFmt": "R$ 281",
    "ticketMedianoSimuladoFmt": "R$ 270",
    "valorTotalAcumuladoSimuladoFmt": "R$ 562",
    "maiorPedidoSimuladoFmt": "R$ 326",
    "menorPedidoSimuladoFmt": "R$ 191",
    "primeiraCompraSimulada": "03/02/2026",
    "ultimaCompraSimulada": "27/04/2026",
    "diasDesdeUltimaCompraSimulado": 17,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0458"
  },
  {
    "clienteId": "CLI_0459",
    "clienteAnonimo": "458",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 307,
    "ticketMedianoSimulado": 292,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 307,
    "maiorPedidoSimulado": 328,
    "menorPedidoSimulado": 176,
    "ticketMedioSimuladoFmt": "R$ 307",
    "ticketMedianoSimuladoFmt": "R$ 292",
    "valorTotalAcumuladoSimuladoFmt": "R$ 307",
    "maiorPedidoSimuladoFmt": "R$ 328",
    "menorPedidoSimuladoFmt": "R$ 176",
    "primeiraCompraSimulada": "18/01/2026",
    "ultimaCompraSimulada": "01/05/2026",
    "diasDesdeUltimaCompraSimulado": 13,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0459"
  },
  {
    "clienteId": "CLI_0460",
    "clienteAnonimo": "459",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 303,
    "ticketMedianoSimulado": 285,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 303,
    "maiorPedidoSimulado": 332,
    "menorPedidoSimulado": 183,
    "ticketMedioSimuladoFmt": "R$ 303",
    "ticketMedianoSimuladoFmt": "R$ 285",
    "valorTotalAcumuladoSimuladoFmt": "R$ 303",
    "maiorPedidoSimuladoFmt": "R$ 332",
    "menorPedidoSimuladoFmt": "R$ 183",
    "primeiraCompraSimulada": "30/11/2025",
    "ultimaCompraSimulada": "14/03/2026",
    "diasDesdeUltimaCompraSimulado": 61,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0460"
  },
  {
    "clienteId": "CLI_0461",
    "clienteAnonimo": "460",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 283,
    "ticketMedianoSimulado": 280,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 849,
    "maiorPedidoSimulado": 336,
    "menorPedidoSimulado": 200,
    "ticketMedioSimuladoFmt": "R$ 283",
    "ticketMedianoSimuladoFmt": "R$ 280",
    "valorTotalAcumuladoSimuladoFmt": "R$ 849",
    "maiorPedidoSimuladoFmt": "R$ 336",
    "menorPedidoSimuladoFmt": "R$ 200",
    "primeiraCompraSimulada": "14/11/2025",
    "ultimaCompraSimulada": "19/04/2026",
    "diasDesdeUltimaCompraSimulado": 25,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0461"
  },
  {
    "clienteId": "CLI_0462",
    "clienteAnonimo": "461",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 309,
    "ticketMedianoSimulado": 286,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 309,
    "maiorPedidoSimulado": 347,
    "menorPedidoSimulado": 197,
    "ticketMedioSimuladoFmt": "R$ 309",
    "ticketMedianoSimuladoFmt": "R$ 286",
    "valorTotalAcumuladoSimuladoFmt": "R$ 309",
    "maiorPedidoSimuladoFmt": "R$ 347",
    "menorPedidoSimuladoFmt": "R$ 197",
    "primeiraCompraSimulada": "29/10/2025",
    "ultimaCompraSimulada": "21/04/2026",
    "diasDesdeUltimaCompraSimulado": 23,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0462"
  },
  {
    "clienteId": "CLI_0463",
    "clienteAnonimo": "462",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 335,
    "ticketMedianoSimulado": 334,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1005,
    "maiorPedidoSimulado": 357,
    "menorPedidoSimulado": 191,
    "ticketMedioSimuladoFmt": "R$ 335",
    "ticketMedianoSimuladoFmt": "R$ 334",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.005",
    "maiorPedidoSimuladoFmt": "R$ 357",
    "menorPedidoSimuladoFmt": "R$ 191",
    "primeiraCompraSimulada": "13/11/2025",
    "ultimaCompraSimulada": "12/03/2026",
    "diasDesdeUltimaCompraSimulado": 63,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0463"
  },
  {
    "clienteId": "CLI_0464",
    "clienteAnonimo": "463",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 362,
    "ticketMedianoSimulado": 337,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 724,
    "maiorPedidoSimulado": 419,
    "menorPedidoSimulado": 244,
    "ticketMedioSimuladoFmt": "R$ 362",
    "ticketMedianoSimuladoFmt": "R$ 337",
    "valorTotalAcumuladoSimuladoFmt": "R$ 724",
    "maiorPedidoSimuladoFmt": "R$ 419",
    "menorPedidoSimuladoFmt": "R$ 244",
    "primeiraCompraSimulada": "29/11/2025",
    "ultimaCompraSimulada": "02/03/2026",
    "diasDesdeUltimaCompraSimulado": 73,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0464"
  },
  {
    "clienteId": "CLI_0465",
    "clienteAnonimo": "464",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 388,
    "ticketMedianoSimulado": 381,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 776,
    "maiorPedidoSimulado": 448,
    "menorPedidoSimulado": 260,
    "ticketMedioSimuladoFmt": "R$ 388",
    "ticketMedianoSimuladoFmt": "R$ 381",
    "valorTotalAcumuladoSimuladoFmt": "R$ 776",
    "maiorPedidoSimuladoFmt": "R$ 448",
    "menorPedidoSimuladoFmt": "R$ 260",
    "primeiraCompraSimulada": "15/12/2025",
    "ultimaCompraSimulada": "12/04/2026",
    "diasDesdeUltimaCompraSimulado": 32,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0465"
  },
  {
    "clienteId": "CLI_0466",
    "clienteAnonimo": "465",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 414,
    "ticketMedianoSimulado": 391,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 828,
    "maiorPedidoSimulado": 440,
    "menorPedidoSimulado": 234,
    "ticketMedioSimuladoFmt": "R$ 414",
    "ticketMedianoSimuladoFmt": "R$ 391",
    "valorTotalAcumuladoSimuladoFmt": "R$ 828",
    "maiorPedidoSimuladoFmt": "R$ 440",
    "menorPedidoSimuladoFmt": "R$ 234",
    "primeiraCompraSimulada": "31/12/2025",
    "ultimaCompraSimulada": "07/05/2026",
    "diasDesdeUltimaCompraSimulado": 7,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0466"
  },
  {
    "clienteId": "CLI_0467",
    "clienteAnonimo": "466",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 440,
    "ticketMedianoSimulado": 426,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 880,
    "maiorPedidoSimulado": 496,
    "menorPedidoSimulado": 281,
    "ticketMedioSimuladoFmt": "R$ 440",
    "ticketMedianoSimuladoFmt": "R$ 426",
    "valorTotalAcumuladoSimuladoFmt": "R$ 880",
    "maiorPedidoSimuladoFmt": "R$ 496",
    "menorPedidoSimuladoFmt": "R$ 281",
    "primeiraCompraSimulada": "16/01/2026",
    "ultimaCompraSimulada": "11/04/2026",
    "diasDesdeUltimaCompraSimulado": 33,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0467"
  },
  {
    "clienteId": "CLI_0468",
    "clienteAnonimo": "467",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 434,
    "ticketMedianoSimulado": 416,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 868,
    "maiorPedidoSimulado": 513,
    "menorPedidoSimulado": 306,
    "ticketMedioSimuladoFmt": "R$ 434",
    "ticketMedianoSimuladoFmt": "R$ 416",
    "valorTotalAcumuladoSimuladoFmt": "R$ 868",
    "maiorPedidoSimuladoFmt": "R$ 513",
    "menorPedidoSimuladoFmt": "R$ 306",
    "primeiraCompraSimulada": "01/02/2026",
    "ultimaCompraSimulada": "23/03/2026",
    "diasDesdeUltimaCompraSimulado": 52,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0468"
  },
  {
    "clienteId": "CLI_0469",
    "clienteAnonimo": "468",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 407,
    "ticketMedianoSimulado": 388,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 407,
    "maiorPedidoSimulado": 445,
    "menorPedidoSimulado": 244,
    "ticketMedioSimuladoFmt": "R$ 407",
    "ticketMedianoSimuladoFmt": "R$ 388",
    "valorTotalAcumuladoSimuladoFmt": "R$ 407",
    "maiorPedidoSimuladoFmt": "R$ 445",
    "menorPedidoSimuladoFmt": "R$ 244",
    "primeiraCompraSimulada": "17/02/2026",
    "ultimaCompraSimulada": "18/04/2026",
    "diasDesdeUltimaCompraSimulado": 26,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0469"
  },
  {
    "clienteId": "CLI_0470",
    "clienteAnonimo": "469",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 442,
    "ticketMedianoSimulado": 416,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 442,
    "maiorPedidoSimulado": 474,
    "menorPedidoSimulado": 255,
    "ticketMedioSimuladoFmt": "R$ 442",
    "ticketMedianoSimuladoFmt": "R$ 416",
    "valorTotalAcumuladoSimuladoFmt": "R$ 442",
    "maiorPedidoSimuladoFmt": "R$ 474",
    "menorPedidoSimuladoFmt": "R$ 255",
    "primeiraCompraSimulada": "06/04/2026",
    "ultimaCompraSimulada": "01/05/2026",
    "diasDesdeUltimaCompraSimulado": 13,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0470"
  },
  {
    "clienteId": "CLI_0471",
    "clienteAnonimo": "470",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 432,
    "ticketMedianoSimulado": 426,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1296,
    "maiorPedidoSimulado": 502,
    "menorPedidoSimulado": 294,
    "ticketMedioSimuladoFmt": "R$ 432",
    "ticketMedianoSimuladoFmt": "R$ 426",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.296",
    "maiorPedidoSimuladoFmt": "R$ 502",
    "menorPedidoSimuladoFmt": "R$ 294",
    "primeiraCompraSimulada": "06/04/2026",
    "ultimaCompraSimulada": "24/04/2026",
    "diasDesdeUltimaCompraSimulado": 20,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0471"
  },
  {
    "clienteId": "CLI_0472",
    "clienteAnonimo": "471",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 406,
    "ticketMedianoSimulado": 376,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 406,
    "maiorPedidoSimulado": 466,
    "menorPedidoSimulado": 269,
    "ticketMedioSimuladoFmt": "R$ 406",
    "ticketMedianoSimuladoFmt": "R$ 376",
    "valorTotalAcumuladoSimuladoFmt": "R$ 406",
    "maiorPedidoSimuladoFmt": "R$ 466",
    "menorPedidoSimuladoFmt": "R$ 269",
    "primeiraCompraSimulada": "21/03/2026",
    "ultimaCompraSimulada": "28/04/2026",
    "diasDesdeUltimaCompraSimulado": 16,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0472"
  },
  {
    "clienteId": "CLI_0473",
    "clienteAnonimo": "472",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 379,
    "ticketMedianoSimulado": 379,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1137,
    "maiorPedidoSimulado": 401,
    "menorPedidoSimulado": 212,
    "ticketMedioSimuladoFmt": "R$ 379",
    "ticketMedianoSimuladoFmt": "R$ 379",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.137",
    "maiorPedidoSimuladoFmt": "R$ 401",
    "menorPedidoSimuladoFmt": "R$ 212",
    "primeiraCompraSimulada": "05/03/2026",
    "ultimaCompraSimulada": "09/05/2026",
    "diasDesdeUltimaCompraSimulado": 5,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0473"
  },
  {
    "clienteId": "CLI_0474",
    "clienteAnonimo": "473",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 353,
    "ticketMedianoSimulado": 327,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 706,
    "maiorPedidoSimulado": 400,
    "menorPedidoSimulado": 228,
    "ticketMedioSimuladoFmt": "R$ 353",
    "ticketMedianoSimuladoFmt": "R$ 327",
    "valorTotalAcumuladoSimuladoFmt": "R$ 706",
    "maiorPedidoSimuladoFmt": "R$ 400",
    "menorPedidoSimuladoFmt": "R$ 228",
    "primeiraCompraSimulada": "17/02/2026",
    "ultimaCompraSimulada": "24/04/2026",
    "diasDesdeUltimaCompraSimulado": 20,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0474"
  },
  {
    "clienteId": "CLI_0475",
    "clienteAnonimo": "474",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 327,
    "ticketMedianoSimulado": 322,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 654,
    "maiorPedidoSimulado": 385,
    "menorPedidoSimulado": 228,
    "ticketMedioSimuladoFmt": "R$ 327",
    "ticketMedianoSimuladoFmt": "R$ 322",
    "valorTotalAcumuladoSimuladoFmt": "R$ 654",
    "maiorPedidoSimuladoFmt": "R$ 385",
    "menorPedidoSimuladoFmt": "R$ 228",
    "primeiraCompraSimulada": "01/02/2026",
    "ultimaCompraSimulada": "29/03/2026",
    "diasDesdeUltimaCompraSimulado": 46,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0475"
  },
  {
    "clienteId": "CLI_0476",
    "clienteAnonimo": "475",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 301,
    "ticketMedianoSimulado": 283,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 602,
    "maiorPedidoSimulado": 327,
    "menorPedidoSimulado": 178,
    "ticketMedioSimuladoFmt": "R$ 301",
    "ticketMedianoSimuladoFmt": "R$ 283",
    "valorTotalAcumuladoSimuladoFmt": "R$ 602",
    "maiorPedidoSimuladoFmt": "R$ 327",
    "menorPedidoSimuladoFmt": "R$ 178",
    "primeiraCompraSimulada": "16/01/2026",
    "ultimaCompraSimulada": "03/04/2026",
    "diasDesdeUltimaCompraSimulado": 41,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0476"
  },
  {
    "clienteId": "CLI_0477",
    "clienteAnonimo": "476",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 286,
    "ticketMedianoSimulado": 278,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 572,
    "maiorPedidoSimulado": 316,
    "menorPedidoSimulado": 175,
    "ticketMedioSimuladoFmt": "R$ 286",
    "ticketMedianoSimuladoFmt": "R$ 278",
    "valorTotalAcumuladoSimuladoFmt": "R$ 572",
    "maiorPedidoSimuladoFmt": "R$ 316",
    "menorPedidoSimuladoFmt": "R$ 175",
    "primeiraCompraSimulada": "31/12/2025",
    "ultimaCompraSimulada": "28/04/2026",
    "diasDesdeUltimaCompraSimulado": 16,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0477"
  },
  {
    "clienteId": "CLI_0478",
    "clienteAnonimo": "477",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 312,
    "ticketMedianoSimulado": 298,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 624,
    "maiorPedidoSimulado": 373,
    "menorPedidoSimulado": 224,
    "ticketMedioSimuladoFmt": "R$ 312",
    "ticketMedianoSimuladoFmt": "R$ 298",
    "valorTotalAcumuladoSimuladoFmt": "R$ 624",
    "maiorPedidoSimuladoFmt": "R$ 373",
    "menorPedidoSimuladoFmt": "R$ 224",
    "primeiraCompraSimulada": "15/12/2025",
    "ultimaCompraSimulada": "22/04/2026",
    "diasDesdeUltimaCompraSimulado": 22,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0478"
  },
  {
    "clienteId": "CLI_0479",
    "clienteAnonimo": "478",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 338,
    "ticketMedianoSimulado": 323,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 676,
    "maiorPedidoSimulado": 377,
    "menorPedidoSimulado": 212,
    "ticketMedioSimuladoFmt": "R$ 338",
    "ticketMedianoSimuladoFmt": "R$ 323",
    "valorTotalAcumuladoSimuladoFmt": "R$ 676",
    "maiorPedidoSimuladoFmt": "R$ 377",
    "menorPedidoSimuladoFmt": "R$ 212",
    "primeiraCompraSimulada": "29/11/2025",
    "ultimaCompraSimulada": "13/03/2026",
    "diasDesdeUltimaCompraSimulado": 62,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0479"
  },
  {
    "clienteId": "CLI_0480",
    "clienteAnonimo": "479",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 287,
    "ticketMedianoSimulado": 271,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 287,
    "maiorPedidoSimulado": 302,
    "menorPedidoSimulado": 158,
    "ticketMedioSimuladoFmt": "R$ 287",
    "ticketMedianoSimuladoFmt": "R$ 271",
    "valorTotalAcumuladoSimuladoFmt": "R$ 287",
    "maiorPedidoSimuladoFmt": "R$ 302",
    "menorPedidoSimuladoFmt": "R$ 158",
    "primeiraCompraSimulada": "14/11/2025",
    "ultimaCompraSimulada": "26/04/2026",
    "diasDesdeUltimaCompraSimulado": 18,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0480"
  },
  {
    "clienteId": "CLI_0481",
    "clienteAnonimo": "480",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 314,
    "ticketMedianoSimulado": 309,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 942,
    "maiorPedidoSimulado": 358,
    "menorPedidoSimulado": 205,
    "ticketMedioSimuladoFmt": "R$ 314",
    "ticketMedianoSimuladoFmt": "R$ 309",
    "valorTotalAcumuladoSimuladoFmt": "R$ 942",
    "maiorPedidoSimuladoFmt": "R$ 358",
    "menorPedidoSimuladoFmt": "R$ 205",
    "primeiraCompraSimulada": "30/11/2025",
    "ultimaCompraSimulada": "17/04/2026",
    "diasDesdeUltimaCompraSimulado": 27,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0481"
  },
  {
    "clienteId": "CLI_0482",
    "clienteAnonimo": "481",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 340,
    "ticketMedianoSimulado": 316,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 340,
    "maiorPedidoSimulado": 398,
    "menorPedidoSimulado": 235,
    "ticketMedioSimuladoFmt": "R$ 340",
    "ticketMedianoSimuladoFmt": "R$ 316",
    "valorTotalAcumuladoSimuladoFmt": "R$ 340",
    "maiorPedidoSimuladoFmt": "R$ 398",
    "menorPedidoSimuladoFmt": "R$ 235",
    "primeiraCompraSimulada": "16/12/2025",
    "ultimaCompraSimulada": "16/03/2026",
    "diasDesdeUltimaCompraSimulado": 59,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0482"
  },
  {
    "clienteId": "CLI_0483",
    "clienteAnonimo": "482",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 366,
    "ticketMedianoSimulado": 365,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1098,
    "maiorPedidoSimulado": 395,
    "menorPedidoSimulado": 214,
    "ticketMedioSimuladoFmt": "R$ 366",
    "ticketMedianoSimuladoFmt": "R$ 365",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.098",
    "maiorPedidoSimuladoFmt": "R$ 395",
    "menorPedidoSimuladoFmt": "R$ 214",
    "primeiraCompraSimulada": "01/01/2026",
    "ultimaCompraSimulada": "22/03/2026",
    "diasDesdeUltimaCompraSimulado": 53,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0483"
  },
  {
    "clienteId": "CLI_0484",
    "clienteAnonimo": "483",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 392,
    "ticketMedianoSimulado": 362,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 784,
    "maiorPedidoSimulado": 435,
    "menorPedidoSimulado": 243,
    "ticketMedioSimuladoFmt": "R$ 392",
    "ticketMedianoSimuladoFmt": "R$ 362",
    "valorTotalAcumuladoSimuladoFmt": "R$ 784",
    "maiorPedidoSimuladoFmt": "R$ 435",
    "menorPedidoSimuladoFmt": "R$ 243",
    "primeiraCompraSimulada": "17/01/2026",
    "ultimaCompraSimulada": "23/04/2026",
    "diasDesdeUltimaCompraSimulado": 21,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0484"
  },
  {
    "clienteId": "CLI_0485",
    "clienteAnonimo": "484",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 418,
    "ticketMedianoSimulado": 413,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 836,
    "maiorPedidoSimulado": 501,
    "menorPedidoSimulado": 303,
    "ticketMedioSimuladoFmt": "R$ 418",
    "ticketMedianoSimuladoFmt": "R$ 413",
    "valorTotalAcumuladoSimuladoFmt": "R$ 836",
    "maiorPedidoSimuladoFmt": "R$ 501",
    "menorPedidoSimuladoFmt": "R$ 303",
    "primeiraCompraSimulada": "02/02/2026",
    "ultimaCompraSimulada": "04/05/2026",
    "diasDesdeUltimaCompraSimulado": 10,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0485"
  },
  {
    "clienteId": "CLI_0486",
    "clienteAnonimo": "485",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 445,
    "ticketMedianoSimulado": 418,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 890,
    "maiorPedidoSimulado": 494,
    "menorPedidoSimulado": 276,
    "ticketMedioSimuladoFmt": "R$ 445",
    "ticketMedianoSimuladoFmt": "R$ 418",
    "valorTotalAcumuladoSimuladoFmt": "R$ 890",
    "maiorPedidoSimuladoFmt": "R$ 494",
    "menorPedidoSimuladoFmt": "R$ 276",
    "primeiraCompraSimulada": "18/02/2026",
    "ultimaCompraSimulada": "16/04/2026",
    "diasDesdeUltimaCompraSimulado": 28,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0486"
  },
  {
    "clienteId": "CLI_0487",
    "clienteAnonimo": "486",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 429,
    "ticketMedianoSimulado": 418,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 858,
    "maiorPedidoSimulado": 464,
    "menorPedidoSimulado": 251,
    "ticketMedioSimuladoFmt": "R$ 429",
    "ticketMedianoSimuladoFmt": "R$ 418",
    "valorTotalAcumuladoSimuladoFmt": "R$ 858",
    "maiorPedidoSimuladoFmt": "R$ 464",
    "menorPedidoSimuladoFmt": "R$ 251",
    "primeiraCompraSimulada": "06/03/2026",
    "ultimaCompraSimulada": "11/04/2026",
    "diasDesdeUltimaCompraSimulado": 33,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0487"
  },
  {
    "clienteId": "CLI_0488",
    "clienteAnonimo": "487",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 403,
    "ticketMedianoSimulado": 384,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 806,
    "maiorPedidoSimulado": 472,
    "menorPedidoSimulado": 278,
    "ticketMedioSimuladoFmt": "R$ 403",
    "ticketMedianoSimuladoFmt": "R$ 384",
    "valorTotalAcumuladoSimuladoFmt": "R$ 806",
    "maiorPedidoSimuladoFmt": "R$ 472",
    "menorPedidoSimuladoFmt": "R$ 278",
    "primeiraCompraSimulada": "22/03/2026",
    "ultimaCompraSimulada": "29/04/2026",
    "diasDesdeUltimaCompraSimulado": 15,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0488"
  },
  {
    "clienteId": "CLI_0489",
    "clienteAnonimo": "488",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 377,
    "ticketMedianoSimulado": 362,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 754,
    "maiorPedidoSimulado": 429,
    "menorPedidoSimulado": 246,
    "ticketMedioSimuladoFmt": "R$ 377",
    "ticketMedianoSimuladoFmt": "R$ 362",
    "valorTotalAcumuladoSimuladoFmt": "R$ 754",
    "maiorPedidoSimuladoFmt": "R$ 429",
    "menorPedidoSimuladoFmt": "R$ 246",
    "primeiraCompraSimulada": "07/04/2026",
    "ultimaCompraSimulada": "11/05/2026",
    "diasDesdeUltimaCompraSimulado": 3,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0489"
  },
  {
    "clienteId": "CLI_0490",
    "clienteAnonimo": "489",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 427,
    "ticketMedianoSimulado": 404,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 427,
    "maiorPedidoSimulado": 459,
    "menorPedidoSimulado": 247,
    "ticketMedioSimuladoFmt": "R$ 427",
    "ticketMedianoSimuladoFmt": "R$ 404",
    "valorTotalAcumuladoSimuladoFmt": "R$ 427",
    "maiorPedidoSimuladoFmt": "R$ 459",
    "menorPedidoSimuladoFmt": "R$ 247",
    "primeiraCompraSimulada": "04/03/2026",
    "ultimaCompraSimulada": "11/04/2026",
    "diasDesdeUltimaCompraSimulado": 33,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0490"
  },
  {
    "clienteId": "CLI_0491",
    "clienteAnonimo": "490",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 401,
    "ticketMedianoSimulado": 393,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1203,
    "maiorPedidoSimulado": 448,
    "menorPedidoSimulado": 252,
    "ticketMedioSimuladoFmt": "R$ 401",
    "ticketMedianoSimuladoFmt": "R$ 393",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.203",
    "maiorPedidoSimuladoFmt": "R$ 448",
    "menorPedidoSimuladoFmt": "R$ 252",
    "primeiraCompraSimulada": "16/02/2026",
    "ultimaCompraSimulada": "23/04/2026",
    "diasDesdeUltimaCompraSimulado": 21,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0491"
  },
  {
    "clienteId": "CLI_0492",
    "clienteAnonimo": "491",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 375,
    "ticketMedianoSimulado": 350,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 375,
    "maiorPedidoSimulado": 448,
    "menorPedidoSimulado": 269,
    "ticketMedioSimuladoFmt": "R$ 375",
    "ticketMedianoSimuladoFmt": "R$ 350",
    "valorTotalAcumuladoSimuladoFmt": "R$ 375",
    "maiorPedidoSimuladoFmt": "R$ 448",
    "menorPedidoSimuladoFmt": "R$ 269",
    "primeiraCompraSimulada": "31/01/2026",
    "ultimaCompraSimulada": "09/05/2026",
    "diasDesdeUltimaCompraSimulado": 5,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0492"
  },
  {
    "clienteId": "CLI_0493",
    "clienteAnonimo": "492",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 349,
    "ticketMedianoSimulado": 347,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1047,
    "maiorPedidoSimulado": 385,
    "menorPedidoSimulado": 214,
    "ticketMedioSimuladoFmt": "R$ 349",
    "ticketMedianoSimuladoFmt": "R$ 347",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.047",
    "maiorPedidoSimuladoFmt": "R$ 385",
    "menorPedidoSimuladoFmt": "R$ 214",
    "primeiraCompraSimulada": "15/01/2026",
    "ultimaCompraSimulada": "12/04/2026",
    "diasDesdeUltimaCompraSimulado": 32,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0493"
  },
  {
    "clienteId": "CLI_0494",
    "clienteAnonimo": "493",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 323,
    "ticketMedianoSimulado": 298,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 323,
    "maiorPedidoSimulado": 351,
    "menorPedidoSimulado": 192,
    "ticketMedioSimuladoFmt": "R$ 323",
    "ticketMedianoSimuladoFmt": "R$ 298",
    "valorTotalAcumuladoSimuladoFmt": "R$ 323",
    "maiorPedidoSimuladoFmt": "R$ 351",
    "menorPedidoSimuladoFmt": "R$ 192",
    "primeiraCompraSimulada": "30/12/2025",
    "ultimaCompraSimulada": "08/03/2026",
    "diasDesdeUltimaCompraSimulado": 67,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0494"
  },
  {
    "clienteId": "CLI_0495",
    "clienteAnonimo": "494",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 296,
    "ticketMedianoSimulado": 293,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 592,
    "maiorPedidoSimulado": 348,
    "menorPedidoSimulado": 207,
    "ticketMedioSimuladoFmt": "R$ 296",
    "ticketMedianoSimuladoFmt": "R$ 293",
    "valorTotalAcumuladoSimuladoFmt": "R$ 592",
    "maiorPedidoSimuladoFmt": "R$ 348",
    "menorPedidoSimuladoFmt": "R$ 207",
    "primeiraCompraSimulada": "14/12/2025",
    "ultimaCompraSimulada": "30/03/2026",
    "diasDesdeUltimaCompraSimulado": 45,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0495"
  },
  {
    "clienteId": "CLI_0496",
    "clienteAnonimo": "495",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 290,
    "ticketMedianoSimulado": 272,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 580,
    "maiorPedidoSimulado": 328,
    "menorPedidoSimulado": 187,
    "ticketMedioSimuladoFmt": "R$ 290",
    "ticketMedianoSimuladoFmt": "R$ 272",
    "valorTotalAcumuladoSimuladoFmt": "R$ 580",
    "maiorPedidoSimuladoFmt": "R$ 328",
    "menorPedidoSimuladoFmt": "R$ 187",
    "primeiraCompraSimulada": "28/11/2025",
    "ultimaCompraSimulada": "02/05/2026",
    "diasDesdeUltimaCompraSimulado": 12,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0496"
  },
  {
    "clienteId": "CLI_0497",
    "clienteAnonimo": "496",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 316,
    "ticketMedianoSimulado": 308,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 632,
    "maiorPedidoSimulado": 334,
    "menorPedidoSimulado": 177,
    "ticketMedioSimuladoFmt": "R$ 316",
    "ticketMedianoSimuladoFmt": "R$ 308",
    "valorTotalAcumuladoSimuladoFmt": "R$ 632",
    "maiorPedidoSimuladoFmt": "R$ 334",
    "menorPedidoSimuladoFmt": "R$ 177",
    "primeiraCompraSimulada": "12/11/2025",
    "ultimaCompraSimulada": "09/04/2026",
    "diasDesdeUltimaCompraSimulado": 35,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0497"
  },
  {
    "clienteId": "CLI_0498",
    "clienteAnonimo": "497",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 342,
    "ticketMedianoSimulado": 325,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 684,
    "maiorPedidoSimulado": 393,
    "menorPedidoSimulado": 227,
    "ticketMedioSimuladoFmt": "R$ 342",
    "ticketMedianoSimuladoFmt": "R$ 325",
    "valorTotalAcumuladoSimuladoFmt": "R$ 684",
    "maiorPedidoSimuladoFmt": "R$ 393",
    "menorPedidoSimuladoFmt": "R$ 227",
    "primeiraCompraSimulada": "30/10/2025",
    "ultimaCompraSimulada": "21/02/2026",
    "diasDesdeUltimaCompraSimulado": 82,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0498"
  },
  {
    "clienteId": "CLI_0499",
    "clienteAnonimo": "498",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 369,
    "ticketMedianoSimulado": 355,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 738,
    "maiorPedidoSimulado": 429,
    "menorPedidoSimulado": 251,
    "ticketMedioSimuladoFmt": "R$ 369",
    "ticketMedianoSimuladoFmt": "R$ 355",
    "valorTotalAcumuladoSimuladoFmt": "R$ 738",
    "maiorPedidoSimuladoFmt": "R$ 429",
    "menorPedidoSimuladoFmt": "R$ 251",
    "primeiraCompraSimulada": "15/11/2025",
    "ultimaCompraSimulada": "08/03/2026",
    "diasDesdeUltimaCompraSimulado": 67,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0499"
  },
  {
    "clienteId": "CLI_0500",
    "clienteAnonimo": "499",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 400,
    "ticketMedianoSimulado": 397,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1200,
    "maiorPedidoSimulado": 428,
    "menorPedidoSimulado": 230,
    "ticketMedioSimuladoFmt": "R$ 400",
    "ticketMedianoSimuladoFmt": "R$ 397",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.200",
    "maiorPedidoSimuladoFmt": "R$ 428",
    "menorPedidoSimuladoFmt": "R$ 230",
    "primeiraCompraSimulada": "08/03/2026",
    "ultimaCompraSimulada": "02/05/2026",
    "diasDesdeUltimaCompraSimulado": 12,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0500"
  },
  {
    "clienteId": "CLI_0501",
    "clienteAnonimo": "500",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 374,
    "ticketMedianoSimulado": 344,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 374,
    "maiorPedidoSimulado": 434,
    "menorPedidoSimulado": 254,
    "ticketMedioSimuladoFmt": "R$ 374",
    "ticketMedianoSimuladoFmt": "R$ 344",
    "valorTotalAcumuladoSimuladoFmt": "R$ 374",
    "maiorPedidoSimuladoFmt": "R$ 434",
    "menorPedidoSimuladoFmt": "R$ 254",
    "primeiraCompraSimulada": "24/03/2026",
    "ultimaCompraSimulada": "06/05/2026",
    "diasDesdeUltimaCompraSimulado": 8,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0501"
  },
  {
    "clienteId": "CLI_0502",
    "clienteAnonimo": "501",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 348,
    "ticketMedianoSimulado": 345,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 696,
    "maiorPedidoSimulado": 400,
    "menorPedidoSimulado": 232,
    "ticketMedioSimuladoFmt": "R$ 348",
    "ticketMedianoSimuladoFmt": "R$ 345",
    "valorTotalAcumuladoSimuladoFmt": "R$ 696",
    "maiorPedidoSimuladoFmt": "R$ 400",
    "menorPedidoSimuladoFmt": "R$ 232",
    "primeiraCompraSimulada": "09/04/2026",
    "ultimaCompraSimulada": "01/05/2026",
    "diasDesdeUltimaCompraSimulado": 13,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0502"
  },
  {
    "clienteId": "CLI_0503",
    "clienteAnonimo": "502",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 322,
    "ticketMedianoSimulado": 301,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 644,
    "maiorPedidoSimulado": 341,
    "menorPedidoSimulado": 180,
    "ticketMedioSimuladoFmt": "R$ 322",
    "ticketMedianoSimuladoFmt": "R$ 301",
    "valorTotalAcumuladoSimuladoFmt": "R$ 644",
    "maiorPedidoSimuladoFmt": "R$ 341",
    "menorPedidoSimuladoFmt": "R$ 180",
    "primeiraCompraSimulada": "03/04/2026",
    "ultimaCompraSimulada": "24/04/2026",
    "diasDesdeUltimaCompraSimulado": 20,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0503"
  },
  {
    "clienteId": "CLI_0504",
    "clienteAnonimo": "503",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 296,
    "ticketMedianoSimulado": 290,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 592,
    "maiorPedidoSimulado": 335,
    "menorPedidoSimulado": 191,
    "ticketMedioSimuladoFmt": "R$ 296",
    "ticketMedianoSimuladoFmt": "R$ 290",
    "valorTotalAcumuladoSimuladoFmt": "R$ 592",
    "maiorPedidoSimuladoFmt": "R$ 335",
    "menorPedidoSimuladoFmt": "R$ 191",
    "primeiraCompraSimulada": "18/03/2026",
    "ultimaCompraSimulada": "30/04/2026",
    "diasDesdeUltimaCompraSimulado": 14,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0504"
  },
  {
    "clienteId": "CLI_0505",
    "clienteAnonimo": "504",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 291,
    "ticketMedianoSimulado": 276,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 582,
    "maiorPedidoSimulado": 343,
    "menorPedidoSimulado": 204,
    "ticketMedioSimuladoFmt": "R$ 291",
    "ticketMedianoSimuladoFmt": "R$ 276",
    "valorTotalAcumuladoSimuladoFmt": "R$ 582",
    "maiorPedidoSimuladoFmt": "R$ 343",
    "menorPedidoSimuladoFmt": "R$ 204",
    "primeiraCompraSimulada": "02/03/2026",
    "ultimaCompraSimulada": "10/05/2026",
    "diasDesdeUltimaCompraSimulado": 4,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0505"
  },
  {
    "clienteId": "CLI_0506",
    "clienteAnonimo": "505",
    "segmentoComercial": "Cliente possível coletivo",
    "ticketMedioSimulado": 1591,
    "ticketMedianoSimulado": 1534,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 3182,
    "maiorPedidoSimulado": 1731,
    "menorPedidoSimulado": 945,
    "ticketMedioSimuladoFmt": "R$ 1.591",
    "ticketMedianoSimuladoFmt": "R$ 1.534",
    "valorTotalAcumuladoSimuladoFmt": "R$ 3.182",
    "maiorPedidoSimuladoFmt": "R$ 1.731",
    "menorPedidoSimuladoFmt": "R$ 945",
    "primeiraCompraSimulada": "14/02/2026",
    "ultimaCompraSimulada": "19/04/2026",
    "diasDesdeUltimaCompraSimulado": 25,
    "hipoteseDePerfil": "Possível compra coletiva, familiar ampliada ou corporativa. Não afirmar sem confirmação.",
    "objetivoProvavel": "Pode comprar para mais de uma pessoa, família ou equipe",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Tratar como hipótese de compra coletiva — G09 ativo.",
    "alertaSimulacao": "Possível compra familiar, equipe ou coletiva. Confirmar antes de assumir.",
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0506"
  },
  {
    "clienteId": "CLI_0507",
    "clienteAnonimo": "506",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 343,
    "ticketMedianoSimulado": 330,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 686,
    "maiorPedidoSimulado": 378,
    "menorPedidoSimulado": 210,
    "ticketMedioSimuladoFmt": "R$ 343",
    "ticketMedianoSimuladoFmt": "R$ 330",
    "valorTotalAcumuladoSimuladoFmt": "R$ 686",
    "maiorPedidoSimuladoFmt": "R$ 378",
    "menorPedidoSimuladoFmt": "R$ 210",
    "primeiraCompraSimulada": "29/01/2026",
    "ultimaCompraSimulada": "23/03/2026",
    "diasDesdeUltimaCompraSimulado": 52,
    "hipoteseDePerfil": "Compra compatível com abastecimento maior, família ou rotina intensa.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0507"
  },
  {
    "clienteId": "CLI_0508",
    "clienteAnonimo": "507",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 369,
    "ticketMedianoSimulado": 350,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 369,
    "maiorPedidoSimulado": 440,
    "menorPedidoSimulado": 264,
    "ticketMedioSimuladoFmt": "R$ 369",
    "ticketMedianoSimuladoFmt": "R$ 350",
    "valorTotalAcumuladoSimuladoFmt": "R$ 369",
    "maiorPedidoSimuladoFmt": "R$ 440",
    "menorPedidoSimuladoFmt": "R$ 264",
    "primeiraCompraSimulada": "13/01/2026",
    "ultimaCompraSimulada": "07/04/2026",
    "diasDesdeUltimaCompraSimulado": 37,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0508"
  },
  {
    "clienteId": "CLI_0509",
    "clienteAnonimo": "508",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 396,
    "ticketMedianoSimulado": 387,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1188,
    "maiorPedidoSimulado": 442,
    "menorPedidoSimulado": 249,
    "ticketMedioSimuladoFmt": "R$ 396",
    "ticketMedianoSimuladoFmt": "R$ 387",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.188",
    "maiorPedidoSimuladoFmt": "R$ 442",
    "menorPedidoSimuladoFmt": "R$ 249",
    "primeiraCompraSimulada": "28/12/2025",
    "ultimaCompraSimulada": "04/05/2026",
    "diasDesdeUltimaCompraSimulado": 10,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0509"
  },
  {
    "clienteId": "CLI_0510",
    "clienteAnonimo": "509",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 345,
    "ticketMedianoSimulado": 342,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1035,
    "maiorPedidoSimulado": 363,
    "menorPedidoSimulado": 191,
    "ticketMedioSimuladoFmt": "R$ 345",
    "ticketMedianoSimuladoFmt": "R$ 342",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.035",
    "maiorPedidoSimuladoFmt": "R$ 363",
    "menorPedidoSimuladoFmt": "R$ 191",
    "primeiraCompraSimulada": "09/11/2025",
    "ultimaCompraSimulada": "09/02/2026",
    "diasDesdeUltimaCompraSimulado": 94,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0510"
  },
  {
    "clienteId": "CLI_0511",
    "clienteAnonimo": "510",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 371,
    "ticketMedianoSimulado": 342,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 371,
    "maiorPedidoSimulado": 422,
    "menorPedidoSimulado": 242,
    "ticketMedioSimuladoFmt": "R$ 371",
    "ticketMedianoSimuladoFmt": "R$ 342",
    "valorTotalAcumuladoSimuladoFmt": "R$ 371",
    "maiorPedidoSimuladoFmt": "R$ 422",
    "menorPedidoSimuladoFmt": "R$ 242",
    "primeiraCompraSimulada": "02/11/2025",
    "ultimaCompraSimulada": "21/03/2026",
    "diasDesdeUltimaCompraSimulado": 54,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0511"
  },
  {
    "clienteId": "CLI_0512",
    "clienteAnonimo": "511",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 397,
    "ticketMedianoSimulado": 395,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 794,
    "maiorPedidoSimulado": 465,
    "menorPedidoSimulado": 275,
    "ticketMedioSimuladoFmt": "R$ 397",
    "ticketMedianoSimuladoFmt": "R$ 395",
    "valorTotalAcumuladoSimuladoFmt": "R$ 794",
    "maiorPedidoSimuladoFmt": "R$ 465",
    "menorPedidoSimuladoFmt": "R$ 275",
    "primeiraCompraSimulada": "18/11/2025",
    "ultimaCompraSimulada": "05/05/2026",
    "diasDesdeUltimaCompraSimulado": 9,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0512"
  },
  {
    "clienteId": "CLI_0513",
    "clienteAnonimo": "512",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 424,
    "ticketMedianoSimulado": 395,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 848,
    "maiorPedidoSimulado": 459,
    "menorPedidoSimulado": 249,
    "ticketMedioSimuladoFmt": "R$ 424",
    "ticketMedianoSimuladoFmt": "R$ 395",
    "valorTotalAcumuladoSimuladoFmt": "R$ 848",
    "maiorPedidoSimuladoFmt": "R$ 459",
    "menorPedidoSimuladoFmt": "R$ 249",
    "primeiraCompraSimulada": "03/12/2025",
    "ultimaCompraSimulada": "10/04/2026",
    "diasDesdeUltimaCompraSimulado": 34,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0513"
  },
  {
    "clienteId": "CLI_0514",
    "clienteAnonimo": "513",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 450,
    "ticketMedianoSimulado": 441,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 900,
    "maiorPedidoSimulado": 499,
    "menorPedidoSimulado": 278,
    "ticketMedioSimuladoFmt": "R$ 450",
    "ticketMedianoSimuladoFmt": "R$ 441",
    "valorTotalAcumuladoSimuladoFmt": "R$ 900",
    "maiorPedidoSimuladoFmt": "R$ 499",
    "menorPedidoSimuladoFmt": "R$ 278",
    "primeiraCompraSimulada": "19/12/2025",
    "ultimaCompraSimulada": "11/03/2026",
    "diasDesdeUltimaCompraSimulado": 64,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0514"
  },
  {
    "clienteId": "CLI_0515",
    "clienteAnonimo": "514",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 424,
    "ticketMedianoSimulado": 401,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 848,
    "maiorPedidoSimulado": 508,
    "menorPedidoSimulado": 307,
    "ticketMedioSimuladoFmt": "R$ 424",
    "ticketMedianoSimuladoFmt": "R$ 401",
    "valorTotalAcumuladoSimuladoFmt": "R$ 848",
    "maiorPedidoSimuladoFmt": "R$ 508",
    "menorPedidoSimuladoFmt": "R$ 307",
    "primeiraCompraSimulada": "04/01/2026",
    "ultimaCompraSimulada": "29/03/2026",
    "diasDesdeUltimaCompraSimulado": 46,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0515"
  },
  {
    "clienteId": "CLI_0516",
    "clienteAnonimo": "515",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 398,
    "ticketMedianoSimulado": 385,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 796,
    "maiorPedidoSimulado": 442,
    "menorPedidoSimulado": 247,
    "ticketMedioSimuladoFmt": "R$ 398",
    "ticketMedianoSimuladoFmt": "R$ 385",
    "valorTotalAcumuladoSimuladoFmt": "R$ 796",
    "maiorPedidoSimuladoFmt": "R$ 442",
    "menorPedidoSimuladoFmt": "R$ 247",
    "primeiraCompraSimulada": "20/01/2026",
    "ultimaCompraSimulada": "29/04/2026",
    "diasDesdeUltimaCompraSimulado": 15,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0516"
  },
  {
    "clienteId": "CLI_0517",
    "clienteAnonimo": "516",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 372,
    "ticketMedianoSimulado": 357,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 744,
    "maiorPedidoSimulado": 401,
    "menorPedidoSimulado": 217,
    "ticketMedioSimuladoFmt": "R$ 372",
    "ticketMedianoSimuladoFmt": "R$ 357",
    "valorTotalAcumuladoSimuladoFmt": "R$ 744",
    "maiorPedidoSimuladoFmt": "R$ 401",
    "menorPedidoSimuladoFmt": "R$ 217",
    "primeiraCompraSimulada": "05/02/2026",
    "ultimaCompraSimulada": "30/04/2026",
    "diasDesdeUltimaCompraSimulado": 14,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0517"
  },
  {
    "clienteId": "CLI_0518",
    "clienteAnonimo": "517",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 345,
    "ticketMedianoSimulado": 328,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 345,
    "maiorPedidoSimulado": 403,
    "menorPedidoSimulado": 238,
    "ticketMedioSimuladoFmt": "R$ 345",
    "ticketMedianoSimuladoFmt": "R$ 328",
    "valorTotalAcumuladoSimuladoFmt": "R$ 345",
    "maiorPedidoSimuladoFmt": "R$ 403",
    "menorPedidoSimuladoFmt": "R$ 238",
    "primeiraCompraSimulada": "21/02/2026",
    "ultimaCompraSimulada": "13/04/2026",
    "diasDesdeUltimaCompraSimulado": 31,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0518"
  },
  {
    "clienteId": "CLI_0519",
    "clienteAnonimo": "518",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 319,
    "ticketMedianoSimulado": 311,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 957,
    "maiorPedidoSimulado": 364,
    "menorPedidoSimulado": 209,
    "ticketMedioSimuladoFmt": "R$ 319",
    "ticketMedianoSimuladoFmt": "R$ 311",
    "valorTotalAcumuladoSimuladoFmt": "R$ 957",
    "maiorPedidoSimuladoFmt": "R$ 364",
    "menorPedidoSimuladoFmt": "R$ 209",
    "primeiraCompraSimulada": "09/03/2026",
    "ultimaCompraSimulada": "15/04/2026",
    "diasDesdeUltimaCompraSimulado": 29,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0519"
  },
  {
    "clienteId": "CLI_0520",
    "clienteAnonimo": "519",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 370,
    "ticketMedianoSimulado": 365,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1110,
    "maiorPedidoSimulado": 398,
    "menorPedidoSimulado": 214,
    "ticketMedioSimuladoFmt": "R$ 370",
    "ticketMedianoSimuladoFmt": "R$ 365",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.110",
    "maiorPedidoSimuladoFmt": "R$ 398",
    "menorPedidoSimuladoFmt": "R$ 214",
    "primeiraCompraSimulada": "01/04/2026",
    "ultimaCompraSimulada": "05/05/2026",
    "diasDesdeUltimaCompraSimulado": 9,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0520"
  },
  {
    "clienteId": "CLI_0521",
    "clienteAnonimo": "520",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 344,
    "ticketMedianoSimulado": 318,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 344,
    "maiorPedidoSimulado": 383,
    "menorPedidoSimulado": 215,
    "ticketMedioSimuladoFmt": "R$ 344",
    "ticketMedianoSimuladoFmt": "R$ 318",
    "valorTotalAcumuladoSimuladoFmt": "R$ 344",
    "maiorPedidoSimuladoFmt": "R$ 383",
    "menorPedidoSimuladoFmt": "R$ 215",
    "primeiraCompraSimulada": "16/03/2026",
    "ultimaCompraSimulada": "20/04/2026",
    "diasDesdeUltimaCompraSimulado": 24,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0521"
  },
  {
    "clienteId": "CLI_0522",
    "clienteAnonimo": "521",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 317,
    "ticketMedianoSimulado": 316,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 951,
    "maiorPedidoSimulado": 379,
    "menorPedidoSimulado": 228,
    "ticketMedioSimuladoFmt": "R$ 317",
    "ticketMedianoSimuladoFmt": "R$ 316",
    "valorTotalAcumuladoSimuladoFmt": "R$ 951",
    "maiorPedidoSimuladoFmt": "R$ 379",
    "menorPedidoSimuladoFmt": "R$ 228",
    "primeiraCompraSimulada": "28/02/2026",
    "ultimaCompraSimulada": "12/04/2026",
    "diasDesdeUltimaCompraSimulado": 32,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0522"
  },
  {
    "clienteId": "CLI_0523",
    "clienteAnonimo": "522",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 291,
    "ticketMedianoSimulado": 270,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 582,
    "maiorPedidoSimulado": 322,
    "menorPedidoSimulado": 179,
    "ticketMedioSimuladoFmt": "R$ 291",
    "ticketMedianoSimuladoFmt": "R$ 270",
    "valorTotalAcumuladoSimuladoFmt": "R$ 582",
    "maiorPedidoSimuladoFmt": "R$ 322",
    "menorPedidoSimuladoFmt": "R$ 179",
    "primeiraCompraSimulada": "12/02/2026",
    "ultimaCompraSimulada": "26/04/2026",
    "diasDesdeUltimaCompraSimulado": 18,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0523"
  },
  {
    "clienteId": "CLI_0524",
    "clienteAnonimo": "523",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 295,
    "ticketMedianoSimulado": 290,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 590,
    "maiorPedidoSimulado": 320,
    "menorPedidoSimulado": 174,
    "ticketMedioSimuladoFmt": "R$ 295",
    "ticketMedianoSimuladoFmt": "R$ 290",
    "valorTotalAcumuladoSimuladoFmt": "R$ 590",
    "maiorPedidoSimuladoFmt": "R$ 320",
    "menorPedidoSimuladoFmt": "R$ 174",
    "primeiraCompraSimulada": "27/01/2026",
    "ultimaCompraSimulada": "04/05/2026",
    "diasDesdeUltimaCompraSimulado": 10,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0524"
  },
  {
    "clienteId": "CLI_0525",
    "clienteAnonimo": "524",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 321,
    "ticketMedianoSimulado": 303,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 642,
    "maiorPedidoSimulado": 377,
    "menorPedidoSimulado": 224,
    "ticketMedioSimuladoFmt": "R$ 321",
    "ticketMedianoSimuladoFmt": "R$ 303",
    "valorTotalAcumuladoSimuladoFmt": "R$ 642",
    "maiorPedidoSimuladoFmt": "R$ 377",
    "menorPedidoSimuladoFmt": "R$ 224",
    "primeiraCompraSimulada": "11/01/2026",
    "ultimaCompraSimulada": "05/04/2026",
    "diasDesdeUltimaCompraSimulado": 39,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0525"
  },
  {
    "clienteId": "CLI_0526",
    "clienteAnonimo": "525",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 348,
    "ticketMedianoSimulado": 337,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 696,
    "maiorPedidoSimulado": 395,
    "menorPedidoSimulado": 226,
    "ticketMedioSimuladoFmt": "R$ 348",
    "ticketMedianoSimuladoFmt": "R$ 337",
    "valorTotalAcumuladoSimuladoFmt": "R$ 696",
    "maiorPedidoSimuladoFmt": "R$ 395",
    "menorPedidoSimuladoFmt": "R$ 226",
    "primeiraCompraSimulada": "26/12/2025",
    "ultimaCompraSimulada": "08/03/2026",
    "diasDesdeUltimaCompraSimulado": 67,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0526"
  },
  {
    "clienteId": "CLI_0527",
    "clienteAnonimo": "526",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 374,
    "ticketMedianoSimulado": 358,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 748,
    "maiorPedidoSimulado": 395,
    "menorPedidoSimulado": 208,
    "ticketMedioSimuladoFmt": "R$ 374",
    "ticketMedianoSimuladoFmt": "R$ 358",
    "valorTotalAcumuladoSimuladoFmt": "R$ 748",
    "maiorPedidoSimuladoFmt": "R$ 395",
    "menorPedidoSimuladoFmt": "R$ 208",
    "primeiraCompraSimulada": "10/12/2025",
    "ultimaCompraSimulada": "04/04/2026",
    "diasDesdeUltimaCompraSimulado": 40,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0527"
  },
  {
    "clienteId": "CLI_0528",
    "clienteAnonimo": "527",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 400,
    "ticketMedianoSimulado": 382,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 400,
    "maiorPedidoSimulado": 458,
    "menorPedidoSimulado": 265,
    "ticketMedioSimuladoFmt": "R$ 400",
    "ticketMedianoSimuladoFmt": "R$ 382",
    "valorTotalAcumuladoSimuladoFmt": "R$ 400",
    "maiorPedidoSimuladoFmt": "R$ 458",
    "menorPedidoSimuladoFmt": "R$ 265",
    "primeiraCompraSimulada": "24/11/2025",
    "ultimaCompraSimulada": "09/05/2026",
    "diasDesdeUltimaCompraSimulado": 5,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0528"
  },
  {
    "clienteId": "CLI_0529",
    "clienteAnonimo": "528",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 426,
    "ticketMedianoSimulado": 414,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1278,
    "maiorPedidoSimulado": 496,
    "menorPedidoSimulado": 291,
    "ticketMedioSimuladoFmt": "R$ 426",
    "ticketMedianoSimuladoFmt": "R$ 414",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.278",
    "maiorPedidoSimuladoFmt": "R$ 496",
    "menorPedidoSimuladoFmt": "R$ 291",
    "primeiraCompraSimulada": "09/11/2025",
    "ultimaCompraSimulada": "31/03/2026",
    "diasDesdeUltimaCompraSimulado": 44,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0529"
  },
  {
    "clienteId": "CLI_0530",
    "clienteAnonimo": "529",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 375,
    "ticketMedianoSimulado": 369,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1125,
    "maiorPedidoSimulado": 412,
    "menorPedidoSimulado": 228,
    "ticketMedioSimuladoFmt": "R$ 375",
    "ticketMedianoSimuladoFmt": "R$ 369",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.125",
    "maiorPedidoSimuladoFmt": "R$ 412",
    "menorPedidoSimuladoFmt": "R$ 228",
    "primeiraCompraSimulada": "05/12/2025",
    "ultimaCompraSimulada": "06/04/2026",
    "diasDesdeUltimaCompraSimulado": 38,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0530"
  },
  {
    "clienteId": "CLI_0531",
    "clienteAnonimo": "530",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 402,
    "ticketMedianoSimulado": 373,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 402,
    "maiorPedidoSimulado": 439,
    "menorPedidoSimulado": 241,
    "ticketMedioSimuladoFmt": "R$ 402",
    "ticketMedianoSimuladoFmt": "R$ 373",
    "valorTotalAcumuladoSimuladoFmt": "R$ 402",
    "maiorPedidoSimuladoFmt": "R$ 439",
    "menorPedidoSimuladoFmt": "R$ 241",
    "primeiraCompraSimulada": "21/12/2025",
    "ultimaCompraSimulada": "10/05/2026",
    "diasDesdeUltimaCompraSimulado": 4,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0531"
  },
  {
    "clienteId": "CLI_0532",
    "clienteAnonimo": "531",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 428,
    "ticketMedianoSimulado": 428,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1284,
    "maiorPedidoSimulado": 506,
    "menorPedidoSimulado": 301,
    "ticketMedioSimuladoFmt": "R$ 428",
    "ticketMedianoSimuladoFmt": "R$ 428",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.284",
    "maiorPedidoSimuladoFmt": "R$ 506",
    "menorPedidoSimuladoFmt": "R$ 301",
    "primeiraCompraSimulada": "06/01/2026",
    "ultimaCompraSimulada": "11/04/2026",
    "diasDesdeUltimaCompraSimulado": 33,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0532"
  },
  {
    "clienteId": "CLI_0533",
    "clienteAnonimo": "532",
    "segmentoComercial": "Cliente possível coletivo",
    "ticketMedioSimulado": 2956,
    "ticketMedianoSimulado": 2740,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 5912,
    "maiorPedidoSimulado": 3334,
    "menorPedidoSimulado": 1895,
    "ticketMedioSimuladoFmt": "R$ 2.956",
    "ticketMedianoSimuladoFmt": "R$ 2.740",
    "valorTotalAcumuladoSimuladoFmt": "R$ 5.912",
    "maiorPedidoSimuladoFmt": "R$ 3.334",
    "menorPedidoSimuladoFmt": "R$ 1.895",
    "primeiraCompraSimulada": "22/01/2026",
    "ultimaCompraSimulada": "21/03/2026",
    "diasDesdeUltimaCompraSimulado": 54,
    "hipoteseDePerfil": "Possível compra coletiva, familiar ampliada ou corporativa. Não afirmar sem confirmação.",
    "objetivoProvavel": "Pode comprar para mais de uma pessoa, família ou equipe",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Tratar como hipótese de compra coletiva — G09 ativo.",
    "alertaSimulacao": "Possível compra familiar, equipe ou coletiva. Confirmar antes de assumir.",
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0533"
  },
  {
    "clienteId": "CLI_0534",
    "clienteAnonimo": "533",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 420,
    "ticketMedianoSimulado": 414,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 840,
    "maiorPedidoSimulado": 446,
    "menorPedidoSimulado": 237,
    "ticketMedioSimuladoFmt": "R$ 420",
    "ticketMedianoSimuladoFmt": "R$ 414",
    "valorTotalAcumuladoSimuladoFmt": "R$ 840",
    "maiorPedidoSimuladoFmt": "R$ 446",
    "menorPedidoSimuladoFmt": "R$ 237",
    "primeiraCompraSimulada": "07/02/2026",
    "ultimaCompraSimulada": "13/04/2026",
    "diasDesdeUltimaCompraSimulado": 31,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0534"
  },
  {
    "clienteId": "CLI_0535",
    "clienteAnonimo": "534",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 393,
    "ticketMedianoSimulado": 370,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 786,
    "maiorPedidoSimulado": 453,
    "menorPedidoSimulado": 263,
    "ticketMedioSimuladoFmt": "R$ 393",
    "ticketMedianoSimuladoFmt": "R$ 370",
    "valorTotalAcumuladoSimuladoFmt": "R$ 786",
    "maiorPedidoSimuladoFmt": "R$ 453",
    "menorPedidoSimuladoFmt": "R$ 263",
    "primeiraCompraSimulada": "23/02/2026",
    "ultimaCompraSimulada": "06/05/2026",
    "diasDesdeUltimaCompraSimulado": 8,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0535"
  },
  {
    "clienteId": "CLI_0536",
    "clienteAnonimo": "535",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 367,
    "ticketMedianoSimulado": 357,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 734,
    "maiorPedidoSimulado": 425,
    "menorPedidoSimulado": 248,
    "ticketMedioSimuladoFmt": "R$ 367",
    "ticketMedianoSimuladoFmt": "R$ 357",
    "valorTotalAcumuladoSimuladoFmt": "R$ 734",
    "maiorPedidoSimuladoFmt": "R$ 425",
    "menorPedidoSimuladoFmt": "R$ 248",
    "primeiraCompraSimulada": "11/03/2026",
    "ultimaCompraSimulada": "01/05/2026",
    "diasDesdeUltimaCompraSimulado": 13,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0536"
  },
  {
    "clienteId": "CLI_0537",
    "clienteAnonimo": "536",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 341,
    "ticketMedianoSimulado": 326,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 682,
    "maiorPedidoSimulado": 364,
    "menorPedidoSimulado": 194,
    "ticketMedioSimuladoFmt": "R$ 341",
    "ticketMedianoSimuladoFmt": "R$ 326",
    "valorTotalAcumuladoSimuladoFmt": "R$ 682",
    "maiorPedidoSimuladoFmt": "R$ 364",
    "menorPedidoSimuladoFmt": "R$ 194",
    "primeiraCompraSimulada": "27/03/2026",
    "ultimaCompraSimulada": "23/04/2026",
    "diasDesdeUltimaCompraSimulado": 21,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0537"
  },
  {
    "clienteId": "CLI_0538",
    "clienteAnonimo": "537",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 315,
    "ticketMedianoSimulado": 302,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 630,
    "maiorPedidoSimulado": 354,
    "menorPedidoSimulado": 200,
    "ticketMedioSimuladoFmt": "R$ 315",
    "ticketMedianoSimuladoFmt": "R$ 302",
    "valorTotalAcumuladoSimuladoFmt": "R$ 630",
    "maiorPedidoSimuladoFmt": "R$ 354",
    "menorPedidoSimuladoFmt": "R$ 200",
    "primeiraCompraSimulada": "12/04/2026",
    "ultimaCompraSimulada": "30/04/2026",
    "diasDesdeUltimaCompraSimulado": 14,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0538"
  },
  {
    "clienteId": "CLI_0539",
    "clienteAnonimo": "538",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 289,
    "ticketMedianoSimulado": 280,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 867,
    "maiorPedidoSimulado": 343,
    "menorPedidoSimulado": 205,
    "ticketMedioSimuladoFmt": "R$ 289",
    "ticketMedianoSimuladoFmt": "R$ 280",
    "valorTotalAcumuladoSimuladoFmt": "R$ 867",
    "maiorPedidoSimuladoFmt": "R$ 343",
    "menorPedidoSimuladoFmt": "R$ 205",
    "primeiraCompraSimulada": "31/03/2026",
    "ultimaCompraSimulada": "05/05/2026",
    "diasDesdeUltimaCompraSimulado": 9,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0539"
  },
  {
    "clienteId": "CLI_0540",
    "clienteAnonimo": "539",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 339,
    "ticketMedianoSimulado": 333,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1017,
    "maiorPedidoSimulado": 380,
    "menorPedidoSimulado": 215,
    "ticketMedioSimuladoFmt": "R$ 339",
    "ticketMedianoSimuladoFmt": "R$ 333",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.017",
    "maiorPedidoSimuladoFmt": "R$ 380",
    "menorPedidoSimuladoFmt": "R$ 215",
    "primeiraCompraSimulada": "11/02/2026",
    "ultimaCompraSimulada": "04/04/2026",
    "diasDesdeUltimaCompraSimulado": 40,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0540"
  },
  {
    "clienteId": "CLI_0541",
    "clienteAnonimo": "540",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 313,
    "ticketMedianoSimulado": 291,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 313,
    "maiorPedidoSimulado": 334,
    "menorPedidoSimulado": 179,
    "ticketMedioSimuladoFmt": "R$ 313",
    "ticketMedianoSimuladoFmt": "R$ 291",
    "valorTotalAcumuladoSimuladoFmt": "R$ 313",
    "maiorPedidoSimuladoFmt": "R$ 334",
    "menorPedidoSimuladoFmt": "R$ 179",
    "primeiraCompraSimulada": "26/01/2026",
    "ultimaCompraSimulada": "04/04/2026",
    "diasDesdeUltimaCompraSimulado": 40,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0541"
  },
  {
    "clienteId": "CLI_0542",
    "clienteAnonimo": "541",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 287,
    "ticketMedianoSimulado": 286,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 861,
    "maiorPedidoSimulado": 333,
    "menorPedidoSimulado": 194,
    "ticketMedioSimuladoFmt": "R$ 287",
    "ticketMedianoSimuladoFmt": "R$ 286",
    "valorTotalAcumuladoSimuladoFmt": "R$ 861",
    "maiorPedidoSimuladoFmt": "R$ 333",
    "menorPedidoSimuladoFmt": "R$ 194",
    "primeiraCompraSimulada": "10/01/2026",
    "ultimaCompraSimulada": "26/04/2026",
    "diasDesdeUltimaCompraSimulado": 18,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0542"
  },
  {
    "clienteId": "CLI_0543",
    "clienteAnonimo": "542",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 299,
    "ticketMedianoSimulado": 276,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 299,
    "maiorPedidoSimulado": 344,
    "menorPedidoSimulado": 200,
    "ticketMedioSimuladoFmt": "R$ 299",
    "ticketMedianoSimuladoFmt": "R$ 276",
    "valorTotalAcumuladoSimuladoFmt": "R$ 299",
    "maiorPedidoSimuladoFmt": "R$ 344",
    "menorPedidoSimuladoFmt": "R$ 200",
    "primeiraCompraSimulada": "25/12/2025",
    "ultimaCompraSimulada": "26/04/2026",
    "diasDesdeUltimaCompraSimulado": 18,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0543"
  },
  {
    "clienteId": "CLI_0544",
    "clienteAnonimo": "543",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 326,
    "ticketMedianoSimulado": 322,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 652,
    "maiorPedidoSimulado": 346,
    "menorPedidoSimulado": 183,
    "ticketMedioSimuladoFmt": "R$ 326",
    "ticketMedianoSimuladoFmt": "R$ 322",
    "valorTotalAcumuladoSimuladoFmt": "R$ 652",
    "maiorPedidoSimuladoFmt": "R$ 346",
    "menorPedidoSimuladoFmt": "R$ 183",
    "primeiraCompraSimulada": "09/12/2025",
    "ultimaCompraSimulada": "20/03/2026",
    "diasDesdeUltimaCompraSimulado": 55,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0544"
  },
  {
    "clienteId": "CLI_0545",
    "clienteAnonimo": "544",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 352,
    "ticketMedianoSimulado": 330,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 704,
    "maiorPedidoSimulado": 398,
    "menorPedidoSimulado": 226,
    "ticketMedioSimuladoFmt": "R$ 352",
    "ticketMedianoSimuladoFmt": "R$ 330",
    "valorTotalAcumuladoSimuladoFmt": "R$ 704",
    "maiorPedidoSimuladoFmt": "R$ 398",
    "menorPedidoSimuladoFmt": "R$ 226",
    "primeiraCompraSimulada": "23/11/2025",
    "ultimaCompraSimulada": "28/02/2026",
    "diasDesdeUltimaCompraSimulado": 75,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0545"
  },
  {
    "clienteId": "CLI_0546",
    "clienteAnonimo": "545",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 378,
    "ticketMedianoSimulado": 368,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 756,
    "maiorPedidoSimulado": 446,
    "menorPedidoSimulado": 265,
    "ticketMedioSimuladoFmt": "R$ 378",
    "ticketMedianoSimuladoFmt": "R$ 368",
    "valorTotalAcumuladoSimuladoFmt": "R$ 756",
    "maiorPedidoSimuladoFmt": "R$ 446",
    "menorPedidoSimuladoFmt": "R$ 265",
    "primeiraCompraSimulada": "07/11/2025",
    "ultimaCompraSimulada": "05/04/2026",
    "diasDesdeUltimaCompraSimulado": 39,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0546"
  },
  {
    "clienteId": "CLI_0547",
    "clienteAnonimo": "546",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 404,
    "ticketMedianoSimulado": 385,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 808,
    "maiorPedidoSimulado": 440,
    "menorPedidoSimulado": 241,
    "ticketMedioSimuladoFmt": "R$ 404",
    "ticketMedianoSimuladoFmt": "R$ 385",
    "valorTotalAcumuladoSimuladoFmt": "R$ 808",
    "maiorPedidoSimuladoFmt": "R$ 440",
    "menorPedidoSimuladoFmt": "R$ 241",
    "primeiraCompraSimulada": "04/11/2025",
    "ultimaCompraSimulada": "05/05/2026",
    "diasDesdeUltimaCompraSimulado": 9,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0547"
  },
  {
    "clienteId": "CLI_0548",
    "clienteAnonimo": "547",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 431,
    "ticketMedianoSimulado": 414,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 862,
    "maiorPedidoSimulado": 474,
    "menorPedidoSimulado": 262,
    "ticketMedioSimuladoFmt": "R$ 431",
    "ticketMedianoSimuladoFmt": "R$ 414",
    "valorTotalAcumuladoSimuladoFmt": "R$ 862",
    "maiorPedidoSimuladoFmt": "R$ 474",
    "menorPedidoSimuladoFmt": "R$ 262",
    "primeiraCompraSimulada": "20/11/2025",
    "ultimaCompraSimulada": "26/03/2026",
    "diasDesdeUltimaCompraSimulado": 49,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0548"
  },
  {
    "clienteId": "CLI_0549",
    "clienteAnonimo": "548",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 443,
    "ticketMedianoSimulado": 429,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1329,
    "maiorPedidoSimulado": 527,
    "menorPedidoSimulado": 316,
    "ticketMedioSimuladoFmt": "R$ 443",
    "ticketMedianoSimuladoFmt": "R$ 429",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.329",
    "maiorPedidoSimuladoFmt": "R$ 527",
    "menorPedidoSimuladoFmt": "R$ 316",
    "primeiraCompraSimulada": "06/12/2025",
    "ultimaCompraSimulada": "22/02/2026",
    "diasDesdeUltimaCompraSimulado": 81,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0549"
  },
  {
    "clienteId": "CLI_0550",
    "clienteAnonimo": "549",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 406,
    "ticketMedianoSimulado": 398,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1218,
    "maiorPedidoSimulado": 465,
    "menorPedidoSimulado": 268,
    "ticketMedioSimuladoFmt": "R$ 406",
    "ticketMedianoSimuladoFmt": "R$ 398",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.218",
    "maiorPedidoSimuladoFmt": "R$ 465",
    "menorPedidoSimuladoFmt": "R$ 268",
    "primeiraCompraSimulada": "23/01/2026",
    "ultimaCompraSimulada": "05/05/2026",
    "diasDesdeUltimaCompraSimulado": 9,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0550"
  },
  {
    "clienteId": "CLI_0551",
    "clienteAnonimo": "550",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 432,
    "ticketMedianoSimulado": 403,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 432,
    "maiorPedidoSimulado": 456,
    "menorPedidoSimulado": 240,
    "ticketMedioSimuladoFmt": "R$ 432",
    "ticketMedianoSimuladoFmt": "R$ 403",
    "valorTotalAcumuladoSimuladoFmt": "R$ 432",
    "maiorPedidoSimuladoFmt": "R$ 456",
    "menorPedidoSimuladoFmt": "R$ 240",
    "primeiraCompraSimulada": "08/02/2026",
    "ultimaCompraSimulada": "15/04/2026",
    "diasDesdeUltimaCompraSimulado": 29,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0551"
  },
  {
    "clienteId": "CLI_0552",
    "clienteAnonimo": "551",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 441,
    "ticketMedianoSimulado": 439,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1323,
    "maiorPedidoSimulado": 501,
    "menorPedidoSimulado": 287,
    "ticketMedioSimuladoFmt": "R$ 441",
    "ticketMedianoSimuladoFmt": "R$ 439",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.323",
    "maiorPedidoSimuladoFmt": "R$ 501",
    "menorPedidoSimuladoFmt": "R$ 287",
    "primeiraCompraSimulada": "24/02/2026",
    "ultimaCompraSimulada": "04/04/2026",
    "diasDesdeUltimaCompraSimulado": 40,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0552"
  },
  {
    "clienteId": "CLI_0553",
    "clienteAnonimo": "552",
    "segmentoComercial": "Cliente possível coletivo",
    "ticketMedioSimulado": 2632,
    "ticketMedianoSimulado": 2426,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 5264,
    "maiorPedidoSimulado": 3091,
    "menorPedidoSimulado": 1829,
    "ticketMedioSimuladoFmt": "R$ 2.632",
    "ticketMedianoSimuladoFmt": "R$ 2.426",
    "valorTotalAcumuladoSimuladoFmt": "R$ 5.264",
    "maiorPedidoSimuladoFmt": "R$ 3.091",
    "menorPedidoSimuladoFmt": "R$ 1.829",
    "primeiraCompraSimulada": "12/03/2026",
    "ultimaCompraSimulada": "26/04/2026",
    "diasDesdeUltimaCompraSimulado": 18,
    "hipoteseDePerfil": "Possível compra coletiva, familiar ampliada ou corporativa. Não afirmar sem confirmação.",
    "objetivoProvavel": "Pode comprar para mais de uma pessoa, família ou equipe",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Tratar como hipótese de compra coletiva — G09 ativo.",
    "alertaSimulacao": "Possível compra familiar, equipe ou coletiva. Confirmar antes de assumir.",
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0553"
  },
  {
    "clienteId": "CLI_0554",
    "clienteAnonimo": "553",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 389,
    "ticketMedianoSimulado": 386,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 778,
    "maiorPedidoSimulado": 422,
    "menorPedidoSimulado": 229,
    "ticketMedioSimuladoFmt": "R$ 389",
    "ticketMedianoSimuladoFmt": "R$ 386",
    "valorTotalAcumuladoSimuladoFmt": "R$ 778",
    "maiorPedidoSimuladoFmt": "R$ 422",
    "menorPedidoSimuladoFmt": "R$ 229",
    "primeiraCompraSimulada": "28/03/2026",
    "ultimaCompraSimulada": "10/05/2026",
    "diasDesdeUltimaCompraSimulado": 4,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0554"
  },
  {
    "clienteId": "CLI_0555",
    "clienteAnonimo": "554",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 363,
    "ticketMedianoSimulado": 340,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 726,
    "maiorPedidoSimulado": 402,
    "menorPedidoSimulado": 223,
    "ticketMedioSimuladoFmt": "R$ 363",
    "ticketMedianoSimuladoFmt": "R$ 340",
    "valorTotalAcumuladoSimuladoFmt": "R$ 726",
    "maiorPedidoSimuladoFmt": "R$ 402",
    "menorPedidoSimuladoFmt": "R$ 223",
    "primeiraCompraSimulada": "13/04/2026",
    "ultimaCompraSimulada": "05/05/2026",
    "diasDesdeUltimaCompraSimulado": 9,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0555"
  },
  {
    "clienteId": "CLI_0556",
    "clienteAnonimo": "555",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 337,
    "ticketMedianoSimulado": 329,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 674,
    "maiorPedidoSimulado": 403,
    "menorPedidoSimulado": 243,
    "ticketMedioSimuladoFmt": "R$ 337",
    "ticketMedianoSimuladoFmt": "R$ 329",
    "valorTotalAcumuladoSimuladoFmt": "R$ 674",
    "maiorPedidoSimuladoFmt": "R$ 403",
    "menorPedidoSimuladoFmt": "R$ 243",
    "primeiraCompraSimulada": "30/03/2026",
    "ultimaCompraSimulada": "22/04/2026",
    "diasDesdeUltimaCompraSimulado": 22,
    "hipoteseDePerfil": "Compra compatível com abastecimento maior, família ou rotina intensa.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0556"
  },
  {
    "clienteId": "CLI_0557",
    "clienteAnonimo": "556",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 310,
    "ticketMedianoSimulado": 295,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 620,
    "maiorPedidoSimulado": 345,
    "menorPedidoSimulado": 193,
    "ticketMedioSimuladoFmt": "R$ 310",
    "ticketMedianoSimuladoFmt": "R$ 295",
    "valorTotalAcumuladoSimuladoFmt": "R$ 620",
    "maiorPedidoSimuladoFmt": "R$ 345",
    "menorPedidoSimuladoFmt": "R$ 193",
    "primeiraCompraSimulada": "14/03/2026",
    "ultimaCompraSimulada": "22/04/2026",
    "diasDesdeUltimaCompraSimulado": 22,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0557"
  },
  {
    "clienteId": "CLI_0558",
    "clienteAnonimo": "557",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 284,
    "ticketMedianoSimulado": 273,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 568,
    "maiorPedidoSimulado": 306,
    "menorPedidoSimulado": 165,
    "ticketMedioSimuladoFmt": "R$ 284",
    "ticketMedianoSimuladoFmt": "R$ 273",
    "valorTotalAcumuladoSimuladoFmt": "R$ 568",
    "maiorPedidoSimuladoFmt": "R$ 306",
    "menorPedidoSimuladoFmt": "R$ 165",
    "primeiraCompraSimulada": "26/02/2026",
    "ultimaCompraSimulada": "04/05/2026",
    "diasDesdeUltimaCompraSimulado": 10,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0558"
  },
  {
    "clienteId": "CLI_0559",
    "clienteAnonimo": "558",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 302,
    "ticketMedianoSimulado": 291,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 906,
    "maiorPedidoSimulado": 352,
    "menorPedidoSimulado": 207,
    "ticketMedioSimuladoFmt": "R$ 302",
    "ticketMedianoSimuladoFmt": "R$ 291",
    "valorTotalAcumuladoSimuladoFmt": "R$ 906",
    "maiorPedidoSimuladoFmt": "R$ 352",
    "menorPedidoSimuladoFmt": "R$ 207",
    "primeiraCompraSimulada": "10/02/2026",
    "ultimaCompraSimulada": "29/04/2026",
    "diasDesdeUltimaCompraSimulado": 15,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0559"
  },
  {
    "clienteId": "CLI_0560",
    "clienteAnonimo": "559",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 309,
    "ticketMedianoSimulado": 302,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 927,
    "maiorPedidoSimulado": 361,
    "menorPedidoSimulado": 212,
    "ticketMedioSimuladoFmt": "R$ 309",
    "ticketMedianoSimuladoFmt": "R$ 302",
    "valorTotalAcumuladoSimuladoFmt": "R$ 927",
    "maiorPedidoSimuladoFmt": "R$ 361",
    "menorPedidoSimuladoFmt": "R$ 212",
    "primeiraCompraSimulada": "24/12/2025",
    "ultimaCompraSimulada": "29/03/2026",
    "diasDesdeUltimaCompraSimulado": 46,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0560"
  },
  {
    "clienteId": "CLI_0561",
    "clienteAnonimo": "560",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 282,
    "ticketMedianoSimulado": 264,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 282,
    "maiorPedidoSimulado": 304,
    "menorPedidoSimulado": 164,
    "ticketMedioSimuladoFmt": "R$ 282",
    "ticketMedianoSimuladoFmt": "R$ 264",
    "valorTotalAcumuladoSimuladoFmt": "R$ 282",
    "maiorPedidoSimuladoFmt": "R$ 304",
    "menorPedidoSimuladoFmt": "R$ 164",
    "primeiraCompraSimulada": "08/12/2025",
    "ultimaCompraSimulada": "29/04/2026",
    "diasDesdeUltimaCompraSimulado": 15,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0561"
  },
  {
    "clienteId": "CLI_0562",
    "clienteAnonimo": "561",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 304,
    "ticketMedianoSimulado": 302,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 912,
    "maiorPedidoSimulado": 338,
    "menorPedidoSimulado": 189,
    "ticketMedioSimuladoFmt": "R$ 304",
    "ticketMedianoSimuladoFmt": "R$ 302",
    "valorTotalAcumuladoSimuladoFmt": "R$ 912",
    "maiorPedidoSimuladoFmt": "R$ 338",
    "menorPedidoSimuladoFmt": "R$ 189",
    "primeiraCompraSimulada": "22/11/2025",
    "ultimaCompraSimulada": "15/04/2026",
    "diasDesdeUltimaCompraSimulado": 29,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0562"
  },
  {
    "clienteId": "CLI_0563",
    "clienteAnonimo": "562",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 330,
    "ticketMedianoSimulado": 304,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 330,
    "maiorPedidoSimulado": 395,
    "menorPedidoSimulado": 238,
    "ticketMedioSimuladoFmt": "R$ 330",
    "ticketMedianoSimuladoFmt": "R$ 304",
    "valorTotalAcumuladoSimuladoFmt": "R$ 330",
    "maiorPedidoSimuladoFmt": "R$ 395",
    "menorPedidoSimuladoFmt": "R$ 238",
    "primeiraCompraSimulada": "06/11/2025",
    "ultimaCompraSimulada": "01/03/2026",
    "diasDesdeUltimaCompraSimulado": 74,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0563"
  },
  {
    "clienteId": "CLI_0564",
    "clienteAnonimo": "563",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 356,
    "ticketMedianoSimulado": 354,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 712,
    "maiorPedidoSimulado": 394,
    "menorPedidoSimulado": 220,
    "ticketMedioSimuladoFmt": "R$ 356",
    "ticketMedianoSimuladoFmt": "R$ 354",
    "valorTotalAcumuladoSimuladoFmt": "R$ 712",
    "maiorPedidoSimuladoFmt": "R$ 394",
    "menorPedidoSimuladoFmt": "R$ 220",
    "primeiraCompraSimulada": "05/11/2025",
    "ultimaCompraSimulada": "28/02/2026",
    "diasDesdeUltimaCompraSimulado": 75,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0564"
  },
  {
    "clienteId": "CLI_0565",
    "clienteAnonimo": "564",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 382,
    "ticketMedianoSimulado": 357,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 764,
    "maiorPedidoSimulado": 414,
    "menorPedidoSimulado": 225,
    "ticketMedioSimuladoFmt": "R$ 382",
    "ticketMedianoSimuladoFmt": "R$ 357",
    "valorTotalAcumuladoSimuladoFmt": "R$ 764",
    "maiorPedidoSimuladoFmt": "R$ 414",
    "menorPedidoSimuladoFmt": "R$ 225",
    "primeiraCompraSimulada": "21/11/2025",
    "ultimaCompraSimulada": "15/04/2026",
    "diasDesdeUltimaCompraSimulado": 29,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0565"
  },
  {
    "clienteId": "CLI_0566",
    "clienteAnonimo": "565",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 409,
    "ticketMedianoSimulado": 400,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 818,
    "maiorPedidoSimulado": 480,
    "menorPedidoSimulado": 284,
    "ticketMedioSimuladoFmt": "R$ 409",
    "ticketMedianoSimuladoFmt": "R$ 400",
    "valorTotalAcumuladoSimuladoFmt": "R$ 818",
    "maiorPedidoSimuladoFmt": "R$ 480",
    "menorPedidoSimuladoFmt": "R$ 284",
    "primeiraCompraSimulada": "07/12/2025",
    "ultimaCompraSimulada": "29/04/2026",
    "diasDesdeUltimaCompraSimulado": 15,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0566"
  },
  {
    "clienteId": "CLI_0567",
    "clienteAnonimo": "566",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 435,
    "ticketMedianoSimulado": 412,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 870,
    "maiorPedidoSimulado": 494,
    "menorPedidoSimulado": 283,
    "ticketMedioSimuladoFmt": "R$ 435",
    "ticketMedianoSimuladoFmt": "R$ 412",
    "valorTotalAcumuladoSimuladoFmt": "R$ 870",
    "maiorPedidoSimuladoFmt": "R$ 494",
    "menorPedidoSimuladoFmt": "R$ 283",
    "primeiraCompraSimulada": "23/12/2025",
    "ultimaCompraSimulada": "29/03/2026",
    "diasDesdeUltimaCompraSimulado": 46,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0567"
  },
  {
    "clienteId": "CLI_0568",
    "clienteAnonimo": "567",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 439,
    "ticketMedianoSimulado": 424,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 878,
    "maiorPedidoSimulado": 463,
    "menorPedidoSimulado": 243,
    "ticketMedioSimuladoFmt": "R$ 439",
    "ticketMedianoSimuladoFmt": "R$ 424",
    "valorTotalAcumuladoSimuladoFmt": "R$ 878",
    "maiorPedidoSimuladoFmt": "R$ 463",
    "menorPedidoSimuladoFmt": "R$ 243",
    "primeiraCompraSimulada": "08/01/2026",
    "ultimaCompraSimulada": "16/03/2026",
    "diasDesdeUltimaCompraSimulado": 59,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0568"
  },
  {
    "clienteId": "CLI_0569",
    "clienteAnonimo": "568",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 413,
    "ticketMedianoSimulado": 397,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 826,
    "maiorPedidoSimulado": 472,
    "menorPedidoSimulado": 272,
    "ticketMedioSimuladoFmt": "R$ 413",
    "ticketMedianoSimuladoFmt": "R$ 397",
    "valorTotalAcumuladoSimuladoFmt": "R$ 826",
    "maiorPedidoSimuladoFmt": "R$ 472",
    "menorPedidoSimuladoFmt": "R$ 272",
    "primeiraCompraSimulada": "24/01/2026",
    "ultimaCompraSimulada": "17/04/2026",
    "diasDesdeUltimaCompraSimulado": 27,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0569"
  },
  {
    "clienteId": "CLI_0570",
    "clienteAnonimo": "569",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 437,
    "ticketMedianoSimulado": 426,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1311,
    "maiorPedidoSimulado": 521,
    "menorPedidoSimulado": 312,
    "ticketMedioSimuladoFmt": "R$ 437",
    "ticketMedianoSimuladoFmt": "R$ 426",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.311",
    "maiorPedidoSimuladoFmt": "R$ 521",
    "menorPedidoSimuladoFmt": "R$ 312",
    "primeiraCompraSimulada": "14/03/2026",
    "ultimaCompraSimulada": "22/04/2026",
    "diasDesdeUltimaCompraSimulado": 22,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0570"
  },
  {
    "clienteId": "CLI_0571",
    "clienteAnonimo": "570",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 437,
    "ticketMedianoSimulado": 410,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 437,
    "maiorPedidoSimulado": 481,
    "menorPedidoSimulado": 266,
    "ticketMedioSimuladoFmt": "R$ 437",
    "ticketMedianoSimuladoFmt": "R$ 410",
    "valorTotalAcumuladoSimuladoFmt": "R$ 437",
    "maiorPedidoSimuladoFmt": "R$ 481",
    "menorPedidoSimuladoFmt": "R$ 266",
    "primeiraCompraSimulada": "30/03/2026",
    "ultimaCompraSimulada": "22/04/2026",
    "diasDesdeUltimaCompraSimulado": 22,
    "hipoteseDePerfil": "Compra compatível com abastecimento maior, família ou rotina intensa.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0571"
  },
  {
    "clienteId": "CLI_0572",
    "clienteAnonimo": "571",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 411,
    "ticketMedianoSimulado": 407,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1233,
    "maiorPedidoSimulado": 448,
    "menorPedidoSimulado": 245,
    "ticketMedioSimuladoFmt": "R$ 411",
    "ticketMedianoSimuladoFmt": "R$ 407",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.233",
    "maiorPedidoSimuladoFmt": "R$ 448",
    "menorPedidoSimuladoFmt": "R$ 245",
    "primeiraCompraSimulada": "13/04/2026",
    "ultimaCompraSimulada": "05/05/2026",
    "diasDesdeUltimaCompraSimulado": 9,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0572"
  },
  {
    "clienteId": "CLI_0573",
    "clienteAnonimo": "572",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 385,
    "ticketMedianoSimulado": 355,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 385,
    "maiorPedidoSimulado": 454,
    "menorPedidoSimulado": 270,
    "ticketMedioSimuladoFmt": "R$ 385",
    "ticketMedianoSimuladoFmt": "R$ 355",
    "valorTotalAcumuladoSimuladoFmt": "R$ 385",
    "maiorPedidoSimuladoFmt": "R$ 454",
    "menorPedidoSimuladoFmt": "R$ 270",
    "primeiraCompraSimulada": "29/03/2026",
    "ultimaCompraSimulada": "10/05/2026",
    "diasDesdeUltimaCompraSimulado": 4,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0573"
  },
  {
    "clienteId": "CLI_0574",
    "clienteAnonimo": "573",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 358,
    "ticketMedianoSimulado": 357,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1074,
    "maiorPedidoSimulado": 405,
    "menorPedidoSimulado": 230,
    "ticketMedioSimuladoFmt": "R$ 358",
    "ticketMedianoSimuladoFmt": "R$ 357",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.074",
    "maiorPedidoSimuladoFmt": "R$ 405",
    "menorPedidoSimuladoFmt": "R$ 230",
    "primeiraCompraSimulada": "13/03/2026",
    "ultimaCompraSimulada": "26/04/2026",
    "diasDesdeUltimaCompraSimulado": 18,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0574"
  },
  {
    "clienteId": "CLI_0575",
    "clienteAnonimo": "574",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 332,
    "ticketMedianoSimulado": 309,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 664,
    "maiorPedidoSimulado": 352,
    "menorPedidoSimulado": 186,
    "ticketMedioSimuladoFmt": "R$ 332",
    "ticketMedianoSimuladoFmt": "R$ 309",
    "valorTotalAcumuladoSimuladoFmt": "R$ 664",
    "maiorPedidoSimuladoFmt": "R$ 352",
    "menorPedidoSimuladoFmt": "R$ 186",
    "primeiraCompraSimulada": "25/02/2026",
    "ultimaCompraSimulada": "05/04/2026",
    "diasDesdeUltimaCompraSimulado": 39,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0575"
  },
  {
    "clienteId": "CLI_0576",
    "clienteAnonimo": "575",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 306,
    "ticketMedianoSimulado": 300,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 612,
    "maiorPedidoSimulado": 352,
    "menorPedidoSimulado": 204,
    "ticketMedioSimuladoFmt": "R$ 306",
    "ticketMedianoSimuladoFmt": "R$ 300",
    "valorTotalAcumuladoSimuladoFmt": "R$ 612",
    "maiorPedidoSimuladoFmt": "R$ 352",
    "menorPedidoSimuladoFmt": "R$ 204",
    "primeiraCompraSimulada": "09/02/2026",
    "ultimaCompraSimulada": "15/04/2026",
    "diasDesdeUltimaCompraSimulado": 29,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0576"
  },
  {
    "clienteId": "CLI_0577",
    "clienteAnonimo": "576",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 280,
    "ticketMedianoSimulado": 265,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 560,
    "maiorPedidoSimulado": 325,
    "menorPedidoSimulado": 190,
    "ticketMedioSimuladoFmt": "R$ 280",
    "ticketMedianoSimuladoFmt": "R$ 265",
    "valorTotalAcumuladoSimuladoFmt": "R$ 560",
    "maiorPedidoSimuladoFmt": "R$ 325",
    "menorPedidoSimuladoFmt": "R$ 190",
    "primeiraCompraSimulada": "24/01/2026",
    "ultimaCompraSimulada": "05/05/2026",
    "diasDesdeUltimaCompraSimulado": 9,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0577"
  },
  {
    "clienteId": "CLI_0578",
    "clienteAnonimo": "577",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 306,
    "ticketMedianoSimulado": 296,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 612,
    "maiorPedidoSimulado": 327,
    "menorPedidoSimulado": 175,
    "ticketMedioSimuladoFmt": "R$ 306",
    "ticketMedianoSimuladoFmt": "R$ 296",
    "valorTotalAcumuladoSimuladoFmt": "R$ 612",
    "maiorPedidoSimuladoFmt": "R$ 327",
    "menorPedidoSimuladoFmt": "R$ 175",
    "primeiraCompraSimulada": "08/01/2026",
    "ultimaCompraSimulada": "19/04/2026",
    "diasDesdeUltimaCompraSimulado": 25,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0578"
  },
  {
    "clienteId": "CLI_0579",
    "clienteAnonimo": "578",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 333,
    "ticketMedianoSimulado": 320,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 666,
    "maiorPedidoSimulado": 373,
    "menorPedidoSimulado": 211,
    "ticketMedioSimuladoFmt": "R$ 333",
    "ticketMedianoSimuladoFmt": "R$ 320",
    "valorTotalAcumuladoSimuladoFmt": "R$ 666",
    "maiorPedidoSimuladoFmt": "R$ 373",
    "menorPedidoSimuladoFmt": "R$ 211",
    "primeiraCompraSimulada": "23/12/2025",
    "ultimaCompraSimulada": "15/03/2026",
    "diasDesdeUltimaCompraSimulado": 60,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0579"
  },
  {
    "clienteId": "CLI_0580",
    "clienteAnonimo": "579",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 282,
    "ticketMedianoSimulado": 274,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 846,
    "maiorPedidoSimulado": 334,
    "menorPedidoSimulado": 200,
    "ticketMedioSimuladoFmt": "R$ 282",
    "ticketMedianoSimuladoFmt": "R$ 274",
    "valorTotalAcumuladoSimuladoFmt": "R$ 846",
    "maiorPedidoSimuladoFmt": "R$ 334",
    "menorPedidoSimuladoFmt": "R$ 200",
    "primeiraCompraSimulada": "04/11/2025",
    "ultimaCompraSimulada": "05/05/2026",
    "diasDesdeUltimaCompraSimulado": 9,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0580"
  },
  {
    "clienteId": "CLI_0581",
    "clienteAnonimo": "580",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 308,
    "ticketMedianoSimulado": 290,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 308,
    "maiorPedidoSimulado": 346,
    "menorPedidoSimulado": 196,
    "ticketMedioSimuladoFmt": "R$ 308",
    "ticketMedianoSimuladoFmt": "R$ 290",
    "valorTotalAcumuladoSimuladoFmt": "R$ 308",
    "maiorPedidoSimuladoFmt": "R$ 346",
    "menorPedidoSimuladoFmt": "R$ 196",
    "primeiraCompraSimulada": "07/11/2025",
    "ultimaCompraSimulada": "05/04/2026",
    "diasDesdeUltimaCompraSimulado": 39,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0581"
  },
  {
    "clienteId": "CLI_0582",
    "clienteAnonimo": "581",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 334,
    "ticketMedianoSimulado": 330,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1002,
    "maiorPedidoSimulado": 356,
    "menorPedidoSimulado": 190,
    "ticketMedioSimuladoFmt": "R$ 334",
    "ticketMedianoSimuladoFmt": "R$ 330",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.002",
    "maiorPedidoSimuladoFmt": "R$ 356",
    "menorPedidoSimuladoFmt": "R$ 190",
    "primeiraCompraSimulada": "23/11/2025",
    "ultimaCompraSimulada": "28/02/2026",
    "diasDesdeUltimaCompraSimulado": 75,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0582"
  },
  {
    "clienteId": "CLI_0583",
    "clienteAnonimo": "582",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 361,
    "ticketMedianoSimulado": 334,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 361,
    "maiorPedidoSimulado": 417,
    "menorPedidoSimulado": 243,
    "ticketMedioSimuladoFmt": "R$ 361",
    "ticketMedianoSimuladoFmt": "R$ 334",
    "valorTotalAcumuladoSimuladoFmt": "R$ 361",
    "maiorPedidoSimuladoFmt": "R$ 417",
    "menorPedidoSimuladoFmt": "R$ 243",
    "primeiraCompraSimulada": "09/12/2025",
    "ultimaCompraSimulada": "20/03/2026",
    "diasDesdeUltimaCompraSimulado": 55,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0583"
  },
  {
    "clienteId": "CLI_0584",
    "clienteAnonimo": "583",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 387,
    "ticketMedianoSimulado": 386,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1161,
    "maiorPedidoSimulado": 446,
    "menorPedidoSimulado": 260,
    "ticketMedioSimuladoFmt": "R$ 387",
    "ticketMedianoSimuladoFmt": "R$ 386",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.161",
    "maiorPedidoSimuladoFmt": "R$ 446",
    "menorPedidoSimuladoFmt": "R$ 260",
    "primeiraCompraSimulada": "25/12/2025",
    "ultimaCompraSimulada": "26/04/2026",
    "diasDesdeUltimaCompraSimulado": 18,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0584"
  },
  {
    "clienteId": "CLI_0585",
    "clienteAnonimo": "584",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 413,
    "ticketMedianoSimulado": 384,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 826,
    "maiorPedidoSimulado": 439,
    "menorPedidoSimulado": 234,
    "ticketMedioSimuladoFmt": "R$ 413",
    "ticketMedianoSimuladoFmt": "R$ 384",
    "valorTotalAcumuladoSimuladoFmt": "R$ 826",
    "maiorPedidoSimuladoFmt": "R$ 439",
    "menorPedidoSimuladoFmt": "R$ 234",
    "primeiraCompraSimulada": "10/01/2026",
    "ultimaCompraSimulada": "26/04/2026",
    "diasDesdeUltimaCompraSimulado": 18,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0585"
  },
  {
    "clienteId": "CLI_0586",
    "clienteAnonimo": "585",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 439,
    "ticketMedianoSimulado": 432,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 878,
    "maiorPedidoSimulado": 495,
    "menorPedidoSimulado": 281,
    "ticketMedioSimuladoFmt": "R$ 439",
    "ticketMedianoSimuladoFmt": "R$ 432",
    "valorTotalAcumuladoSimuladoFmt": "R$ 878",
    "maiorPedidoSimuladoFmt": "R$ 495",
    "menorPedidoSimuladoFmt": "R$ 281",
    "primeiraCompraSimulada": "26/01/2026",
    "ultimaCompraSimulada": "04/04/2026",
    "diasDesdeUltimaCompraSimulado": 40,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0586"
  },
  {
    "clienteId": "CLI_0587",
    "clienteAnonimo": "586",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 435,
    "ticketMedianoSimulado": 410,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 870,
    "maiorPedidoSimulado": 515,
    "menorPedidoSimulado": 307,
    "ticketMedioSimuladoFmt": "R$ 435",
    "ticketMedianoSimuladoFmt": "R$ 410",
    "valorTotalAcumuladoSimuladoFmt": "R$ 870",
    "maiorPedidoSimuladoFmt": "R$ 515",
    "menorPedidoSimuladoFmt": "R$ 307",
    "primeiraCompraSimulada": "11/02/2026",
    "ultimaCompraSimulada": "04/04/2026",
    "diasDesdeUltimaCompraSimulado": 40,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0587"
  },
  {
    "clienteId": "CLI_0588",
    "clienteAnonimo": "587",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 408,
    "ticketMedianoSimulado": 396,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 816,
    "maiorPedidoSimulado": 446,
    "menorPedidoSimulado": 245,
    "ticketMedioSimuladoFmt": "R$ 408",
    "ticketMedianoSimuladoFmt": "R$ 396",
    "valorTotalAcumuladoSimuladoFmt": "R$ 816",
    "maiorPedidoSimuladoFmt": "R$ 446",
    "menorPedidoSimuladoFmt": "R$ 245",
    "primeiraCompraSimulada": "27/02/2026",
    "ultimaCompraSimulada": "28/04/2026",
    "diasDesdeUltimaCompraSimulado": 16,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0588"
  },
  {
    "clienteId": "CLI_0589",
    "clienteAnonimo": "588",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 382,
    "ticketMedianoSimulado": 366,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 764,
    "maiorPedidoSimulado": 419,
    "menorPedidoSimulado": 231,
    "ticketMedioSimuladoFmt": "R$ 382",
    "ticketMedianoSimuladoFmt": "R$ 366",
    "valorTotalAcumuladoSimuladoFmt": "R$ 764",
    "maiorPedidoSimuladoFmt": "R$ 419",
    "menorPedidoSimuladoFmt": "R$ 231",
    "primeiraCompraSimulada": "15/03/2026",
    "ultimaCompraSimulada": "08/05/2026",
    "diasDesdeUltimaCompraSimulado": 6,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0589"
  },
  {
    "clienteId": "CLI_0590",
    "clienteAnonimo": "589",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 433,
    "ticketMedianoSimulado": 420,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1299,
    "maiorPedidoSimulado": 503,
    "menorPedidoSimulado": 295,
    "ticketMedioSimuladoFmt": "R$ 433",
    "ticketMedianoSimuladoFmt": "R$ 420",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.299",
    "maiorPedidoSimuladoFmt": "R$ 503",
    "menorPedidoSimuladoFmt": "R$ 295",
    "primeiraCompraSimulada": "27/03/2026",
    "ultimaCompraSimulada": "23/04/2026",
    "diasDesdeUltimaCompraSimulado": 21,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0590"
  },
  {
    "clienteId": "CLI_0591",
    "clienteAnonimo": "590",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 407,
    "ticketMedianoSimulado": 384,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 407,
    "maiorPedidoSimulado": 467,
    "menorPedidoSimulado": 270,
    "ticketMedioSimuladoFmt": "R$ 407",
    "ticketMedianoSimuladoFmt": "R$ 384",
    "valorTotalAcumuladoSimuladoFmt": "R$ 407",
    "maiorPedidoSimuladoFmt": "R$ 467",
    "menorPedidoSimuladoFmt": "R$ 270",
    "primeiraCompraSimulada": "11/03/2026",
    "ultimaCompraSimulada": "01/05/2026",
    "diasDesdeUltimaCompraSimulado": 13,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0591"
  },
  {
    "clienteId": "CLI_0592",
    "clienteAnonimo": "591",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 380,
    "ticketMedianoSimulado": 374,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1140,
    "maiorPedidoSimulado": 402,
    "menorPedidoSimulado": 212,
    "ticketMedioSimuladoFmt": "R$ 380",
    "ticketMedianoSimuladoFmt": "R$ 374",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.140",
    "maiorPedidoSimuladoFmt": "R$ 402",
    "menorPedidoSimuladoFmt": "R$ 212",
    "primeiraCompraSimulada": "23/02/2026",
    "ultimaCompraSimulada": "06/05/2026",
    "diasDesdeUltimaCompraSimulado": 8,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0592"
  },
  {
    "clienteId": "CLI_0593",
    "clienteAnonimo": "592",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 354,
    "ticketMedianoSimulado": 329,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 354,
    "maiorPedidoSimulado": 401,
    "menorPedidoSimulado": 229,
    "ticketMedioSimuladoFmt": "R$ 354",
    "ticketMedianoSimuladoFmt": "R$ 329",
    "valorTotalAcumuladoSimuladoFmt": "R$ 354",
    "maiorPedidoSimuladoFmt": "R$ 401",
    "menorPedidoSimuladoFmt": "R$ 229",
    "primeiraCompraSimulada": "07/02/2026",
    "ultimaCompraSimulada": "13/04/2026",
    "diasDesdeUltimaCompraSimulado": 31,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0593"
  },
  {
    "clienteId": "CLI_0594",
    "clienteAnonimo": "593",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 328,
    "ticketMedianoSimulado": 328,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 984,
    "maiorPedidoSimulado": 386,
    "menorPedidoSimulado": 229,
    "ticketMedioSimuladoFmt": "R$ 328",
    "ticketMedianoSimuladoFmt": "R$ 328",
    "valorTotalAcumuladoSimuladoFmt": "R$ 984",
    "maiorPedidoSimuladoFmt": "R$ 386",
    "menorPedidoSimuladoFmt": "R$ 229",
    "primeiraCompraSimulada": "22/01/2026",
    "ultimaCompraSimulada": "21/03/2026",
    "diasDesdeUltimaCompraSimulado": 54,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0594"
  },
  {
    "clienteId": "CLI_0595",
    "clienteAnonimo": "594",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 302,
    "ticketMedianoSimulado": 280,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 604,
    "maiorPedidoSimulado": 328,
    "menorPedidoSimulado": 179,
    "ticketMedioSimuladoFmt": "R$ 302",
    "ticketMedianoSimuladoFmt": "R$ 280",
    "valorTotalAcumuladoSimuladoFmt": "R$ 604",
    "maiorPedidoSimuladoFmt": "R$ 328",
    "menorPedidoSimuladoFmt": "R$ 179",
    "primeiraCompraSimulada": "06/01/2026",
    "ultimaCompraSimulada": "11/04/2026",
    "diasDesdeUltimaCompraSimulado": 33,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0595"
  },
  {
    "clienteId": "CLI_0596",
    "clienteAnonimo": "595",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 285,
    "ticketMedianoSimulado": 281,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 570,
    "maiorPedidoSimulado": 315,
    "menorPedidoSimulado": 175,
    "ticketMedioSimuladoFmt": "R$ 285",
    "ticketMedianoSimuladoFmt": "R$ 281",
    "valorTotalAcumuladoSimuladoFmt": "R$ 570",
    "maiorPedidoSimuladoFmt": "R$ 315",
    "menorPedidoSimuladoFmt": "R$ 175",
    "primeiraCompraSimulada": "21/12/2025",
    "ultimaCompraSimulada": "10/05/2026",
    "diasDesdeUltimaCompraSimulado": 4,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0596"
  },
  {
    "clienteId": "CLI_0597",
    "clienteAnonimo": "596",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 311,
    "ticketMedianoSimulado": 292,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 622,
    "maiorPedidoSimulado": 371,
    "menorPedidoSimulado": 223,
    "ticketMedioSimuladoFmt": "R$ 311",
    "ticketMedianoSimuladoFmt": "R$ 292",
    "valorTotalAcumuladoSimuladoFmt": "R$ 622",
    "maiorPedidoSimuladoFmt": "R$ 371",
    "menorPedidoSimuladoFmt": "R$ 223",
    "primeiraCompraSimulada": "05/12/2025",
    "ultimaCompraSimulada": "06/04/2026",
    "diasDesdeUltimaCompraSimulado": 38,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0597"
  },
  {
    "clienteId": "CLI_0598",
    "clienteAnonimo": "597",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 337,
    "ticketMedianoSimulado": 328,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 674,
    "maiorPedidoSimulado": 376,
    "menorPedidoSimulado": 211,
    "ticketMedioSimuladoFmt": "R$ 337",
    "ticketMedianoSimuladoFmt": "R$ 328",
    "valorTotalAcumuladoSimuladoFmt": "R$ 674",
    "maiorPedidoSimuladoFmt": "R$ 376",
    "menorPedidoSimuladoFmt": "R$ 211",
    "primeiraCompraSimulada": "19/11/2025",
    "ultimaCompraSimulada": "21/02/2026",
    "diasDesdeUltimaCompraSimulado": 82,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0598"
  },
  {
    "clienteId": "CLI_0599",
    "clienteAnonimo": "598",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 363,
    "ticketMedianoSimulado": 347,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 726,
    "maiorPedidoSimulado": 390,
    "menorPedidoSimulado": 210,
    "ticketMedioSimuladoFmt": "R$ 363",
    "ticketMedianoSimuladoFmt": "R$ 347",
    "valorTotalAcumuladoSimuladoFmt": "R$ 726",
    "maiorPedidoSimuladoFmt": "R$ 390",
    "menorPedidoSimuladoFmt": "R$ 210",
    "primeiraCompraSimulada": "03/11/2025",
    "ultimaCompraSimulada": "13/03/2026",
    "diasDesdeUltimaCompraSimulado": 62,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0599"
  },
  {
    "clienteId": "CLI_0600",
    "clienteAnonimo": "599",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 406,
    "ticketMedianoSimulado": 378,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 406,
    "maiorPedidoSimulado": 484,
    "menorPedidoSimulado": 291,
    "ticketMedioSimuladoFmt": "R$ 406",
    "ticketMedianoSimuladoFmt": "R$ 378",
    "valorTotalAcumuladoSimuladoFmt": "R$ 406",
    "maiorPedidoSimuladoFmt": "R$ 484",
    "menorPedidoSimuladoFmt": "R$ 291",
    "primeiraCompraSimulada": "13/02/2026",
    "ultimaCompraSimulada": "03/05/2026",
    "diasDesdeUltimaCompraSimulado": 11,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0600"
  },
  {
    "clienteId": "CLI_0601",
    "clienteAnonimo": "600",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 380,
    "ticketMedianoSimulado": 379,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1140,
    "maiorPedidoSimulado": 419,
    "menorPedidoSimulado": 232,
    "ticketMedioSimuladoFmt": "R$ 380",
    "ticketMedianoSimuladoFmt": "R$ 379",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.140",
    "maiorPedidoSimuladoFmt": "R$ 419",
    "menorPedidoSimuladoFmt": "R$ 232",
    "primeiraCompraSimulada": "01/03/2026",
    "ultimaCompraSimulada": "01/05/2026",
    "diasDesdeUltimaCompraSimulado": 13,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0601"
  },
  {
    "clienteId": "CLI_0602",
    "clienteAnonimo": "601",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 353,
    "ticketMedianoSimulado": 326,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 353,
    "maiorPedidoSimulado": 384,
    "menorPedidoSimulado": 210,
    "ticketMedioSimuladoFmt": "R$ 353",
    "ticketMedianoSimuladoFmt": "R$ 326",
    "valorTotalAcumuladoSimuladoFmt": "R$ 353",
    "maiorPedidoSimuladoFmt": "R$ 384",
    "menorPedidoSimuladoFmt": "R$ 210",
    "primeiraCompraSimulada": "17/03/2026",
    "ultimaCompraSimulada": "20/04/2026",
    "diasDesdeUltimaCompraSimulado": 24,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0602"
  },
  {
    "clienteId": "CLI_0603",
    "clienteAnonimo": "602",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 327,
    "ticketMedianoSimulado": 323,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 654,
    "maiorPedidoSimulado": 385,
    "menorPedidoSimulado": 229,
    "ticketMedioSimuladoFmt": "R$ 327",
    "ticketMedianoSimuladoFmt": "R$ 323",
    "valorTotalAcumuladoSimuladoFmt": "R$ 654",
    "maiorPedidoSimuladoFmt": "R$ 385",
    "menorPedidoSimuladoFmt": "R$ 229",
    "primeiraCompraSimulada": "02/04/2026",
    "ultimaCompraSimulada": "26/04/2026",
    "diasDesdeUltimaCompraSimulado": 18,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0603"
  },
  {
    "clienteId": "CLI_0604",
    "clienteAnonimo": "603",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 301,
    "ticketMedianoSimulado": 282,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 602,
    "maiorPedidoSimulado": 341,
    "menorPedidoSimulado": 194,
    "ticketMedioSimuladoFmt": "R$ 301",
    "ticketMedianoSimuladoFmt": "R$ 282",
    "valorTotalAcumuladoSimuladoFmt": "R$ 602",
    "maiorPedidoSimuladoFmt": "R$ 341",
    "menorPedidoSimuladoFmt": "R$ 194",
    "primeiraCompraSimulada": "10/04/2026",
    "ultimaCompraSimulada": "06/05/2026",
    "diasDesdeUltimaCompraSimulado": 8,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0604"
  },
  {
    "clienteId": "CLI_0605",
    "clienteAnonimo": "604",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 285,
    "ticketMedianoSimulado": 278,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 570,
    "maiorPedidoSimulado": 302,
    "menorPedidoSimulado": 160,
    "ticketMedioSimuladoFmt": "R$ 285",
    "ticketMedianoSimuladoFmt": "R$ 278",
    "valorTotalAcumuladoSimuladoFmt": "R$ 570",
    "maiorPedidoSimuladoFmt": "R$ 302",
    "menorPedidoSimuladoFmt": "R$ 160",
    "primeiraCompraSimulada": "25/03/2026",
    "ultimaCompraSimulada": "08/05/2026",
    "diasDesdeUltimaCompraSimulado": 6,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0605"
  },
  {
    "clienteId": "CLI_0606",
    "clienteAnonimo": "605",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 312,
    "ticketMedianoSimulado": 297,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 624,
    "maiorPedidoSimulado": 358,
    "menorPedidoSimulado": 207,
    "ticketMedioSimuladoFmt": "R$ 312",
    "ticketMedianoSimuladoFmt": "R$ 297",
    "valorTotalAcumuladoSimuladoFmt": "R$ 624",
    "maiorPedidoSimuladoFmt": "R$ 358",
    "menorPedidoSimuladoFmt": "R$ 207",
    "primeiraCompraSimulada": "09/03/2026",
    "ultimaCompraSimulada": "22/04/2026",
    "diasDesdeUltimaCompraSimulado": 22,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0606"
  },
  {
    "clienteId": "CLI_0607",
    "clienteAnonimo": "606",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 338,
    "ticketMedianoSimulado": 325,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 676,
    "maiorPedidoSimulado": 392,
    "menorPedidoSimulado": 230,
    "ticketMedioSimuladoFmt": "R$ 338",
    "ticketMedianoSimuladoFmt": "R$ 325",
    "valorTotalAcumuladoSimuladoFmt": "R$ 676",
    "maiorPedidoSimuladoFmt": "R$ 392",
    "menorPedidoSimuladoFmt": "R$ 230",
    "primeiraCompraSimulada": "21/02/2026",
    "ultimaCompraSimulada": "04/04/2026",
    "diasDesdeUltimaCompraSimulado": 40,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0607"
  },
  {
    "clienteId": "CLI_0608",
    "clienteAnonimo": "607",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 364,
    "ticketMedianoSimulado": 352,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1092,
    "maiorPedidoSimulado": 390,
    "menorPedidoSimulado": 209,
    "ticketMedioSimuladoFmt": "R$ 364",
    "ticketMedianoSimuladoFmt": "R$ 352",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.092",
    "maiorPedidoSimuladoFmt": "R$ 390",
    "menorPedidoSimuladoFmt": "R$ 209",
    "primeiraCompraSimulada": "05/02/2026",
    "ultimaCompraSimulada": "18/04/2026",
    "diasDesdeUltimaCompraSimulado": 26,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0608"
  },
  {
    "clienteId": "CLI_0609",
    "clienteAnonimo": "608",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 390,
    "ticketMedianoSimulado": 369,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 390,
    "maiorPedidoSimulado": 436,
    "menorPedidoSimulado": 246,
    "ticketMedioSimuladoFmt": "R$ 390",
    "ticketMedianoSimuladoFmt": "R$ 369",
    "valorTotalAcumuladoSimuladoFmt": "R$ 390",
    "maiorPedidoSimuladoFmt": "R$ 436",
    "menorPedidoSimuladoFmt": "R$ 246",
    "primeiraCompraSimulada": "20/01/2026",
    "ultimaCompraSimulada": "10/05/2026",
    "diasDesdeUltimaCompraSimulado": 4,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0609"
  },
  {
    "clienteId": "CLI_0610",
    "clienteAnonimo": "609",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 340,
    "ticketMedianoSimulado": 317,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 340,
    "maiorPedidoSimulado": 403,
    "menorPedidoSimulado": 240,
    "ticketMedioSimuladoFmt": "R$ 340",
    "ticketMedianoSimuladoFmt": "R$ 317",
    "valorTotalAcumuladoSimuladoFmt": "R$ 340",
    "maiorPedidoSimuladoFmt": "R$ 403",
    "menorPedidoSimuladoFmt": "R$ 240",
    "primeiraCompraSimulada": "03/12/2025",
    "ultimaCompraSimulada": "28/02/2026",
    "diasDesdeUltimaCompraSimulado": 75,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0610"
  },
  {
    "clienteId": "CLI_0611",
    "clienteAnonimo": "610",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 366,
    "ticketMedianoSimulado": 364,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1098,
    "maiorPedidoSimulado": 412,
    "menorPedidoSimulado": 234,
    "ticketMedioSimuladoFmt": "R$ 366",
    "ticketMedianoSimuladoFmt": "R$ 364",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.098",
    "maiorPedidoSimuladoFmt": "R$ 412",
    "menorPedidoSimuladoFmt": "R$ 234",
    "primeiraCompraSimulada": "17/11/2025",
    "ultimaCompraSimulada": "03/04/2026",
    "diasDesdeUltimaCompraSimulado": 41,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0611"
  },
  {
    "clienteId": "CLI_0612",
    "clienteAnonimo": "611",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 392,
    "ticketMedianoSimulado": 361,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 392,
    "maiorPedidoSimulado": 417,
    "menorPedidoSimulado": 222,
    "ticketMedioSimuladoFmt": "R$ 392",
    "ticketMedianoSimuladoFmt": "R$ 361",
    "valorTotalAcumuladoSimuladoFmt": "R$ 392",
    "maiorPedidoSimuladoFmt": "R$ 417",
    "menorPedidoSimuladoFmt": "R$ 222",
    "primeiraCompraSimulada": "01/11/2025",
    "ultimaCompraSimulada": "09/05/2026",
    "diasDesdeUltimaCompraSimulado": 5,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0612"
  },
  {
    "clienteId": "CLI_0613",
    "clienteAnonimo": "612",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 418,
    "ticketMedianoSimulado": 414,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 836,
    "maiorPedidoSimulado": 483,
    "menorPedidoSimulado": 281,
    "ticketMedioSimuladoFmt": "R$ 418",
    "ticketMedianoSimuladoFmt": "R$ 414",
    "valorTotalAcumuladoSimuladoFmt": "R$ 836",
    "maiorPedidoSimuladoFmt": "R$ 483",
    "menorPedidoSimuladoFmt": "R$ 281",
    "primeiraCompraSimulada": "10/11/2025",
    "ultimaCompraSimulada": "28/03/2026",
    "diasDesdeUltimaCompraSimulado": 47,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0613"
  },
  {
    "clienteId": "CLI_0614",
    "clienteAnonimo": "613",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 444,
    "ticketMedianoSimulado": 415,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 888,
    "maiorPedidoSimulado": 513,
    "menorPedidoSimulado": 299,
    "ticketMedioSimuladoFmt": "R$ 444",
    "ticketMedianoSimuladoFmt": "R$ 415",
    "valorTotalAcumuladoSimuladoFmt": "R$ 888",
    "maiorPedidoSimuladoFmt": "R$ 513",
    "menorPedidoSimuladoFmt": "R$ 299",
    "primeiraCompraSimulada": "26/11/2025",
    "ultimaCompraSimulada": "21/02/2026",
    "diasDesdeUltimaCompraSimulado": 82,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0614"
  },
  {
    "clienteId": "CLI_0615",
    "clienteAnonimo": "614",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 429,
    "ticketMedianoSimulado": 419,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 858,
    "maiorPedidoSimulado": 457,
    "menorPedidoSimulado": 243,
    "ticketMedioSimuladoFmt": "R$ 429",
    "ticketMedianoSimuladoFmt": "R$ 419",
    "valorTotalAcumuladoSimuladoFmt": "R$ 858",
    "maiorPedidoSimuladoFmt": "R$ 457",
    "menorPedidoSimuladoFmt": "R$ 243",
    "primeiraCompraSimulada": "12/12/2025",
    "ultimaCompraSimulada": "28/03/2026",
    "diasDesdeUltimaCompraSimulado": 47,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0615"
  },
  {
    "clienteId": "CLI_0616",
    "clienteAnonimo": "615",
    "segmentoComercial": "Cliente alto valor",
    "ticketMedioSimulado": 1085,
    "ticketMedianoSimulado": 1031,
    "totalPedidosSimulado": 6,
    "valorTotalAcumuladoSimulado": 6510,
    "maiorPedidoSimulado": 1221,
    "menorPedidoSimulado": 692,
    "ticketMedioSimuladoFmt": "R$ 1.085",
    "ticketMedianoSimuladoFmt": "R$ 1.031",
    "valorTotalAcumuladoSimuladoFmt": "R$ 6.510",
    "maiorPedidoSimuladoFmt": "R$ 1.221",
    "menorPedidoSimuladoFmt": "R$ 692",
    "primeiraCompraSimulada": "28/12/2025",
    "ultimaCompraSimulada": "03/05/2026",
    "diasDesdeUltimaCompraSimulado": 11,
    "hipoteseDePerfil": "Compra compatível com abastecimento maior, família ou rotina intensa.",
    "objetivoProvavel": "Pode buscar abastecimento maior ou comprar para várias pessoas",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0616"
  },
  {
    "clienteId": "CLI_0617",
    "clienteAnonimo": "616",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 377,
    "ticketMedianoSimulado": 363,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 754,
    "maiorPedidoSimulado": 447,
    "menorPedidoSimulado": 266,
    "ticketMedioSimuladoFmt": "R$ 377",
    "ticketMedianoSimuladoFmt": "R$ 363",
    "valorTotalAcumuladoSimuladoFmt": "R$ 754",
    "maiorPedidoSimuladoFmt": "R$ 447",
    "menorPedidoSimuladoFmt": "R$ 266",
    "primeiraCompraSimulada": "13/01/2026",
    "ultimaCompraSimulada": "21/04/2026",
    "diasDesdeUltimaCompraSimulado": 23,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0617"
  },
  {
    "clienteId": "CLI_0618",
    "clienteAnonimo": "617",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 351,
    "ticketMedianoSimulado": 339,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1053,
    "maiorPedidoSimulado": 384,
    "menorPedidoSimulado": 211,
    "ticketMedioSimuladoFmt": "R$ 351",
    "ticketMedianoSimuladoFmt": "R$ 339",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.053",
    "maiorPedidoSimuladoFmt": "R$ 384",
    "menorPedidoSimuladoFmt": "R$ 211",
    "primeiraCompraSimulada": "29/01/2026",
    "ultimaCompraSimulada": "31/03/2026",
    "diasDesdeUltimaCompraSimulado": 44,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0618"
  },
  {
    "clienteId": "CLI_0619",
    "clienteAnonimo": "618",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 324,
    "ticketMedianoSimulado": 307,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 324,
    "maiorPedidoSimulado": 355,
    "menorPedidoSimulado": 196,
    "ticketMedioSimuladoFmt": "R$ 324",
    "ticketMedianoSimuladoFmt": "R$ 307",
    "valorTotalAcumuladoSimuladoFmt": "R$ 324",
    "maiorPedidoSimuladoFmt": "R$ 355",
    "menorPedidoSimuladoFmt": "R$ 196",
    "primeiraCompraSimulada": "14/02/2026",
    "ultimaCompraSimulada": "09/04/2026",
    "diasDesdeUltimaCompraSimulado": 35,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0619"
  },
  {
    "clienteId": "CLI_0620",
    "clienteAnonimo": "619",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 375,
    "ticketMedianoSimulado": 351,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 375,
    "maiorPedidoSimulado": 435,
    "menorPedidoSimulado": 255,
    "ticketMedioSimuladoFmt": "R$ 375",
    "ticketMedianoSimuladoFmt": "R$ 351",
    "valorTotalAcumuladoSimuladoFmt": "R$ 375",
    "maiorPedidoSimuladoFmt": "R$ 435",
    "menorPedidoSimuladoFmt": "R$ 255",
    "primeiraCompraSimulada": "03/04/2026",
    "ultimaCompraSimulada": "04/05/2026",
    "diasDesdeUltimaCompraSimulado": 10,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0620"
  },
  {
    "clienteId": "CLI_0621",
    "clienteAnonimo": "620",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 349,
    "ticketMedianoSimulado": 346,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1047,
    "maiorPedidoSimulado": 401,
    "menorPedidoSimulado": 232,
    "ticketMedioSimuladoFmt": "R$ 349",
    "ticketMedianoSimuladoFmt": "R$ 346",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.047",
    "maiorPedidoSimuladoFmt": "R$ 401",
    "menorPedidoSimuladoFmt": "R$ 232",
    "primeiraCompraSimulada": "09/04/2026",
    "ultimaCompraSimulada": "28/04/2026",
    "diasDesdeUltimaCompraSimulado": 16,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0621"
  },
  {
    "clienteId": "CLI_0622",
    "clienteAnonimo": "621",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 323,
    "ticketMedianoSimulado": 298,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 323,
    "maiorPedidoSimulado": 342,
    "menorPedidoSimulado": 181,
    "ticketMedioSimuladoFmt": "R$ 323",
    "ticketMedianoSimuladoFmt": "R$ 298",
    "valorTotalAcumuladoSimuladoFmt": "R$ 323",
    "maiorPedidoSimuladoFmt": "R$ 342",
    "menorPedidoSimuladoFmt": "R$ 181",
    "primeiraCompraSimulada": "24/03/2026",
    "ultimaCompraSimulada": "24/04/2026",
    "diasDesdeUltimaCompraSimulado": 20,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0622"
  },
  {
    "clienteId": "CLI_0623",
    "clienteAnonimo": "622",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 297,
    "ticketMedianoSimulado": 295,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 594,
    "maiorPedidoSimulado": 336,
    "menorPedidoSimulado": 192,
    "ticketMedioSimuladoFmt": "R$ 297",
    "ticketMedianoSimuladoFmt": "R$ 295",
    "valorTotalAcumuladoSimuladoFmt": "R$ 594",
    "maiorPedidoSimuladoFmt": "R$ 336",
    "menorPedidoSimuladoFmt": "R$ 192",
    "primeiraCompraSimulada": "08/03/2026",
    "ultimaCompraSimulada": "03/05/2026",
    "diasDesdeUltimaCompraSimulado": 11,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0623"
  },
  {
    "clienteId": "CLI_0624",
    "clienteAnonimo": "623",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 290,
    "ticketMedianoSimulado": 271,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 580,
    "maiorPedidoSimulado": 342,
    "menorPedidoSimulado": 203,
    "ticketMedioSimuladoFmt": "R$ 290",
    "ticketMedianoSimuladoFmt": "R$ 271",
    "valorTotalAcumuladoSimuladoFmt": "R$ 580",
    "maiorPedidoSimuladoFmt": "R$ 342",
    "menorPedidoSimuladoFmt": "R$ 203",
    "primeiraCompraSimulada": "20/02/2026",
    "ultimaCompraSimulada": "02/05/2026",
    "diasDesdeUltimaCompraSimulado": 12,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0624"
  },
  {
    "clienteId": "CLI_0625",
    "clienteAnonimo": "624",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 316,
    "ticketMedianoSimulado": 310,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 632,
    "maiorPedidoSimulado": 344,
    "menorPedidoSimulado": 188,
    "ticketMedioSimuladoFmt": "R$ 316",
    "ticketMedianoSimuladoFmt": "R$ 310",
    "valorTotalAcumuladoSimuladoFmt": "R$ 632",
    "maiorPedidoSimuladoFmt": "R$ 344",
    "menorPedidoSimuladoFmt": "R$ 188",
    "primeiraCompraSimulada": "04/02/2026",
    "ultimaCompraSimulada": "08/04/2026",
    "diasDesdeUltimaCompraSimulado": 36,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0625"
  },
  {
    "clienteId": "CLI_0626",
    "clienteAnonimo": "625",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 342,
    "ticketMedianoSimulado": 324,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 684,
    "maiorPedidoSimulado": 377,
    "menorPedidoSimulado": 209,
    "ticketMedioSimuladoFmt": "R$ 342",
    "ticketMedianoSimuladoFmt": "R$ 324",
    "valorTotalAcumuladoSimuladoFmt": "R$ 684",
    "maiorPedidoSimuladoFmt": "R$ 377",
    "menorPedidoSimuladoFmt": "R$ 209",
    "primeiraCompraSimulada": "19/01/2026",
    "ultimaCompraSimulada": "24/03/2026",
    "diasDesdeUltimaCompraSimulado": 51,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0626"
  },
  {
    "clienteId": "CLI_0627",
    "clienteAnonimo": "626",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 368,
    "ticketMedianoSimulado": 355,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 736,
    "maiorPedidoSimulado": 439,
    "menorPedidoSimulado": 264,
    "ticketMedioSimuladoFmt": "R$ 368",
    "ticketMedianoSimuladoFmt": "R$ 355",
    "valorTotalAcumuladoSimuladoFmt": "R$ 736",
    "maiorPedidoSimuladoFmt": "R$ 439",
    "menorPedidoSimuladoFmt": "R$ 264",
    "primeiraCompraSimulada": "03/01/2026",
    "ultimaCompraSimulada": "16/04/2026",
    "diasDesdeUltimaCompraSimulado": 28,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0627"
  },
  {
    "clienteId": "CLI_0628",
    "clienteAnonimo": "627",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 395,
    "ticketMedianoSimulado": 380,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 790,
    "maiorPedidoSimulado": 441,
    "menorPedidoSimulado": 248,
    "ticketMedioSimuladoFmt": "R$ 395",
    "ticketMedianoSimuladoFmt": "R$ 380",
    "valorTotalAcumuladoSimuladoFmt": "R$ 790",
    "maiorPedidoSimuladoFmt": "R$ 441",
    "menorPedidoSimuladoFmt": "R$ 248",
    "primeiraCompraSimulada": "18/12/2025",
    "ultimaCompraSimulada": "06/05/2026",
    "diasDesdeUltimaCompraSimulado": 8,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0628"
  },
  {
    "clienteId": "CLI_0629",
    "clienteAnonimo": "628",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 421,
    "ticketMedianoSimulado": 400,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 421,
    "maiorPedidoSimulado": 452,
    "menorPedidoSimulado": 243,
    "ticketMedioSimuladoFmt": "R$ 421",
    "ticketMedianoSimuladoFmt": "R$ 400",
    "valorTotalAcumuladoSimuladoFmt": "R$ 421",
    "maiorPedidoSimuladoFmt": "R$ 452",
    "menorPedidoSimuladoFmt": "R$ 243",
    "primeiraCompraSimulada": "02/12/2025",
    "ultimaCompraSimulada": "29/03/2026",
    "diasDesdeUltimaCompraSimulado": 46,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0629"
  },
  {
    "clienteId": "CLI_0630",
    "clienteAnonimo": "629",
    "segmentoComercial": "Cliente alto valor",
    "ticketMedioSimulado": 1022,
    "ticketMedianoSimulado": 959,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 3066,
    "maiorPedidoSimulado": 1163,
    "menorPedidoSimulado": 667,
    "ticketMedioSimuladoFmt": "R$ 1.022",
    "ticketMedianoSimuladoFmt": "R$ 959",
    "valorTotalAcumuladoSimuladoFmt": "R$ 3.066",
    "maiorPedidoSimuladoFmt": "R$ 1.163",
    "menorPedidoSimuladoFmt": "R$ 667",
    "primeiraCompraSimulada": "11/11/2025",
    "ultimaCompraSimulada": "09/04/2026",
    "diasDesdeUltimaCompraSimulado": 35,
    "hipoteseDePerfil": "Compra compatível com abastecimento maior, família ou rotina intensa.",
    "objetivoProvavel": "Pode buscar abastecimento maior ou comprar para várias pessoas",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Personalizar abordagem por segmento.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0630"
  },
  {
    "clienteId": "CLI_0631",
    "clienteAnonimo": "630",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 396,
    "ticketMedianoSimulado": 392,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1188,
    "maiorPedidoSimulado": 464,
    "menorPedidoSimulado": 274,
    "ticketMedioSimuladoFmt": "R$ 396",
    "ticketMedianoSimuladoFmt": "R$ 392",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.188",
    "maiorPedidoSimuladoFmt": "R$ 464",
    "menorPedidoSimuladoFmt": "R$ 274",
    "primeiraCompraSimulada": "27/11/2025",
    "ultimaCompraSimulada": "02/05/2026",
    "diasDesdeUltimaCompraSimulado": 12,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0631"
  },
  {
    "clienteId": "CLI_0632",
    "clienteAnonimo": "631",
    "segmentoComercial": "Cliente possível coletivo",
    "ticketMedioSimulado": 2709,
    "ticketMedianoSimulado": 2502,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 2709,
    "maiorPedidoSimulado": 2930,
    "menorPedidoSimulado": 1590,
    "ticketMedioSimuladoFmt": "R$ 2.709",
    "ticketMedianoSimuladoFmt": "R$ 2.502",
    "valorTotalAcumuladoSimuladoFmt": "R$ 2.709",
    "maiorPedidoSimuladoFmt": "R$ 2.930",
    "menorPedidoSimuladoFmt": "R$ 1.590",
    "primeiraCompraSimulada": "13/12/2025",
    "ultimaCompraSimulada": "29/03/2026",
    "diasDesdeUltimaCompraSimulado": 46,
    "hipoteseDePerfil": "Possível compra coletiva, familiar ampliada ou corporativa. Não afirmar sem confirmação.",
    "objetivoProvavel": "Pode comprar para mais de uma pessoa, família ou equipe",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Tratar como hipótese de compra coletiva — G09 ativo.",
    "alertaSimulacao": "Possível compra familiar, equipe ou coletiva. Confirmar antes de assumir.",
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0632"
  },
  {
    "clienteId": "CLI_0633",
    "clienteAnonimo": "632",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 449,
    "ticketMedianoSimulado": 447,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1347,
    "maiorPedidoSimulado": 498,
    "menorPedidoSimulado": 278,
    "ticketMedioSimuladoFmt": "R$ 449",
    "ticketMedianoSimuladoFmt": "R$ 447",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.347",
    "maiorPedidoSimuladoFmt": "R$ 498",
    "menorPedidoSimuladoFmt": "R$ 278",
    "primeiraCompraSimulada": "29/12/2025",
    "ultimaCompraSimulada": "08/03/2026",
    "diasDesdeUltimaCompraSimulado": 67,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0633"
  },
  {
    "clienteId": "CLI_0634",
    "clienteAnonimo": "633",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 425,
    "ticketMedianoSimulado": 396,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 850,
    "maiorPedidoSimulado": 509,
    "menorPedidoSimulado": 308,
    "ticketMedioSimuladoFmt": "R$ 425",
    "ticketMedianoSimuladoFmt": "R$ 396",
    "valorTotalAcumuladoSimuladoFmt": "R$ 850",
    "maiorPedidoSimuladoFmt": "R$ 509",
    "menorPedidoSimuladoFmt": "R$ 308",
    "primeiraCompraSimulada": "14/01/2026",
    "ultimaCompraSimulada": "12/04/2026",
    "diasDesdeUltimaCompraSimulado": 32,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0634"
  },
  {
    "clienteId": "CLI_0635",
    "clienteAnonimo": "634",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 399,
    "ticketMedianoSimulado": 392,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 798,
    "maiorPedidoSimulado": 443,
    "menorPedidoSimulado": 248,
    "ticketMedioSimuladoFmt": "R$ 399",
    "ticketMedianoSimuladoFmt": "R$ 392",
    "valorTotalAcumuladoSimuladoFmt": "R$ 798",
    "maiorPedidoSimuladoFmt": "R$ 443",
    "menorPedidoSimuladoFmt": "R$ 248",
    "primeiraCompraSimulada": "30/01/2026",
    "ultimaCompraSimulada": "09/05/2026",
    "diasDesdeUltimaCompraSimulado": 5,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0635"
  },
  {
    "clienteId": "CLI_0636",
    "clienteAnonimo": "635",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 373,
    "ticketMedianoSimulado": 353,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 746,
    "maiorPedidoSimulado": 403,
    "menorPedidoSimulado": 218,
    "ticketMedioSimuladoFmt": "R$ 373",
    "ticketMedianoSimuladoFmt": "R$ 353",
    "valorTotalAcumuladoSimuladoFmt": "R$ 746",
    "maiorPedidoSimuladoFmt": "R$ 403",
    "menorPedidoSimuladoFmt": "R$ 218",
    "primeiraCompraSimulada": "15/02/2026",
    "ultimaCompraSimulada": "23/04/2026",
    "diasDesdeUltimaCompraSimulado": 21,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0636"
  },
  {
    "clienteId": "CLI_0637",
    "clienteAnonimo": "636",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 346,
    "ticketMedianoSimulado": 335,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 692,
    "maiorPedidoSimulado": 405,
    "menorPedidoSimulado": 238,
    "ticketMedioSimuladoFmt": "R$ 346",
    "ticketMedianoSimuladoFmt": "R$ 335",
    "valorTotalAcumuladoSimuladoFmt": "R$ 692",
    "maiorPedidoSimuladoFmt": "R$ 405",
    "menorPedidoSimuladoFmt": "R$ 238",
    "primeiraCompraSimulada": "03/03/2026",
    "ultimaCompraSimulada": "10/04/2026",
    "diasDesdeUltimaCompraSimulado": 34,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0637"
  },
  {
    "clienteId": "CLI_0638",
    "clienteAnonimo": "637",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 320,
    "ticketMedianoSimulado": 307,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 640,
    "maiorPedidoSimulado": 365,
    "menorPedidoSimulado": 210,
    "ticketMedioSimuladoFmt": "R$ 320",
    "ticketMedianoSimuladoFmt": "R$ 307",
    "valorTotalAcumuladoSimuladoFmt": "R$ 640",
    "maiorPedidoSimuladoFmt": "R$ 365",
    "menorPedidoSimuladoFmt": "R$ 210",
    "primeiraCompraSimulada": "19/03/2026",
    "ultimaCompraSimulada": "24/04/2026",
    "diasDesdeUltimaCompraSimulado": 20,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0638"
  },
  {
    "clienteId": "CLI_0639",
    "clienteAnonimo": "638",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 294,
    "ticketMedianoSimulado": 280,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 294,
    "maiorPedidoSimulado": 309,
    "menorPedidoSimulado": 162,
    "ticketMedioSimuladoFmt": "R$ 294",
    "ticketMedianoSimuladoFmt": "R$ 280",
    "valorTotalAcumuladoSimuladoFmt": "R$ 294",
    "maiorPedidoSimuladoFmt": "R$ 309",
    "menorPedidoSimuladoFmt": "R$ 162",
    "primeiraCompraSimulada": "04/04/2026",
    "ultimaCompraSimulada": "08/05/2026",
    "diasDesdeUltimaCompraSimulado": 6,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0639"
  },
  {
    "clienteId": "CLI_0640",
    "clienteAnonimo": "639",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 345,
    "ticketMedianoSimulado": 325,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 345,
    "maiorPedidoSimulado": 385,
    "menorPedidoSimulado": 216,
    "ticketMedioSimuladoFmt": "R$ 345",
    "ticketMedianoSimuladoFmt": "R$ 325",
    "valorTotalAcumuladoSimuladoFmt": "R$ 345",
    "maiorPedidoSimuladoFmt": "R$ 385",
    "menorPedidoSimuladoFmt": "R$ 216",
    "primeiraCompraSimulada": "06/03/2026",
    "ultimaCompraSimulada": "11/04/2026",
    "diasDesdeUltimaCompraSimulado": 33,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0640"
  },
  {
    "clienteId": "CLI_0641",
    "clienteAnonimo": "640",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 318,
    "ticketMedianoSimulado": 314,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 954,
    "maiorPedidoSimulado": 380,
    "menorPedidoSimulado": 229,
    "ticketMedioSimuladoFmt": "R$ 318",
    "ticketMedianoSimuladoFmt": "R$ 314",
    "valorTotalAcumuladoSimuladoFmt": "R$ 954",
    "maiorPedidoSimuladoFmt": "R$ 380",
    "menorPedidoSimuladoFmt": "R$ 229",
    "primeiraCompraSimulada": "18/02/2026",
    "ultimaCompraSimulada": "16/04/2026",
    "diasDesdeUltimaCompraSimulado": 28,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0641"
  },
  {
    "clienteId": "CLI_0642",
    "clienteAnonimo": "641",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 292,
    "ticketMedianoSimulado": 270,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 292,
    "maiorPedidoSimulado": 323,
    "menorPedidoSimulado": 179,
    "ticketMedioSimuladoFmt": "R$ 292",
    "ticketMedianoSimuladoFmt": "R$ 270",
    "valorTotalAcumuladoSimuladoFmt": "R$ 292",
    "maiorPedidoSimuladoFmt": "R$ 323",
    "menorPedidoSimuladoFmt": "R$ 179",
    "primeiraCompraSimulada": "02/02/2026",
    "ultimaCompraSimulada": "04/05/2026",
    "diasDesdeUltimaCompraSimulado": 10,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0642"
  },
  {
    "clienteId": "CLI_0643",
    "clienteAnonimo": "642",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 294,
    "ticketMedianoSimulado": 294,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 882,
    "maiorPedidoSimulado": 319,
    "menorPedidoSimulado": 174,
    "ticketMedioSimuladoFmt": "R$ 294",
    "ticketMedianoSimuladoFmt": "R$ 294",
    "valorTotalAcumuladoSimuladoFmt": "R$ 882",
    "maiorPedidoSimuladoFmt": "R$ 319",
    "menorPedidoSimuladoFmt": "R$ 174",
    "primeiraCompraSimulada": "17/01/2026",
    "ultimaCompraSimulada": "23/04/2026",
    "diasDesdeUltimaCompraSimulado": 21,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0643"
  },
  {
    "clienteId": "CLI_0644",
    "clienteAnonimo": "643",
    "segmentoComercial": "Cliente possível coletivo",
    "ticketMedioSimulado": 1627,
    "ticketMedianoSimulado": 1510,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 3254,
    "maiorPedidoSimulado": 1913,
    "menorPedidoSimulado": 1133,
    "ticketMedioSimuladoFmt": "R$ 1.627",
    "ticketMedianoSimuladoFmt": "R$ 1.510",
    "valorTotalAcumuladoSimuladoFmt": "R$ 3.254",
    "maiorPedidoSimuladoFmt": "R$ 1.913",
    "menorPedidoSimuladoFmt": "R$ 1.133",
    "primeiraCompraSimulada": "01/01/2026",
    "ultimaCompraSimulada": "22/03/2026",
    "diasDesdeUltimaCompraSimulado": 53,
    "hipoteseDePerfil": "Possível compra coletiva, familiar ampliada ou corporativa. Não afirmar sem confirmação.",
    "objetivoProvavel": "Pode comprar para mais de uma pessoa, família ou equipe",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Tratar como hipótese de compra coletiva — G09 ativo.",
    "alertaSimulacao": "Possível compra familiar, equipe ou coletiva. Confirmar antes de assumir.",
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0644"
  },
  {
    "clienteId": "CLI_0645",
    "clienteAnonimo": "644",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 347,
    "ticketMedianoSimulado": 342,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 694,
    "maiorPedidoSimulado": 394,
    "menorPedidoSimulado": 225,
    "ticketMedioSimuladoFmt": "R$ 347",
    "ticketMedianoSimuladoFmt": "R$ 342",
    "valorTotalAcumuladoSimuladoFmt": "R$ 694",
    "maiorPedidoSimuladoFmt": "R$ 394",
    "menorPedidoSimuladoFmt": "R$ 225",
    "primeiraCompraSimulada": "17/12/2025",
    "ultimaCompraSimulada": "17/03/2026",
    "diasDesdeUltimaCompraSimulado": 58,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0645"
  },
  {
    "clienteId": "CLI_0646",
    "clienteAnonimo": "645",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 373,
    "ticketMedianoSimulado": 352,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 746,
    "maiorPedidoSimulado": 394,
    "menorPedidoSimulado": 208,
    "ticketMedioSimuladoFmt": "R$ 373",
    "ticketMedianoSimuladoFmt": "R$ 352",
    "valorTotalAcumuladoSimuladoFmt": "R$ 746",
    "maiorPedidoSimuladoFmt": "R$ 394",
    "menorPedidoSimuladoFmt": "R$ 208",
    "primeiraCompraSimulada": "01/12/2025",
    "ultimaCompraSimulada": "17/04/2026",
    "diasDesdeUltimaCompraSimulado": 27,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0646"
  },
  {
    "clienteId": "CLI_0647",
    "clienteAnonimo": "646",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 399,
    "ticketMedianoSimulado": 387,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 798,
    "maiorPedidoSimulado": 457,
    "menorPedidoSimulado": 264,
    "ticketMedioSimuladoFmt": "R$ 399",
    "ticketMedianoSimuladoFmt": "R$ 387",
    "valorTotalAcumuladoSimuladoFmt": "R$ 798",
    "maiorPedidoSimuladoFmt": "R$ 457",
    "menorPedidoSimuladoFmt": "R$ 264",
    "primeiraCompraSimulada": "15/11/2025",
    "ultimaCompraSimulada": "26/04/2026",
    "diasDesdeUltimaCompraSimulado": 18,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0647"
  },
  {
    "clienteId": "CLI_0648",
    "clienteAnonimo": "647",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 425,
    "ticketMedianoSimulado": 407,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 850,
    "maiorPedidoSimulado": 495,
    "menorPedidoSimulado": 290,
    "ticketMedioSimuladoFmt": "R$ 425",
    "ticketMedianoSimuladoFmt": "R$ 407",
    "valorTotalAcumuladoSimuladoFmt": "R$ 850",
    "maiorPedidoSimuladoFmt": "R$ 495",
    "menorPedidoSimuladoFmt": "R$ 290",
    "primeiraCompraSimulada": "30/10/2025",
    "ultimaCompraSimulada": "11/03/2026",
    "diasDesdeUltimaCompraSimulado": 64,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0648"
  },
  {
    "clienteId": "CLI_0649",
    "clienteAnonimo": "648",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 449,
    "ticketMedianoSimulado": 429,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 898,
    "maiorPedidoSimulado": 482,
    "menorPedidoSimulado": 259,
    "ticketMedioSimuladoFmt": "R$ 449",
    "ticketMedianoSimuladoFmt": "R$ 429",
    "valorTotalAcumuladoSimuladoFmt": "R$ 898",
    "maiorPedidoSimuladoFmt": "R$ 482",
    "menorPedidoSimuladoFmt": "R$ 259",
    "primeiraCompraSimulada": "12/11/2025",
    "ultimaCompraSimulada": "18/02/2026",
    "diasDesdeUltimaCompraSimulado": 85,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0649"
  },
  {
    "clienteId": "CLI_0650",
    "clienteAnonimo": "649",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 401,
    "ticketMedianoSimulado": 378,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 401,
    "maiorPedidoSimulado": 438,
    "menorPedidoSimulado": 240,
    "ticketMedioSimuladoFmt": "R$ 401",
    "ticketMedianoSimuladoFmt": "R$ 378",
    "valorTotalAcumuladoSimuladoFmt": "R$ 401",
    "maiorPedidoSimuladoFmt": "R$ 438",
    "menorPedidoSimuladoFmt": "R$ 240",
    "primeiraCompraSimulada": "31/12/2025",
    "ultimaCompraSimulada": "28/04/2026",
    "diasDesdeUltimaCompraSimulado": 16,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0650"
  },
  {
    "clienteId": "CLI_0651",
    "clienteAnonimo": "650",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 427,
    "ticketMedianoSimulado": 420,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1281,
    "maiorPedidoSimulado": 505,
    "menorPedidoSimulado": 301,
    "ticketMedioSimuladoFmt": "R$ 427",
    "ticketMedianoSimuladoFmt": "R$ 420",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.281",
    "maiorPedidoSimuladoFmt": "R$ 505",
    "menorPedidoSimuladoFmt": "R$ 301",
    "primeiraCompraSimulada": "16/01/2026",
    "ultimaCompraSimulada": "03/04/2026",
    "diasDesdeUltimaCompraSimulado": 41,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0651"
  },
  {
    "clienteId": "CLI_0652",
    "clienteAnonimo": "651",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 447,
    "ticketMedianoSimulado": 415,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 447,
    "maiorPedidoSimulado": 504,
    "menorPedidoSimulado": 286,
    "ticketMedioSimuladoFmt": "R$ 447",
    "ticketMedianoSimuladoFmt": "R$ 415",
    "valorTotalAcumuladoSimuladoFmt": "R$ 447",
    "maiorPedidoSimuladoFmt": "R$ 504",
    "menorPedidoSimuladoFmt": "R$ 286",
    "primeiraCompraSimulada": "01/02/2026",
    "ultimaCompraSimulada": "29/03/2026",
    "diasDesdeUltimaCompraSimulado": 46,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0652"
  },
  {
    "clienteId": "CLI_0653",
    "clienteAnonimo": "652",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 421,
    "ticketMedianoSimulado": 420,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1263,
    "maiorPedidoSimulado": 447,
    "menorPedidoSimulado": 238,
    "ticketMedioSimuladoFmt": "R$ 421",
    "ticketMedianoSimuladoFmt": "R$ 420",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.263",
    "maiorPedidoSimuladoFmt": "R$ 447",
    "menorPedidoSimuladoFmt": "R$ 238",
    "primeiraCompraSimulada": "17/02/2026",
    "ultimaCompraSimulada": "24/04/2026",
    "diasDesdeUltimaCompraSimulado": 20,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0653"
  },
  {
    "clienteId": "CLI_0654",
    "clienteAnonimo": "653",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 394,
    "ticketMedianoSimulado": 365,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 788,
    "maiorPedidoSimulado": 454,
    "menorPedidoSimulado": 264,
    "ticketMedioSimuladoFmt": "R$ 394",
    "ticketMedianoSimuladoFmt": "R$ 365",
    "valorTotalAcumuladoSimuladoFmt": "R$ 788",
    "maiorPedidoSimuladoFmt": "R$ 454",
    "menorPedidoSimuladoFmt": "R$ 264",
    "primeiraCompraSimulada": "05/03/2026",
    "ultimaCompraSimulada": "09/05/2026",
    "diasDesdeUltimaCompraSimulado": 5,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0654"
  },
  {
    "clienteId": "CLI_0655",
    "clienteAnonimo": "654",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 368,
    "ticketMedianoSimulado": 363,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 736,
    "maiorPedidoSimulado": 426,
    "menorPedidoSimulado": 248,
    "ticketMedioSimuladoFmt": "R$ 368",
    "ticketMedianoSimuladoFmt": "R$ 363",
    "valorTotalAcumuladoSimuladoFmt": "R$ 736",
    "maiorPedidoSimuladoFmt": "R$ 426",
    "menorPedidoSimuladoFmt": "R$ 248",
    "primeiraCompraSimulada": "21/03/2026",
    "ultimaCompraSimulada": "28/04/2026",
    "diasDesdeUltimaCompraSimulado": 16,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0655"
  },
  {
    "clienteId": "CLI_0656",
    "clienteAnonimo": "655",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 342,
    "ticketMedianoSimulado": 321,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 684,
    "maiorPedidoSimulado": 365,
    "menorPedidoSimulado": 195,
    "ticketMedioSimuladoFmt": "R$ 342",
    "ticketMedianoSimuladoFmt": "R$ 321",
    "valorTotalAcumuladoSimuladoFmt": "R$ 684",
    "maiorPedidoSimuladoFmt": "R$ 365",
    "menorPedidoSimuladoFmt": "R$ 195",
    "primeiraCompraSimulada": "06/04/2026",
    "ultimaCompraSimulada": "24/04/2026",
    "diasDesdeUltimaCompraSimulado": 20,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0656"
  },
  {
    "clienteId": "CLI_0657",
    "clienteAnonimo": "656",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 316,
    "ticketMedianoSimulado": 307,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 632,
    "maiorPedidoSimulado": 355,
    "menorPedidoSimulado": 201,
    "ticketMedioSimuladoFmt": "R$ 316",
    "ticketMedianoSimuladoFmt": "R$ 307",
    "valorTotalAcumuladoSimuladoFmt": "R$ 632",
    "maiorPedidoSimuladoFmt": "R$ 355",
    "menorPedidoSimuladoFmt": "R$ 201",
    "primeiraCompraSimulada": "06/04/2026",
    "ultimaCompraSimulada": "01/05/2026",
    "diasDesdeUltimaCompraSimulado": 13,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0657"
  },
  {
    "clienteId": "CLI_0658",
    "clienteAnonimo": "657",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 290,
    "ticketMedianoSimulado": 277,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 580,
    "maiorPedidoSimulado": 344,
    "menorPedidoSimulado": 206,
    "ticketMedioSimuladoFmt": "R$ 290",
    "ticketMedianoSimuladoFmt": "R$ 277",
    "valorTotalAcumuladoSimuladoFmt": "R$ 580",
    "maiorPedidoSimuladoFmt": "R$ 344",
    "menorPedidoSimuladoFmt": "R$ 206",
    "primeiraCompraSimulada": "21/03/2026",
    "ultimaCompraSimulada": "09/05/2026",
    "diasDesdeUltimaCompraSimulado": 5,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0658"
  },
  {
    "clienteId": "CLI_0659",
    "clienteAnonimo": "658",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 297,
    "ticketMedianoSimulado": 285,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 594,
    "maiorPedidoSimulado": 326,
    "menorPedidoSimulado": 179,
    "ticketMedioSimuladoFmt": "R$ 297",
    "ticketMedianoSimuladoFmt": "R$ 285",
    "valorTotalAcumuladoSimuladoFmt": "R$ 594",
    "maiorPedidoSimuladoFmt": "R$ 326",
    "menorPedidoSimuladoFmt": "R$ 179",
    "primeiraCompraSimulada": "05/03/2026",
    "ultimaCompraSimulada": "29/04/2026",
    "diasDesdeUltimaCompraSimulado": 15,
    "hipoteseDePerfil": "Compra compatível com rotina de marmitas e recompra planejada.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0659"
  },
  {
    "clienteId": "CLI_0660",
    "clienteAnonimo": "659",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 314,
    "ticketMedianoSimulado": 297,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 314,
    "maiorPedidoSimulado": 336,
    "menorPedidoSimulado": 179,
    "ticketMedioSimuladoFmt": "R$ 314",
    "ticketMedianoSimuladoFmt": "R$ 297",
    "valorTotalAcumuladoSimuladoFmt": "R$ 314",
    "maiorPedidoSimuladoFmt": "R$ 336",
    "menorPedidoSimuladoFmt": "R$ 179",
    "primeiraCompraSimulada": "16/01/2026",
    "ultimaCompraSimulada": "11/04/2026",
    "diasDesdeUltimaCompraSimulado": 33,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0660"
  },
  {
    "clienteId": "CLI_0661",
    "clienteAnonimo": "660",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 288,
    "ticketMedianoSimulado": 283,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 864,
    "maiorPedidoSimulado": 334,
    "menorPedidoSimulado": 195,
    "ticketMedioSimuladoFmt": "R$ 288",
    "ticketMedianoSimuladoFmt": "R$ 283",
    "valorTotalAcumuladoSimuladoFmt": "R$ 864",
    "maiorPedidoSimuladoFmt": "R$ 334",
    "menorPedidoSimuladoFmt": "R$ 195",
    "primeiraCompraSimulada": "31/12/2025",
    "ultimaCompraSimulada": "07/05/2026",
    "diasDesdeUltimaCompraSimulado": 7,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0661"
  },
  {
    "clienteId": "CLI_0662",
    "clienteAnonimo": "661",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 298,
    "ticketMedianoSimulado": 278,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 298,
    "maiorPedidoSimulado": 343,
    "menorPedidoSimulado": 199,
    "ticketMedioSimuladoFmt": "R$ 298",
    "ticketMedianoSimuladoFmt": "R$ 278",
    "valorTotalAcumuladoSimuladoFmt": "R$ 298",
    "maiorPedidoSimuladoFmt": "R$ 343",
    "menorPedidoSimuladoFmt": "R$ 199",
    "primeiraCompraSimulada": "15/12/2025",
    "ultimaCompraSimulada": "12/04/2026",
    "diasDesdeUltimaCompraSimulado": 32,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0662"
  },
  {
    "clienteId": "CLI_0663",
    "clienteAnonimo": "662",
    "segmentoComercial": "Cliente possível coletivo",
    "ticketMedioSimulado": 1673,
    "ticketMedianoSimulado": 1666,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 5019,
    "maiorPedidoSimulado": 1775,
    "menorPedidoSimulado": 941,
    "ticketMedioSimuladoFmt": "R$ 1.673",
    "ticketMedianoSimuladoFmt": "R$ 1.666",
    "valorTotalAcumuladoSimuladoFmt": "R$ 5.019",
    "maiorPedidoSimuladoFmt": "R$ 1.775",
    "menorPedidoSimuladoFmt": "R$ 941",
    "primeiraCompraSimulada": "29/11/2025",
    "ultimaCompraSimulada": "02/03/2026",
    "diasDesdeUltimaCompraSimulado": 73,
    "hipoteseDePerfil": "Possível compra coletiva, familiar ampliada ou corporativa. Não afirmar sem confirmação.",
    "objetivoProvavel": "Pode comprar para mais de uma pessoa, família ou equipe",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Tratar como hipótese de compra coletiva — G09 ativo.",
    "alertaSimulacao": "Possível compra familiar, equipe ou coletiva. Confirmar antes de assumir.",
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0663"
  },
  {
    "clienteId": "CLI_0664",
    "clienteAnonimo": "663",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 351,
    "ticketMedianoSimulado": 324,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 351,
    "maiorPedidoSimulado": 396,
    "menorPedidoSimulado": 226,
    "ticketMedioSimuladoFmt": "R$ 351",
    "ticketMedianoSimuladoFmt": "R$ 324",
    "valorTotalAcumuladoSimuladoFmt": "R$ 351",
    "maiorPedidoSimuladoFmt": "R$ 396",
    "menorPedidoSimuladoFmt": "R$ 226",
    "primeiraCompraSimulada": "13/11/2025",
    "ultimaCompraSimulada": "12/03/2026",
    "diasDesdeUltimaCompraSimulado": 63,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0664"
  },
  {
    "clienteId": "CLI_0665",
    "clienteAnonimo": "664",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 377,
    "ticketMedianoSimulado": 373,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 754,
    "maiorPedidoSimulado": 445,
    "menorPedidoSimulado": 265,
    "ticketMedioSimuladoFmt": "R$ 377",
    "ticketMedianoSimuladoFmt": "R$ 373",
    "valorTotalAcumuladoSimuladoFmt": "R$ 754",
    "maiorPedidoSimuladoFmt": "R$ 445",
    "menorPedidoSimuladoFmt": "R$ 265",
    "primeiraCompraSimulada": "29/10/2025",
    "ultimaCompraSimulada": "21/04/2026",
    "diasDesdeUltimaCompraSimulado": 23,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0665"
  },
  {
    "clienteId": "CLI_0666",
    "clienteAnonimo": "665",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 403,
    "ticketMedianoSimulado": 378,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 806,
    "maiorPedidoSimulado": 439,
    "menorPedidoSimulado": 241,
    "ticketMedioSimuladoFmt": "R$ 403",
    "ticketMedianoSimuladoFmt": "R$ 378",
    "valorTotalAcumuladoSimuladoFmt": "R$ 806",
    "maiorPedidoSimuladoFmt": "R$ 439",
    "menorPedidoSimuladoFmt": "R$ 241",
    "primeiraCompraSimulada": "14/11/2025",
    "ultimaCompraSimulada": "19/04/2026",
    "diasDesdeUltimaCompraSimulado": 25,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0666"
  },
  {
    "clienteId": "CLI_0667",
    "clienteAnonimo": "666",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 430,
    "ticketMedianoSimulado": 419,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 860,
    "maiorPedidoSimulado": 473,
    "menorPedidoSimulado": 262,
    "ticketMedioSimuladoFmt": "R$ 430",
    "ticketMedianoSimuladoFmt": "R$ 419",
    "valorTotalAcumuladoSimuladoFmt": "R$ 860",
    "maiorPedidoSimuladoFmt": "R$ 473",
    "menorPedidoSimuladoFmt": "R$ 262",
    "primeiraCompraSimulada": "30/11/2025",
    "ultimaCompraSimulada": "14/03/2026",
    "diasDesdeUltimaCompraSimulado": 61,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0667"
  },
  {
    "clienteId": "CLI_0668",
    "clienteAnonimo": "667",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 444,
    "ticketMedianoSimulado": 423,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 888,
    "maiorPedidoSimulado": 528,
    "menorPedidoSimulado": 317,
    "ticketMedioSimuladoFmt": "R$ 444",
    "ticketMedianoSimuladoFmt": "R$ 423",
    "valorTotalAcumuladoSimuladoFmt": "R$ 888",
    "maiorPedidoSimuladoFmt": "R$ 528",
    "menorPedidoSimuladoFmt": "R$ 317",
    "primeiraCompraSimulada": "16/12/2025",
    "ultimaCompraSimulada": "12/03/2026",
    "diasDesdeUltimaCompraSimulado": 63,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0668"
  },
  {
    "clienteId": "CLI_0669",
    "clienteAnonimo": "668",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 418,
    "ticketMedianoSimulado": 402,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 836,
    "maiorPedidoSimulado": 468,
    "menorPedidoSimulado": 264,
    "ticketMedioSimuladoFmt": "R$ 418",
    "ticketMedianoSimuladoFmt": "R$ 402",
    "valorTotalAcumuladoSimuladoFmt": "R$ 836",
    "maiorPedidoSimuladoFmt": "R$ 468",
    "menorPedidoSimuladoFmt": "R$ 264",
    "primeiraCompraSimulada": "01/01/2026",
    "ultimaCompraSimulada": "18/04/2026",
    "diasDesdeUltimaCompraSimulado": 26,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0669"
  },
  {
    "clienteId": "CLI_0670",
    "clienteAnonimo": "669",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 431,
    "ticketMedianoSimulado": 409,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 431,
    "maiorPedidoSimulado": 455,
    "menorPedidoSimulado": 239,
    "ticketMedioSimuladoFmt": "R$ 431",
    "ticketMedianoSimuladoFmt": "R$ 409",
    "valorTotalAcumuladoSimuladoFmt": "R$ 431",
    "maiorPedidoSimuladoFmt": "R$ 455",
    "menorPedidoSimuladoFmt": "R$ 239",
    "primeiraCompraSimulada": "18/02/2026",
    "ultimaCompraSimulada": "10/04/2026",
    "diasDesdeUltimaCompraSimulado": 34,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0670"
  },
  {
    "clienteId": "CLI_0671",
    "clienteAnonimo": "670",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 443,
    "ticketMedianoSimulado": 434,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1329,
    "maiorPedidoSimulado": 503,
    "menorPedidoSimulado": 288,
    "ticketMedioSimuladoFmt": "R$ 443",
    "ticketMedianoSimuladoFmt": "R$ 434",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.329",
    "maiorPedidoSimuladoFmt": "R$ 503",
    "menorPedidoSimuladoFmt": "R$ 288",
    "primeiraCompraSimulada": "06/03/2026",
    "ultimaCompraSimulada": "15/04/2026",
    "diasDesdeUltimaCompraSimulado": 29,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0671"
  },
  {
    "clienteId": "CLI_0672",
    "clienteAnonimo": "671",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 416,
    "ticketMedianoSimulado": 388,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 416,
    "maiorPedidoSimulado": 488,
    "menorPedidoSimulado": 289,
    "ticketMedioSimuladoFmt": "R$ 416",
    "ticketMedianoSimuladoFmt": "R$ 388",
    "valorTotalAcumuladoSimuladoFmt": "R$ 416",
    "maiorPedidoSimuladoFmt": "R$ 488",
    "menorPedidoSimuladoFmt": "R$ 289",
    "primeiraCompraSimulada": "22/03/2026",
    "ultimaCompraSimulada": "03/05/2026",
    "diasDesdeUltimaCompraSimulado": 11,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0672"
  },
  {
    "clienteId": "CLI_0673",
    "clienteAnonimo": "672",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 390,
    "ticketMedianoSimulado": 387,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1170,
    "maiorPedidoSimulado": 423,
    "menorPedidoSimulado": 230,
    "ticketMedioSimuladoFmt": "R$ 390",
    "ticketMedianoSimuladoFmt": "R$ 387",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.170",
    "maiorPedidoSimuladoFmt": "R$ 423",
    "menorPedidoSimuladoFmt": "R$ 230",
    "primeiraCompraSimulada": "07/04/2026",
    "ultimaCompraSimulada": "09/05/2026",
    "diasDesdeUltimaCompraSimulado": 5,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0673"
  },
  {
    "clienteId": "CLI_0674",
    "clienteAnonimo": "673",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 364,
    "ticketMedianoSimulado": 335,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 364,
    "maiorPedidoSimulado": 403,
    "menorPedidoSimulado": 224,
    "ticketMedioSimuladoFmt": "R$ 364",
    "ticketMedianoSimuladoFmt": "R$ 335",
    "valorTotalAcumuladoSimuladoFmt": "R$ 364",
    "maiorPedidoSimuladoFmt": "R$ 403",
    "menorPedidoSimuladoFmt": "R$ 224",
    "primeiraCompraSimulada": "05/04/2026",
    "ultimaCompraSimulada": "30/04/2026",
    "diasDesdeUltimaCompraSimulado": 14,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0674"
  },
  {
    "clienteId": "CLI_0675",
    "clienteAnonimo": "674",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 338,
    "ticketMedianoSimulado": 335,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 676,
    "maiorPedidoSimulado": 404,
    "menorPedidoSimulado": 244,
    "ticketMedioSimuladoFmt": "R$ 338",
    "ticketMedianoSimuladoFmt": "R$ 335",
    "valorTotalAcumuladoSimuladoFmt": "R$ 676",
    "maiorPedidoSimuladoFmt": "R$ 404",
    "menorPedidoSimuladoFmt": "R$ 244",
    "primeiraCompraSimulada": "20/03/2026",
    "ultimaCompraSimulada": "17/04/2026",
    "diasDesdeUltimaCompraSimulado": 27,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0675"
  },
  {
    "clienteId": "CLI_0676",
    "clienteAnonimo": "675",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 311,
    "ticketMedianoSimulado": 291,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 622,
    "maiorPedidoSimulado": 346,
    "menorPedidoSimulado": 194,
    "ticketMedioSimuladoFmt": "R$ 311",
    "ticketMedianoSimuladoFmt": "R$ 291",
    "valorTotalAcumuladoSimuladoFmt": "R$ 622",
    "maiorPedidoSimuladoFmt": "R$ 346",
    "menorPedidoSimuladoFmt": "R$ 194",
    "primeiraCompraSimulada": "04/03/2026",
    "ultimaCompraSimulada": "25/04/2026",
    "diasDesdeUltimaCompraSimulado": 19,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0676"
  },
  {
    "clienteId": "CLI_0677",
    "clienteAnonimo": "676",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 285,
    "ticketMedianoSimulado": 279,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 570,
    "maiorPedidoSimulado": 307,
    "menorPedidoSimulado": 166,
    "ticketMedioSimuladoFmt": "R$ 285",
    "ticketMedianoSimuladoFmt": "R$ 279",
    "valorTotalAcumuladoSimuladoFmt": "R$ 570",
    "maiorPedidoSimuladoFmt": "R$ 307",
    "menorPedidoSimuladoFmt": "R$ 166",
    "primeiraCompraSimulada": "16/02/2026",
    "ultimaCompraSimulada": "11/05/2026",
    "diasDesdeUltimaCompraSimulado": 3,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0677"
  },
  {
    "clienteId": "CLI_0678",
    "clienteAnonimo": "677",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 301,
    "ticketMedianoSimulado": 286,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 602,
    "maiorPedidoSimulado": 351,
    "menorPedidoSimulado": 207,
    "ticketMedioSimuladoFmt": "R$ 301",
    "ticketMedianoSimuladoFmt": "R$ 286",
    "valorTotalAcumuladoSimuladoFmt": "R$ 602",
    "maiorPedidoSimuladoFmt": "R$ 351",
    "menorPedidoSimuladoFmt": "R$ 207",
    "primeiraCompraSimulada": "31/01/2026",
    "ultimaCompraSimulada": "18/04/2026",
    "diasDesdeUltimaCompraSimulado": 26,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0678"
  },
  {
    "clienteId": "CLI_0679",
    "clienteAnonimo": "678",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 327,
    "ticketMedianoSimulado": 315,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 654,
    "maiorPedidoSimulado": 374,
    "menorPedidoSimulado": 215,
    "ticketMedioSimuladoFmt": "R$ 327",
    "ticketMedianoSimuladoFmt": "R$ 315",
    "valorTotalAcumuladoSimuladoFmt": "R$ 654",
    "maiorPedidoSimuladoFmt": "R$ 374",
    "menorPedidoSimuladoFmt": "R$ 215",
    "primeiraCompraSimulada": "15/01/2026",
    "ultimaCompraSimulada": "19/03/2026",
    "diasDesdeUltimaCompraSimulado": 56,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0679"
  },
  {
    "clienteId": "CLI_0680",
    "clienteAnonimo": "679",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 283,
    "ticketMedianoSimulado": 269,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 283,
    "maiorPedidoSimulado": 305,
    "menorPedidoSimulado": 165,
    "ticketMedioSimuladoFmt": "R$ 283",
    "ticketMedianoSimuladoFmt": "R$ 269",
    "valorTotalAcumuladoSimuladoFmt": "R$ 283",
    "maiorPedidoSimuladoFmt": "R$ 305",
    "menorPedidoSimuladoFmt": "R$ 165",
    "primeiraCompraSimulada": "28/11/2025",
    "ultimaCompraSimulada": "09/05/2026",
    "diasDesdeUltimaCompraSimulado": 5,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0680"
  },
  {
    "clienteId": "CLI_0681",
    "clienteAnonimo": "680",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 303,
    "ticketMedianoSimulado": 296,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 909,
    "maiorPedidoSimulado": 337,
    "menorPedidoSimulado": 189,
    "ticketMedioSimuladoFmt": "R$ 303",
    "ticketMedianoSimuladoFmt": "R$ 296",
    "valorTotalAcumuladoSimuladoFmt": "R$ 909",
    "maiorPedidoSimuladoFmt": "R$ 337",
    "menorPedidoSimuladoFmt": "R$ 189",
    "primeiraCompraSimulada": "12/11/2025",
    "ultimaCompraSimulada": "28/03/2026",
    "diasDesdeUltimaCompraSimulado": 47,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0681"
  },
  {
    "clienteId": "CLI_0682",
    "clienteAnonimo": "681",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 329,
    "ticketMedianoSimulado": 308,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 329,
    "maiorPedidoSimulado": 394,
    "menorPedidoSimulado": 238,
    "ticketMedioSimuladoFmt": "R$ 329",
    "ticketMedianoSimuladoFmt": "R$ 308",
    "valorTotalAcumuladoSimuladoFmt": "R$ 329",
    "maiorPedidoSimuladoFmt": "R$ 394",
    "menorPedidoSimuladoFmt": "R$ 238",
    "primeiraCompraSimulada": "30/10/2025",
    "ultimaCompraSimulada": "08/02/2026",
    "diasDesdeUltimaCompraSimulado": 95,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0682"
  },
  {
    "clienteId": "CLI_0683",
    "clienteAnonimo": "682",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 355,
    "ticketMedianoSimulado": 352,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1065,
    "maiorPedidoSimulado": 393,
    "menorPedidoSimulado": 219,
    "ticketMedioSimuladoFmt": "R$ 355",
    "ticketMedianoSimuladoFmt": "R$ 352",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.065",
    "maiorPedidoSimuladoFmt": "R$ 393",
    "menorPedidoSimuladoFmt": "R$ 219",
    "primeiraCompraSimulada": "15/11/2025",
    "ultimaCompraSimulada": "20/03/2026",
    "diasDesdeUltimaCompraSimulado": 55,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0683"
  },
  {
    "clienteId": "CLI_0684",
    "clienteAnonimo": "683",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 381,
    "ticketMedianoSimulado": 351,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 381,
    "maiorPedidoSimulado": 413,
    "menorPedidoSimulado": 224,
    "ticketMedioSimuladoFmt": "R$ 381",
    "ticketMedianoSimuladoFmt": "R$ 351",
    "valorTotalAcumuladoSimuladoFmt": "R$ 381",
    "maiorPedidoSimuladoFmt": "R$ 413",
    "menorPedidoSimuladoFmt": "R$ 224",
    "primeiraCompraSimulada": "01/12/2025",
    "ultimaCompraSimulada": "01/05/2026",
    "diasDesdeUltimaCompraSimulado": 13,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0684"
  },
  {
    "clienteId": "CLI_0685",
    "clienteAnonimo": "684",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 408,
    "ticketMedianoSimulado": 406,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 816,
    "maiorPedidoSimulado": 479,
    "menorPedidoSimulado": 283,
    "ticketMedioSimuladoFmt": "R$ 408",
    "ticketMedianoSimuladoFmt": "R$ 406",
    "valorTotalAcumuladoSimuladoFmt": "R$ 816",
    "maiorPedidoSimuladoFmt": "R$ 479",
    "menorPedidoSimuladoFmt": "R$ 283",
    "primeiraCompraSimulada": "17/12/2025",
    "ultimaCompraSimulada": "16/04/2026",
    "diasDesdeUltimaCompraSimulado": 28,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0685"
  },
  {
    "clienteId": "CLI_0686",
    "clienteAnonimo": "685",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 434,
    "ticketMedianoSimulado": 405,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 868,
    "maiorPedidoSimulado": 493,
    "menorPedidoSimulado": 283,
    "ticketMedioSimuladoFmt": "R$ 434",
    "ticketMedianoSimuladoFmt": "R$ 405",
    "valorTotalAcumuladoSimuladoFmt": "R$ 868",
    "maiorPedidoSimuladoFmt": "R$ 493",
    "menorPedidoSimuladoFmt": "R$ 283",
    "primeiraCompraSimulada": "02/01/2026",
    "ultimaCompraSimulada": "20/03/2026",
    "diasDesdeUltimaCompraSimulado": 55,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Alta",
    "propensaoACrossSell": "Alta",
    "interesseEmAcompCalorico": "Alto",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0686"
  },
  {
    "clienteId": "CLI_0687",
    "clienteAnonimo": "686",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 440,
    "ticketMedianoSimulado": 431,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 880,
    "maiorPedidoSimulado": 464,
    "menorPedidoSimulado": 244,
    "ticketMedioSimuladoFmt": "R$ 440",
    "ticketMedianoSimuladoFmt": "R$ 431",
    "valorTotalAcumuladoSimuladoFmt": "R$ 880",
    "maiorPedidoSimuladoFmt": "R$ 464",
    "menorPedidoSimuladoFmt": "R$ 244",
    "primeiraCompraSimulada": "18/01/2026",
    "ultimaCompraSimulada": "31/03/2026",
    "diasDesdeUltimaCompraSimulado": 44,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0687"
  },
  {
    "clienteId": "CLI_0688",
    "clienteAnonimo": "687",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 414,
    "ticketMedianoSimulado": 392,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 828,
    "maiorPedidoSimulado": 474,
    "menorPedidoSimulado": 273,
    "ticketMedioSimuladoFmt": "R$ 414",
    "ticketMedianoSimuladoFmt": "R$ 392",
    "valorTotalAcumuladoSimuladoFmt": "R$ 828",
    "maiorPedidoSimuladoFmt": "R$ 474",
    "menorPedidoSimuladoFmt": "R$ 273",
    "primeiraCompraSimulada": "03/02/2026",
    "ultimaCompraSimulada": "28/04/2026",
    "diasDesdeUltimaCompraSimulado": 16,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0688"
  },
  {
    "clienteId": "CLI_0689",
    "clienteAnonimo": "688",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 387,
    "ticketMedianoSimulado": 374,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 774,
    "maiorPedidoSimulado": 451,
    "menorPedidoSimulado": 265,
    "ticketMedioSimuladoFmt": "R$ 387",
    "ticketMedianoSimuladoFmt": "R$ 374",
    "valorTotalAcumuladoSimuladoFmt": "R$ 774",
    "maiorPedidoSimuladoFmt": "R$ 451",
    "menorPedidoSimuladoFmt": "R$ 265",
    "primeiraCompraSimulada": "19/02/2026",
    "ultimaCompraSimulada": "03/05/2026",
    "diasDesdeUltimaCompraSimulado": 11,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0689"
  },
  {
    "clienteId": "CLI_0690",
    "clienteAnonimo": "689",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 438,
    "ticketMedianoSimulado": 418,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 438,
    "maiorPedidoSimulado": 482,
    "menorPedidoSimulado": 267,
    "ticketMedioSimuladoFmt": "R$ 438",
    "ticketMedianoSimuladoFmt": "R$ 418",
    "valorTotalAcumuladoSimuladoFmt": "R$ 438",
    "maiorPedidoSimuladoFmt": "R$ 482",
    "menorPedidoSimuladoFmt": "R$ 267",
    "primeiraCompraSimulada": "08/04/2026",
    "ultimaCompraSimulada": "29/04/2026",
    "diasDesdeUltimaCompraSimulado": 15,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0690"
  },
  {
    "clienteId": "CLI_0691",
    "clienteAnonimo": "690",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 412,
    "ticketMedianoSimulado": 401,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1236,
    "maiorPedidoSimulado": 449,
    "menorPedidoSimulado": 245,
    "ticketMedioSimuladoFmt": "R$ 412",
    "ticketMedianoSimuladoFmt": "R$ 401",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.236",
    "maiorPedidoSimuladoFmt": "R$ 449",
    "menorPedidoSimuladoFmt": "R$ 245",
    "primeiraCompraSimulada": "04/04/2026",
    "ultimaCompraSimulada": "07/05/2026",
    "diasDesdeUltimaCompraSimulado": 7,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0691"
  },
  {
    "clienteId": "CLI_0692",
    "clienteAnonimo": "691",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 386,
    "ticketMedianoSimulado": 362,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 386,
    "maiorPedidoSimulado": 455,
    "menorPedidoSimulado": 271,
    "ticketMedioSimuladoFmt": "R$ 386",
    "ticketMedianoSimuladoFmt": "R$ 362",
    "valorTotalAcumuladoSimuladoFmt": "R$ 386",
    "maiorPedidoSimuladoFmt": "R$ 455",
    "menorPedidoSimuladoFmt": "R$ 271",
    "primeiraCompraSimulada": "19/03/2026",
    "ultimaCompraSimulada": "05/05/2026",
    "diasDesdeUltimaCompraSimulado": 9,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Baixa (já alto)",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0692"
  },
  {
    "clienteId": "CLI_0693",
    "clienteAnonimo": "692",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 359,
    "ticketMedianoSimulado": 355,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1077,
    "maiorPedidoSimulado": 406,
    "menorPedidoSimulado": 231,
    "ticketMedioSimuladoFmt": "R$ 359",
    "ticketMedianoSimuladoFmt": "R$ 355",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.077",
    "maiorPedidoSimuladoFmt": "R$ 406",
    "menorPedidoSimuladoFmt": "R$ 231",
    "primeiraCompraSimulada": "03/03/2026",
    "ultimaCompraSimulada": "17/04/2026",
    "diasDesdeUltimaCompraSimulado": 27,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0693"
  },
  {
    "clienteId": "CLI_0694",
    "clienteAnonimo": "693",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 333,
    "ticketMedianoSimulado": 308,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 333,
    "maiorPedidoSimulado": 353,
    "menorPedidoSimulado": 187,
    "ticketMedioSimuladoFmt": "R$ 333",
    "ticketMedianoSimuladoFmt": "R$ 308",
    "valorTotalAcumuladoSimuladoFmt": "R$ 333",
    "maiorPedidoSimuladoFmt": "R$ 353",
    "menorPedidoSimuladoFmt": "R$ 187",
    "primeiraCompraSimulada": "15/02/2026",
    "ultimaCompraSimulada": "05/04/2026",
    "diasDesdeUltimaCompraSimulado": 39,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0694"
  },
  {
    "clienteId": "CLI_0695",
    "clienteAnonimo": "694",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 307,
    "ticketMedianoSimulado": 306,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 921,
    "maiorPedidoSimulado": 353,
    "menorPedidoSimulado": 205,
    "ticketMedioSimuladoFmt": "R$ 307",
    "ticketMedianoSimuladoFmt": "R$ 306",
    "valorTotalAcumuladoSimuladoFmt": "R$ 921",
    "maiorPedidoSimuladoFmt": "R$ 353",
    "menorPedidoSimuladoFmt": "R$ 205",
    "primeiraCompraSimulada": "30/01/2026",
    "ultimaCompraSimulada": "22/04/2026",
    "diasDesdeUltimaCompraSimulado": 22,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0695"
  },
  {
    "clienteId": "CLI_0696",
    "clienteAnonimo": "695",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 281,
    "ticketMedianoSimulado": 261,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 562,
    "maiorPedidoSimulado": 326,
    "menorPedidoSimulado": 190,
    "ticketMedioSimuladoFmt": "R$ 281",
    "ticketMedianoSimuladoFmt": "R$ 261",
    "valorTotalAcumuladoSimuladoFmt": "R$ 562",
    "maiorPedidoSimuladoFmt": "R$ 326",
    "menorPedidoSimuladoFmt": "R$ 190",
    "primeiraCompraSimulada": "14/01/2026",
    "ultimaCompraSimulada": "06/05/2026",
    "diasDesdeUltimaCompraSimulado": 8,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0696"
  },
  {
    "clienteId": "CLI_0697",
    "clienteAnonimo": "696",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 305,
    "ticketMedianoSimulado": 300,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 610,
    "maiorPedidoSimulado": 326,
    "menorPedidoSimulado": 175,
    "ticketMedioSimuladoFmt": "R$ 305",
    "ticketMedianoSimuladoFmt": "R$ 300",
    "valorTotalAcumuladoSimuladoFmt": "R$ 610",
    "maiorPedidoSimuladoFmt": "R$ 326",
    "menorPedidoSimuladoFmt": "R$ 175",
    "primeiraCompraSimulada": "29/12/2025",
    "ultimaCompraSimulada": "05/04/2026",
    "diasDesdeUltimaCompraSimulado": 39,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0697"
  },
  {
    "clienteId": "CLI_0698",
    "clienteAnonimo": "697",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 332,
    "ticketMedianoSimulado": 314,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 664,
    "maiorPedidoSimulado": 372,
    "menorPedidoSimulado": 210,
    "ticketMedioSimuladoFmt": "R$ 332",
    "ticketMedianoSimuladoFmt": "R$ 314",
    "valorTotalAcumuladoSimuladoFmt": "R$ 664",
    "maiorPedidoSimuladoFmt": "R$ 372",
    "menorPedidoSimuladoFmt": "R$ 210",
    "primeiraCompraSimulada": "13/12/2025",
    "ultimaCompraSimulada": "26/02/2026",
    "diasDesdeUltimaCompraSimulado": 77,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0698"
  },
  {
    "clienteId": "CLI_0699",
    "clienteAnonimo": "698",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 358,
    "ticketMedianoSimulado": 347,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 716,
    "maiorPedidoSimulado": 426,
    "menorPedidoSimulado": 255,
    "ticketMedioSimuladoFmt": "R$ 358",
    "ticketMedianoSimuladoFmt": "R$ 347",
    "valorTotalAcumuladoSimuladoFmt": "R$ 716",
    "maiorPedidoSimuladoFmt": "R$ 426",
    "menorPedidoSimuladoFmt": "R$ 255",
    "primeiraCompraSimulada": "27/11/2025",
    "ultimaCompraSimulada": "28/03/2026",
    "diasDesdeUltimaCompraSimulado": 47,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0699"
  },
  {
    "clienteId": "CLI_0700",
    "clienteAnonimo": "699",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 411,
    "ticketMedianoSimulado": 405,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1233,
    "maiorPedidoSimulado": 434,
    "menorPedidoSimulado": 229,
    "ticketMedioSimuladoFmt": "R$ 411",
    "ticketMedianoSimuladoFmt": "R$ 405",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.233",
    "maiorPedidoSimuladoFmt": "R$ 434",
    "menorPedidoSimuladoFmt": "R$ 229",
    "primeiraCompraSimulada": "21/01/2026",
    "ultimaCompraSimulada": "06/05/2026",
    "diasDesdeUltimaCompraSimulado": 8,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0700"
  },
  {
    "clienteId": "CLI_0701",
    "clienteAnonimo": "700",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 385,
    "ticketMedianoSimulado": 357,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 385,
    "maiorPedidoSimulado": 437,
    "menorPedidoSimulado": 249,
    "ticketMedioSimuladoFmt": "R$ 385",
    "ticketMedianoSimuladoFmt": "R$ 357",
    "valorTotalAcumuladoSimuladoFmt": "R$ 385",
    "maiorPedidoSimuladoFmt": "R$ 437",
    "menorPedidoSimuladoFmt": "R$ 249",
    "primeiraCompraSimulada": "05/02/2026",
    "ultimaCompraSimulada": "23/04/2026",
    "diasDesdeUltimaCompraSimulado": 21,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0701"
  },
  {
    "clienteId": "CLI_0702",
    "clienteAnonimo": "701",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 359,
    "ticketMedianoSimulado": 359,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1077,
    "maiorPedidoSimulado": 422,
    "menorPedidoSimulado": 250,
    "ticketMedioSimuladoFmt": "R$ 359",
    "ticketMedianoSimuladoFmt": "R$ 359",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.077",
    "maiorPedidoSimuladoFmt": "R$ 422",
    "menorPedidoSimuladoFmt": "R$ 250",
    "primeiraCompraSimulada": "21/02/2026",
    "ultimaCompraSimulada": "08/04/2026",
    "diasDesdeUltimaCompraSimulado": 36,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Baixo",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0702"
  },
  {
    "clienteId": "CLI_0703",
    "clienteAnonimo": "702",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 332,
    "ticketMedianoSimulado": 308,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 664,
    "maiorPedidoSimulado": 360,
    "menorPedidoSimulado": 196,
    "ticketMedioSimuladoFmt": "R$ 332",
    "ticketMedianoSimuladoFmt": "R$ 308",
    "valorTotalAcumuladoSimuladoFmt": "R$ 664",
    "maiorPedidoSimuladoFmt": "R$ 360",
    "menorPedidoSimuladoFmt": "R$ 196",
    "primeiraCompraSimulada": "09/03/2026",
    "ultimaCompraSimulada": "19/04/2026",
    "diasDesdeUltimaCompraSimulado": 25,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0703"
  },
  {
    "clienteId": "CLI_0704",
    "clienteAnonimo": "703",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 306,
    "ticketMedianoSimulado": 301,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 612,
    "maiorPedidoSimulado": 338,
    "menorPedidoSimulado": 188,
    "ticketMedioSimuladoFmt": "R$ 306",
    "ticketMedianoSimuladoFmt": "R$ 301",
    "valorTotalAcumuladoSimuladoFmt": "R$ 612",
    "maiorPedidoSimuladoFmt": "R$ 338",
    "menorPedidoSimuladoFmt": "R$ 188",
    "primeiraCompraSimulada": "25/03/2026",
    "ultimaCompraSimulada": "06/05/2026",
    "diasDesdeUltimaCompraSimulado": 8,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0704"
  },
  {
    "clienteId": "CLI_0705",
    "clienteAnonimo": "704",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 280,
    "ticketMedianoSimulado": 264,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 560,
    "maiorPedidoSimulado": 335,
    "menorPedidoSimulado": 201,
    "ticketMedioSimuladoFmt": "R$ 280",
    "ticketMedianoSimuladoFmt": "R$ 264",
    "valorTotalAcumuladoSimuladoFmt": "R$ 560",
    "maiorPedidoSimuladoFmt": "R$ 335",
    "menorPedidoSimuladoFmt": "R$ 201",
    "primeiraCompraSimulada": "10/04/2026",
    "ultimaCompraSimulada": "07/05/2026",
    "diasDesdeUltimaCompraSimulado": 7,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0705"
  },
  {
    "clienteId": "CLI_0706",
    "clienteAnonimo": "705",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 306,
    "ticketMedianoSimulado": 297,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 612,
    "maiorPedidoSimulado": 341,
    "menorPedidoSimulado": 191,
    "ticketMedioSimuladoFmt": "R$ 306",
    "ticketMedianoSimuladoFmt": "R$ 297",
    "valorTotalAcumuladoSimuladoFmt": "R$ 612",
    "maiorPedidoSimuladoFmt": "R$ 341",
    "menorPedidoSimuladoFmt": "R$ 191",
    "primeiraCompraSimulada": "02/04/2026",
    "ultimaCompraSimulada": "27/04/2026",
    "diasDesdeUltimaCompraSimulado": 17,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0706"
  },
  {
    "clienteId": "CLI_0707",
    "clienteAnonimo": "706",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 332,
    "ticketMedianoSimulado": 318,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 664,
    "maiorPedidoSimulado": 357,
    "menorPedidoSimulado": 192,
    "ticketMedioSimuladoFmt": "R$ 332",
    "ticketMedianoSimuladoFmt": "R$ 318",
    "valorTotalAcumuladoSimuladoFmt": "R$ 664",
    "maiorPedidoSimuladoFmt": "R$ 357",
    "menorPedidoSimuladoFmt": "R$ 192",
    "primeiraCompraSimulada": "17/03/2026",
    "ultimaCompraSimulada": "18/04/2026",
    "diasDesdeUltimaCompraSimulado": 26,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0707"
  },
  {
    "clienteId": "CLI_0708",
    "clienteAnonimo": "707",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 359,
    "ticketMedianoSimulado": 343,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 718,
    "maiorPedidoSimulado": 418,
    "menorPedidoSimulado": 246,
    "ticketMedioSimuladoFmt": "R$ 359",
    "ticketMedianoSimuladoFmt": "R$ 343",
    "valorTotalAcumuladoSimuladoFmt": "R$ 718",
    "maiorPedidoSimuladoFmt": "R$ 418",
    "menorPedidoSimuladoFmt": "R$ 246",
    "primeiraCompraSimulada": "01/03/2026",
    "ultimaCompraSimulada": "28/04/2026",
    "diasDesdeUltimaCompraSimulado": 16,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0708"
  },
  {
    "clienteId": "CLI_0709",
    "clienteAnonimo": "708",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 385,
    "ticketMedianoSimulado": 374,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1155,
    "maiorPedidoSimulado": 441,
    "menorPedidoSimulado": 254,
    "ticketMedioSimuladoFmt": "R$ 385",
    "ticketMedianoSimuladoFmt": "R$ 374",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.155",
    "maiorPedidoSimuladoFmt": "R$ 441",
    "menorPedidoSimuladoFmt": "R$ 254",
    "primeiraCompraSimulada": "13/02/2026",
    "ultimaCompraSimulada": "07/05/2026",
    "diasDesdeUltimaCompraSimulado": 7,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0709"
  },
  {
    "clienteId": "CLI_0710",
    "clienteAnonimo": "709",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 334,
    "ticketMedianoSimulado": 329,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1002,
    "maiorPedidoSimulado": 360,
    "menorPedidoSimulado": 195,
    "ticketMedioSimuladoFmt": "R$ 334",
    "ticketMedianoSimuladoFmt": "R$ 329",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.002",
    "maiorPedidoSimuladoFmt": "R$ 360",
    "menorPedidoSimuladoFmt": "R$ 195",
    "primeiraCompraSimulada": "26/12/2025",
    "ultimaCompraSimulada": "17/03/2026",
    "diasDesdeUltimaCompraSimulado": 58,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0710"
  },
  {
    "clienteId": "CLI_0711",
    "clienteAnonimo": "710",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 360,
    "ticketMedianoSimulado": 335,
    "totalPedidosSimulado": 1,
    "valorTotalAcumuladoSimulado": 360,
    "maiorPedidoSimulado": 400,
    "menorPedidoSimulado": 224,
    "ticketMedioSimuladoFmt": "R$ 360",
    "ticketMedianoSimuladoFmt": "R$ 335",
    "valorTotalAcumuladoSimuladoFmt": "R$ 360",
    "maiorPedidoSimuladoFmt": "R$ 400",
    "menorPedidoSimuladoFmt": "R$ 224",
    "primeiraCompraSimulada": "10/12/2025",
    "ultimaCompraSimulada": "15/04/2026",
    "diasDesdeUltimaCompraSimulado": 29,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0711"
  },
  {
    "clienteId": "CLI_0712",
    "clienteAnonimo": "711",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 387,
    "ticketMedianoSimulado": 386,
    "totalPedidosSimulado": 3,
    "valorTotalAcumuladoSimulado": 1161,
    "maiorPedidoSimulado": 464,
    "menorPedidoSimulado": 280,
    "ticketMedioSimuladoFmt": "R$ 387",
    "ticketMedianoSimuladoFmt": "R$ 386",
    "valorTotalAcumuladoSimuladoFmt": "R$ 1.161",
    "maiorPedidoSimuladoFmt": "R$ 464",
    "menorPedidoSimuladoFmt": "R$ 280",
    "primeiraCompraSimulada": "24/11/2025",
    "ultimaCompraSimulada": "01/05/2026",
    "diasDesdeUltimaCompraSimulado": 13,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0712"
  },
  {
    "clienteId": "CLI_0713",
    "clienteAnonimo": "712",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 413,
    "ticketMedianoSimulado": 382,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 826,
    "maiorPedidoSimulado": 458,
    "menorPedidoSimulado": 255,
    "ticketMedioSimuladoFmt": "R$ 413",
    "ticketMedianoSimuladoFmt": "R$ 382",
    "valorTotalAcumuladoSimuladoFmt": "R$ 826",
    "maiorPedidoSimuladoFmt": "R$ 458",
    "menorPedidoSimuladoFmt": "R$ 255",
    "primeiraCompraSimulada": "08/11/2025",
    "ultimaCompraSimulada": "19/03/2026",
    "diasDesdeUltimaCompraSimulado": 56,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Desconhecido",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0713"
  },
  {
    "clienteId": "CLI_0714",
    "clienteAnonimo": "713",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 439,
    "ticketMedianoSimulado": 434,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 878,
    "maiorPedidoSimulado": 475,
    "menorPedidoSimulado": 258,
    "ticketMedioSimuladoFmt": "R$ 439",
    "ticketMedianoSimuladoFmt": "R$ 434",
    "valorTotalAcumuladoSimuladoFmt": "R$ 878",
    "maiorPedidoSimuladoFmt": "R$ 475",
    "menorPedidoSimuladoFmt": "R$ 258",
    "primeiraCompraSimulada": "03/11/2025",
    "ultimaCompraSimulada": "10/02/2026",
    "diasDesdeUltimaCompraSimulado": 93,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0714"
  },
  {
    "clienteId": "CLI_0715",
    "clienteAnonimo": "714",
    "segmentoComercial": "Cliente inativo",
    "ticketMedioSimulado": 435,
    "ticketMedianoSimulado": 409,
    "totalPedidosSimulado": 2,
    "valorTotalAcumuladoSimulado": 870,
    "maiorPedidoSimulado": 510,
    "menorPedidoSimulado": 301,
    "ticketMedioSimuladoFmt": "R$ 435",
    "ticketMedianoSimuladoFmt": "R$ 409",
    "valorTotalAcumuladoSimuladoFmt": "R$ 870",
    "maiorPedidoSimuladoFmt": "R$ 510",
    "menorPedidoSimuladoFmt": "R$ 301",
    "primeiraCompraSimulada": "19/11/2025",
    "ultimaCompraSimulada": "29/03/2026",
    "diasDesdeUltimaCompraSimulado": 46,
    "hipoteseDePerfil": "Cliente com oportunidade de reativação.",
    "objetivoProvavel": "Pode se beneficiar de lembrete de recompra",
    "propensaoARecompra": "Muito baixa (reativação)",
    "propensaoAUpsell": "Média",
    "propensaoACrossSell": "Baixa",
    "interesseEmAcompCalorico": "Médio",
    "observacaoParaChatbot": "Cliente para reativação — sugerir recompra.",
    "alertaSimulacao": null,
    "fonteValores": "Simulação plausível para protótipo",
    "rawClienteId": "CLI_0715"
  }
]